/* eslint-disable */
/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import type { DocumentTypeDecoration } from '@graphql-typed-document-node/core';
export type AbortAvatarInput = {
  storageKey: string;
};

export type AbortOrgLogoInput = {
  storageKey: string;
};

export type ActivityFilter = {
  actorId?: IdFilter | null | undefined;
  clientId?: IdFilter | null | undefined;
  dealId?: IdFilter | null | undefined;
  documentId?: IdFilter | null | undefined;
  id?: IdFilter | null | undefined;
  leadId?: IdFilter | null | undefined;
  occurredAt?: DateTimeFilter | null | undefined;
  propertyId?: IdFilter | null | undefined;
  taskId?: IdFilter | null | undefined;
  title?: StringFilter | null | undefined;
  type?: ActivityTypeEnumEnumFilter | null | undefined;
};

export type ActivityTimelineInput = {
  clientId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
  documentId?: string | number | null | undefined;
  leadId?: string | number | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  propertyId?: string | number | null | undefined;
  taskId?: string | number | null | undefined;
};

export type ActivityTypeEnum =
  | 'AGENT_CHANGE'
  | 'CALL'
  | 'DEAL_CREATED'
  | 'DEAL_LOST'
  | 'DEAL_STAGE_CHANGED'
  | 'DEAL_WON'
  | 'DOCUMENT_DELETED'
  | 'DOCUMENT_MOVED'
  | 'DOCUMENT_RENAMED'
  | 'DOCUMENT_REPLACED'
  | 'DOCUMENT_RESTORED'
  | 'DOCUMENT_UPLOADED'
  | 'EMAIL'
  | 'FOLDER_CREATED'
  | 'LEAD_CONVERTED'
  | 'LEAD_CREATED'
  | 'MEETING'
  | 'NOTE'
  | 'OTHER'
  | 'PROPERTY_PUBLISHED'
  | 'PROPERTY_UPDATED'
  | 'STATUS_CHANGE'
  | 'TASK_CANCELLED'
  | 'TASK_COMPLETED'
  | 'TASK_CREATED'
  | 'TASK_DELETED'
  | 'TASK_UPDATED'
  | 'VIEWING';

export type ActivityTypeEnumEnumFilter = {
  exact?: ActivityTypeEnum | null | undefined;
  in_?: Array<ActivityTypeEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<ActivityTypeEnum> | null | undefined;
};

export type AddTaskReminderInput = {
  channel?: ReminderChannelEnum;
  remindAt: string;
  taskId: string | number;
};

export type AdvertRoomCountEnum =
  | 'ATYPICAL'
  | 'FIVE_PLUS'
  | 'FOUR'
  | 'ONE'
  | 'THREE'
  | 'TWO';

export type ArchiveWorkflowInput = {
  workflowId: string | number;
};

export type AssignLeadInput = {
  assignedAgentId: string | number;
  id: string | number;
};

export type AssistOutputFormatEnum =
  | 'LAYOUT'
  | 'TYPST';

export type AssistTypstInput = {
  brief?: string | null | undefined;
  currentLayout?: unknown;
  currentSource?: string | null | undefined;
  documentBase64?: string | null | undefined;
  documentFilename?: string | null | undefined;
  idempotencyKey?: string | null | undefined;
  kind: RenderTemplateKindEnum;
  locale?: string;
  markup?: string | null | undefined;
  markupFormat?: string;
  mode: TypstAssistModeEnum;
  outputFormat?: AssistOutputFormatEnum;
  overwrite?: boolean;
  styleTemplateId?: string | number | null | undefined;
};

export type AuctionKindEnum =
  | 'AUCTION'
  | 'EXECUTION'
  | 'INVOLUNTARY'
  | 'PUBLIC_COMMERCIAL_COMPETITION'
  | 'VOLUNTARY';

export type AuditActionEnum =
  | 'ASSIGN'
  | 'CREATE'
  | 'DELETE'
  | 'EXPORT'
  | 'IMPORT'
  | 'LOGIN'
  | 'LOGOUT'
  | 'MERGE'
  | 'OTHER'
  | 'STATUS_CHANGE'
  | 'UPDATE';

export type AuditEntityTypeEnum =
  | 'AUDIT'
  | 'BILLING'
  | 'BLOG_POST'
  | 'CLIENT'
  | 'CREDIT'
  | 'DEAL'
  | 'DOCUMENT'
  | 'INTEGRATION'
  | 'LEAD'
  | 'LEGAL_ENTITY'
  | 'ORGANIZATION'
  | 'OTHER'
  | 'PIPELINE'
  | 'PROPERTY'
  | 'PROPERTY_MESSAGE'
  | 'TASK'
  | 'TEAM'
  | 'USER'
  | 'VENUE'
  | 'WORKFLOW';

export type AvatarUploadIntentInput = {
  contentType: string;
  sizeBytes?: number | null | undefined;
};

export type BiddingEnum =
  | 'DUTCH'
  | 'ENGLISH';

export type BillingModeEnum =
  | 'INVOICE'
  | 'PREPAID';

export type BillingPeriodEnum =
  | 'MONTHLY'
  | 'YEARLY';

export type BlogPostAssetKindEnum =
  | 'CONTENT'
  | 'COVER';

export type BlogPostFilter = {
  authorId?: IdFilter | null | undefined;
  contentSearch?: string | null | undefined;
  createdAt?: DateTimeFilter | null | undefined;
  id?: IdFilter | null | undefined;
  publishedAt?: DateTimeFilter | null | undefined;
  status?: BlogPostStatusEnumEnumFilter | null | undefined;
  titleSearch?: string | null | undefined;
};

export type BlogPostOrder = {
  createdAt?: Ordering | null | undefined;
  publishedAt?: Ordering | null | undefined;
  status?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type BlogPostStatusEnum =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'PUBLISHED';

export type BlogPostStatusEnumEnumFilter = {
  exact?: BlogPostStatusEnum | null | undefined;
  in_?: Array<BlogPostStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<BlogPostStatusEnum> | null | undefined;
};

export type BooleanFilter = {
  exact?: boolean | null | undefined;
  isnull?: boolean | null | undefined;
};

export type BuildingTypeEnum =
  | 'BRICK'
  | 'MIXED'
  | 'MODULAR'
  | 'PANEL'
  | 'PREFAB'
  | 'SKELETON'
  | 'STONE'
  | 'WOOD';

export type BulkTransferFilterInput = {
  assignedAgentId?: string | number | null | undefined;
  category?: PropertyCategoryEnum | null | undefined;
  isPublished?: boolean | null | undefined;
  status?: PropertyStatusEnum | null | undefined;
};

export type BulkTransferInput = {
  filter?: BulkTransferFilterInput | null | undefined;
  includeDeals?: boolean;
  includeTasks?: boolean;
  propertyIds?: Array<string | number> | null | undefined;
  reprovisionSrealitySeller?: boolean;
  toUserId: string | number;
};

export type CalendarProviderEnum =
  | 'GOOGLE'
  | 'MICROSOFT'
  | 'NONE';

export type CalendarProviderEnumEnumFilter = {
  exact?: CalendarProviderEnum | null | undefined;
  in_?: Array<CalendarProviderEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<CalendarProviderEnum> | null | undefined;
};

export type CalendarScopeEnum =
  | 'ALL'
  | 'MINE'
  | 'TEAM';

export type CalendarSyncStatusEnum =
  | 'DISCONNECTED'
  | 'ERROR'
  | 'NONE'
  | 'PENDING'
  | 'SYNCED';

export type CalendarSyncStatusEnumEnumFilter = {
  exact?: CalendarSyncStatusEnum | null | undefined;
  in_?: Array<CalendarSyncStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<CalendarSyncStatusEnum> | null | undefined;
};

export type ChangeDealStageInput = {
  actualValue?: string | null | undefined;
  id: string | number;
  lostReason?: string | null | undefined;
  note?: string | null | undefined;
  stageId: string | number;
};

export type ChangePasswordInput = {
  currentPassword: string;
  newPassword: string;
};

export type ChatAttachmentEntityTypeEnum =
  | 'CLIENT'
  | 'DEAL'
  | 'DOCUMENT'
  | 'LEAD'
  | 'PROPERTY'
  | 'TASK';

export type ChatAttachmentInput = {
  entityId: string | number;
  entityType: ChatAttachmentEntityTypeEnum;
};

export type ChatConversationKindEnum =
  | 'DIRECT'
  | 'GROUP';

export type CircuitBreakerEnum =
  | 'A16'
  | 'A20'
  | 'A25'
  | 'A32'
  | 'A40'
  | 'A50'
  | 'A63';

export type ClientContactInput = {
  isPrimary?: boolean;
  label?: string | null | undefined;
  type: ContactTypeEnum;
  value: string;
};

export type ClientFilter = {
  assignedAgentId?: IdFilter | null | undefined;
  createdAt?: DateTimeFilter | null | undefined;
  firstName?: StringFilter | null | undefined;
  hasAllRoles?: Array<ClientTypeEnum> | null | undefined;
  hasAllTags?: Array<string> | null | undefined;
  hasAnyRole?: Array<ClientTypeEnum> | null | undefined;
  hasAnyTag?: Array<string> | null | undefined;
  id?: IdFilter | null | undefined;
  lastName?: StringFilter | null | undefined;
  nameSearch?: string | null | undefined;
  priority?: PriorityEnumEnumFilter | null | undefined;
  source?: LeadSourceEnumEnumFilter | null | undefined;
  status?: ClientStatusEnumEnumFilter | null | undefined;
  tags?: ClientTagFilter | null | undefined;
  type?: ClientTypeEnumEnumFilter | null | undefined;
  updatedAt?: DateTimeFilter | null | undefined;
};

export type ClientOrder = {
  createdAt?: Ordering | null | undefined;
  firstName?: Ordering | null | undefined;
  lastName?: Ordering | null | undefined;
  priority?: Ordering | null | undefined;
  status?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type ClientStatusEnum =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'BLACKLIST'
  | 'INACTIVE'
  | 'NEW';

export type ClientStatusEnumEnumFilter = {
  exact?: ClientStatusEnum | null | undefined;
  in_?: Array<ClientStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<ClientStatusEnum> | null | undefined;
};

export type ClientTagFilter = {
  catalogTag?: TagFilter | null | undefined;
  tagId?: IdFilter | null | undefined;
};

export type ClientTagInput = {
  tag: string;
};

export type ClientTypeEnum =
  | 'BUYER'
  | 'INVESTOR'
  | 'LANDLORD'
  | 'OTHER'
  | 'SELLER'
  | 'TENANT';

export type ClientTypeEnumEnumFilter = {
  exact?: ClientTypeEnum | null | undefined;
  in_?: Array<ClientTypeEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<ClientTypeEnum> | null | undefined;
};

export type CodebookYesNoEnum =
  | 'NO'
  | 'YES';

export type CompileLayoutInput = {
  kind: RenderTemplateKindEnum;
  layout: unknown;
  preview?: boolean;
  sampleData?: unknown;
};

export type CompileMarkupInput = {
  kind: RenderTemplateKindEnum;
  markup: string;
  markupFormat?: string;
  preview?: boolean;
  sampleData?: unknown;
  theme?: unknown;
};

export type CompleteMetaPublishInput = {
  accountKind?: MetaPublishAccountKindEnum | null | undefined;
  caption?: string | null | undefined;
  igContainerId?: string | null | undefined;
  imageUrl?: string | null | undefined;
  label?: string | null | undefined;
  mediaType: string;
  platform: string;
  propertyId?: string | number | null | undefined;
  videoUrl?: string | null | undefined;
};

export type CompleteMetaSetupInput = {
  pageId: string;
};

export type CompleteYoutubeExportInput = {
  label?: string | null | undefined;
  propertyId: string | number;
  youtubeVideoId: string;
};

export type ConsentChannelEnum =
  | 'EMAIL'
  | 'REMARKETING'
  | 'SMS';

export type ConsentTypeEnum =
  | 'ANALYTICS'
  | 'MARKETING'
  | 'TRANSACTIONAL';

export type ContactTypeEnum =
  | 'DISCORD'
  | 'EMAIL'
  | 'LINKEDIN'
  | 'OTHER'
  | 'PHONE'
  | 'SIGNAL'
  | 'TELEGRAM'
  | 'WEBSITE'
  | 'WHATSAPP';

export type CreateActivityInput = {
  body?: string | null | undefined;
  clientId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
  documentId?: string | number | null | undefined;
  leadId?: string | number | null | undefined;
  metadata?: unknown;
  occurredAt?: string | null | undefined;
  propertyId?: string | number | null | undefined;
  taskId?: string | number | null | undefined;
  title: string;
  type: ActivityTypeEnum;
};

export type CreateBlogPostInput = {
  authorId?: string | number | null | undefined;
  bodyMd?: unknown;
  content?: unknown;
  excerpt?: unknown;
  seoDescription?: unknown;
  seoTitle?: unknown;
  slugs?: unknown;
  status?: BlogPostStatusEnum | null | undefined;
  tags?: unknown;
  title: unknown;
};

export type CreateClientInput = {
  assignedAgentId?: string | number | null | undefined;
  contacts?: Array<ClientContactInput> | null | undefined;
  firstName: string;
  lastName: string;
  notes?: string | null | undefined;
  preferredCommunicationMethod?: PreferredCommunicationMethodEnum | null | undefined;
  preferredLanguage?: string | null | undefined;
  priority?: PriorityEnum;
  roles?: Array<ClientTypeEnum> | null | undefined;
  source?: LeadSourceEnum | null | undefined;
  status?: ClientStatusEnum;
  tags?: Array<ClientTagInput> | null | undefined;
  type: ClientTypeEnum;
};

export type CreateClientRequirementInput = {
  budgetMax?: string | null | undefined;
  budgetMin?: string | null | undefined;
  clientId: string | number;
  currency?: string;
  financingStatus?: FinancingStatusEnum;
  isActive?: boolean;
  isPrimary?: boolean | null | undefined;
  latitude?: number | null | undefined;
  localityId?: string | number | null | undefined;
  locationAddress?: string | null | undefined;
  longitude?: number | null | undefined;
  name: string;
  notes?: string | null | undefined;
  preferences?: unknown;
  preferredLayouts?: Array<PropertyLayoutEnum> | null | undefined;
  priority?: PriorityEnum;
  propertyCategory?: PropertyCategoryEnum | null | undefined;
  propertyType?: PropertyTypeEnum | null | undefined;
  radiusKm?: number | null | undefined;
  transactionType: TransactionTypeEnum;
  usableAreaMax?: string | null | undefined;
  usableAreaMin?: string | null | undefined;
};

export type CreateDealInput = {
  assignedAgentId?: string | number | null | undefined;
  clientId: string | number;
  currency?: string | null | undefined;
  description?: string | null | undefined;
  expectedCloseDate?: string | null | undefined;
  expectedValue?: string | null | undefined;
  leadId?: string | number | null | undefined;
  nextStep?: string | null | undefined;
  nextStepAt?: string | null | undefined;
  pipelineId?: string | number | null | undefined;
  propertyId?: string | number | null | undefined;
  provisionAmount?: string | null | undefined;
  provisionNotes?: string | null | undefined;
  provisionPercent?: string | null | undefined;
  stageId?: string | number | null | undefined;
  title: string;
  transactionType: TransactionTypeEnum;
};

export type CreateDealProvisionSplitInput = {
  amount?: string | null | undefined;
  dealId: string | number;
  notes?: string | null | undefined;
  percent?: string | null | undefined;
  userId: string | number;
};

export type CreateGoogleBusinessPostInput = {
  accountId?: string | null | undefined;
  callToActionType?: string;
  callToActionUrl?: string | null | undefined;
  languageCode?: string;
  locationId?: string | null | undefined;
  mediaUrl?: string | null | undefined;
  summary: string;
  topicType?: string;
};

export type CreateImportTokenInput = {
  expiresInDays?: number | null | undefined;
  name: string;
  notes?: string | null | undefined;
};

export type CreateIntegrationConnectionInput = {
  authType?: IntegrationAuthTypeEnum;
  credentialsJson?: string | null | undefined;
  direction?: IntegrationDirectionEnum;
  isActive?: boolean;
  name: string;
  provider: IntegrationProviderEnum;
  settings?: unknown;
};

export type CreateLeadInput = {
  assignedAgentId?: string | number | null | undefined;
  clientId?: string | number | null | undefined;
  email?: string | null | undefined;
  externalId?: string | null | undefined;
  firstName: string;
  lastName: string;
  message?: string | null | undefined;
  metadata?: unknown;
  notes?: string | null | undefined;
  phone?: string | null | undefined;
  propertyId?: string | number | null | undefined;
  source: LeadSourceEnum;
  sourceLabel?: string | null | undefined;
  utmCampaign?: string | null | undefined;
  utmMedium?: string | null | undefined;
  utmSource?: string | null | undefined;
};

export type CreateListingProjectInput = {
  annotation: string;
  description: string;
  developerIc: string;
  latitude?: number | null | undefined;
  localityCity: string;
  localityCitypart?: string | null | undefined;
  localityCo?: string | null | undefined;
  localityCp?: string | null | undefined;
  localityDescription: string;
  localityRuian?: number | null | undefined;
  localityRuianLevel?: number | null | undefined;
  localityStreet?: string | null | undefined;
  longitude?: number | null | undefined;
  name: string;
  projectActive?: boolean;
  projectLifetime?: number;
  projectMatterportUrl?: string | null | undefined;
  projectRkid: string;
  projectUrl?: string | null | undefined;
};

export type CreateOrganizationInput = {
  dpaAccepted?: boolean;
  legalEntity?: LegalEntityInput | null | undefined;
  locale?: string | null | undefined;
  name: string;
  ownerFirstName: string;
  ownerLastName: string;
  ownerLoginEmail: string;
  ownerPassword: string;
  planCode?: string | null | undefined;
  slug?: string | null | undefined;
  timezone?: string | null | undefined;
};

export type CreatePaymentInput = {
  amount: string;
  currency?: string;
  dealId: string | number;
  documentId?: string | number | null | undefined;
  dueAt?: string | null | undefined;
  idempotencyKey?: string | null | undefined;
  paidAt?: string | null | undefined;
  payeeUserId?: string | number | null | undefined;
  payerClientId: string | number;
  propertyId?: string | number | null | undefined;
  status?: PaymentStatusEnum;
  type: PaymentTypeEnum;
  variableSymbol?: string | null | undefined;
};

export type CreatePropertyContractInput = {
  assignedAgentId?: string | number | null | undefined;
  contractNumber?: string | null | undefined;
  contractType: PropertyContractTypeEnum;
  counterpartyContactId?: string | number | null | undefined;
  counterpartyName?: string | null | undefined;
  metadata?: unknown;
  notes?: string | null | undefined;
  primaryDocumentId?: string | number | null | undefined;
  propertyId: string | number;
  signedAt?: string | null | undefined;
  status?: PropertyContractStatusEnum;
  terminatedAt?: string | null | undefined;
  title: string;
  validFrom?: string | null | undefined;
  validUntil?: string | null | undefined;
};

export type CreatePropertyInput = {
  acceptanceYear?: number | null | undefined;
  apartmentNumber?: number | null | undefined;
  assignedAgentId?: string | number | null | undefined;
  attributes?: Array<PropertyAttributeInput> | null | undefined;
  availableFrom?: string | null | undefined;
  balconyArea?: string | null | undefined;
  basinArea?: string | null | undefined;
  buildingArea?: string | null | undefined;
  buildingType?: BuildingTypeEnum | null | undefined;
  category: PropertyCategoryEnum;
  ceilingHeight?: string | null | undefined;
  cellarArea?: string | null | undefined;
  condition?: PropertyConditionEnum | null | undefined;
  contractValidUntil?: string | null | undefined;
  currency?: string | null | undefined;
  description: unknown;
  energyClass?: EnergyClassEnum | null | undefined;
  exportToPortals?: boolean;
  floor?: number | null | undefined;
  floorArea?: string | null | undefined;
  furnished?: FurnishedEnum | null | undefined;
  garageCount?: number | null | undefined;
  gardenArea?: string | null | undefined;
  hasBalcony?: boolean;
  hasBasin?: boolean;
  hasCellar?: boolean;
  hasElevator?: boolean;
  hasGarage?: boolean;
  hasLoggia?: boolean;
  hasParking?: boolean;
  hasTerrace?: boolean;
  internalNotes?: string | null | undefined;
  layout?: PropertyLayoutEnum | null | undefined;
  locale?: string;
  location: PropertyLocationInput;
  locationPrivacy?: LocationPrivacyEnum;
  loggiaArea?: string | null | undefined;
  lotSize?: string | null | undefined;
  marketDetails?: PropertyMarketDetailsInput | null | undefined;
  marketingText?: unknown;
  objectType?: ObjectTypeEnum | null | undefined;
  occupiedUntil?: string | null | undefined;
  ownerContactId?: string | number | null | undefined;
  ownershipType: OwnershipTypeEnum;
  parkingCount?: number | null | undefined;
  price?: string | null | undefined;
  priceNotes?: unknown;
  priceUnit?: PriceUnitEnum | null | undefined;
  propertyType: PropertyTypeEnum;
  reconstructionYear?: number | null | undefined;
  rentPrice?: string | null | undefined;
  roomCount?: AdvertRoomCountEnum | null | undefined;
  seoDescription?: unknown;
  seoKeywords?: unknown;
  seoTitle?: unknown;
  slug?: string | null | undefined;
  terraceArea?: string | null | undefined;
  title: unknown;
  totalFloors?: number | null | undefined;
  undergroundFloors?: number | null | undefined;
  usableArea?: string | null | undefined;
  webVisibility?: PropertyWebVisibilityEnum;
  yearBuilt?: number | null | undefined;
};

export type CreatePropertyLinkInput = {
  label?: string | null | undefined;
  position?: number | null | undefined;
  propertyId: string | number;
  type: PropertyLinkTypeEnum;
  url: string;
};

export type CreatePropertyPartyInput = {
  clientId?: string | number | null | undefined;
  displayName?: string | null | undefined;
  notes?: string | null | undefined;
  ownershipSharePercent?: string | null | undefined;
  position?: number | null | undefined;
  propertyId: string | number;
  role: PropertyPartyRoleEnum;
};

export type CreateTagInput = {
  color?: string | null | undefined;
  name: string;
};

export type CreateTaskInput = {
  allDay?: boolean;
  assigneeId?: string | number | null | undefined;
  assigneeIds?: Array<string | number> | null | undefined;
  calendarProvider?: CalendarProviderEnum | null | undefined;
  category: TaskCategoryEnum;
  clientId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
  description?: string | null | undefined;
  dueAt?: string | null | undefined;
  endAt?: string | null | undefined;
  leadId?: string | number | null | undefined;
  locationLabel?: string | null | undefined;
  pipelineId?: string | number | null | undefined;
  priority?: PriorityEnum;
  propertyId?: string | number | null | undefined;
  reminders?: Array<TaskReminderInput> | null | undefined;
  startAt?: string | null | undefined;
  status?: TaskStatusEnum;
  syncToCalendar?: boolean;
  title: string;
};

export type CreateViewingInput = {
  agentId?: string | number | null | undefined;
  clientId: string | number;
  dealId?: string | number | null | undefined;
  feedback?: string | null | undefined;
  propertyId: string | number;
  scheduledAt: string;
  status?: ViewingStatusEnum;
  suppressSms?: boolean;
  syncToCalendar?: boolean;
  taskId?: string | number | null | undefined;
};

export type CreateWorkflowFromTemplateInput = {
  name?: string | null | undefined;
  templateSlug: string;
};

export type CreateWorkflowInput = {
  description?: string | null | undefined;
  isActive?: boolean;
  name: string;
};

export type CreditAllocationPeriodEnum =
  | 'FOREVER'
  | 'MONTHLY';

export type CreditFeatureEnum =
  | 'CEE_LOOKUP'
  | 'ENHANCE'
  | 'GENERATE_TEXT'
  | 'KN_LV_EXTRACT'
  | 'META_PUBLISH'
  | 'SIGNING_ENVELOPE'
  | 'SOCIAL_POST_RENDER'
  | 'STAGING'
  | 'TRANSLATE'
  | 'YOUTUBE_EXPORT';

export type CreditLedgerEntryTypeEnum =
  | 'CONSUME'
  | 'EXPIRE'
  | 'GRANT'
  | 'INVOICE_ACCRUAL'
  | 'REFUND'
  | 'TOPUP';

export type CreditLedgerStatusEnum =
  | 'PENDING'
  | 'POSTED';

export type CreditWalletKindEnum =
  | 'ORG_POOL'
  | 'PERSONAL';

export type DateTimeFilter = {
  exact?: string | null | undefined;
  ge?: string | null | undefined;
  gt?: string | null | undefined;
  in_?: Array<string> | null | undefined;
  isnull?: boolean | null | undefined;
  le?: string | null | undefined;
  lt?: string | null | undefined;
  notIn_?: Array<string> | null | undefined;
  range?: Array<string> | null | undefined;
};

export type DealFilter = {
  assignedAgentId?: IdFilter | null | undefined;
  clientId?: IdFilter | null | undefined;
  createdAt?: DateTimeFilter | null | undefined;
  id?: IdFilter | null | undefined;
  pipelineId?: IdFilter | null | undefined;
  propertyId?: IdFilter | null | undefined;
  stageId?: IdFilter | null | undefined;
  title?: StringFilter | null | undefined;
  transactionType?: TransactionTypeEnumEnumFilter | null | undefined;
};

export type DealOrder = {
  createdAt?: Ordering | null | undefined;
  expectedCloseDate?: Ordering | null | undefined;
  nextStepAt?: Ordering | null | undefined;
  title?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type DeleteWorkflowInput = {
  workflowId: string | number;
};

export type DmsEntityKindEnum =
  | 'CLIENT'
  | 'DEAL'
  | 'PROPERTY';

export type DmsNodeKindEnum =
  | 'FILE'
  | 'FOLDER';

export type DmsShareScopeEnum =
  | 'FILE'
  | 'FOLDER';

export type DocumentCategoryEnum =
  | 'AUCTION_ADVERTISEMENT'
  | 'AUCTION_REVIEW'
  | 'CONTRACT'
  | 'ENERGY_CERTIFICATE'
  | 'FINANCING'
  | 'FLOORPLAN'
  | 'IDENTITY'
  | 'LEGAL'
  | 'OTHER'
  | 'PHOTO'
  | 'RESERVATION';

export type ElectricityEnum =
  | 'NO_CONNECTION'
  | 'V120'
  | 'V230'
  | 'V400';

export type EnergyClassEnum =
  | 'A'
  | 'B'
  | 'C'
  | 'D'
  | 'E'
  | 'F'
  | 'G'
  | 'UNKNOWN';

export type EnergyClassEnumEnumFilter = {
  exact?: EnergyClassEnum | null | undefined;
  in_?: Array<EnergyClassEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<EnergyClassEnum> | null | undefined;
};

export type EnergyPerformanceCertificateEnum =
  | 'ACT_78_2013'
  | 'ACT_148_2007'
  | 'ACT_264_2020';

export type EnhanceModeEnum =
  | 'ALIGN'
  | 'AUTO'
  | 'CROP'
  | 'DENOISE'
  | 'LIGHTING';

export type ExportPropertyToSrealityInput = {
  connectionId?: string | number | null | undefined;
  dryRun?: boolean | null | undefined;
  propertyId: string | number;
};

export type FetchKnLvExcerptInput = {
  clientId?: string | number | null | undefined;
  idempotencyKey?: string | null | undefined;
  kuKod?: number | null | undefined;
  lvCislo?: number | null | undefined;
  lvId?: number | null | undefined;
  propertyId?: string | number | null | undefined;
};

export type FinalizeAvatarInput = {
  storageKey: string;
};

export type FinalizeOrgLogoInput = {
  storageKey: string;
};

export type FinancingStatusEnum =
  | 'CASH'
  | 'MORTGAGE_IN_PROGRESS'
  | 'MORTGAGE_PREAPPROVED'
  | 'NOT_STARTED'
  | 'OTHER'
  | 'UNKNOWN';

export type FlatClassEnum =
  | 'ATTIC'
  | 'LOFT'
  | 'MEZZANINE'
  | 'SINGLE_LEVEL';

export type ForceUnlockWorkflowInput = {
  workflowId: string | number;
};

export type ForkRenderTemplateInput = {
  id: string | number;
  name?: string | null | undefined;
  slug?: string | null | undefined;
};

export type FurnishedEnum =
  | 'NO'
  | 'PARTIAL'
  | 'YES';

export type GasSupplyEnum =
  | 'INDIVIDUALNI'
  | 'PLYNOVOD';

export type GenerateCustomSocialPostImageInput = {
  agencyName?: string | null | undefined;
  city?: string | null | undefined;
  heroDocumentId?: string | number | null | undefined;
  priceDisplay?: string | null | undefined;
  templateId?: string | null | undefined;
  title: string;
};

export type GenerateLegalDocumentInput = {
  id: string | number;
  locale?: string;
  overrides?: unknown;
  templateId?: string | null | undefined;
};

export type GenerateSocialCaptionInput = {
  idempotencyKey?: string | null | undefined;
  locale?: string;
  platform?: string;
  propertyId: string | number;
  tone?: string | null | undefined;
};

export type GenerateSocialPostImageInput = {
  locale?: string;
  overrides?: unknown;
  propertyId: string | number;
  templateId?: string | null | undefined;
};

export type GenerateViewingProtocolInput = {
  attendees?: Array<string> | null | undefined;
  locale?: string;
  notes?: string | null | undefined;
  taskId: string | number;
  templateId?: string | null | undefined;
};

export type GrantClientConsentInput = {
  channel: ConsentChannelEnum;
  clientId: string | number;
  consentType?: ConsentTypeEnum;
  source: string;
  wording?: string | null | undefined;
};

export type GullyEnum =
  | 'COV_PRO_CELY_OBJEKT'
  | 'JIMKA'
  | 'SEPTIK'
  | 'TRATIVOD'
  | 'VEREJNA_KANALIZACE';

export type HeatingElementEnum =
  | 'AKUMULACNI_KAMNA'
  | 'INFRAPANEL'
  | 'JINE'
  | 'KAMNA'
  | 'KLIMATIZACE'
  | 'KOTEL_NA_TUHA_PALIVA'
  | 'KRB'
  | 'KRBOVA_KAMNA'
  | 'PODLAHOVE_VYTAPENI'
  | 'PRIMOTOP'
  | 'RADIATORY'
  | 'WAW';

export type HeatingSourceEnum =
  | 'AKUMULACNI_KAMNA'
  | 'CENTRALNI_DALKOVE'
  | 'ELEKTROKOTEL'
  | 'INFRAPANEL'
  | 'JINE'
  | 'KAMNA'
  | 'KOTEL_NA_TUHA_PALIVA'
  | 'KRB'
  | 'KRBOVA_KAMNA'
  | 'PARA_S_VYMENIKEM'
  | 'PLYNOVY_KONDENZACNI_KOTEL'
  | 'PLYNOVY_KOTEL'
  | 'PRIMOTOP'
  | 'TEPELNE_CERPADLO'
  | 'USTREDNI_DALKOVE'
  | 'WAW';

export type IdFilter = {
  exact?: string | number | null | undefined;
  in_?: Array<string | number> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<string | number> | null | undefined;
};

export type ImageVariantKindEnum =
  | 'ENHANCED'
  | 'STAGING';

export type IntFilter = {
  exact?: number | null | undefined;
  ge?: number | null | undefined;
  gt?: number | null | undefined;
  in_?: Array<number> | null | undefined;
  isnull?: boolean | null | undefined;
  le?: number | null | undefined;
  lt?: number | null | undefined;
  notIn_?: Array<number> | null | undefined;
  range?: Array<number> | null | undefined;
};

export type IntegrationAuthTypeEnum =
  | 'API_KEY'
  | 'BASIC'
  | 'BEARER'
  | 'CUSTOM'
  | 'NONE'
  | 'OAUTH2';

export type IntegrationDirectionEnum =
  | 'BIDIRECTIONAL'
  | 'EXPORT'
  | 'IMPORT';

export type IntegrationProviderEnum =
  | 'ANNONCE'
  | 'API_GENERIC'
  | 'ARKCR'
  | 'AVIZO'
  | 'B3_TECHNOLOGY'
  | 'BAZOS'
  | 'BYDLENI_CZ'
  | 'BYTY_A_DOMY'
  | 'BYTY_CZ'
  | 'BYZNYS_NA_PRODEJ'
  | 'CESKE_REALITY'
  | 'CINCINK'
  | 'COMPETITOR_IMPORT'
  | 'DIGIREALITY'
  | 'DOBRE_NEMOVITOSTI'
  | 'DOMONAUT'
  | 'DOMUHQ'
  | 'DOMY_BYTY_POZEMKY'
  | 'EMAIL'
  | 'EUROBYDLENI'
  | 'EXPATS'
  | 'EXPERTREALITY'
  | 'GOOGLE_ADS'
  | 'GOOGLE_BUSINESS'
  | 'GOOGLE_CALENDAR'
  | 'GREEN_ACRES'
  | 'HOMER'
  | 'IDEALISTA'
  | 'IDNES_REALITY'
  | 'IMMOBILIENSCOUT24'
  | 'INZERCEREALITY'
  | 'JENREALITY'
  | 'LEVNE_BYDLENI'
  | 'LOVEC_REALIT'
  | 'META'
  | 'NEHNUTELNOSTI_SK'
  | 'NEMOVITOSTI_CZ'
  | 'NETREALIT'
  | 'OTHER'
  | 'POZEMKY_CZ'
  | 'PRAHANOI'
  | 'PRAZSKE_REALITY'
  | 'RBREALITY'
  | 'REALCITY'
  | 'REALHIT'
  | 'REALINGO'
  | 'REALITES'
  | 'REALITNI_ESO'
  | 'REALITNI_KOMORA'
  | 'REALITNI_SEO'
  | 'REALITNI_TRH'
  | 'REALITNI_TRZNICE'
  | 'REALITYMIX'
  | 'REALITY_CECHY'
  | 'REALITY_CZ'
  | 'REALITY_HRADEC_KRALOVE'
  | 'REALITY_MORAVA'
  | 'REALS'
  | 'RIGHTMOVE'
  | 'SIDLOREALIT'
  | 'SKLIK'
  | 'SREALITY'
  | 'SUPA24'
  | 'SUPERHOME'
  | 'ULOVDOMOV'
  | 'VIAREALITY'
  | 'WEB'
  | 'WEB_FORM'
  | 'XML_FEED';

export type IntegrationRunStatusEnum =
  | 'CANCELLED'
  | 'FAILED'
  | 'PARTIAL_SUCCESS'
  | 'QUEUED'
  | 'RUNNING'
  | 'SUCCESS';

export type IntegrationSyncStatusEnum =
  | 'CONFLICT'
  | 'ERROR'
  | 'PENDING'
  | 'SKIPPED'
  | 'SYNCED';

export type InternetConnectionTypeEnum =
  | 'ADSL'
  | 'OPTIKA'
  | 'VDSL'
  | 'VZDUCHEM';

export type InvestmentHorizonEnum =
  | 'LONG'
  | 'MEDIUM'
  | 'OTHER'
  | 'SHORT';

export type InvestmentStrategyEnum =
  | 'BRRRR'
  | 'BUY_AND_HOLD'
  | 'DEVELOPMENT'
  | 'FIX_AND_FLIP'
  | 'OTHER'
  | 'RENTAL_INCOME';

export type InvestorFinancingMethodEnum =
  | 'CASH'
  | 'COMBINATION'
  | 'MORTGAGE'
  | 'OTHER'
  | 'PRIVATE_EQUITY';

export type InvestorRiskLevelEnum =
  | 'HIGH'
  | 'LOW'
  | 'MEDIUM'
  | 'OTHER';

export type InvoiceStatusEnum =
  | 'DRAFT'
  | 'ISSUED'
  | 'PAID'
  | 'VOID';

export type IsirLookupInput = {
  activeOnly?: boolean;
  birthDate?: string | null | undefined;
  clientId?: string | number | null | undefined;
  firstName?: string | null | undefined;
  ico?: string | null | undefined;
  lastName?: string | null | undefined;
  maxResults?: number;
};

export type LeadFilter = {
  assignedAgentId?: IdFilter | null | undefined;
  clientId?: IdFilter | null | undefined;
  createdAt?: DateTimeFilter | null | undefined;
  email?: StringFilter | null | undefined;
  externalId?: StringFilter | null | undefined;
  id?: IdFilter | null | undefined;
  nameSearch?: string | null | undefined;
  phone?: StringFilter | null | undefined;
  propertyId?: IdFilter | null | undefined;
  source?: LeadSourceEnumEnumFilter | null | undefined;
  status?: LeadStatusEnumEnumFilter | null | undefined;
};

export type LeadOrder = {
  assignedAgentId?: Ordering | null | undefined;
  createdAt?: Ordering | null | undefined;
  email?: Ordering | null | undefined;
  firstName?: Ordering | null | undefined;
  lastName?: Ordering | null | undefined;
  score?: Ordering | null | undefined;
  source?: Ordering | null | undefined;
  status?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type LeadSourceEnum =
  | 'CAMPAIGN'
  | 'EMAIL'
  | 'FACEBOOK'
  | 'GOOGLE_ADS'
  | 'IMPORT'
  | 'INSTAGRAM'
  | 'LINKEDIN'
  | 'OTHER'
  | 'PHONE'
  | 'RECOMMENDATION'
  | 'SKLIK'
  | 'SREALITY'
  | 'TIKTOK'
  | 'WALK_IN'
  | 'WEB_FORM';

export type LeadSourceEnumEnumFilter = {
  exact?: LeadSourceEnum | null | undefined;
  in_?: Array<LeadSourceEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<LeadSourceEnum> | null | undefined;
};

export type LeadStatusEnum =
  | 'CONTACTED'
  | 'CONVERTED'
  | 'LOST'
  | 'NEW'
  | 'QUALIFIED'
  | 'SPAM';

export type LeadStatusEnumEnumFilter = {
  exact?: LeadStatusEnum | null | undefined;
  in_?: Array<LeadStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<LeadStatusEnum> | null | undefined;
};

export type LegalEntityInput = {
  address?: string | null | undefined;
  dic?: string | null | undefined;
  email?: string | null | undefined;
  ico?: string | null | undefined;
  name: string;
  phone?: string | null | undefined;
  website?: string | null | undefined;
};

export type LicenseBundlingEnum =
  | 'BUNDLED'
  | 'SELF_MANAGED';

export type LicenseStatusEnum =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'EXPIRED'
  | 'SUSPENDED';

export type LiftContactSuppressionInput = {
  id: string | number;
};

export type ListingExtraInfoEnum =
  | 'RESERVED'
  | 'SOLD';

export type LocationPrivacyEnum =
  | 'APPROXIMATE'
  | 'EXACT'
  | 'HIDDEN';

export type LocationPrivacyEnumEnumFilter = {
  exact?: LocationPrivacyEnum | null | undefined;
  in_?: Array<LocationPrivacyEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<LocationPrivacyEnum> | null | undefined;
};

export type LockWorkflowInput = {
  version: number;
  workflowId: string | number;
};

export type LoginInput = {
  loginEmail: string;
  organizationSlug?: string | null | undefined;
  password: string;
  totpCode?: string | null | undefined;
};

export type LustraceRegistryEnum =
  | 'ARES'
  | 'CEE'
  | 'ISIR'
  | 'KN'
  | 'WSDP';

export type MarkDealLostInput = {
  id: string | number;
  lostReason: string;
  note?: string | null | undefined;
};

export type MarkDealWonInput = {
  actualValue?: string | null | undefined;
  id: string | number;
  note?: string | null | undefined;
};

export type MarkUnavailableInput = {
  propertyId: string | number;
  status: PropertyStatusEnum;
};

export type MergeClientsInput = {
  reason?: string | null | undefined;
  sourceClientId: string | number;
  targetClientId: string | number;
};

export type MetaPublishAccountKindEnum =
  | 'ORGANIZATION'
  | 'PERSONAL';

export type NeighbourhoodPresenceEnum =
  | 'HEALTHCARE'
  | 'HIGHWAY'
  | 'KINDERGARTEN'
  | 'PARK'
  | 'PHARMACY'
  | 'POST_OFFICE'
  | 'PUBLIC_TRANSPORT'
  | 'RESTAURANTS'
  | 'SCHOOL'
  | 'SHOPS'
  | 'SUPERMARKET'
  | 'TRAIN';

export type NotificationCategoryEnum =
  | 'DIGEST'
  | 'MARKETING'
  | 'REACTIVATION'
  | 'TRANSACTIONAL'
  | 'VIEWING';

export type NotificationKindEnum =
  | 'CHAT_MESSAGE'
  | 'CLIENT_ASSIGNED'
  | 'CONTRACT_EXPIRING'
  | 'DEAL_ASSIGNED'
  | 'DEAL_STAGE_CHANGED'
  | 'DEMAND_MATCH'
  | 'DOCUMENT_UPLOADED'
  | 'INTEGRATION_FAILED'
  | 'LEAD_ASSIGNED'
  | 'LEAD_CREATED'
  | 'OTHER'
  | 'SYSTEM'
  | 'TASK_ASSIGNED'
  | 'TASK_DUE'
  | 'TASK_REMINDER';

/** Numeric comparison operators (price, area). */
export type NumericFilter = {
  exact?: string | null | undefined;
  ge?: string | null | undefined;
  gt?: string | null | undefined;
  in_?: Array<string> | null | undefined;
  isnull?: boolean | null | undefined;
  le?: string | null | undefined;
  lt?: string | null | undefined;
  notIn_?: Array<string> | null | undefined;
  range?: Array<string> | null | undefined;
};

export type ObjectKindEnum =
  | 'CORNER'
  | 'DETACHED'
  | 'IN_BLOCK'
  | 'TERRACED';

export type ObjectLocationEnum =
  | 'BUSY_PART'
  | 'HOUSING_ESTATE'
  | 'ISOLATED'
  | 'QUIET_PART'
  | 'SEMI_ISOLATED'
  | 'TOWN_CENTER'
  | 'TOWN_EDGE';

export type ObjectTypeEnum =
  | 'GROUND_FLOOR'
  | 'MULTI_STOREY';

export type Ordering =
  | 'ASC'
  | 'DESC';

export type OrgLogoUploadIntentInput = {
  contentType: string;
  sizeBytes?: number | null | undefined;
};

export type OrganizationModelTypeEnum =
  | 'FRANCHISEE'
  | 'FRANCHISOR'
  | 'STANDALONE';

export type OrganizationSubscriptionStatusEnum =
  | 'ACTIVE'
  | 'CANCELLED'
  | 'EXPIRED'
  | 'TRIAL';

export type OutreachChannelEnum =
  | 'CALL'
  | 'EMAIL'
  | 'PUSH'
  | 'SMS';

export type OwnershipTypeEnum =
  | 'COOPERATIVE'
  | 'LEGAL_ENTITY'
  | 'MUNICIPALITY'
  | 'NATURAL_PERSON'
  | 'STATE';

export type OwnershipTypeEnumEnumFilter = {
  exact?: OwnershipTypeEnum | null | undefined;
  in_?: Array<OwnershipTypeEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<OwnershipTypeEnum> | null | undefined;
};

export type PaymentStatusEnum =
  | 'CANCELLED'
  | 'DUE'
  | 'PAID'
  | 'PARTIALLY_PAID'
  | 'PENDING'
  | 'REFUNDED';

export type PaymentTypeEnum =
  | 'COMMISSION'
  | 'OTHER'
  | 'RESERVATION_DEPOSIT'
  | 'SECURITY_DEPOSIT';

export type PhaseDistributionEnum =
  | 'SINGLE'
  | 'THREE';

export type PhotoRoomTypeEnum =
  | 'BALCONY'
  | 'BATHROOM'
  | 'BEDROOM'
  | 'CELLAR'
  | 'DETAILS'
  | 'DINING_ROOM'
  | 'DOCUMENTS'
  | 'DRESSING_ROOM'
  | 'EMPTY_ROOM'
  | 'ENERGY_LABEL'
  | 'FLOOR_PLAN_2D'
  | 'FLOOR_PLAN_3D'
  | 'GARDEN'
  | 'GYM'
  | 'HALLWAY'
  | 'KITCHEN'
  | 'LAUNDRY'
  | 'LIVING_ROOM'
  | 'LIVING_ROOM_WITH_DINING'
  | 'MAP_LOCATION'
  | 'MOUNTAIN_VIEW'
  | 'OFFICE'
  | 'OUTBUILDING'
  | 'OUTDOOR_HOUSE'
  | 'PANTRY'
  | 'PARKING'
  | 'POOL'
  | 'RECEPTION'
  | 'STAIRS'
  | 'TERRACE'
  | 'UNRELATED'
  | 'WATER_VIEW';

export type PolishSocialCaptionInput = {
  caption: string;
  idempotencyKey?: string | null | undefined;
  locale?: string;
  platform?: string;
  propertyId: string | number;
};

export type PortalBumpPriorityEnum =
  | 'HIGH'
  | 'LOW'
  | 'NORMAL';

export type PortalIdnesCredentialsInput = {
  baseUrl?: string | null | undefined;
  dryRun?: boolean;
  ftpHost?: string | null | undefined;
  ftpPassword?: string | null | undefined;
  ftpUser?: string | null | undefined;
  login: string;
  password?: string | null | undefined;
  replaceCredentials?: boolean;
  useTest?: boolean;
};

export type PortalMismatchTypeEnum =
  | 'MISSING_PUBLICATION'
  | 'STALE_VERIFICATION'
  | 'STATE_CONFLICT';

export type PortalNativeCredentialsInput = {
  acknowledgeStub?: boolean;
};

export type PortalPublicationEventKindEnum =
  | 'MANUAL_VERIFY'
  | 'RECONCILE'
  | 'REMEDIATE'
  | 'VERIFY';

export type PortalPublicationStatusEnum =
  | 'ERROR'
  | 'NOT_PUBLISHED'
  | 'PUBLISHED'
  | 'RETRACTED'
  | 'UNKNOWN';

export type PortalVerificationCapabilityEnum =
  | 'API_CHECK'
  | 'PUBLIC_PAGE'
  | 'UNSUPPORTED';

export type PortalXmlFeedCredentialsInput = {
  advertLifetime?: number | null | undefined;
  rotateKey?: boolean;
};

export type PortalXmlrpcCredentialsInput = {
  advertLifetime?: number | null | undefined;
  clientId: number;
  dryRun?: boolean;
  endpoint?: string | null | undefined;
  password?: string | null | undefined;
  passwordMd5?: string | null | undefined;
  replaceCredentials?: boolean;
  softwareKey: string;
};

export type PreferredCommunicationMethodEnum =
  | 'EMAIL'
  | 'IN_PERSON'
  | 'OTHER'
  | 'PHONE'
  | 'SMS'
  | 'WHATSAPP';

export type PreviewRenderTemplateInput = {
  id?: string | number | null | undefined;
  kind?: RenderTemplateKindEnum | null | undefined;
  layout?: unknown;
  overrides?: unknown;
  propertyId?: string | number | null | undefined;
  sampleData?: unknown;
  slug?: string | null | undefined;
  source?: string | null | undefined;
};

export type PriceUnitEnum =
  | 'DAY'
  | 'HOUR'
  | 'M2'
  | 'M2_DAY'
  | 'M2_HOUR'
  | 'M2_MONTH'
  | 'M2_YEAR'
  | 'MONTH'
  | 'PROPERTY'
  | 'YEAR';

export type PriorityEnum =
  | 'HIGH'
  | 'LOW'
  | 'NORMAL'
  | 'URGENT';

export type PriorityEnumEnumFilter = {
  exact?: PriorityEnum | null | undefined;
  in_?: Array<PriorityEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PriorityEnum> | null | undefined;
};

export type PropertyAttributeInput = {
  dataType?: string;
  key: string;
  value: string;
};

export type PropertyCategoryEnum =
  | 'AUCTION'
  | 'EXCHANGE'
  | 'RENT'
  | 'SALE'
  | 'SALE_OR_RENT'
  | 'SHARES'
  | 'SUBLET';

export type PropertyCategoryEnumEnumFilter = {
  exact?: PropertyCategoryEnum | null | undefined;
  in_?: Array<PropertyCategoryEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PropertyCategoryEnum> | null | undefined;
};

export type PropertyConditionEnum =
  | 'AVERAGE'
  | 'GOOD'
  | 'NEW'
  | 'OTHER'
  | 'TO_RENOVATE'
  | 'UNDER_CONSTRUCTION'
  | 'VERY_GOOD';

export type PropertyContractStatusEnum =
  | 'ACTIVE'
  | 'COMPLETED'
  | 'DRAFT'
  | 'EXPIRED'
  | 'TERMINATED';

export type PropertyContractTypeEnum =
  | 'EXCLUSIVE_REPRESENTATION'
  | 'LEASE'
  | 'LISTING'
  | 'OTHER'
  | 'RESERVATION'
  | 'SALE_PURCHASE';

/** Declarative filters for PropertyType list/connection */
export type PropertyFilter = {
  assignedAgentId?: IdFilter | null | undefined;
  category?: PropertyCategoryEnumEnumFilter | null | undefined;
  citySearch?: string | null | undefined;
  createdAt?: DateTimeFilter | null | undefined;
  currency?: StringFilter | null | undefined;
  energyClass?: EnergyClassEnumEnumFilter | null | undefined;
  exclusive?: boolean | null | undefined;
  exportToPortals?: BooleanFilter | null | undefined;
  floor?: IntFilter | null | undefined;
  floorArea?: NumericFilter | null | undefined;
  id?: IdFilter | null | undefined;
  isPublished?: BooleanFilter | null | undefined;
  layout?: PropertyLayoutEnumEnumFilter | null | undefined;
  listingCode?: string | null | undefined;
  locationPrivacy?: LocationPrivacyEnumEnumFilter | null | undefined;
  ownerContactId?: IdFilter | null | undefined;
  ownershipType?: OwnershipTypeEnumEnumFilter | null | undefined;
  price?: NumericFilter | null | undefined;
  propertyType?: PropertyTypeEnumEnumFilter | null | undefined;
  publishedAt?: DateTimeFilter | null | undefined;
  status?: PropertyStatusEnumEnumFilter | null | undefined;
  streetSearch?: string | null | undefined;
  titleSearch?: string | null | undefined;
  updatedAt?: DateTimeFilter | null | undefined;
  usableArea?: NumericFilter | null | undefined;
  webVisibility?: PropertyWebVisibilityEnumEnumFilter | null | undefined;
  yearBuilt?: IntFilter | null | undefined;
};

export type PropertyLayoutEnum =
  | 'ATYPICAL'
  | 'FIVE_KK'
  | 'FIVE_PLUS_ONE'
  | 'FOUR_KK'
  | 'FOUR_PLUS_ONE'
  | 'ONE_KK'
  | 'ONE_PLUS_ONE'
  | 'SIX_PLUS'
  | 'STUDIO'
  | 'THREE_KK'
  | 'THREE_PLUS_ONE'
  | 'TWO_KK'
  | 'TWO_PLUS_ONE';

export type PropertyLayoutEnumEnumFilter = {
  exact?: PropertyLayoutEnum | null | undefined;
  in_?: Array<PropertyLayoutEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PropertyLayoutEnum> | null | undefined;
};

export type PropertyLinkTypeEnum =
  | 'FACEBOOK'
  | 'INSTAGRAM'
  | 'MATTERPORT'
  | 'OTHER'
  | 'VIRTUAL_TOUR'
  | 'WEBSITE'
  | 'YOUTUBE';

export type PropertyLocationInput = {
  addressLine: string;
  city: string;
  countryCode?: string;
  district?: string | null | undefined;
  houseNumber?: string | null | undefined;
  knBuildingId?: number | null | undefined;
  knLvId?: number | null | undefined;
  kuKod?: number | null | undefined;
  latitude: number;
  longitude: number;
  lvCislo?: number | null | undefined;
  orientationNumber?: string | null | undefined;
  postalCode?: string | null | undefined;
  region?: string | null | undefined;
  ruian?: number | null | undefined;
  ruianLevel?: number | null | undefined;
  street?: string | null | undefined;
  uir?: number | null | undefined;
  uirLevel?: number | null | undefined;
};

export type PropertyMarketDetailsInput = {
  advertSubtype?: number | null | undefined;
  annuity?: number | null | undefined;
  auctionAdvertisementDocumentId?: string | number | null | undefined;
  auctionDate?: string | null | undefined;
  auctionDateTour?: string | null | undefined;
  auctionDateTour2?: string | null | undefined;
  auctionKind?: AuctionKindEnum | null | undefined;
  auctionPlace?: string | null | undefined;
  auctionReviewDocumentId?: string | number | null | undefined;
  beginningDate?: string | null | undefined;
  bidding?: BiddingEnum | null | undefined;
  circuitBreaker?: CircuitBreakerEnum | null | undefined;
  commission?: string | null | undefined;
  costOfLiving?: string | null | undefined;
  easyAccess?: CodebookYesNoEnum | null | undefined;
  electricity?: Array<ElectricityEnum> | null | undefined;
  energyPerformanceCertificate?: EnergyPerformanceCertificateEnum | null | undefined;
  energyPerformanceDocumentId?: string | number | null | undefined;
  energyPerformanceSummary?: string | null | undefined;
  exclusiveListing?: boolean | null | undefined;
  extraAttributes?: unknown;
  finishDate?: string | null | undefined;
  firstTourDate?: string | null | undefined;
  firstTourDateTo?: string | null | undefined;
  flatClass?: FlatClassEnum | null | undefined;
  ftvPanels?: boolean | null | undefined;
  gas?: Array<GasSupplyEnum> | null | undefined;
  gully?: Array<GullyEnum> | null | undefined;
  heatingElement?: Array<HeatingElementEnum> | null | undefined;
  heatingSource?: Array<HeatingSourceEnum> | null | undefined;
  internetConnectionProvider?: string | null | undefined;
  internetConnectionSpeed?: number | null | undefined;
  internetConnectionType?: Array<InternetConnectionTypeEnum> | null | undefined;
  listingCode?: string | null | undefined;
  listingExtraInfo?: ListingExtraInfoEnum | null | undefined;
  lowEnergy?: boolean | null | undefined;
  mapyPanoramaUrl?: string | null | undefined;
  matterportUrl?: string | null | undefined;
  mortgage?: boolean | null | undefined;
  mortgagePercent?: string | null | undefined;
  neighbourhoodPresence?: Array<NeighbourhoodPresenceEnum> | null | undefined;
  noliveTotalArea?: string | null | undefined;
  numOwners?: number | null | undefined;
  objectKind?: ObjectKindEnum | null | undefined;
  objectLocation?: ObjectLocationEnum | null | undefined;
  officesArea?: string | null | undefined;
  panorama?: number | null | undefined;
  personal?: CodebookYesNoEnum | null | undefined;
  phaseDistributions?: PhaseDistributionEnum | null | undefined;
  priceAuctionPrincipal?: string | null | undefined;
  priceExpertReport?: string | null | undefined;
  priceHidden?: boolean | null | undefined;
  priceMinimumBid?: string | null | undefined;
  priceNegotiable?: boolean | null | undefined;
  priceOnRequest?: boolean | null | undefined;
  productionArea?: string | null | undefined;
  projectRkid?: string | null | undefined;
  protection?: ProtectionEnum | null | undefined;
  refundableDeposit?: string | null | undefined;
  roadType?: Array<RoadTypeEnum> | null | undefined;
  saleDate?: string | null | undefined;
  shareCommonAreaDenominator?: number | null | undefined;
  shareCommonAreaNumerator?: number | null | undefined;
  shareDenominator?: number | null | undefined;
  shareNumerator?: number | null | undefined;
  shopArea?: string | null | undefined;
  solarPanels?: boolean | null | undefined;
  sporPercent?: string | null | undefined;
  steps?: string | null | undefined;
  storeArea?: string | null | undefined;
  surroundingsType?: SurroundingsTypeEnum | null | undefined;
  telecommunication?: Array<TelecommunicationEnum> | null | undefined;
  tenantNotPayCommission?: boolean | null | undefined;
  transport?: Array<TransportEnum> | null | undefined;
  water?: Array<WaterSupplyEnum> | null | undefined;
  waterHeatSource?: Array<WaterHeatSourceEnum> | null | undefined;
  wellType?: Array<WellTypeEnum> | null | undefined;
  workshopArea?: string | null | undefined;
};

export type PropertyMessageDirectionEnum =
  | 'INBOUND'
  | 'OUTBOUND';

export type PropertyMessageStatusEnum =
  | 'ARCHIVED'
  | 'NEW'
  | 'READ'
  | 'REPLIED';

/** Declarative ordering for PropertyType list/connection */
export type PropertyOrder = {
  assignedAgentId?: Ordering | null | undefined;
  category?: Ordering | null | undefined;
  createdAt?: Ordering | null | undefined;
  isPublished?: Ordering | null | undefined;
  /** Sort by stored price. Requires filters.category of a single money kind (SALE vs RENT). Prefer priceSale / rentMonthly for mixed lists. */
  price?: Ordering | null | undefined;
  /** Purchase-price sort (SALE/AUCTION/SHARES/EXCHANGE/SALE_OR_RENT). Rent listings sort as null (nulls last). */
  priceSale?: Ordering | null | undefined;
  propertyType?: Ordering | null | undefined;
  publishedAt?: Ordering | null | undefined;
  /** Monthly-rent sort via rent_price (RENT/SUBLET/SALE_OR_RENT). Sale listings sort as null (nulls last). */
  rentMonthly?: Ordering | null | undefined;
  status?: Ordering | null | undefined;
  title?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type PropertyPartyRoleEnum =
  | 'BUYER'
  | 'LANDLORD'
  | 'OTHER'
  | 'SELLER'
  | 'TENANT';

export type PropertyStatusEnum =
  | 'ACTIVE'
  | 'ARCHIVED'
  | 'DRAFT'
  | 'RENTED'
  | 'RESERVED'
  | 'SOLD';

export type PropertyStatusEnumEnumFilter = {
  exact?: PropertyStatusEnum | null | undefined;
  in_?: Array<PropertyStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PropertyStatusEnum> | null | undefined;
};

export type PropertyTypeEnum =
  | 'APARTMENT'
  | 'COMMERCIAL'
  | 'GARAGE'
  | 'HOUSE'
  | 'LAND'
  | 'OFFICE'
  | 'OTHER';

export type PropertyTypeEnumEnumFilter = {
  exact?: PropertyTypeEnum | null | undefined;
  in_?: Array<PropertyTypeEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PropertyTypeEnum> | null | undefined;
};

export type PropertyWebVisibilityEnum =
  | 'FEATURED'
  | 'PUBLIC'
  | 'UNLISTED';

export type PropertyWebVisibilityEnumEnumFilter = {
  exact?: PropertyWebVisibilityEnum | null | undefined;
  in_?: Array<PropertyWebVisibilityEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<PropertyWebVisibilityEnum> | null | undefined;
};

export type ProtectionEnum =
  | 'CHKO'
  | 'CULTURAL_MONUMENT'
  | 'HERITAGE_RESERVE'
  | 'HERITAGE_ZONE'
  | 'NATIONAL_CULTURAL_MONUMENT'
  | 'NATIONAL_PARK'
  | 'PROTECTION_ZONE';

/** Axis-aligned map viewport (WGS84). */
export type PublicBBoxInput = {
  maxLat: number;
  maxLng: number;
  minLat: number;
  minLng: number;
};

export type PublicBlogSearchInput = {
  limit?: number | null | undefined;
  locale?: string;
  offset?: number | null | undefined;
  organizationSlug?: string;
  tag?: string | null | undefined;
};

/** Center + radius filter (PostGIS geography, meters). */
export type PublicNearInput = {
  lat: number;
  lng: number;
  /** Search radius in kilometers (max 200). */
  radiusKm: number;
};

export type PublicPropertySearchInput = {
  areaMax?: string | null | undefined;
  areaMin?: string | null | undefined;
  bbox?: PublicBBoxInput | null | undefined;
  category?: PropertyCategoryEnum | null | undefined;
  layout?: PropertyLayoutEnum | null | undefined;
  limit?: number | null | undefined;
  locale?: string;
  /** City / locality name substring filter */
  locality?: string | null | undefined;
  near?: PublicNearInput | null | undefined;
  offset?: number | null | undefined;
  /** Tenant scope for the catalog. Falls back to the request Host header (Organization.branding.public_host), then the legacy default org. */
  organizationSlug?: string | null | undefined;
  priceMax?: string | null | undefined;
  priceMin?: string | null | undefined;
  propertyType?: PropertyTypeEnum | null | undefined;
};

export type PublishWorkflowInput = {
  version: number;
  workflowId: string | number;
};

export type RefreshInput = {
  refreshToken: string;
};

export type RegenerateWorkflowWebhookTokenInput = {
  id: string | number;
};

export type ReminderChannelEnum =
  | 'APP'
  | 'EMAIL'
  | 'PUSH'
  | 'SMS';

export type RenderAspectRatioEnum =
  | 'A4'
  | 'FACEBOOK_LANDSCAPE'
  | 'INSTAGRAM_PORTRAIT'
  | 'INSTAGRAM_SQUARE';

export type RenderContextTypeEnum =
  | 'CLIENT'
  | 'NONE'
  | 'PROPERTY';

export type RenderFieldGroupEnum =
  | 'AGENT'
  | 'CUSTOM'
  | 'MEDIA'
  | 'META'
  | 'ORGANIZATION'
  | 'PARTIES'
  | 'PROPERTY'
  | 'TERMS';

export type RenderFieldValueTypeEnum =
  | 'DATE'
  | 'IMAGE'
  | 'IMAGE_LIST'
  | 'JSON'
  | 'MONEY'
  | 'SPEC_LIST'
  | 'STRING'
  | 'STRING_LIST'
  | 'TEXT';

export type RenderTemplateFormatEnum =
  | 'PDF'
  | 'PNG';

export type RenderTemplateKindEnum =
  | 'CATALOG_PDF'
  | 'LEGAL'
  | 'SOCIAL_POST'
  | 'VIEWING_PROTOCOL';

export type RenderValueSourceEnum =
  | 'AUTOFILL'
  | 'EMPTY'
  | 'OVERRIDE'
  | 'TEMPLATE_DEFAULT';

export type ReportFilterInput = {
  agentId?: string | number | null | undefined;
  defaultPipeline?: boolean;
  periodEnd?: string | null | undefined;
  periodStart?: string | null | undefined;
  pipelineId?: string | number | null | undefined;
  source?: LeadSourceEnum | null | undefined;
  teamId?: string | number | null | undefined;
};

export type RequestPasswordResetInput = {
  loginEmail: string;
  organizationSlug?: string | null | undefined;
};

export type ResetPasswordInput = {
  newPassword: string;
  token: string;
};

export type RoadTypeEnum =
  | 'ASFALTOVA'
  | 'BETONOVA'
  | 'DLAZDENA'
  | 'NENI_PRIJEZDOVA_KOMUNIKACE'
  | 'NEUPRAVENA'
  | 'SOTOLINA'
  | 'STERKOVA'
  | 'ZPEVNENA';

export type RuianLookupPurposeEnum =
  | 'LOCALITY'
  | 'PROPERTY'
  | 'REQUIREMENT';

export type RunWorkflowInput = {
  id: string | number;
  payload?: unknown;
};

export type SelectGoogleBusinessLocationInput = {
  accountId: string;
  locationId: string;
};

export type SetClientNotificationPreferenceInput = {
  category: NotificationCategoryEnum;
  channel: OutreachChannelEnum;
  clientId: string | number;
  enabled: boolean;
};

export type SetDealNextStepInput = {
  id: string | number;
  nextStep?: string | null | undefined;
  nextStepAt?: string | null | undefined;
};

export type SetPortalBumpScheduleInput = {
  bumpAfterHour?: number | null | undefined;
  bumpDays?: Array<number> | null | undefined;
  bumpEnabled: boolean;
  bumpPriority?: PortalBumpPriorityEnum | null | undefined;
  propertyId: string | number;
  provider: IntegrationProviderEnum;
};

export type SetPortalExportInput = {
  isEnabled: boolean;
  propertyId: string | number;
  provider: IntegrationProviderEnum;
};

export type SmsMessageStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'SENT'
  | 'SKIPPED';

export type StageMappingInput = {
  fromStageId: string | number;
  toStageId: string | number;
};

export type StagingStyleEnum =
  | 'CLASSIC'
  | 'MINIMAL'
  | 'MODERN'
  | 'SCANDI';

export type StartMetaPublishInput = {
  accountKind?: MetaPublishAccountKindEnum | null | undefined;
  caption?: string | null | undefined;
  documentId?: string | number | null | undefined;
  fileSizeBytes?: number | null | undefined;
  mediaType: string;
  mimeType?: string | null | undefined;
  platform: string;
  propertyId?: string | number | null | undefined;
};

export type StartYoutubeExportInput = {
  description?: string | null | undefined;
  fileSizeBytes: number;
  mimeType: string;
  privacyStatus?: string;
  propertyId: string | number;
  title: string;
};

export type StringFilter = {
  contains?: string | null | undefined;
  endswith?: string | null | undefined;
  exact?: string | null | undefined;
  icontains?: string | null | undefined;
  iendswith?: string | null | undefined;
  iexact?: string | null | undefined;
  in_?: Array<string> | null | undefined;
  isnull?: boolean | null | undefined;
  istartswith?: string | null | undefined;
  notIn_?: Array<string> | null | undefined;
  startswith?: string | null | undefined;
};

export type SubscriptionStatusEnum =
  | 'ACTIVE'
  | 'CANCELED'
  | 'PAST_DUE'
  | 'TRIALING';

export type SuppressContactInput = {
  address: string;
  channel: OutreachChannelEnum;
  clientId?: string | number | null | undefined;
  expiresAt?: string | null | undefined;
  note?: string | null | undefined;
  reason?: SuppressionReasonEnum;
  source?: string;
};

export type SuppressionReasonEnum =
  | 'BLACKLIST'
  | 'BOUNCE'
  | 'COMPLAINT'
  | 'LEGAL'
  | 'MANUAL'
  | 'UNSUBSCRIBE';

export type SurroundingsTypeEnum =
  | 'ADMINISTRATIVE'
  | 'COMMERCIAL'
  | 'INDUSTRIAL'
  | 'RECREATIONAL'
  | 'RESIDENTIAL'
  | 'RESIDENTIAL_AND_OFFICES'
  | 'RURAL'
  | 'UNUSED_RECREATIONAL';

export type SyncTaskToCalendarInput = {
  provider?: CalendarProviderEnum;
  taskId: string | number;
};

export type SyncTasksToCalendarInput = {
  assigneeIds?: Array<string | number> | null | undefined;
  end: string;
  includeUnassigned?: boolean;
  provider?: CalendarProviderEnum | null | undefined;
  scope?: CalendarScopeEnum;
  start: string;
  taskIds?: Array<string | number> | null | undefined;
  venueId?: string | number | null | undefined;
};

export type TagFilter = {
  name?: StringFilter | null | undefined;
};

export type TaskCategoryEnum =
  | 'ASSISTANT_REQUEST'
  | 'CALL'
  | 'CONTRACT_SEND'
  | 'CONTRACT_SIGNING'
  | 'DEADLINE'
  | 'DOCUMENT_PREP'
  | 'FOLLOW_UP'
  | 'HOME_STAGING'
  | 'MEETING'
  | 'MORTGAGE_CONTACT'
  | 'OTHER'
  | 'PHOTO_SHOOT'
  | 'PROPERTY_HANDOVER'
  | 'PROPERTY_TAKEOVER'
  | 'RECRUITMENT'
  | 'VIEWING';

export type TaskCategoryEnumEnumFilter = {
  exact?: TaskCategoryEnum | null | undefined;
  in_?: Array<TaskCategoryEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<TaskCategoryEnum> | null | undefined;
};

export type TaskFilter = {
  allDay?: BooleanFilter | null | undefined;
  assigneeId?: IdFilter | null | undefined;
  calendarProvider?: CalendarProviderEnumEnumFilter | null | undefined;
  category?: TaskCategoryEnumEnumFilter | null | undefined;
  clientId?: IdFilter | null | undefined;
  creatorId?: IdFilter | null | undefined;
  dealId?: IdFilter | null | undefined;
  dueAt?: DateTimeFilter | null | undefined;
  endAt?: DateTimeFilter | null | undefined;
  id?: IdFilter | null | undefined;
  leadId?: IdFilter | null | undefined;
  pipelineId?: IdFilter | null | undefined;
  priority?: PriorityEnumEnumFilter | null | undefined;
  propertyId?: IdFilter | null | undefined;
  stageId?: IdFilter | null | undefined;
  startAt?: DateTimeFilter | null | undefined;
  status?: TaskStatusEnumEnumFilter | null | undefined;
  syncStatus?: CalendarSyncStatusEnumEnumFilter | null | undefined;
  title?: StringFilter | null | undefined;
};

export type TaskOrder = {
  assigneeId?: Ordering | null | undefined;
  category?: Ordering | null | undefined;
  createdAt?: Ordering | null | undefined;
  dueAt?: Ordering | null | undefined;
  priority?: Ordering | null | undefined;
  startAt?: Ordering | null | undefined;
  status?: Ordering | null | undefined;
  title?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type TaskPipelineKindEnum =
  | 'ASSISTANT'
  | 'DEAL'
  | 'GENERAL'
  | 'LISTING';

export type TaskReminderInput = {
  channel?: ReminderChannelEnum;
  remindAt: string;
};

export type TaskStatusEnum =
  | 'CANCELLED'
  | 'DONE'
  | 'IN_PROGRESS'
  | 'TODO';

export type TaskStatusEnumEnumFilter = {
  exact?: TaskStatusEnum | null | undefined;
  in_?: Array<TaskStatusEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<TaskStatusEnum> | null | undefined;
};

export type TelecommunicationEnum =
  | 'INTERNET'
  | 'KABELOVA_TELEVIZE'
  | 'KABELOVE_ROZVODY'
  | 'OSTATNI'
  | 'SATELIT'
  | 'TELEFON';

export type TransactionTypeEnum =
  | 'PURCHASE'
  | 'RENT';

export type TransactionTypeEnumEnumFilter = {
  exact?: TransactionTypeEnum | null | undefined;
  in_?: Array<TransactionTypeEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<TransactionTypeEnum> | null | undefined;
};

export type TransitionViewingStatusInput = {
  feedback?: string | null | undefined;
  id: string | number;
  reasonNotPurchased?: ViewingNotPurchaseReasonEnum | null | undefined;
  reasonNote?: string | null | undefined;
  status: ViewingStatusEnum;
};

export type TranslateSocialCaptionInput = {
  caption: string;
  idempotencyKey?: string | null | undefined;
  propertyId: string | number;
  sourceLocale?: string;
  targetLocales: Array<string>;
};

export type TransportEnum =
  | 'BUS'
  | 'HIGHWAY'
  | 'PUBLIC_TRANSIT'
  | 'ROAD'
  | 'TRAIN';

export type TypstAssistModeEnum =
  | 'FROM_BRIEF'
  | 'FROM_DOCUMENT'
  | 'FROM_MARKUP'
  | 'STYLE_TRANSFER';

export type UnlockWorkflowInput = {
  version: number;
  workflowId: string | number;
};

export type UpdateBlogPostInput = {
  authorId?: string | number | null | undefined;
  bodyMd?: unknown;
  content?: unknown;
  excerpt?: unknown;
  id: string | number;
  seoDescription?: unknown;
  seoTitle?: unknown;
  slugs?: unknown;
  status?: BlogPostStatusEnum | null | undefined;
  tags?: unknown;
  title?: unknown;
};

export type UpdateClientInput = {
  assignedAgentId?: string | number | null | undefined;
  contacts?: Array<ClientContactInput> | null | undefined;
  firstName?: string | null | undefined;
  id: string | number;
  investorProfile?: UpsertClientInvestorProfileFields | null | undefined;
  lastName?: string | null | undefined;
  notes?: string | null | undefined;
  preferredCommunicationMethod?: PreferredCommunicationMethodEnum | null | undefined;
  preferredLanguage?: string | null | undefined;
  priority?: PriorityEnum | null | undefined;
  roles?: Array<ClientTypeEnum> | null | undefined;
  source?: LeadSourceEnum | null | undefined;
  status?: ClientStatusEnum | null | undefined;
  tags?: Array<ClientTagInput> | null | undefined;
  type?: ClientTypeEnum | null | undefined;
};

export type UpdateClientRequirementInput = {
  budgetMax?: string | null | undefined;
  budgetMin?: string | null | undefined;
  currency?: string | null | undefined;
  financingStatus?: FinancingStatusEnum | null | undefined;
  id: string | number;
  isActive?: boolean | null | undefined;
  isPrimary?: boolean | null | undefined;
  latitude?: number | null | undefined;
  localityId?: string | number | null | undefined;
  locationAddress?: string | null | undefined;
  longitude?: number | null | undefined;
  name?: string | null | undefined;
  notes?: string | null | undefined;
  preferences?: unknown;
  preferredLayouts?: Array<PropertyLayoutEnum> | null | undefined;
  priority?: PriorityEnum | null | undefined;
  propertyCategory?: PropertyCategoryEnum | null | undefined;
  propertyType?: PropertyTypeEnum | null | undefined;
  radiusKm?: number | null | undefined;
  transactionType?: TransactionTypeEnum | null | undefined;
  usableAreaMax?: string | null | undefined;
  usableAreaMin?: string | null | undefined;
};

export type UpdateDealInput = {
  actualValue?: string | null | undefined;
  assignedAgentId?: string | number | null | undefined;
  currency?: string | null | undefined;
  description?: string | null | undefined;
  expectedCloseDate?: string | null | undefined;
  expectedValue?: string | null | undefined;
  id: string | number;
  leadId?: string | number | null | undefined;
  propertyId?: string | number | null | undefined;
  provisionAmount?: string | null | undefined;
  provisionNotes?: string | null | undefined;
  provisionPercent?: string | null | undefined;
  title?: string | null | undefined;
  transactionType?: TransactionTypeEnum | null | undefined;
};

export type UpdateDealProvisionSplitInput = {
  amount?: string | null | undefined;
  id: string | number;
  notes?: string | null | undefined;
  percent?: string | null | undefined;
  userId?: string | number | null | undefined;
};

export type UpdateIntegrationConnectionInput = {
  credentialsJson?: string | null | undefined;
  id: string | number;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
  settings?: unknown;
};

export type UpdateLeadInput = {
  assignedAgentId?: string | number | null | undefined;
  clientId?: string | number | null | undefined;
  convertedClientId?: string | number | null | undefined;
  email?: string | null | undefined;
  firstName?: string | null | undefined;
  id: string | number;
  lastName?: string | null | undefined;
  lostReason?: string | null | undefined;
  message?: string | null | undefined;
  notes?: string | null | undefined;
  phone?: string | null | undefined;
  propertyId?: string | number | null | undefined;
  score?: number | null | undefined;
  source?: LeadSourceEnum | null | undefined;
  sourceLabel?: string | null | undefined;
  status?: LeadStatusEnum | null | undefined;
};

export type UpdateListingProjectInput = {
  annotation?: string | null | undefined;
  description?: string | null | undefined;
  developerIc?: string | null | undefined;
  id: string | number;
  latitude?: number | null | undefined;
  localityCity?: string | null | undefined;
  localityCitypart?: string | null | undefined;
  localityCo?: string | null | undefined;
  localityCp?: string | null | undefined;
  localityDescription?: string | null | undefined;
  localityRuian?: number | null | undefined;
  localityRuianLevel?: number | null | undefined;
  localityStreet?: string | null | undefined;
  longitude?: number | null | undefined;
  name?: string | null | undefined;
  projectActive?: boolean | null | undefined;
  projectLifetime?: number | null | undefined;
  projectMatterportUrl?: string | null | undefined;
  projectRkid?: string | null | undefined;
  projectUrl?: string | null | undefined;
};

export type UpdatePaymentInput = {
  amount?: string | null | undefined;
  currency?: string | null | undefined;
  documentId?: string | number | null | undefined;
  dueAt?: string | null | undefined;
  id: string | number;
  paidAt?: string | null | undefined;
  payeeUserId?: string | number | null | undefined;
  propertyId?: string | number | null | undefined;
  status?: PaymentStatusEnum | null | undefined;
  type?: PaymentTypeEnum | null | undefined;
  variableSymbol?: string | null | undefined;
};

export type UpdatePropertyContractInput = {
  assignedAgentId?: string | number | null | undefined;
  contractNumber?: string | null | undefined;
  contractType?: PropertyContractTypeEnum | null | undefined;
  counterpartyContactId?: string | number | null | undefined;
  counterpartyName?: string | null | undefined;
  id: string | number;
  metadata?: unknown;
  notes?: string | null | undefined;
  primaryDocumentId?: string | number | null | undefined;
  signedAt?: string | null | undefined;
  status?: PropertyContractStatusEnum | null | undefined;
  terminatedAt?: string | null | undefined;
  title?: string | null | undefined;
  validFrom?: string | null | undefined;
  validUntil?: string | null | undefined;
};

export type UpdatePropertyInput = {
  acceptanceYear?: number | null | undefined;
  apartmentNumber?: number | null | undefined;
  assignedAgentId?: string | number | null | undefined;
  attributes?: Array<PropertyAttributeInput> | null | undefined;
  availableFrom?: string | null | undefined;
  balconyArea?: string | null | undefined;
  basinArea?: string | null | undefined;
  buildingArea?: string | null | undefined;
  buildingType?: BuildingTypeEnum | null | undefined;
  category?: PropertyCategoryEnum | null | undefined;
  ceilingHeight?: string | null | undefined;
  cellarArea?: string | null | undefined;
  condition?: PropertyConditionEnum | null | undefined;
  contractValidUntil?: string | null | undefined;
  currency?: string | null | undefined;
  description?: unknown;
  energyClass?: EnergyClassEnum | null | undefined;
  exportToPortals?: boolean | null | undefined;
  floor?: number | null | undefined;
  floorArea?: string | null | undefined;
  furnished?: FurnishedEnum | null | undefined;
  garageCount?: number | null | undefined;
  gardenArea?: string | null | undefined;
  hasBalcony?: boolean | null | undefined;
  hasBasin?: boolean | null | undefined;
  hasCellar?: boolean | null | undefined;
  hasElevator?: boolean | null | undefined;
  hasGarage?: boolean | null | undefined;
  hasLoggia?: boolean | null | undefined;
  hasParking?: boolean | null | undefined;
  hasTerrace?: boolean | null | undefined;
  id: string | number;
  internalNotes?: string | null | undefined;
  layout?: PropertyLayoutEnum | null | undefined;
  locale?: string | null | undefined;
  location?: PropertyLocationInput | null | undefined;
  locationPrivacy?: LocationPrivacyEnum | null | undefined;
  loggiaArea?: string | null | undefined;
  lotSize?: string | null | undefined;
  marketDetails?: PropertyMarketDetailsInput | null | undefined;
  marketingText?: unknown;
  objectType?: ObjectTypeEnum | null | undefined;
  occupiedUntil?: string | null | undefined;
  ownerContactId?: string | number | null | undefined;
  ownershipType?: OwnershipTypeEnum | null | undefined;
  parkingCount?: number | null | undefined;
  price?: string | null | undefined;
  priceNotes?: unknown;
  priceUnit?: PriceUnitEnum | null | undefined;
  propertyType?: PropertyTypeEnum | null | undefined;
  reconstructionYear?: number | null | undefined;
  rentPrice?: string | null | undefined;
  roomCount?: AdvertRoomCountEnum | null | undefined;
  seoDescription?: unknown;
  seoKeywords?: unknown;
  seoTitle?: unknown;
  slug?: string | null | undefined;
  status?: PropertyStatusEnum | null | undefined;
  terraceArea?: string | null | undefined;
  title?: unknown;
  totalFloors?: number | null | undefined;
  undergroundFloors?: number | null | undefined;
  usableArea?: string | null | undefined;
  webVisibility?: PropertyWebVisibilityEnum | null | undefined;
  yearBuilt?: number | null | undefined;
};

export type UpdatePropertyLinkInput = {
  id: string | number;
  label?: string | null | undefined;
  position?: number | null | undefined;
  type?: PropertyLinkTypeEnum | null | undefined;
  url?: string | null | undefined;
};

export type UpdatePropertyPartyInput = {
  clientId?: string | number | null | undefined;
  displayName?: string | null | undefined;
  id: string | number;
  notes?: string | null | undefined;
  ownershipSharePercent?: string | null | undefined;
  position?: number | null | undefined;
  role?: PropertyPartyRoleEnum | null | undefined;
};

export type UpdatePublicProfileInput = {
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  publicBio?: unknown;
  publicEmail?: string | null | undefined;
  publicPhone?: string | null | undefined;
  publicSlug?: string | null | undefined;
  publicTitle?: string | null | undefined;
  showPublicProfile?: boolean | null | undefined;
  userId?: string | number | null | undefined;
};

export type UpdateTagInput = {
  color?: string | null | undefined;
  id: string | number;
  name?: string | null | undefined;
};

export type UpdateTaskInput = {
  allDay?: boolean | null | undefined;
  assigneeId?: string | number | null | undefined;
  assigneeIds?: Array<string | number> | null | undefined;
  category?: TaskCategoryEnum | null | undefined;
  clientId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
  description?: string | null | undefined;
  dueAt?: string | null | undefined;
  endAt?: string | null | undefined;
  id: string | number;
  leadId?: string | number | null | undefined;
  locationLabel?: string | null | undefined;
  priority?: PriorityEnum | null | undefined;
  propertyId?: string | number | null | undefined;
  reminders?: Array<TaskReminderInput> | null | undefined;
  startAt?: string | null | undefined;
  status?: TaskStatusEnum | null | undefined;
  title?: string | null | undefined;
};

export type UpdateViewingInput = {
  agentId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
  feedback?: string | null | undefined;
  id: string | number;
  reasonNote?: string | null | undefined;
  scheduledAt?: string | null | undefined;
  suppressSms?: boolean | null | undefined;
  taskId?: string | number | null | undefined;
};

export type UpdateWorkflowConnectionsInput = {
  deleteEdgeIds?: Array<string>;
  deleteNodeIds?: Array<string>;
  edges?: Array<WorkflowEdgeInput>;
  nodes?: Array<WorkflowNodeInput>;
  version: number;
  workflowId: string | number;
};

export type UpdateWorkflowInput = {
  description?: string | null | undefined;
  id: string | number;
  isActive?: boolean | null | undefined;
  name?: string | null | undefined;
};

export type UploadStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'PROCESSING'
  | 'READY';

export type UpsertClientCommunicationProfileInput = {
  clientId: string | number;
  preferredLanguage?: string | null | undefined;
  preferredMethod?: PreferredCommunicationMethodEnum | null | undefined;
  timezone?: string | null | undefined;
};

export type UpsertClientInvestorProfileFields = {
  appreciationPotential?: string | null | undefined;
  assetType?: string | null | undefined;
  expectedReturn?: string | null | undefined;
  financingMethod?: InvestorFinancingMethodEnum | null | undefined;
  horizon?: InvestmentHorizonEnum | null | undefined;
  occupancy?: string | null | undefined;
  purpose?: string | null | undefined;
  riskLevel?: InvestorRiskLevelEnum | null | undefined;
  strategy?: InvestmentStrategyEnum | null | undefined;
};

export type UpsertClientInvestorProfileInput = {
  appreciationPotential?: string | null | undefined;
  assetType?: string | null | undefined;
  clientId: string | number;
  expectedReturn?: string | null | undefined;
  financingMethod?: InvestorFinancingMethodEnum | null | undefined;
  horizon?: InvestmentHorizonEnum | null | undefined;
  occupancy?: string | null | undefined;
  purpose?: string | null | undefined;
  riskLevel?: InvestorRiskLevelEnum | null | undefined;
  strategy?: InvestmentStrategyEnum | null | undefined;
};

export type UpsertGoogleAdsConnectionInput = {
  customerId: string;
  defaultCampaignIds?: Array<string> | null | undefined;
  isActive?: boolean;
  loginCustomerId?: string | null | undefined;
  name?: string;
  refreshToken?: string | null | undefined;
  replaceToken?: boolean;
};

export type UpsertPortalConnectionInput = {
  idnes?: PortalIdnesCredentialsInput | null | undefined;
  isActive?: boolean;
  name?: string | null | undefined;
  native?: PortalNativeCredentialsInput | null | undefined;
  provider: IntegrationProviderEnum;
  xmlFeed?: PortalXmlFeedCredentialsInput | null | undefined;
  xmlrpc?: PortalXmlrpcCredentialsInput | null | undefined;
};

export type UpsertRenderTemplateInput = {
  aspectRatio: RenderAspectRatioEnum;
  format: RenderTemplateFormatEnum;
  id?: string | number | null | undefined;
  isActive?: boolean;
  isDefault?: boolean | null | undefined;
  kind: RenderTemplateKindEnum;
  locale?: string;
  name: string;
  settings?: unknown;
  slug: string;
  source?: string | null | undefined;
};

export type UpsertSklikConnectionInput = {
  apiToken?: string | null | undefined;
  autoConvertLeads?: boolean;
  autoRetargetLeads?: boolean;
  conversionEventName?: string | null | undefined;
  conversionValueCzk?: number | null | undefined;
  dryRun?: boolean;
  endpoint?: string | null | undefined;
  isActive?: boolean;
  name?: string;
  replaceToken?: boolean;
  retargetingListId?: number | null | undefined;
  semS2sId?: number | null | undefined;
};

export type UserCredentialProviderEnum =
  | 'GOOGLE'
  | 'META'
  | 'MICROSOFT_CALENDAR'
  | 'SREALITY_SELLER';

export type UserCredentialStatusEnum =
  | 'ACTIVE'
  | 'ERROR'
  | 'NOT_LINKED'
  | 'PENDING';

export type UserFilter = {
  createdAt?: DateTimeFilter | null | undefined;
  firstName?: StringFilter | null | undefined;
  id?: IdFilter | null | undefined;
  isActive?: BooleanFilter | null | undefined;
  lastName?: StringFilter | null | undefined;
  loginEmail?: StringFilter | null | undefined;
  role?: UserRoleEnumEnumFilter | null | undefined;
  updatedAt?: DateTimeFilter | null | undefined;
  venueId?: IdFilter | null | undefined;
};

export type UserOrder = {
  createdAt?: Ordering | null | undefined;
  firstName?: Ordering | null | undefined;
  lastName?: Ordering | null | undefined;
  loginEmail?: Ordering | null | undefined;
  role?: Ordering | null | undefined;
  updatedAt?: Ordering | null | undefined;
};

export type UserRoleEnum =
  | 'ADMIN'
  | 'ASSISTANT'
  | 'BROKER'
  | 'EXTERNAL'
  | 'FRANCHISE_MANAGER'
  | 'ORGANIZATION_ADMIN'
  | 'TEAM_LEAD';

export type UserRoleEnumEnumFilter = {
  exact?: UserRoleEnum | null | undefined;
  in_?: Array<UserRoleEnum> | null | undefined;
  isnull?: boolean | null | undefined;
  notIn_?: Array<UserRoleEnum> | null | undefined;
};

export type VerifyPortalPublicationInput = {
  propertyId: string | number;
  provider: IntegrationProviderEnum;
};

export type ViewingNotPurchaseReasonEnum =
  | 'CHANGED_MIND'
  | 'COMPETITION'
  | 'CONDITION'
  | 'FINANCING'
  | 'LAYOUT'
  | 'LOCATION'
  | 'OTHER'
  | 'PRICE';

export type ViewingProtocolSignerInput = {
  email: string;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  phone?: string | null | undefined;
};

export type ViewingProtocolSigningDeliveryMode =
  | 'EMAIL'
  | 'LINK';

export type ViewingStatusEnum =
  | 'ATTENDED'
  | 'BOOKED'
  | 'CANCELLED'
  | 'CONFIRMED'
  | 'FEEDBACK_COLLECTED'
  | 'INTEREST_EXPRESSED'
  | 'NOT_CONFIRMED'
  | 'NOT_PURCHASED'
  | 'RE_ATTENDED';

export type WaterHeatSourceEnum =
  | 'BOJLER_ELEKTRO'
  | 'BOJLER_PLYN'
  | 'CENTRALNI_DALKOVY_OHREV'
  | 'ELEKTROKOTEL'
  | 'JINE'
  | 'KOTEL_NA_TUHA_PALIVA'
  | 'PLYNOVA_KARMA'
  | 'PLYNOVY_KONDENZACNI_KOTEL'
  | 'PLYNOVY_KOTEL'
  | 'PRUTOKOVY_OHRIVAC'
  | 'TEPELNE_CERPADLO';

export type WaterSupplyEnum =
  | 'MISTNI_ZDROJ_VODY'
  | 'RETENCNI_NADRZ_NA_DESTOVOU_VODU'
  | 'STUDNA'
  | 'VODOVOD';

export type WellTypeEnum =
  | 'KOPANA_STUDNA'
  | 'VRTANA_STUDNA';

export type WithdrawClientConsentInput = {
  channel: ConsentChannelEnum;
  clientId: string | number;
};

export type WorkflowActionTypeEnum =
  | 'ASSIGN_AGENT'
  | 'CHANGE_STAGE'
  | 'CREATE_DOCUMENT_SHARE'
  | 'CREATE_TASK'
  | 'GENERATE_PROPERTY_CATALOG_PDF'
  | 'SEND_EMAIL'
  | 'SEND_NOTIFICATION'
  | 'UPDATE_FIELD'
  | 'WEBHOOK_CALL';

export type WorkflowEdgeInput = {
  config?: unknown;
  id?: string | null | undefined;
  label?: string | null | undefined;
  sourceNodeId: string;
  targetNodeId: string;
};

export type WorkflowFilter = {
  id?: IdFilter | null | undefined;
  isActive?: BooleanFilter | null | undefined;
  name?: StringFilter | null | undefined;
  status?: StringFilter | null | undefined;
  version?: IdFilter | null | undefined;
};

export type WorkflowNodeInput = {
  actionType?: string | null | undefined;
  config?: unknown;
  continueOnError?: boolean;
  id?: string | null | undefined;
  isActive?: boolean;
  label?: string | null | undefined;
  nodeType: string;
  position?: unknown;
};

export type WorkflowRunFilter = {
  id?: IdFilter | null | undefined;
  status?: StringFilter | null | undefined;
  triggerKey?: StringFilter | null | undefined;
  workflowId?: IdFilter | null | undefined;
};

export type WorkflowRunStatusEnum =
  | 'FAILED'
  | 'PENDING'
  | 'RUNNING'
  | 'SKIPPED'
  | 'SUCCEEDED';

export type WorkflowStatusEnum =
  | 'ARCHIVED'
  | 'DRAFT'
  | 'PUBLISHED';

export type WorkflowTriggerTypeEnum =
  | 'EVENT'
  | 'MANUAL'
  | 'SCHEDULE'
  | 'WEBHOOK';

export type ActivityTimelineQueryVariables = Exact<{
  input: ActivityTimelineInput;
}>;


export type ActivityTimelineQuery = { activity: { timeline: Array<{ id: string, type: ActivityTypeEnum, title: string, body: string | null, occurredAt: string, createdAt: string | null, actorId: string, clientId: string | null, propertyId: string | null, dealId: string | null, leadId: string | null, taskId: string | null }> } };

export type ActivityListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: ActivityFilter | null | undefined;
}>;


export type ActivityListQuery = { activity: { list: { totalCount: number | null, items: Array<{ id: string, type: ActivityTypeEnum, body: string | null, occurredAt: string, createdAt: string | null, actorId: string }> } } };

export type ActivityNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type ActivityNodeQuery = { activity: { node: { id: string, type: ActivityTypeEnum, body: string | null, occurredAt: string, createdAt: string | null, actorId: string } | null } };

export type ActivityCreateMutationVariables = Exact<{
  input: CreateActivityInput;
}>;


export type ActivityCreateMutation = { activity: { create:
      | { __typename: 'CreateActivityError', message: string, code: string, details: unknown }
      | { __typename: 'CreateActivitySuccess', message: string, activity: { id: string, type: ActivityTypeEnum } }
     } };

export type AuditListQueryVariables = Exact<{
  limit?: number;
  offset?: number;
  actorId?: string | number | null | undefined;
  entityType?: AuditEntityTypeEnum | null | undefined;
  entityId?: string | null | undefined;
  actionKey?: string | null | undefined;
  createdAfter?: string | null | undefined;
  createdBefore?: string | null | undefined;
}>;


export type AuditListQuery = { audit: { list: { totalCount: number, items: Array<{ id: string, action: AuditActionEnum, actionKey: string, summary: string | null, entityType: AuditEntityTypeEnum, entityId: string | null, entityLabel: string | null, actorId: string | null, changes: unknown, metadata: unknown, createdAt: string | null, actor: { id: string | null, displayName: string } | null }> } } };

export type AutomationWorkflowsQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: WorkflowFilter | null | undefined;
}>;


export type AutomationWorkflowsQuery = { automation: { workflows: { totalCount: number | null, items: Array<{ id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number }> } } };

export type AutomationWorkflowQueryVariables = Exact<{
  id: string | number;
}>;


export type AutomationWorkflowQuery = { automation: { workflow: { id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number, latestRevisionId: string | null, lockedBy: string | null, lockedAt: string | null, webhookToken: string | null, createdById: string | null, updatedById: string | null, nodes: Array<{ id: string, nodeType: string, position: unknown, config: unknown, label: string | null, actionType: string | null, continueOnError: boolean, isActive: boolean }>, edges: Array<{ id: string, sourceNodeId: string, targetNodeId: string, label: string | null, config: unknown }> } | null } };

export type AutomationRunsQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: WorkflowRunFilter | null | undefined;
}>;


export type AutomationRunsQuery = { automation: { runs: { totalCount: number | null, items: Array<{ id: string, workflowId: string | null, status: WorkflowRunStatusEnum, triggerType: WorkflowTriggerTypeEnum | null, triggerKey: string | null, startedAt: string, finishedAt: string | null, summary: string | null, errorMessage: string | null, actionRuns: Array<{ id: string | null, position: number, actionType: WorkflowActionTypeEnum, status: WorkflowRunStatusEnum, startedAt: string, finishedAt: string | null, errorMessage: string | null, output: unknown, configSnapshot: unknown, resultEntityType: string | null, resultEntityId: string | null }> }> } } };

export type AutomationRunQueryVariables = Exact<{
  id: string | number;
}>;


export type AutomationRunQuery = { automation: { run: { id: string, workflowId: string | null, revisionId: string | null, status: WorkflowRunStatusEnum, triggerType: WorkflowTriggerTypeEnum | null, triggerKey: string | null, startedAt: string, finishedAt: string | null, summary: string | null, errorMessage: string | null, context: unknown, planSnapshot: unknown, actionRuns: Array<{ id: string | null, position: number, actionType: WorkflowActionTypeEnum, status: WorkflowRunStatusEnum, startedAt: string, finishedAt: string | null, errorMessage: string | null, output: unknown, configSnapshot: unknown, resultEntityType: string | null, resultEntityId: string | null, nodeId: string | null }> } | null } };

export type AutomationWorkflowTemplatesQueryVariables = Exact<{ [key: string]: never; }>;


export type AutomationWorkflowTemplatesQuery = { automation: { workflowTemplates: Array<{ slug: string, name: string, description: string, category: string }> } };

export type AutomationCreateWorkflowMutationVariables = Exact<{
  input: CreateWorkflowInput;
}>;


export type AutomationCreateWorkflowMutation = { automation: { createWorkflow:
      | { __typename: 'CreateWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'CreateWorkflowSuccess', message: string, workflow: { id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number } }
     } };

export type AutomationCreateWorkflowFromTemplateMutationVariables = Exact<{
  input: CreateWorkflowFromTemplateInput;
}>;


export type AutomationCreateWorkflowFromTemplateMutation = { automation: { createWorkflowFromTemplate:
      | { __typename: 'CreateWorkflowFromTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'CreateWorkflowFromTemplateSuccess', message: string, workflow: { id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number } }
     } };

export type AutomationUpdateWorkflowMutationVariables = Exact<{
  input: UpdateWorkflowInput;
}>;


export type AutomationUpdateWorkflowMutation = { automation: { updateWorkflow:
      | { __typename: 'UpdateWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateWorkflowSuccess', message: string, workflow: { id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number } }
     } };

export type AutomationUpdateWorkflowConnectionsMutationVariables = Exact<{
  input: UpdateWorkflowConnectionsInput;
}>;


export type AutomationUpdateWorkflowConnectionsMutation = { automation: { updateWorkflowConnections:
      | { __typename: 'UpdateWorkflowConnectionsError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateWorkflowConnectionsSuccess', message: string, workflow: { id: string, name: string, isActive: boolean, description: string | null, status: WorkflowStatusEnum, version: number, webhookToken: string | null, nodes: Array<{ id: string, nodeType: string, position: unknown, config: unknown, label: string | null, actionType: string | null, continueOnError: boolean, isActive: boolean }>, edges: Array<{ id: string, sourceNodeId: string, targetNodeId: string, label: string | null, config: unknown }> } }
     } };

export type AutomationLockWorkflowMutationVariables = Exact<{
  input: LockWorkflowInput;
}>;


export type AutomationLockWorkflowMutation = { automation: { lockWorkflow:
      | { __typename: 'LockWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'LockWorkflowSuccess', message: string, workflow: { id: string, status: WorkflowStatusEnum, version: number, lockedBy: string | null, lockedAt: string | null } }
     } };

export type AutomationUnlockWorkflowMutationVariables = Exact<{
  input: UnlockWorkflowInput;
}>;


export type AutomationUnlockWorkflowMutation = { automation: { unlockWorkflow:
      | { __typename: 'UnlockWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'UnlockWorkflowSuccess', message: string, workflow: { id: string, status: WorkflowStatusEnum, version: number, lockedBy: string | null, lockedAt: string | null } }
     } };

export type AutomationForceUnlockWorkflowMutationVariables = Exact<{
  input: ForceUnlockWorkflowInput;
}>;


export type AutomationForceUnlockWorkflowMutation = { automation: { forceUnlockWorkflow:
      | { __typename: 'ForceUnlockWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'ForceUnlockWorkflowSuccess', message: string, workflow: { id: string, status: WorkflowStatusEnum, version: number, lockedBy: string | null, lockedAt: string | null } }
     } };

export type AutomationPublishWorkflowMutationVariables = Exact<{
  input: PublishWorkflowInput;
}>;


export type AutomationPublishWorkflowMutation = { automation: { publishWorkflow:
      | { __typename: 'PublishWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'PublishWorkflowSuccess', message: string, workflow: { id: string, status: WorkflowStatusEnum, version: number, latestRevisionId: string | null, webhookToken: string | null } }
     } };

export type AutomationArchiveWorkflowMutationVariables = Exact<{
  input: ArchiveWorkflowInput;
}>;


export type AutomationArchiveWorkflowMutation = { automation: { archiveWorkflow:
      | { __typename: 'ArchiveWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'ArchiveWorkflowSuccess', message: string, workflow: { id: string, status: WorkflowStatusEnum, version: number } }
     } };

export type AutomationDeleteWorkflowMutationVariables = Exact<{
  input: DeleteWorkflowInput;
}>;


export type AutomationDeleteWorkflowMutation = { automation: { deleteWorkflow:
      | { __typename: 'DeleteWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteWorkflowSuccess', message: string, success: boolean }
     } };

export type AutomationRunWorkflowMutationVariables = Exact<{
  input: RunWorkflowInput;
}>;


export type AutomationRunWorkflowMutation = { automation: { runWorkflow:
      | { __typename: 'RunWorkflowError', message: string, code: string, details: unknown }
      | { __typename: 'RunWorkflowSuccess', message: string, workflowRun: { id: string, workflowId: string | null, status: WorkflowRunStatusEnum, startedAt: string, actionRuns: Array<{ id: string | null, position: number, actionType: WorkflowActionTypeEnum, status: WorkflowRunStatusEnum, startedAt: string, finishedAt: string | null, errorMessage: string | null }> } }
     } };

export type AutomationRegenerateWorkflowWebhookTokenMutationVariables = Exact<{
  input: RegenerateWorkflowWebhookTokenInput;
}>;


export type AutomationRegenerateWorkflowWebhookTokenMutation = { automation: { regenerateWorkflowWebhookToken:
      | { __typename: 'RegenerateWorkflowWebhookTokenError', message: string, code: string, details: unknown }
      | { __typename: 'RegenerateWorkflowWebhookTokenSuccess', message: string, workflow: { id: string, webhookToken: string | null, version: number } }
     } };

export type BillingMeQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingMeQuery = { billing: { me: { personalAvailable: number, orgAllocationLimit: number, orgAllocationUsed: number, orgAllocationRemaining: number, availableTotal: number, billingMode: BillingModeEnum } } };

export type BillingOrgQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingOrgQuery = { billing: { org: { orgPoolBalance: number, invoiceAccrued: number, invoiceCreditCap: number | null, billingMode: BillingModeEnum } } };

export type BillingFeatureCostsQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingFeatureCostsQuery = { billing: { featureCosts: Array<{ feature: CreditFeatureEnum, creditsPerUnit: number, label: string }> } };

export type BillingLedgerQueryVariables = Exact<{
  limit?: number;
  offset?: number;
  userId?: string | number | null | undefined;
}>;


export type BillingLedgerQuery = { billing: { ledger: { totalCount: number, items: Array<{ id: string, entryType: CreditLedgerEntryTypeEnum, status: CreditLedgerStatusEnum, amount: number, feature: CreditFeatureEnum | null, note: string | null, createdAt: string | null, userId: string | null }> } } };

export type BillingGrantOrgCreditsMutationVariables = Exact<{
  amount: number;
  note?: string | null | undefined;
}>;


export type BillingGrantOrgCreditsMutation = { billing: { grantOrgCredits:
      | { __typename: 'GrantOrgCreditsError', message: string, code: string, details: unknown }
      | { __typename: 'GrantOrgCreditsSuccess', message: string, wallet: { id: string, kind: CreditWalletKindEnum, ownerId: string | null } }
     } };

export type BillingSetUserAllocationMutationVariables = Exact<{
  userId: string | number;
  limitCredits: number;
  period?: CreditAllocationPeriodEnum;
}>;


export type BillingSetUserAllocationMutation = { billing: { setUserAllocation:
      | { __typename: 'SetUserAllocationError', message: string, code: string, details: unknown }
      | { __typename: 'SetUserAllocationSuccess', message: string, allocation: { id: string, userId: string, period: CreditAllocationPeriodEnum, limitCredits: number, resetAt: string | null } }
     } };

export type BillingSetBillingModeMutationVariables = Exact<{
  mode: BillingModeEnum;
  invoiceCreditCap?: number | null | undefined;
}>;


export type BillingSetBillingModeMutation = { billing: { setBillingMode:
      | { __typename: 'SetBillingModeError', message: string, code: string, details: unknown }
      | { __typename: 'SetBillingModeSuccess', message: string, organization: { billingMode: BillingModeEnum, invoiceCreditCap: number | null, aiFeaturesEnabled: boolean } }
     } };

export type BillingTopUpPersonalMutationVariables = Exact<{
  amount: number;
  note?: string | null | undefined;
  postImmediately?: boolean;
}>;


export type BillingTopUpPersonalMutation = { billing: { topUpPersonal:
      | { __typename: 'TopUpPersonalError', message: string, code: string, details: unknown }
      | { __typename: 'TopUpPersonalSuccess', message: string, stub: boolean, paymentUrl: string | null, ledgerEntry: { id: string, entryType: CreditLedgerEntryTypeEnum, status: CreditLedgerStatusEnum, amount: number, note: string | null, createdAt: string | null } }
     } };

export type BillingSyncGopayPaymentMutationVariables = Exact<{
  paymentId: string;
}>;


export type BillingSyncGopayPaymentMutation = { billing: { syncGopayPayment:
      | { __typename: 'SyncGopayPaymentError', message: string, code: string, details: unknown }
      | { __typename: 'SyncGopayPaymentSuccess', message: string, ledgerEntry: { id: string, status: CreditLedgerStatusEnum, amount: number } }
     } };

export type BillingPostTopUpMutationVariables = Exact<{
  id: string | number;
}>;


export type BillingPostTopUpMutation = { billing: { postTopUp:
      | { __typename: 'PostTopUpError', message: string, code: string, details: unknown }
      | { __typename: 'PostTopUpSuccess', message: string, ledgerEntry: { id: string, status: CreditLedgerStatusEnum, amount: number } }
     } };

export type BillingPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingPlansQuery = { billing: { plans: Array<{ id: string, code: string, name: string, description: string | null, priceAmount: string, currency: string, billingPeriod: BillingPeriodEnum, includedCredits: number, seatLimit: number | null, isActive: boolean, isPublic: boolean }> } };

export type BillingSubscriptionQueryVariables = Exact<{ [key: string]: never; }>;


export type BillingSubscriptionQuery = { billing: { subscription: { subscription: { id: string, status: SubscriptionStatusEnum, currentPeriodStart: string, currentPeriodEnd: string, cancelAtPeriodEnd: boolean, plan: { id: string, code: string, name: string, priceAmount: string, currency: string, includedCredits: number, seatLimit: number | null } | null } | null, plan: { id: string, code: string, name: string, priceAmount: string, currency: string, includedCredits: number, seatLimit: number | null } | null } } };

export type BillingInvoicesQueryVariables = Exact<{
  limit?: number;
  offset?: number;
}>;


export type BillingInvoicesQuery = { billing: { invoices: { totalCount: number, items: Array<{ id: string, number: string, status: InvoiceStatusEnum, issueDate: string, dueDate: string | null, currency: string, subtotalAmount: string, vatRate: string, vatAmount: string, totalAmount: string, paidAt: string | null, pdfDocumentId: string | null }> } } };

export type BillingSetPlanMutationVariables = Exact<{
  planCode: string;
  issueInvoice?: boolean;
}>;


export type BillingSetPlanMutation = { billing: { setPlan:
      | { __typename: 'SetPlanError', message: string, code: string, details: unknown }
      | { __typename: 'SetPlanSuccess', message: string, subscription: { subscription: { id: string, status: SubscriptionStatusEnum, currentPeriodStart: string, currentPeriodEnd: string, plan: { id: string, code: string, name: string, priceAmount: string, currency: string, includedCredits: number } | null } | null, plan: { id: string, code: string, name: string, priceAmount: string, currency: string, includedCredits: number } | null } }
     } };

export type BlogListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: BlogPostFilter | null | undefined;
  order?: BlogPostOrder | null | undefined;
}>;


export type BlogListQuery = { blog: { list: { totalCount: number | null, items: Array<{ id: string, status: BlogPostStatusEnum, title: unknown, excerpt: unknown, coverUrl: string | null, tags: unknown, publishedAt: string | null, createdAt: string | null, updatedAt: string | null, authorId: string | null, slugs: Array<{ locale: string, slug: string }> }> } } };

export type BlogConnectionQueryVariables = Exact<{
  first: number;
  after?: string | null | undefined;
  filters?: BlogPostFilter | null | undefined;
  order?: BlogPostOrder | null | undefined;
}>;


export type BlogConnectionQuery = { blog: { connection: { totalCount: number, edges: Array<{ cursor: string, node: { id: string, status: BlogPostStatusEnum, title: unknown, excerpt: unknown, coverUrl: string | null, tags: unknown, publishedAt: string | null, createdAt: string | null, updatedAt: string | null, authorId: string | null, slugs: Array<{ locale: string, slug: string }> } }>, pageInfo: { hasNextPage: boolean, endCursor: string | null } } } };

export type BlogNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type BlogNodeQuery = { blog: { node: { id: string, status: BlogPostStatusEnum, title: unknown, excerpt: unknown, content: unknown, bodyMd: unknown, localeMeta: unknown, resolvedContent: unknown, resolvedMarkdown: unknown, coverUrl: string | null, tags: unknown, seoTitle: unknown, seoDescription: unknown, publishedAt: string | null, createdAt: string | null, updatedAt: string | null, authorId: string | null, slugs: Array<{ locale: string, slug: string }> } | null } };

export type BlogCreateMutationVariables = Exact<{
  input: CreateBlogPostInput;
}>;


export type BlogCreateMutation = { blog: { create:
      | { __typename: 'CreateBlogPostError', message: string, code: string, details: unknown }
      | { __typename: 'CreateBlogPostSuccess', message: string, blogPost: { id: string } }
     } };

export type BlogUpdateMutationVariables = Exact<{
  input: UpdateBlogPostInput;
}>;


export type BlogUpdateMutation = { blog: { update:
      | { __typename: 'UpdateBlogPostError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateBlogPostSuccess', message: string, blogPost: { id: string } }
     } };

export type BlogPublishMutationVariables = Exact<{
  id: string | number;
}>;


export type BlogPublishMutation = { blog: { publish:
      | { __typename: 'PublishBlogPostError', message: string, code: string, details: unknown }
      | { __typename: 'PublishBlogPostSuccess', message: string, blogPost: { id: string, status: BlogPostStatusEnum, publishedAt: string | null } }
     } };

export type BlogUnpublishMutationVariables = Exact<{
  id: string | number;
}>;


export type BlogUnpublishMutation = { blog: { unpublish:
      | { __typename: 'UnpublishBlogPostError', message: string, code: string, details: unknown }
      | { __typename: 'UnpublishBlogPostSuccess', message: string, blogPost: { id: string, status: BlogPostStatusEnum } }
     } };

export type BlogDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type BlogDeleteMutation = { blog: { delete:
      | { __typename: 'DeleteBlogPostError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteBlogPostSuccess', message: string, success: boolean }
     } };

export type BlogCreateAssetUploadIntentMutationVariables = Exact<{
  postId: string | number;
  kind: BlogPostAssetKindEnum;
  contentType: string;
  sizeBytes?: number | null | undefined;
}>;


export type BlogCreateAssetUploadIntentMutation = { blog: { createAssetUploadIntent:
      | { __typename: 'CreateBlogPostAssetUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateBlogPostAssetUploadIntentSuccess', message: string, uploadIntent: { displayUrl: string | null, asset: { id: string }, upload: { url: string, method: string, headers: unknown, storageKey: string, expiresAt: string, maxBytes: number } } }
     } };

export type BlogFinalizeAssetUploadMutationVariables = Exact<{
  assetId: string | number;
}>;


export type BlogFinalizeAssetUploadMutation = { blog: { finalizeAssetUpload:
      | { __typename: 'FinalizeBlogPostAssetUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeBlogPostAssetUploadSuccess', message: string, asset: { id: string, displayUrl: string | null } }
     } };

export type BlogCreateCoverUploadIntentMutationVariables = Exact<{
  postId: string | number;
  contentType: string;
  sizeBytes?: number | null | undefined;
}>;


export type BlogCreateCoverUploadIntentMutation = { blog: { createCoverUploadIntent:
      | { __typename: 'CreateBlogPostAssetUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateBlogPostAssetUploadIntentSuccess', message: string, uploadIntent: { displayUrl: string | null, asset: { id: string }, upload: { url: string, method: string, headers: unknown, storageKey: string, expiresAt: string, maxBytes: number } } }
     } };

export type BlogFinalizeCoverUploadMutationVariables = Exact<{
  postId: string | number;
}>;


export type BlogFinalizeCoverUploadMutation = { blog: { finalizeCoverUpload:
      | { __typename: 'FinalizeBlogPostCoverUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeBlogPostCoverUploadSuccess', message: string, blogPost: { id: string, coverUrl: string | null } }
     } };

export type BlogMarkdownToHtmlQueryVariables = Exact<{
  markdown: string;
}>;


export type BlogMarkdownToHtmlQuery = { blog: { markdownToHtml: string } };

export type BlogHtmlToMarkdownQueryVariables = Exact<{
  html: string;
}>;


export type BlogHtmlToMarkdownQuery = { blog: { htmlToMarkdown: string } };

export type BlogTranslateWithAiMutationVariables = Exact<{
  id: string | number;
  sourceLocale?: string;
  targetLocales?: Array<string> | string | null | undefined;
  fields?: Array<string> | string | null | undefined;
  overwrite?: boolean;
  idempotencyKey?: string | null | undefined;
}>;


export type BlogTranslateWithAiMutation = { blog: { translateWithAi:
      | { __typename: 'TranslateBlogPostWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'TranslateBlogPostWithAiSuccess', message: string, job: { postId: string, queued: boolean, locale: string | null } }
     } };

export type BlogPolishWithAiMutationVariables = Exact<{
  id: string | number;
  locale?: string;
  fields?: Array<string> | string | null | undefined;
  idempotencyKey?: string | null | undefined;
}>;


export type BlogPolishWithAiMutation = { blog: { polishWithAi:
      | { __typename: 'PolishBlogPostWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'PolishBlogPostWithAiSuccess', message: string, job: { postId: string, queued: boolean, locale: string | null } }
     } };

export type BlogGenerateWithAiMutationVariables = Exact<{
  id: string | number;
  locale?: string;
  brief?: string | null | undefined;
  overwrite?: boolean;
  idempotencyKey?: string | null | undefined;
}>;


export type BlogGenerateWithAiMutation = { blog: { generateWithAi:
      | { __typename: 'GenerateBlogPostWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'GenerateBlogPostWithAiSuccess', message: string, job: { postId: string, queued: boolean, locale: string | null } }
     } };

export type BlogConfirmAiTranslationMutationVariables = Exact<{
  id: string | number;
  locale: string;
}>;


export type BlogConfirmAiTranslationMutation = { blog: { confirmAiTranslation:
      | { __typename: 'ConfirmBlogPostAiTranslationError', message: string, code: string, details: unknown }
      | { __typename: 'ConfirmBlogPostAiTranslationSuccess', message: string, result: { postId: string, locale: string, confirmed: boolean } }
     } };

export type ChatDirectoryQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type ChatDirectoryQuery = { chat: { directory: Array<{ id: string, firstName: string, lastName: string, loginEmail: string, venueId: string | null }> } };

export type ChatConversationsQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type ChatConversationsQuery = { chat: { conversations: Array<{ id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, createdAt: string | null, createdById: string, peerDeliveredAt: string | null, peerReadAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, lastReadAt: string | null, lastDeliveredAt: string | null, joinedAt: string | null, isPinned: boolean, displayName: string | null }> | null }> } };

export type ChatConversationQueryVariables = Exact<{
  id: string | number;
}>;


export type ChatConversationQuery = { chat: { conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, createdAt: string | null, createdById: string, peerDeliveredAt: string | null, peerReadAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, lastReadAt: string | null, lastDeliveredAt: string | null, joinedAt: string | null, isPinned: boolean, displayName: string | null }> | null } } };

export type ChatMessagesQueryVariables = Exact<{
  conversationId: string | number;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  before?: string | null | undefined;
}>;


export type ChatMessagesQuery = { chat: { messages: Array<{ id: string, conversationId: string, senderId: string | null, senderPortalAccountId: string | null, clientMessageId: string | null, body: string | null, isSystem: boolean, createdAt: string | null, attachments: Array<{ id: string, entityType: ChatAttachmentEntityTypeEnum, entityId: string, snapshot: unknown }> | null, files: Array<{ id: string, originalName: string, mimeType: string, sizeBytes: number, uploadStatus: string, isImage: boolean, downloadUrl: string, previewUrl: string | null }> | null }> } };

export type ChatMessagesConnectionQueryVariables = Exact<{
  conversationId: string | number;
  first?: number | null | undefined;
  before?: string | null | undefined;
  after?: string | null | undefined;
}>;


export type ChatMessagesConnectionQuery = { chat: { messagesConnection: { hasOlder: boolean, oldestCreatedAt: string | null, newestCreatedAt: string | null, items: Array<{ id: string, conversationId: string, senderId: string | null, senderPortalAccountId: string | null, clientMessageId: string | null, body: string | null, isSystem: boolean, createdAt: string | null, attachments: Array<{ id: string, entityType: ChatAttachmentEntityTypeEnum, entityId: string, snapshot: unknown }> | null, files: Array<{ id: string, originalName: string, mimeType: string, sizeBytes: number, uploadStatus: string, isImage: boolean, downloadUrl: string, previewUrl: string | null }> | null }> } } };

export type ChatUnreadCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ChatUnreadCountsQuery = { chat: { unreadCounts: Array<{ conversationId: string, unreadCount: number }> } };

export type ChatStartDirectMutationVariables = Exact<{
  peerUserId: string | number;
}>;


export type ChatStartDirectMutation = { chat: { startDirect:
      | { __typename: 'StartDirectChatError', message: string, code: string, details: unknown }
      | { __typename: 'StartDirectChatSuccess', message: string, conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, isPinned: boolean, displayName: string | null }> | null } }
     } };

export type ChatStartDirectWithClientMutationVariables = Exact<{
  clientId: string | number;
}>;


export type ChatStartDirectWithClientMutation = { chat: { startDirectWithClient:
      | { __typename: 'StartDirectChatWithClientError', message: string, code: string, details: unknown }
      | { __typename: 'StartDirectChatWithClientSuccess', message: string, conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, isPinned: boolean, displayName: string | null }> | null } }
     } };

export type ChatStartGroupMutationVariables = Exact<{
  participantIds: Array<string | number> | string | number;
  title?: string | null | undefined;
}>;


export type ChatStartGroupMutation = { chat: { startGroup:
      | { __typename: 'StartGroupChatError', message: string, code: string, details: unknown }
      | { __typename: 'StartGroupChatSuccess', message: string, conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, isPinned: boolean, displayName: string | null }> | null } }
     } };

export type ChatSetTitleMutationVariables = Exact<{
  conversationId: string | number;
  title?: string | null | undefined;
}>;


export type ChatSetTitleMutation = { chat: { setTitle:
      | { __typename: 'SetTitleChatError', message: string, code: string, details: unknown }
      | { __typename: 'SetTitleChatSuccess', message: string, conversation: { id: string, title: string | null, kind: ChatConversationKindEnum } }
     } };

export type ChatSetPinnedMutationVariables = Exact<{
  conversationId: string | number;
  pinned: boolean;
}>;


export type ChatSetPinnedMutation = { chat: { setPinned:
      | { __typename: 'SetPinnedChatError', message: string, code: string, details: unknown }
      | { __typename: 'SetPinnedChatSuccess', message: string, conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, lastMessageAt: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, isPinned: boolean, displayName: string | null }> | null } }
     } };

export type ChatAddParticipantsMutationVariables = Exact<{
  conversationId: string | number;
  userIds: Array<string | number> | string | number;
}>;


export type ChatAddParticipantsMutation = { chat: { addParticipants:
      | { __typename: 'AddChatParticipantsError', message: string, code: string, details: unknown }
      | { __typename: 'AddChatParticipantsSuccess', message: string, conversation: { id: string, kind: ChatConversationKindEnum, title: string | null, participants: Array<{ id: string, userId: string | null, portalAccountId: string | null, isPinned: boolean, displayName: string | null }> | null } }
     } };

export type ChatCreateFileUploadIntentMutationVariables = Exact<{
  conversationId: string | number;
  mimeType: string;
  originalName: string;
  sizeBytes?: number | null | undefined;
}>;


export type ChatCreateFileUploadIntentMutation = { chat: { createFileUploadIntent:
      | { __typename: 'CreateChatFileUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateChatFileUploadIntentSuccess', message: string, uploadIntent: { file: { id: string, originalName: string, mimeType: string, sizeBytes: number, uploadStatus: string, isImage: boolean }, upload: { url: string, method: string, headers: unknown, storageKey: string, expiresAt: string, maxBytes: number } } }
     } };

export type ChatFinalizeFileUploadMutationVariables = Exact<{
  fileId: string | number;
}>;


export type ChatFinalizeFileUploadMutation = { chat: { finalizeFileUpload:
      | { __typename: 'FinalizeChatFileUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeChatFileUploadSuccess', message: string, file: { id: string, originalName: string, mimeType: string, sizeBytes: number, uploadStatus: string, isImage: boolean } }
     } };

export type ChatSendMessageMutationVariables = Exact<{
  conversationId: string | number;
  body?: string | null | undefined;
  attachments?: Array<ChatAttachmentInput> | ChatAttachmentInput | null | undefined;
  fileIds?: Array<string | number> | string | number | null | undefined;
  clientMessageId?: string | null | undefined;
}>;


export type ChatSendMessageMutation = { chat: { sendMessage:
      | { __typename: 'SendChatMessageError', message: string, code: string, details: unknown }
      | { __typename: 'SendChatMessageSuccess', message: string, chatMessage: { id: string, conversationId: string, senderId: string | null, senderPortalAccountId: string | null, clientMessageId: string | null, body: string | null, isSystem: boolean, createdAt: string | null, attachments: Array<{ id: string, entityType: ChatAttachmentEntityTypeEnum, entityId: string, snapshot: unknown }> | null, files: Array<{ id: string, originalName: string, mimeType: string, sizeBytes: number, uploadStatus: string, isImage: boolean, downloadUrl: string, previewUrl: string | null }> | null } }
     } };

export type ChatMarkReadMutationVariables = Exact<{
  conversationId: string | number;
}>;


export type ChatMarkReadMutation = { chat: { markRead:
      | { __typename: 'MarkChatReadError', message: string, code: string, details: unknown }
      | { __typename: 'MarkChatReadSuccess', message: string, conversation: { id: string, peerDeliveredAt: string | null, peerReadAt: string | null, participants: Array<{ id: string, userId: string | null, lastReadAt: string | null, lastDeliveredAt: string | null }> | null } }
     } };

export type ChatAckDeliveredMutationVariables = Exact<{
  conversationId: string | number;
  upToCreatedAt: string;
}>;


export type ChatAckDeliveredMutation = { chat: { ackDelivered:
      | { __typename: 'AckChatDeliveredError', message: string, code: string, details: unknown }
      | { __typename: 'AckChatDeliveredSuccess', message: string, conversation: { id: string, peerDeliveredAt: string | null, peerReadAt: string | null, participants: Array<{ id: string, userId: string | null, lastReadAt: string | null, lastDeliveredAt: string | null }> | null } }
     } };

export type ChatTransferClientMutationVariables = Exact<{
  conversationId: string | number;
  clientId: string | number;
  toUserId: string | number;
}>;


export type ChatTransferClientMutation = { chat: { transferClient:
      | { __typename: 'TransferChatClientError', message: string, code: string, details: unknown }
      | { __typename: 'TransferChatClientSuccess', message: string, chatMessage: { id: string, body: string | null, isSystem: boolean, createdAt: string | null } }
     } };

export type ChatTransferTaskMutationVariables = Exact<{
  conversationId: string | number;
  taskId: string | number;
  toUserId: string | number;
}>;


export type ChatTransferTaskMutation = { chat: { transferTask:
      | { __typename: 'TransferChatTaskError', message: string, code: string, details: unknown }
      | { __typename: 'TransferChatTaskSuccess', message: string, chatMessage: { id: string, body: string | null, isSystem: boolean, createdAt: string | null } }
     } };

export type ChatTransferPropertyMutationVariables = Exact<{
  conversationId: string | number;
  propertyId: string | number;
  toUserId: string | number;
}>;


export type ChatTransferPropertyMutation = { chat: { transferProperty:
      | { __typename: 'TransferChatPropertyError', message: string, code: string, details: unknown }
      | { __typename: 'TransferChatPropertySuccess', message: string, chatMessage: { id: string, body: string | null, isSystem: boolean, createdAt: string | null } }
     } };

export type ClientListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: ClientFilter | null | undefined;
  order?: ClientOrder | null | undefined;
}>;


export type ClientListQuery = { client: { list: { totalCount: number | null, items: Array<{ id: string, firstName: string, lastName: string, type: ClientTypeEnum, status: ClientStatusEnum, priority: PriorityEnum, source: LeadSourceEnum | null, assignedAgentId: string | null, createdAt: string | null, updatedAt: string | null, roles: Array<{ id: string, role: ClientTypeEnum }>, tags: Array<{ id: string, tag: string, tagId: string | null, catalogTag: { id: string, name: string } | null }> }> } } };

export type ClientNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type ClientNodeQuery = { client: { node: { id: string, firstName: string, lastName: string, notes: string | null, type: ClientTypeEnum, status: ClientStatusEnum, priority: PriorityEnum, source: LeadSourceEnum | null, preferredCommunicationMethod: PreferredCommunicationMethodEnum | null, preferredLanguage: string | null, leadScore: number, intentScore: number, propertyMatchScore: number, recencyScore: number, assignedAgentId: string | null, portalAccountId: string | null, createdAt: string | null, updatedAt: string | null, roles: Array<{ id: string, role: ClientTypeEnum }>, tags: Array<{ id: string, tag: string, tagId: string | null, catalogTag: { id: string, name: string } | null }>, contacts: Array<{ id: string, type: ContactTypeEnum, value: string, label: string | null, isPrimary: boolean }>, consents: Array<{ id: string, channel: ConsentChannelEnum, consentType: ConsentTypeEnum, grantedAt: string, source: string, wording: string | null, withdrawnAt: string | null }>, communicationProfile: { id: string, preferredMethod: PreferredCommunicationMethodEnum | null, preferredLanguage: string | null, timezone: string | null } | null, notificationPreferences: Array<{ id: string, channel: OutreachChannelEnum, category: NotificationCategoryEnum, enabled: boolean }>, suppressions: Array<{ id: string, channel: OutreachChannelEnum, address: string, reason: SuppressionReasonEnum, source: string, note: string | null, expiresAt: string | null }>, investorProfile: { id: string, strategy: InvestmentStrategyEnum | null, purpose: string | null, expectedReturn: string | null, riskLevel: InvestorRiskLevelEnum | null, assetType: string | null, financingMethod: InvestorFinancingMethodEnum | null, horizon: InvestmentHorizonEnum | null, appreciationPotential: string | null, occupancy: string | null } | null, requirements: Array<{ id: string, name: string, transactionType: TransactionTypeEnum, isPrimary: boolean, priority: PriorityEnum, localityId: string | null, locationAddress: string | null, latitude: number | null, longitude: number | null, radiusKm: number | null, budgetMin: number | null, budgetMax: number | null, currency: string, propertyType: PropertyTypeEnum | null, propertyCategory: PropertyCategoryEnum | null, preferredLayouts: Array<PropertyLayoutEnum>, usableAreaMin: number | null, usableAreaMax: number | null, financingStatus: FinancingStatusEnum, notes: string | null, isActive: boolean, matchingProperties: Array<{ id: string, propertyId: string, score: number, reasons: Array<string>, reasonLabels: Array<string>, taskId: string | null, createdAt: string | null }> }> } | null } };

export type ClientDemandListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: ClientFilter | null | undefined;
}>;


export type ClientDemandListQuery = { client: { list: { totalCount: number | null, items: Array<{ id: string, firstName: string, lastName: string, type: ClientTypeEnum, status: ClientStatusEnum, requirements: Array<{ id: string, name: string, transactionType: TransactionTypeEnum, isPrimary: boolean, isActive: boolean, priority: PriorityEnum, localityId: string | null, locationAddress: string | null, latitude: number | null, longitude: number | null, radiusKm: number | null, budgetMin: number | null, budgetMax: number | null, currency: string, propertyType: PropertyTypeEnum | null, propertyCategory: PropertyCategoryEnum | null, preferredLayouts: Array<PropertyLayoutEnum>, usableAreaMin: number | null, usableAreaMax: number | null, financingStatus: FinancingStatusEnum, notes: string | null, matchingPropertiesCount: number, matchingProperties: Array<{ id: string, propertyId: string, score: number, reasons: Array<string>, reasonLabels: Array<string>, taskId: string | null, createdAt: string | null }> }> }> } } };

export type ClientRequirementQueryVariables = Exact<{
  id: string | number;
}>;


export type ClientRequirementQuery = { client: { requirement: { id: string, clientId: string, name: string, transactionType: TransactionTypeEnum, isPrimary: boolean, isActive: boolean, priority: PriorityEnum, localityId: string | null, locationAddress: string | null, latitude: number | null, longitude: number | null, radiusKm: number | null, budgetMin: number | null, budgetMax: number | null, currency: string, propertyType: PropertyTypeEnum | null, propertyCategory: PropertyCategoryEnum | null, preferredLayouts: Array<PropertyLayoutEnum>, usableAreaMin: number | null, usableAreaMax: number | null, financingStatus: FinancingStatusEnum, notes: string | null, matchingProperties: Array<{ id: string, propertyId: string, score: number, reasons: Array<string>, reasonLabels: Array<string>, taskId: string | null, createdAt: string | null }> } | null } };

export type ClientLocalitiesQueryVariables = Exact<{
  query?: string;
  limit?: number;
}>;


export type ClientLocalitiesQuery = { client: { localities: Array<{ id: string, city: string, district: string, region: string, countryCode: string }> } };

export type ClientCreateMutationVariables = Exact<{
  input: CreateClientInput;
}>;


export type ClientCreateMutation = { client: { create:
      | { __typename: 'CreateClientError', message: string, code: string, details: unknown }
      | { __typename: 'CreateClientSuccess', message: string, client: { id: string, type: ClientTypeEnum, roles: Array<{ id: string, role: ClientTypeEnum }>, tags: Array<{ id: string, tag: string, tagId: string | null, catalogTag: { id: string, name: string } | null }> } }
     } };

export type ClientUpdateMutationVariables = Exact<{
  input: UpdateClientInput;
}>;


export type ClientUpdateMutation = { client: { update:
      | { __typename: 'UpdateClientError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateClientSuccess', message: string, client: { id: string, type: ClientTypeEnum, roles: Array<{ id: string, role: ClientTypeEnum }>, tags: Array<{ id: string, tag: string, tagId: string | null, catalogTag: { id: string, name: string } | null }> } }
     } };

export type ClientGrantConsentMutationVariables = Exact<{
  input: GrantClientConsentInput;
}>;


export type ClientGrantConsentMutation = { client: { grantConsent:
      | { __typename: 'GrantClientConsentError', message: string, code: string, details: unknown }
      | { __typename: 'GrantClientConsentSuccess', message: string, consent: { id: string, channel: ConsentChannelEnum, consentType: ConsentTypeEnum, grantedAt: string, source: string, wording: string | null, withdrawnAt: string | null } }
     } };

export type ClientWithdrawConsentMutationVariables = Exact<{
  input: WithdrawClientConsentInput;
}>;


export type ClientWithdrawConsentMutation = { client: { withdrawConsent:
      | { __typename: 'WithdrawClientConsentError', message: string, code: string, details: unknown }
      | { __typename: 'WithdrawClientConsentSuccess', message: string, consent: { id: string, channel: ConsentChannelEnum, consentType: ConsentTypeEnum, grantedAt: string, source: string, wording: string | null, withdrawnAt: string | null } }
     } };

export type ClientDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type ClientDeleteMutation = { client: { delete:
      | { __typename: 'DeleteClientError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteClientSuccess', message: string, success: boolean }
     } };

export type ClientCreateRequirementMutationVariables = Exact<{
  input: CreateClientRequirementInput;
}>;


export type ClientCreateRequirementMutation = { client: { createRequirement:
      | { __typename: 'CreateClientRequirementError', message: string, code: string, details: unknown }
      | { __typename: 'CreateClientRequirementSuccess', message: string, requirement: { id: string, name: string, isActive: boolean } }
     } };

export type ClientUpdateRequirementMutationVariables = Exact<{
  input: UpdateClientRequirementInput;
}>;


export type ClientUpdateRequirementMutation = { client: { updateRequirement:
      | { __typename: 'UpdateClientRequirementError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateClientRequirementSuccess', message: string, requirement: { id: string, name: string, isActive: boolean } }
     } };

export type ClientDeleteRequirementMutationVariables = Exact<{
  id: string | number;
}>;


export type ClientDeleteRequirementMutation = { client: { deleteRequirement:
      | { __typename: 'DeleteClientRequirementError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteClientRequirementSuccess', message: string, success: boolean }
     } };

export type ClientRunDemandMatchingMutationVariables = Exact<{
  requirementId: string | number;
}>;


export type ClientRunDemandMatchingMutation = { client: { runDemandMatching:
      | { __typename: 'RunClientDemandMatchingError', message: string, code: string, details: unknown }
      | { __typename: 'RunClientDemandMatchingSuccess', message: string, created: number, updated: number, tasksCreated: number, staleRemoved: number, matches: Array<{ id: string, propertyId: string, requirementId: string, clientId: string, score: number, reasons: Array<string>, reasonLabels: Array<string>, taskId: string | null }> }
     } };

export type ClientExportCsvQueryVariables = Exact<{ [key: string]: never; }>;


export type ClientExportCsvQuery = { client: { exportCsv: { filename: string, content: string, mimeType: string } } };

export type ClientCreateLocalityMutationVariables = Exact<{
  city: string;
  district?: string;
  region?: string;
  countryCode?: string;
}>;


export type ClientCreateLocalityMutation = { client: { createLocality:
      | { __typename: 'CreateLocalityError', message: string, code: string, details: unknown }
      | { __typename: 'CreateLocalitySuccess', message: string, locality: { id: string, city: string, district: string, region: string, countryCode: string } }
     } };

export type ClientMergeMutationVariables = Exact<{
  input: MergeClientsInput;
}>;


export type ClientMergeMutation = { client: { merge:
      | { __typename: 'MergeClientsError', message: string, code: string, details: unknown }
      | { __typename: 'MergeClientsSuccess', message: string, client: { id: string, firstName: string, lastName: string, status: ClientStatusEnum } }
     } };

export type ClientUpsertInvestorProfileMutationVariables = Exact<{
  input: UpsertClientInvestorProfileInput;
}>;


export type ClientUpsertInvestorProfileMutation = { client: { upsertInvestorProfile:
      | { __typename: 'UpsertClientInvestorProfileError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertClientInvestorProfileSuccess', message: string, investorProfile: { id: string, strategy: InvestmentStrategyEnum | null, purpose: string | null, expectedReturn: string | null, riskLevel: InvestorRiskLevelEnum | null, assetType: string | null, financingMethod: InvestorFinancingMethodEnum | null, horizon: InvestmentHorizonEnum | null, appreciationPotential: string | null, occupancy: string | null } }
     } };

export type ClientUpsertCommunicationProfileMutationVariables = Exact<{
  input: UpsertClientCommunicationProfileInput;
}>;


export type ClientUpsertCommunicationProfileMutation = { client: { upsertCommunicationProfile:
      | { __typename: 'UpsertClientCommunicationProfileError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertClientCommunicationProfileSuccess', message: string, communicationProfile: { id: string, preferredMethod: PreferredCommunicationMethodEnum | null, preferredLanguage: string | null, timezone: string | null } }
     } };

export type ClientSetNotificationPreferenceMutationVariables = Exact<{
  input: SetClientNotificationPreferenceInput;
}>;


export type ClientSetNotificationPreferenceMutation = { client: { setNotificationPreference:
      | { __typename: 'SetClientNotificationPreferenceError', message: string, code: string, details: unknown }
      | { __typename: 'SetClientNotificationPreferenceSuccess', message: string, notificationPreference: { id: string, channel: OutreachChannelEnum, category: NotificationCategoryEnum, enabled: boolean } }
     } };

export type ClientSuppressContactMutationVariables = Exact<{
  input: SuppressContactInput;
}>;


export type ClientSuppressContactMutation = { client: { suppressContact:
      | { __typename: 'SuppressContactError', message: string, code: string, details: unknown }
      | { __typename: 'SuppressContactSuccess', message: string, suppression: { id: string, channel: OutreachChannelEnum, address: string, reason: SuppressionReasonEnum, source: string, note: string | null, expiresAt: string | null } }
     } };

export type ClientLiftContactSuppressionMutationVariables = Exact<{
  input: LiftContactSuppressionInput;
}>;


export type ClientLiftContactSuppressionMutation = { client: { liftContactSuppression:
      | { __typename: 'LiftContactSuppressionError', message: string, code: string, details: unknown }
      | { __typename: 'LiftContactSuppressionSuccess', message: string, success: boolean }
     } };

export type EntityPickerClientsQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type EntityPickerClientsQuery = { client: { list: { items: Array<{ id: string, firstName: string, lastName: string, type: ClientTypeEnum, status: ClientStatusEnum, contacts: Array<{ type: ContactTypeEnum, value: string, isPrimary: boolean }> }> } } };

export type ClientTagListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type ClientTagListQuery = { client: { tag: { list: { totalCount: number | null, items: Array<{ id: string, name: string, color: string | null, clientCount: number, createdAt: string | null, updatedAt: string | null }> } } } };

export type ClientTagCreateMutationVariables = Exact<{
  input: CreateTagInput;
}>;


export type ClientTagCreateMutation = { client: { tag: { create:
        | { __typename: 'CreateTagError', message: string, code: string, details: unknown }
        | { __typename: 'CreateTagSuccess', message: string, tag: { id: string, name: string, color: string | null, clientCount: number } }
       } } };

export type ClientTagUpdateMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type ClientTagUpdateMutation = { client: { tag: { update:
        | { __typename: 'UpdateTagError', message: string, code: string, details: unknown }
        | { __typename: 'UpdateTagSuccess', message: string, tag: { id: string, name: string, color: string | null, clientCount: number } }
       } } };

export type ClientTagDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type ClientTagDeleteMutation = { client: { tag: { delete:
        | { __typename: 'DeleteTagError', message: string, code: string, details: unknown }
        | { __typename: 'DeleteTagSuccess', message: string, success: boolean }
       } } };

export type DealPipelineQueryVariables = Exact<{
  id?: string | number | null | undefined;
}>;


export type DealPipelineQuery = { deal: { pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } | null } };

export type DealPipelinesQueryVariables = Exact<{
  includeArchived?: boolean;
}>;


export type DealPipelinesQuery = { deal: { pipelines: Array<{ ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } }> } };

export type DealPipelineFieldsFragment = { id: string, name: string, isDefault: boolean, isArchived: boolean, position: number, itemCount: number, stages: Array<{ id: string, name: string, color: string | null, position: number, isWon: boolean, isLost: boolean, itemCount: number }> } & { ' $fragmentName'?: 'DealPipelineFieldsFragment' };

export type DealCreatePipelineMutationVariables = Exact<{
  name: string;
  isDefault?: boolean;
  withDefaultStages?: boolean;
  cloneFromId?: string | number | null | undefined;
}>;


export type DealCreatePipelineMutation = { deal: { createPipeline:
      | { __typename: 'CreateDealPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDealPipelineSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealUpdatePipelineMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  isDefault?: boolean | null | undefined;
  position?: number | null | undefined;
}>;


export type DealUpdatePipelineMutation = { deal: { updatePipeline:
      | { __typename: 'UpdateDealPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateDealPipelineSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealArchivePipelineMutationVariables = Exact<{
  id: string | number;
}>;


export type DealArchivePipelineMutation = { deal: { archivePipeline:
      | { __typename: 'ArchiveDealPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'ArchiveDealPipelineSuccess', message: string, pipeline: { id: string, isArchived: boolean } }
     } };

export type DealDeletePipelineMutationVariables = Exact<{
  id: string | number;
  targetPipelineId?: string | number | null | undefined;
  mappings?: Array<StageMappingInput> | StageMappingInput | null | undefined;
}>;


export type DealDeletePipelineMutation = { deal: { deletePipeline:
      | { __typename: 'DeleteDealPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDealPipelineSuccess', message: string, success: boolean }
     } };

export type DealMovePipelineItemsMutationVariables = Exact<{
  fromPipelineId: string | number;
  toPipelineId: string | number;
  mappings: Array<StageMappingInput> | StageMappingInput;
}>;


export type DealMovePipelineItemsMutation = { deal: { movePipelineItems:
      | { __typename: 'MoveDealPipelineItemsError', message: string, code: string, details: unknown }
      | { __typename: 'MoveDealPipelineItemsSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealAddStageMutationVariables = Exact<{
  pipelineId: string | number;
  name: string;
  color?: string | null | undefined;
  position?: number | null | undefined;
  isWon?: boolean;
  isLost?: boolean;
}>;


export type DealAddStageMutation = { deal: { addStage:
      | { __typename: 'AddDealStageError', message: string, code: string, details: unknown }
      | { __typename: 'AddDealStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealUpdateStageMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  color?: string | null | undefined;
  isWon?: boolean | null | undefined;
  isLost?: boolean | null | undefined;
}>;


export type DealUpdateStageMutation = { deal: { updateStage:
      | { __typename: 'UpdateDealStageError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateDealStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealDeleteStageMutationVariables = Exact<{
  id: string | number;
  moveToStageId?: string | number | null | undefined;
}>;


export type DealDeleteStageMutation = { deal: { deleteStage:
      | { __typename: 'DeleteDealStageError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDealStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealReorderStagesMutationVariables = Exact<{
  pipelineId: string | number;
  stageIds: Array<string | number> | string | number;
}>;


export type DealReorderStagesMutation = { deal: { reorderStages:
      | { __typename: 'ReorderDealStagesError', message: string, code: string, details: unknown }
      | { __typename: 'ReorderDealStagesSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'DealPipelineFieldsFragment': DealPipelineFieldsFragment } } }
     } };

export type DealListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: DealFilter | null | undefined;
  order?: DealOrder | null | undefined;
}>;


export type DealListQuery = { deal: { list: { totalCount: number | null, items: Array<{ id: string, title: string, stageId: string, pipelineId: string, clientId: string, propertyId: string | null, assignedAgentId: string, expectedValue: string | null, pipelineValue: string | null, provisionAmount: string | null, provisionPercent: string | null, currency: string, transactionType: TransactionTypeEnum, nextStep: string | null, nextStepAt: string | null, expectedCloseDate: string | null, lostReason: string | null, updatedAt: string | null }> } } };

export type DealNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type DealNodeQuery = { deal: { node: { id: string, title: string, pipelineId: string, stageId: string, clientId: string, propertyId: string | null, leadId: string | null, assignedAgentId: string, expectedValue: string | null, actualValue: string | null, pipelineValue: string | null, provisionAmount: string | null, provisionPercent: string | null, provisionNotes: string | null, currency: string, nextStep: string | null, nextStepAt: string | null, expectedCloseDate: string | null, actualCloseDate: string | null, lostReason: string | null, transactionType: TransactionTypeEnum, description: string | null, provisionSplits: Array<{ id: string, dealId: string, userId: string, percent: string | null, amount: string | null, notes: string | null }>, payments: Array<{ id: string, type: PaymentTypeEnum, amount: string, currency: string, dueAt: string | null, paidAt: string | null, status: PaymentStatusEnum, payerClientId: string, payeeUserId: string | null, dealId: string, propertyId: string | null, variableSymbol: string | null, documentId: string | null, createdAt: string | null, updatedAt: string | null }> } | null } };

export type DealCreateMutationVariables = Exact<{
  input: CreateDealInput;
}>;


export type DealCreateMutation = { deal: { create:
      | { __typename: 'CreateDealError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDealSuccess', message: string, deal: { id: string } }
     } };

export type DealUpdateMutationVariables = Exact<{
  input: UpdateDealInput;
}>;


export type DealUpdateMutation = { deal: { update:
      | { __typename: 'UpdateDealError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateDealSuccess', message: string, deal: { id: string } }
     } };

export type DealChangeStageMutationVariables = Exact<{
  input: ChangeDealStageInput;
}>;


export type DealChangeStageMutation = { deal: { changeStage:
      | { __typename: 'ChangeDealStageError', message: string, code: string, details: unknown }
      | { __typename: 'ChangeDealStageSuccess', message: string, deal: { id: string, stageId: string } }
     } };

export type DealSetNextStepMutationVariables = Exact<{
  input: SetDealNextStepInput;
}>;


export type DealSetNextStepMutation = { deal: { setNextStep:
      | { __typename: 'SetDealNextStepError', message: string, code: string, details: unknown }
      | { __typename: 'SetDealNextStepSuccess', message: string, deal: { id: string, nextStep: string | null, nextStepAt: string | null } }
     } };

export type DealMarkWonMutationVariables = Exact<{
  input: MarkDealWonInput;
}>;


export type DealMarkWonMutation = { deal: { markWon:
      | { __typename: 'MarkDealWonError', message: string, code: string, details: unknown }
      | { __typename: 'MarkDealWonSuccess', message: string, deal: { id: string } }
     } };

export type DealMarkLostMutationVariables = Exact<{
  input: MarkDealLostInput;
}>;


export type DealMarkLostMutation = { deal: { markLost:
      | { __typename: 'MarkDealLostError', message: string, code: string, details: unknown }
      | { __typename: 'MarkDealLostSuccess', message: string, deal: { id: string, lostReason: string | null } }
     } };

export type DealDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type DealDeleteMutation = { deal: { delete:
      | { __typename: 'DeleteDealError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDealSuccess', message: string, success: boolean }
     } };

export type DealCreateProvisionSplitMutationVariables = Exact<{
  input: CreateDealProvisionSplitInput;
}>;


export type DealCreateProvisionSplitMutation = { deal: { createProvisionSplit:
      | { __typename: 'CreateDealProvisionSplitError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDealProvisionSplitSuccess', message: string, provisionSplit: { id: string, dealId: string, userId: string, percent: string | null, amount: string | null, notes: string | null } }
     } };

export type DealUpdateProvisionSplitMutationVariables = Exact<{
  input: UpdateDealProvisionSplitInput;
}>;


export type DealUpdateProvisionSplitMutation = { deal: { updateProvisionSplit:
      | { __typename: 'UpdateDealProvisionSplitError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateDealProvisionSplitSuccess', message: string, provisionSplit: { id: string, dealId: string, userId: string, percent: string | null, amount: string | null, notes: string | null } }
     } };

export type DealDeleteProvisionSplitMutationVariables = Exact<{
  id: string | number;
}>;


export type DealDeleteProvisionSplitMutation = { deal: { deleteProvisionSplit:
      | { __typename: 'DeleteDealProvisionSplitError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDealProvisionSplitSuccess', message: string, success: boolean }
     } };

export type EntityPickerDealsQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type EntityPickerDealsQuery = { deal: { list: { items: Array<{ id: string, title: string, transactionType: TransactionTypeEnum, expectedCloseDate: string | null, clientId: string, propertyId: string | null }> } } };

export type DocumentNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type DocumentNodeQuery = { document: { node: { id: string, kind: DmsNodeKindEnum, name: string, path: string, depth: number, parentId: string | null, rootId: string, documentId: string | null, propertyId: string | null, clientId: string | null, dealId: string | null, createdById: string | null, createdAt: string | null, updatedAt: string | null, deletedAt: string | null } } };

export type DocumentChildrenQueryVariables = Exact<{
  folderId: string | number;
  limit?: number;
  offset?: number;
}>;


export type DocumentChildrenQuery = { document: { children: { total: number, limit: number, offset: number, items: Array<{ id: string, kind: DmsNodeKindEnum, name: string, path: string, depth: number, parentId: string | null, rootId: string, documentId: string | null, propertyId: string | null, clientId: string | null, dealId: string | null, createdAt: string | null, updatedAt: string | null }> } } };

export type DocumentRootsQueryVariables = Exact<{
  limit?: number;
  offset?: number;
  entityKind?: string | null | undefined;
  orderBy?: string;
  descending?: boolean;
}>;


export type DocumentRootsQuery = { document: { roots: { total: number, limit: number, offset: number, items: Array<{ id: string, kind: DmsNodeKindEnum, name: string, path: string, depth: number, parentId: string | null, rootId: string, propertyId: string | null, clientId: string | null, dealId: string | null, entityLabel: string | null, entityKind: DmsEntityKindEnum | null, createdAt: string | null, updatedAt: string | null }> } } };

export type DocumentRootCountsQueryVariables = Exact<{ [key: string]: never; }>;


export type DocumentRootCountsQuery = { document: { rootCounts: { all: number, property: number, client: number, deal: number, other: number } } };

export type DocumentSubtreeFilesQueryVariables = Exact<{
  folderId: string | number;
  limit?: number;
  offset?: number;
}>;


export type DocumentSubtreeFilesQuery = { document: { subtreeFiles: { total: number, limit: number, offset: number, items: Array<{ id: string, kind: DmsNodeKindEnum, name: string, documentId: string | null, parentId: string | null, path: string, createdAt: string | null }> } } };

export type DocumentSearchQueryVariables = Exact<{
  query: string;
  folderId?: string | number | null | undefined;
  limit?: number;
  offset?: number;
}>;


export type DocumentSearchQuery = { document: { search: { total: number, limit: number, offset: number, items: Array<{ id: string, kind: DmsNodeKindEnum, name: string, path: string, depth: number, parentId: string | null, rootId: string, documentId: string | null, propertyId: string | null, clientId: string | null, dealId: string | null, entityLabel: string | null, entityKind: DmsEntityKindEnum | null, createdAt: string | null }> } } };

export type DocumentAncestorsQueryVariables = Exact<{
  id: string | number;
}>;


export type DocumentAncestorsQuery = { document: { ancestors: Array<{ id: string, kind: DmsNodeKindEnum, name: string, parentId: string | null, depth: number }> } };

export type DocumentSharesQueryVariables = Exact<{
  nodeId: string | number;
}>;


export type DocumentSharesQuery = { document: { shares: Array<{ id: string, dmsNodeId: string, label: string | null, scope: DmsShareScopeEnum, allowDownload: boolean, hasPassword: boolean, expiresAt: string | null, maxDownloads: number | null, downloadCount: number, revokedAt: string | null, createdById: string | null }> } };

export type DocumentTrashQueryVariables = Exact<{
  limit?: number;
  offset?: number;
}>;


export type DocumentTrashQuery = { document: { trash: { total: number, limit: number, offset: number, items: Array<{ id: string, kind: DmsNodeKindEnum, name: string, path: string, documentId: string | null, propertyId: string | null, clientId: string | null, dealId: string | null, deletedAt: string | null, createdAt: string | null }> } } };

export type DocumentVersionsQueryVariables = Exact<{
  id: string | number;
}>;


export type DocumentVersionsQuery = { document: { versions: Array<{ id: string, filename: string, originalName: string, mimeType: string, sizeBytes: number, version: number, supersedesId: string | null, uploadStatus: UploadStatusEnum, downloadUrl: string | null, createdAt: string | null }> } };

export type DocumentBlobQueryVariables = Exact<{
  id: string | number;
}>;


export type DocumentBlobQuery = { document: { document: { id: string, filename: string, originalName: string, mimeType: string, sizeBytes: number, category: DocumentCategoryEnum, isPublic: boolean, uploadStatus: UploadStatusEnum, uploadError: string | null, downloadUrl: string | null, version: number, supersedesId: string | null, createdAt: string | null, updatedAt: string | null } } };

export type DocumentCreateUploadIntentMutationVariables = Exact<{
  category: DocumentCategoryEnum;
  mimeType: string;
  originalName: string;
  folderId?: string | number | null | undefined;
  propertyId?: string | number | null | undefined;
  isPublic?: boolean;
  sizeBytes?: number | null | undefined;
}>;


export type DocumentCreateUploadIntentMutation = { document: { createUploadIntent:
      | { __typename: 'CreateDocumentUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDocumentUploadIntentSuccess', message: string, uploadIntent: { document: { id: string, uploadStatus: UploadStatusEnum, originalName: string }, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } } }
     } };

export type DocumentFinalizeUploadMutationVariables = Exact<{
  id: string | number;
}>;


export type DocumentFinalizeUploadMutation = { document: { finalizeUpload:
      | { __typename: 'FinalizeDocumentUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeDocumentUploadSuccess', message: string, document: { id: string, uploadStatus: UploadStatusEnum, uploadError: string | null, downloadUrl: string | null, originalName: string } }
     } };

export type DocumentAbortUploadMutationVariables = Exact<{
  id: string | number;
}>;


export type DocumentAbortUploadMutation = { document: { abortUpload:
      | { __typename: 'AbortDocumentUploadError', message: string, code: string, details: unknown }
      | { __typename: 'AbortDocumentUploadSuccess', message: string, success: boolean }
     } };

export type DocumentCreateFolderMutationVariables = Exact<{
  name: string;
  parentId?: string | number | null | undefined;
  propertyId?: string | number | null | undefined;
  clientId?: string | number | null | undefined;
  dealId?: string | number | null | undefined;
}>;


export type DocumentCreateFolderMutation = { document: { createFolder:
      | { __typename: 'CreateDocumentFolderError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDocumentFolderSuccess', message: string, node: { id: string, kind: DmsNodeKindEnum, name: string, parentId: string | null, path: string } }
     } };

export type DocumentEnsurePropertyFolderMutationVariables = Exact<{
  propertyId: string | number;
  name?: string;
}>;


export type DocumentEnsurePropertyFolderMutation = { document: { ensurePropertyFolder:
      | { __typename: 'EnsurePropertyDocumentFolderError', message: string, code: string, details: unknown }
      | { __typename: 'EnsurePropertyDocumentFolderSuccess', message: string, node: { id: string, kind: DmsNodeKindEnum, name: string, propertyId: string | null, path: string } }
     } };

export type DocumentEnsureClientFolderMutationVariables = Exact<{
  clientId: string | number;
  name?: string;
}>;


export type DocumentEnsureClientFolderMutation = { document: { ensureClientFolder:
      | { __typename: 'EnsureClientDocumentFolderError', message: string, code: string, details: unknown }
      | { __typename: 'EnsureClientDocumentFolderSuccess', message: string, node: { id: string, kind: DmsNodeKindEnum, name: string, clientId: string | null, path: string } }
     } };

export type DocumentEnsureDealFolderMutationVariables = Exact<{
  dealId: string | number;
  name?: string;
}>;


export type DocumentEnsureDealFolderMutation = { document: { ensureDealFolder:
      | { __typename: 'EnsureDealDocumentFolderError', message: string, code: string, details: unknown }
      | { __typename: 'EnsureDealDocumentFolderSuccess', message: string, node: { id: string, kind: DmsNodeKindEnum, name: string, dealId: string | null, path: string } }
     } };

export type DocumentPlaceInFolderMutationVariables = Exact<{
  documentId: string | number;
  folderId: string | number;
  name?: string | null | undefined;
}>;


export type DocumentPlaceInFolderMutation = { document: { placeDocumentInFolder:
      | { __typename: 'PlaceDocumentInFolderError', message: string, code: string, details: unknown }
      | { __typename: 'PlaceDocumentInFolderSuccess', message: string, node: { id: string, kind: DmsNodeKindEnum, name: string, documentId: string | null, parentId: string | null } }
     } };

export type DocumentRenameNodeMutationVariables = Exact<{
  id: string | number;
  name: string;
}>;


export type DocumentRenameNodeMutation = { document: { renameNode:
      | { __typename: 'RenameDocumentNodeError', message: string, code: string, details: unknown }
      | { __typename: 'RenameDocumentNodeSuccess', message: string, node: { id: string, name: string } }
     } };

export type DocumentMoveNodeMutationVariables = Exact<{
  id: string | number;
  newParentId: string | number;
}>;


export type DocumentMoveNodeMutation = { document: { moveNode:
      | { __typename: 'MoveDocumentNodeError', message: string, code: string, details: unknown }
      | { __typename: 'MoveDocumentNodeSuccess', message: string, node: { id: string, parentId: string | null, path: string } }
     } };

export type DocumentDeleteNodeMutationVariables = Exact<{
  id: string | number;
}>;


export type DocumentDeleteNodeMutation = { document: { deleteNode:
      | { __typename: 'DeleteDocumentNodeError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDocumentNodeSuccess', message: string, success: boolean }
     } };

export type DocumentRestoreNodeMutationVariables = Exact<{
  id: string | number;
}>;


export type DocumentRestoreNodeMutation = { document: { restoreNode:
      | { __typename: 'RestoreDocumentNodeError', message: string, code: string, details: unknown }
      | { __typename: 'RestoreDocumentNodeSuccess', message: string, node: { id: string, name: string, deletedAt: string | null, parentId: string | null } }
     } };

export type DocumentReplaceFileMutationVariables = Exact<{
  nodeId: string | number;
  documentId: string | number;
  name?: string | null | undefined;
}>;


export type DocumentReplaceFileMutation = { document: { replaceFile:
      | { __typename: 'ReplaceDocumentFileError', message: string, code: string, details: unknown }
      | { __typename: 'ReplaceDocumentFileSuccess', message: string, node: { id: string, name: string, documentId: string | null } }
     } };

export type DocumentCreateShareMutationVariables = Exact<{
  nodeId: string | number;
  label?: string | null | undefined;
  password?: string | null | undefined;
  allowDownload?: boolean;
  expiresAt?: string | null | undefined;
  expiresInHours?: number | null | undefined;
  maxDownloads?: number | null | undefined;
}>;


export type DocumentCreateShareMutation = { document: { createShare:
      | { __typename: 'CreateDocumentShareError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDocumentShareSuccess', message: string, share: { token: string, url: string, urlPath: string, share: { id: string, label: string | null, scope: DmsShareScopeEnum, allowDownload: boolean, hasPassword: boolean, expiresAt: string | null, maxDownloads: number | null } } }
     } };

export type DocumentRevokeShareMutationVariables = Exact<{
  id: string | number;
}>;


export type DocumentRevokeShareMutation = { document: { revokeShare:
      | { __typename: 'RevokeDocumentShareError', message: string, code: string, details: unknown }
      | { __typename: 'RevokeDocumentShareSuccess', message: string, success: boolean }
     } };

export type DocumentCreateFolderZipMutationVariables = Exact<{
  folderId: string | number;
}>;


export type DocumentCreateFolderZipMutation = { document: { createFolderZip:
      | { __typename: 'CreateDocumentFolderZipError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDocumentFolderZipSuccess', message: string, job: { queued: boolean, folderId: string, fileCount: number } }
     } };

export type DocumentAttachToPropertyMutationVariables = Exact<{
  documentId: string | number;
  propertyId: string | number;
}>;


export type DocumentAttachToPropertyMutation = { document: { attachToProperty:
      | { __typename: 'AttachDocumentToPropertyError', message: string, code: string, details: unknown }
      | { __typename: 'AttachDocumentToPropertySuccess', message: string, document: { id: string, originalName: string } }
     } };

export type IdentityLicenseOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityLicenseOrganizationsQuery = { identity: { licenseOrganizations: Array<{ id: string, name: string, slug: string, createdAt: string, modelType: OrganizationModelTypeEnum, licenseStatus: LicenseStatusEnum, licenseBundling: LicenseBundlingEnum, subscriptionStatus: OrganizationSubscriptionStatusEnum, trialEndsAt: string | null, userCount: number, venueCount: number, listingCount: number, accessActive: boolean }> } };

export type IdentityCreateLicenseOrganizationMutationVariables = Exact<{
  name: string;
  bundling: LicenseBundlingEnum;
  ownerLoginEmail: string;
  ownerFirstName: string;
  ownerLastName: string;
  ownerPassword: string;
  slug?: string | null | undefined;
  timezone?: string | null | undefined;
  locale?: string | null | undefined;
  childModelType?: OrganizationModelTypeEnum | null | undefined;
}>;


export type IdentityCreateLicenseOrganizationMutation = { identity: { createLicenseOrganization:
      | { __typename: 'CreateLicenseOrganizationError', message: string, code: string, details: unknown }
      | { __typename: 'CreateLicenseOrganizationSuccess', message: string, organization: { id: string, name: string, slug: string, modelType: OrganizationModelTypeEnum, licenseStatus: LicenseStatusEnum | null, licenseBundling: LicenseBundlingEnum | null } }
     } };

export type IdentitySuspendLicenseMutationVariables = Exact<{
  organizationId: string | number;
}>;


export type IdentitySuspendLicenseMutation = { identity: { suspendLicense:
      | { __typename: 'SuspendLicenseError', message: string, code: string, details: unknown }
      | { __typename: 'SuspendLicenseSuccess', message: string, organization: { id: string, name: string, licenseStatus: LicenseStatusEnum | null } }
     } };

export type IdentityReactivateLicenseMutationVariables = Exact<{
  organizationId: string | number;
}>;


export type IdentityReactivateLicenseMutation = { identity: { reactivateLicense:
      | { __typename: 'ReactivateLicenseError', message: string, code: string, details: unknown }
      | { __typename: 'ReactivateLicenseSuccess', message: string, organization: { id: string, name: string, licenseStatus: LicenseStatusEnum | null } }
     } };

export type IdentityCreateOrganizationMutationVariables = Exact<{
  input: CreateOrganizationInput;
}>;


export type IdentityCreateOrganizationMutation = { identity: { createOrganization:
      | { __typename: 'CreateOrganizationError', message: string, code: string, details: unknown }
      | { __typename: 'CreateOrganizationSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, organization: { id: string, name: string, slug: string, modelType: OrganizationModelTypeEnum }, user: { id: string, loginEmail: string, role: UserRoleEnum } }
     } };

export type IdentityPublicSignupEnabledQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityPublicSignupEnabledQuery = { identity: { publicSignupEnabled: boolean } };

export type IdentitySignupPlansQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentitySignupPlansQuery = { identity: { signupPlans: Array<{ id: string, code: string, name: string, description: string | null, priceAmount: string, currency: string, billingPeriod: BillingPeriodEnum, includedCredits: number, seatLimit: number | null, isPublic: boolean }> } };

export type IdentitySignupLookupAresQueryVariables = Exact<{
  ico: string;
}>;


export type IdentitySignupLookupAresQuery = { identity: { signupLookupAres: { ico: string, dic: string | null, companyName: string, legalForm: string | null, seatAddress: string | null } | null } };

export type IdentityLoginMutationVariables = Exact<{
  input: LoginInput;
}>;


export type IdentityLoginMutation = { identity: { login:
      | { __typename: 'LoginError', message: string, code: string, details: unknown }
      | { __typename: 'LoginSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityRefreshMutationVariables = Exact<{
  input: RefreshInput;
}>;


export type IdentityRefreshMutation = { identity: { refresh:
      | { __typename: 'RefreshError', message: string, code: string, details: unknown }
      | { __typename: 'RefreshSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityLogoutMutationVariables = Exact<{
  refreshToken?: string | null | undefined;
  allSessions?: boolean | null | undefined;
}>;


export type IdentityLogoutMutation = { identity: { logout:
      | { __typename: 'LogoutError', message: string, code: string, details: unknown }
      | { __typename: 'LogoutSuccess', message: string, success: boolean }
     } };

export type IdentityChangePasswordMutationVariables = Exact<{
  input: ChangePasswordInput;
}>;


export type IdentityChangePasswordMutation = { identity: { changePassword:
      | { __typename: 'ChangePasswordError', message: string, code: string, details: unknown }
      | { __typename: 'ChangePasswordSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityRequestPasswordResetMutationVariables = Exact<{
  input: RequestPasswordResetInput;
}>;


export type IdentityRequestPasswordResetMutation = { identity: { requestPasswordReset:
      | { __typename: 'RequestPasswordResetError', message: string, code: string, details: unknown }
      | { __typename: 'RequestPasswordResetSuccess', message: string, success: boolean }
     } };

export type IdentityResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type IdentityResetPasswordMutation = { identity: { resetPassword:
      | { __typename: 'ResetPasswordError', message: string, code: string, details: unknown }
      | { __typename: 'ResetPasswordSuccess', message: string, success: boolean }
     } };

export type IdentityCompleteOauthLoginMutationVariables = Exact<{
  pendingToken: string;
  totpCode: string;
}>;


export type IdentityCompleteOauthLoginMutation = { identity: { completeOauthLogin:
      | { __typename: 'CompleteOauthLoginError', message: string, code: string, details: unknown }
      | { __typename: 'CompleteOauthLoginSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityMeQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityMeQuery = { identity: { me: { id: string, loginEmail: string, firstName: string, lastName: string, role: UserRoleEnum, isActive: boolean, avatarUrl: string | null, publicSlug: string | null, publicTitle: string | null, publicEmail: string | null, publicPhone: string | null, publicBio: unknown, showPublicProfile: boolean, mustResetPassword: boolean, totpEnabled: boolean } } };

export type IdentityUsersQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: UserFilter | null | undefined;
  order?: UserOrder | null | undefined;
}>;


export type IdentityUsersQuery = { identity: { users: { totalCount: number | null, items: Array<{ id: string, loginEmail: string, firstName: string, lastName: string, role: UserRoleEnum, isActive: boolean, venueId: string, avatarUrl: string | null, publicPhone: string | null, createdAt: string | null }> } } };

export type IdentityCalendarFeedUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityCalendarFeedUrlQuery = { identity: { calendarFeedUrl: string } };

export type IdentityReadyQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityReadyQuery = { identity: { ready: boolean } };

export type IdentityGoogleLoginEligibleQueryVariables = Exact<{
  loginEmail?: string | null | undefined;
  organizationSlug?: string | null | undefined;
}>;


export type IdentityGoogleLoginEligibleQuery = { identity: { googleLoginEligible: boolean } };

export type IdentityMetaLoginEligibleQueryVariables = Exact<{
  loginEmail?: string | null | undefined;
  organizationSlug?: string | null | undefined;
}>;


export type IdentityMetaLoginEligibleQuery = { identity: { metaLoginEligible: boolean } };

export type IdentityTeamsQueryVariables = Exact<{
  limit?: number;
  offset?: number;
  venueId?: string | number | null | undefined;
}>;


export type IdentityTeamsQuery = { identity: { teams: Array<{ id: string, name: string, venueId: string, leaderId: string | null, memberIds: Array<string>, createdAt: string | null }> } };

export type IdentityTeamQueryVariables = Exact<{
  id: string | number;
}>;


export type IdentityTeamQuery = { identity: { team: { id: string, name: string, leaderId: string | null, memberIds: Array<string>, createdAt: string | null, updatedAt: string | null } } };

export type IdentityCreateUserMutationVariables = Exact<{
  loginEmail: string;
  firstName: string;
  lastName: string;
  password?: string | null | undefined;
  role: UserRoleEnum;
  isActive?: boolean;
  venueId?: string | number | null | undefined;
  provisionSrealitySeller?: boolean | null | undefined;
  alreadyRegisteredOnSreality?: boolean | null | undefined;
  srealityClientLogin?: string | null | undefined;
  srealityContactGsm?: string | null | undefined;
  srealityClientIc?: string | null | undefined;
  srealityIsEmployee?: boolean | null | undefined;
  idempotencyKey?: string | null | undefined;
}>;


export type IdentityCreateUserMutation = { identity: { createUser:
      | { __typename: 'CreateUserError', message: string, code: string, details: unknown }
      | { __typename: 'CreateUserSuccess', message: string, inviteUrl: string | null, inviteEmailSent: boolean, mustResetPassword: boolean, user: { id: string, loginEmail: string, firstName: string, lastName: string, role: UserRoleEnum, isActive: boolean, venueId: string, mustResetPassword: boolean } }
     } };

export type IdentityUpdateUserMutationVariables = Exact<{
  id: string | number;
  firstName?: string | null | undefined;
  lastName?: string | null | undefined;
  loginEmail?: string | null | undefined;
  role?: UserRoleEnum | null | undefined;
  isActive?: boolean | null | undefined;
  password?: string | null | undefined;
  venueId?: string | number | null | undefined;
  provisionSrealitySeller?: boolean | null | undefined;
  alreadyRegisteredOnSreality?: boolean | null | undefined;
  srealityClientLogin?: string | null | undefined;
  srealityContactGsm?: string | null | undefined;
  srealityClientIc?: string | null | undefined;
  srealityIsEmployee?: boolean | null | undefined;
}>;


export type IdentityUpdateUserMutation = { identity: { updateUser:
      | { __typename: 'UpdateUserError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateUserSuccess', message: string, user: { id: string, loginEmail: string, firstName: string, lastName: string, role: UserRoleEnum, isActive: boolean, venueId: string } }
     } };

export type IdentitySetUserActiveMutationVariables = Exact<{
  id: string | number;
  isActive: boolean;
}>;


export type IdentitySetUserActiveMutation = { identity: { setUserActive:
      | { __typename: 'SetUserActiveError', message: string, code: string, details: unknown }
      | { __typename: 'SetUserActiveSuccess', message: string, user: { id: string, isActive: boolean } }
     } };

export type IdentityCreateTeamMutationVariables = Exact<{
  name: string;
  leaderId?: string | number | null | undefined;
  venueId?: string | number | null | undefined;
}>;


export type IdentityCreateTeamMutation = { identity: { createTeam:
      | { __typename: 'CreateTeamError', message: string, code: string, details: unknown }
      | { __typename: 'CreateTeamSuccess', message: string, team: { id: string, name: string, venueId: string, leaderId: string | null, memberIds: Array<string> } }
     } };

export type IdentityUpdateTeamMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  leaderId?: string | number | null | undefined;
}>;


export type IdentityUpdateTeamMutation = { identity: { updateTeam:
      | { __typename: 'UpdateTeamError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateTeamSuccess', message: string, team: { id: string, name: string, leaderId: string | null, memberIds: Array<string> } }
     } };

export type IdentityAddTeamMemberMutationVariables = Exact<{
  teamId: string | number;
  userId: string | number;
}>;


export type IdentityAddTeamMemberMutation = { identity: { addTeamMember:
      | { __typename: 'AddTeamMemberError', message: string, code: string, details: unknown }
      | { __typename: 'AddTeamMemberSuccess', message: string, team: { id: string, memberIds: Array<string> } }
     } };

export type IdentityRemoveTeamMemberMutationVariables = Exact<{
  teamId: string | number;
  userId: string | number;
}>;


export type IdentityRemoveTeamMemberMutation = { identity: { removeTeamMember:
      | { __typename: 'RemoveTeamMemberError', message: string, code: string, details: unknown }
      | { __typename: 'RemoveTeamMemberSuccess', message: string, team: { id: string, leaderId: string | null, memberIds: Array<string> } }
     } };

export type IdentityDeleteTeamMutationVariables = Exact<{
  id: string | number;
  memberTeamId?: string | number | null | undefined;
}>;


export type IdentityDeleteTeamMutation = { identity: { deleteTeam:
      | { __typename: 'DeleteTeamError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteTeamSuccess', message: string, success: boolean }
     } };

export type IdentityCreateAvatarUploadIntentMutationVariables = Exact<{
  input: AvatarUploadIntentInput;
}>;


export type IdentityCreateAvatarUploadIntentMutation = { identity: { createAvatarUploadIntent:
      | { __typename: 'CreateAvatarUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateAvatarUploadIntentSuccess', message: string, storageKey: string, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type IdentityFinalizeAvatarUploadMutationVariables = Exact<{
  input: FinalizeAvatarInput;
}>;


export type IdentityFinalizeAvatarUploadMutation = { identity: { finalizeAvatarUpload:
      | { __typename: 'FinalizeAvatarUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeAvatarUploadSuccess', message: string, user: { id: string, avatarUrl: string | null } }
     } };

export type IdentityAbortAvatarUploadMutationVariables = Exact<{
  input: AbortAvatarInput;
}>;


export type IdentityAbortAvatarUploadMutation = { identity: { abortAvatarUpload:
      | { __typename: 'AbortAvatarUploadError', message: string, code: string, details: unknown }
      | { __typename: 'AbortAvatarUploadSuccess', message: string, success: boolean }
     } };

export type IdentityCreateOrgLogoUploadIntentMutationVariables = Exact<{
  input: OrgLogoUploadIntentInput;
}>;


export type IdentityCreateOrgLogoUploadIntentMutation = { identity: { createOrgLogoUploadIntent:
      | { __typename: 'CreateOrgLogoUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateOrgLogoUploadIntentSuccess', message: string, storageKey: string, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type IdentityFinalizeOrgLogoUploadMutationVariables = Exact<{
  input: FinalizeOrgLogoInput;
}>;


export type IdentityFinalizeOrgLogoUploadMutation = { identity: { finalizeOrgLogoUpload:
      | { __typename: 'FinalizeOrgLogoUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeOrgLogoUploadSuccess', message: string, organization: { id: string, branding: unknown } }
     } };

export type IdentityAbortOrgLogoUploadMutationVariables = Exact<{
  input: AbortOrgLogoInput;
}>;


export type IdentityAbortOrgLogoUploadMutation = { identity: { abortOrgLogoUpload:
      | { __typename: 'AbortOrgLogoUploadError', message: string, code: string, details: unknown }
      | { __typename: 'AbortOrgLogoUploadSuccess', message: string, success: boolean }
     } };

export type IdentityClearOrgLogoMutationVariables = Exact<{ [key: string]: never; }>;


export type IdentityClearOrgLogoMutation = { identity: { clearOrgLogo:
      | { __typename: 'ClearOrgLogoError', message: string, code: string, details: unknown }
      | { __typename: 'ClearOrgLogoSuccess', message: string, organization: { id: string, branding: unknown } }
     } };

export type IdentityUpdatePublicProfileMutationVariables = Exact<{
  input: UpdatePublicProfileInput;
}>;


export type IdentityUpdatePublicProfileMutation = { identity: { updatePublicProfile:
      | { __typename: 'UpdatePublicProfileError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePublicProfileSuccess', message: string, user: { id: string, firstName: string, lastName: string, publicSlug: string | null, publicTitle: string | null, publicEmail: string | null, publicPhone: string | null, publicBio: unknown, showPublicProfile: boolean } }
     } };

export type IdentitySettingsQueryVariables = Exact<{
  userId?: string | number | null | undefined;
}>;


export type IdentitySettingsQuery = { identity: { settings: { locale: string, theme: string, timezone: string, dateFormat: string, defaultCalendarScope: CalendarScopeEnum, taskListDefaultScope: CalendarScopeEnum, preferredTaskPipelineId: string | null, notifyPrefs: unknown, messagesLayout: unknown } } };

export type IdentityUpdateSettingsMutationVariables = Exact<{
  locale?: string | null | undefined;
  theme?: string | null | undefined;
  timezone?: string | null | undefined;
  dateFormat?: string | null | undefined;
  defaultCalendarScope?: CalendarScopeEnum | null | undefined;
  taskListDefaultScope?: CalendarScopeEnum | null | undefined;
  preferredTaskPipelineId?: string | number | null | undefined;
  notifyPrefs?: unknown;
  messagesLayout?: unknown;
  userId?: string | number | null | undefined;
}>;


export type IdentityUpdateSettingsMutation = { identity: { updateSettings:
      | { __typename: 'UpdateSettingsError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateSettingsSuccess', message: string, settings: { locale: string, theme: string, timezone: string, dateFormat: string, defaultCalendarScope: CalendarScopeEnum, taskListDefaultScope: CalendarScopeEnum, preferredTaskPipelineId: string | null, notifyPrefs: unknown, messagesLayout: unknown } }
     } };

export type IdentityCalendarSyncQueryVariables = Exact<{
  userId?: string | number | null | undefined;
}>;


export type IdentityCalendarSyncQuery = { identity: { calendarSync: { userId: string, provider: CalendarProviderEnum, syncInbound: boolean, syncOutbound: boolean, externalCalendarId: string | null, exportOwnTasksDefault: boolean, includeTeamExportable: boolean, skipPrivateInbound: boolean, lastManualSyncAt: string | null, manualSyncCooldownUntil: string | null } } };

export type IdentityUpdateCalendarSyncMutationVariables = Exact<{
  provider?: CalendarProviderEnum | null | undefined;
  syncInbound?: boolean | null | undefined;
  syncOutbound?: boolean | null | undefined;
  externalCalendarId?: string | null | undefined;
  exportOwnTasksDefault?: boolean | null | undefined;
  includeTeamExportable?: boolean | null | undefined;
  skipPrivateInbound?: boolean | null | undefined;
  userId?: string | number | null | undefined;
}>;


export type IdentityUpdateCalendarSyncMutation = { identity: { updateCalendarSync:
      | { __typename: 'UpdateCalendarSyncError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateCalendarSyncSuccess', message: string, settings: { userId: string, provider: CalendarProviderEnum, syncInbound: boolean, syncOutbound: boolean, externalCalendarId: string | null, exportOwnTasksDefault: boolean, includeTeamExportable: boolean, skipPrivateInbound: boolean, lastManualSyncAt: string | null, manualSyncCooldownUntil: string | null } }
     } };

export type IdentityConnectCalendarMutationVariables = Exact<{
  provider?: CalendarProviderEnum;
  returnTo?: string | null | undefined;
}>;


export type IdentityConnectCalendarMutation = { identity: { connectCalendar:
      | { __typename: 'ConnectCalendarError', message: string, code: string, details: unknown }
      | { __typename: 'ConnectCalendarSuccess', message: string, oauthStart: { provider: CalendarProviderEnum, authorizationUrl: string | null, stub: boolean } }
     } };

export type IdentityConnectGoogleMutationVariables = Exact<{
  returnTo?: string | null | undefined;
}>;


export type IdentityConnectGoogleMutation = { identity: { connectGoogle:
      | { __typename: 'ConnectGoogleError', message: string, code: string, details: unknown }
      | { __typename: 'ConnectGoogleSuccess', message: string, oauthStart: { provider: CalendarProviderEnum, authorizationUrl: string | null, stub: boolean } }
     } };

export type IdentityDisconnectGoogleMutationVariables = Exact<{ [key: string]: never; }>;


export type IdentityDisconnectGoogleMutation = { identity: { disconnectGoogle:
      | { __typename: 'DisconnectGoogleError', message: string, code: string, details: unknown }
      | { __typename: 'DisconnectGoogleSuccess', message: string, success: boolean }
     } };

export type IdentityUnlinkGoogleMutationVariables = Exact<{ [key: string]: never; }>;


export type IdentityUnlinkGoogleMutation = { identity: { unlinkGoogle:
      | { __typename: 'UnlinkGoogleError', message: string, code: string, details: unknown }
      | { __typename: 'UnlinkGoogleSuccess', message: string, success: boolean }
     } };

export type IdentityConnectPersonalMetaMutationVariables = Exact<{
  returnTo?: string | null | undefined;
}>;


export type IdentityConnectPersonalMetaMutation = { identity: { connectPersonalMeta:
      | { __typename: 'ConnectPersonalMetaError', message: string, code: string, details: unknown }
      | { __typename: 'ConnectPersonalMetaSuccess', message: string, oauthStart: { provider: string, authorizationUrl: string | null, stub: boolean } }
     } };

export type IdentityUnlinkPersonalMetaMutationVariables = Exact<{ [key: string]: never; }>;


export type IdentityUnlinkPersonalMetaMutation = { identity: { unlinkPersonalMeta:
      | { __typename: 'UnlinkPersonalMetaError', message: string, code: string, details: unknown }
      | { __typename: 'UnlinkPersonalMetaSuccess', message: string, success: boolean }
     } };

export type IdentityCompletePersonalMetaSetupMutationVariables = Exact<{
  input: CompleteMetaSetupInput;
}>;


export type IdentityCompletePersonalMetaSetupMutation = { identity: { completePersonalMetaSetup:
      | { __typename: 'CompletePersonalMetaSetupError', message: string, code: string, details: unknown }
      | { __typename: 'CompletePersonalMetaSetupSuccess', message: string, status: { configured: boolean, connected: boolean, stub: boolean, setupComplete: boolean, pendingPageSelection: boolean, connectionId: string | null, pageId: string | null, pageName: string | null, igUserId: string | null, igUsername: string | null, availablePages: Array<{ id: string, name: string }> | null } }
     } };

export type IdentityPersonalMetaStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityPersonalMetaStatusQuery = { identity: { personalMetaStatus: { configured: boolean, connected: boolean, stub: boolean, setupComplete: boolean, pendingPageSelection: boolean, connectionId: string | null, pageId: string | null, pageName: string | null, igUserId: string | null, igUsername: string | null, message: string, availablePages: Array<{ id: string, name: string }> | null } } };

export type IdentityStartGoogleLoginMutationVariables = Exact<{
  organizationSlug?: string | null | undefined;
  returnTo?: string | null | undefined;
}>;


export type IdentityStartGoogleLoginMutation = { identity: { startGoogleLogin:
      | { __typename: 'StartGoogleLoginError', message: string, code: string, details: unknown }
      | { __typename: 'StartGoogleLoginSuccess', message: string, oauthStart: { provider: CalendarProviderEnum, authorizationUrl: string | null, stub: boolean } }
     } };

export type IdentityLoginWithGoogleMutationVariables = Exact<{
  code: string;
  state: string;
  totpCode?: string | null | undefined;
}>;


export type IdentityLoginWithGoogleMutation = { identity: { loginWithGoogle:
      | { __typename: 'LoginWithGoogleError', message: string, code: string, details: unknown }
      | { __typename: 'LoginWithGoogleSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityStartMetaLoginMutationVariables = Exact<{
  organizationSlug?: string | null | undefined;
  returnTo?: string | null | undefined;
}>;


export type IdentityStartMetaLoginMutation = { identity: { startMetaLogin:
      | { __typename: 'StartMetaLoginError', message: string, code: string, details: unknown }
      | { __typename: 'StartMetaLoginSuccess', message: string, oauthStart: { provider: string, authorizationUrl: string | null, stub: boolean } }
     } };

export type IdentityLoginWithMetaMutationVariables = Exact<{
  code: string;
  state: string;
  totpCode?: string | null | undefined;
}>;


export type IdentityLoginWithMetaMutation = { identity: { loginWithMeta:
      | { __typename: 'LoginWithMetaError', message: string, code: string, details: unknown }
      | { __typename: 'LoginWithMetaSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityDisconnectCalendarMutationVariables = Exact<{
  provider?: CalendarProviderEnum;
}>;


export type IdentityDisconnectCalendarMutation = { identity: { disconnectCalendar:
      | { __typename: 'DisconnectCalendarError', message: string, code: string, details: unknown }
      | { __typename: 'DisconnectCalendarSuccess', message: string, success: boolean }
     } };

export type IdentityCalendarOAuthStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityCalendarOAuthStatusQuery = { identity: { calendarOauthStatus: { googleConfigured: boolean, microsoftConfigured: boolean } } };

export type IdentityCredentialsQueryVariables = Exact<{
  userId?: string | number | null | undefined;
}>;


export type IdentityCredentialsQuery = { identity: { credentials: Array<{ id: string, provider: UserCredentialProviderEnum, authType: IntegrationAuthTypeEnum, externalId: string | null, status: UserCredentialStatusEnum, hasCredential: boolean, lastError: string | null, lastSyncedAt: string | null, settings: unknown }> } };

export type IdentitySrealitySellersQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentitySrealitySellersQuery = { identity: { srealitySellers: Array<{ sellerId: string, clientLogin: string, clientName: string, contactGsm: string | null, clientIsEmployee: boolean }> } };

export type IdentityOrganizationQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityOrganizationQuery = { identity: { organization: { id: string, name: string, slug: string, timezone: string, locale: string, aiFeaturesEnabled: boolean, branding: unknown, legalEntityId: string | null, modelType: OrganizationModelTypeEnum, parentOrganizationId: string | null, licenseStatus: LicenseStatusEnum | null, licenseBundling: LicenseBundlingEnum | null, subscriptionStatus: OrganizationSubscriptionStatusEnum, trialEndsAt: string | null, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null } } };

export type IdentityUpdateOrganizationMutationVariables = Exact<{
  name?: string | null | undefined;
  slug?: string | null | undefined;
  timezone?: string | null | undefined;
  locale?: string | null | undefined;
  aiFeaturesEnabled?: boolean | null | undefined;
  branding?: unknown;
  legalEntityId?: string | number | null | undefined;
}>;


export type IdentityUpdateOrganizationMutation = { identity: { updateOrganization:
      | { __typename: 'UpdateOrganizationError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateOrganizationSuccess', message: string, organization: { id: string, name: string, slug: string, timezone: string, locale: string, aiFeaturesEnabled: boolean, branding: unknown, legalEntityId: string | null, modelType: OrganizationModelTypeEnum, parentOrganizationId: string | null, licenseStatus: LicenseStatusEnum | null, licenseBundling: LicenseBundlingEnum | null, subscriptionStatus: OrganizationSubscriptionStatusEnum, trialEndsAt: string | null, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null } }
     } };

export type IdentityVenuesQueryVariables = Exact<{
  limit?: number;
  offset?: number;
}>;


export type IdentityVenuesQuery = { identity: { venues: Array<{ id: string, name: string, slug: string, isActive: boolean, legalEntityId: string | null, inheritsLegalEntity: boolean, userIds: Array<string>, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null, effectiveLegalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null }> } };

export type IdentityLegalEntitiesQueryVariables = Exact<{
  limit?: number;
  offset?: number;
}>;


export type IdentityLegalEntitiesQuery = { identity: { legalEntities: Array<{ id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null }> } };

export type IdentityCreateLegalEntityMutationVariables = Exact<{
  name: string;
  ico?: string | null | undefined;
  dic?: string | null | undefined;
  address?: string | null | undefined;
  phone?: string | null | undefined;
  email?: string | null | undefined;
  website?: string | null | undefined;
}>;


export type IdentityCreateLegalEntityMutation = { identity: { createLegalEntity:
      | { __typename: 'CreateLegalEntityError', message: string, code: string, details: unknown }
      | { __typename: 'CreateLegalEntitySuccess', message: string, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } }
     } };

export type IdentityUpdateLegalEntityMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  ico?: string | null | undefined;
  dic?: string | null | undefined;
  address?: string | null | undefined;
  phone?: string | null | undefined;
  email?: string | null | undefined;
  website?: string | null | undefined;
}>;


export type IdentityUpdateLegalEntityMutation = { identity: { updateLegalEntity:
      | { __typename: 'UpdateLegalEntityError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateLegalEntitySuccess', message: string, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } }
     } };

export type IdentityDeleteLegalEntityMutationVariables = Exact<{
  id: string | number;
}>;


export type IdentityDeleteLegalEntityMutation = { identity: { deleteLegalEntity:
      | { __typename: 'DeleteLegalEntityError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteLegalEntitySuccess', message: string, success: boolean }
     } };

export type IdentityCreateVenueMutationVariables = Exact<{
  name: string;
  slug?: string | null | undefined;
  isActive?: boolean;
  legalEntityId?: string | number | null | undefined;
}>;


export type IdentityCreateVenueMutation = { identity: { createVenue:
      | { __typename: 'CreateVenueError', message: string, code: string, details: unknown }
      | { __typename: 'CreateVenueSuccess', message: string, venue: { id: string, name: string, slug: string, isActive: boolean, legalEntityId: string | null, inheritsLegalEntity: boolean, userIds: Array<string>, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null, effectiveLegalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null } }
     } };

export type IdentityUpdateVenueMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  slug?: string | null | undefined;
  isActive?: boolean | null | undefined;
  legalEntityId?: string | number | null | undefined;
}>;


export type IdentityUpdateVenueMutation = { identity: { updateVenue:
      | { __typename: 'UpdateVenueError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateVenueSuccess', message: string, venue: { id: string, name: string, slug: string, isActive: boolean, legalEntityId: string | null, inheritsLegalEntity: boolean, userIds: Array<string>, legalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null, effectiveLegalEntity: { id: string, name: string, ico: string | null, dic: string | null, address: string | null, phone: string | null, email: string | null, website: string | null } | null } }
     } };

export type IdentityDeleteVenueMutationVariables = Exact<{
  id: string | number;
  memberVenueId?: string | number | null | undefined;
}>;


export type IdentityDeleteVenueMutation = { identity: { deleteVenue:
      | { __typename: 'DeleteVenueError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteVenueSuccess', message: string, success: boolean }
     } };

export type IdentityProvisionSrealitySellerMutationVariables = Exact<{
  userId: string | number;
  clientLogin: string;
  contactGsm: string;
  clientIc?: string | null | undefined;
  isEmployee?: boolean | null | undefined;
  alreadyRegisteredOnSreality?: boolean | null | undefined;
}>;


export type IdentityProvisionSrealitySellerMutation = { identity: { provisionSrealitySeller:
      | { __typename: 'ProvisionSrealitySellerError', message: string, code: string, details: unknown }
      | { __typename: 'ProvisionSrealitySellerSuccess', message: string, credential: { id: string, provider: UserCredentialProviderEnum, status: UserCredentialStatusEnum, externalId: string | null, lastError: string | null, hasCredential: boolean } }
     } };

export type IdentityAcceptInviteMutationVariables = Exact<{
  token: string;
  password: string;
}>;


export type IdentityAcceptInviteMutation = { identity: { acceptInvite:
      | { __typename: 'AcceptInviteError', message: string, code: string, details: unknown }
      | { __typename: 'AcceptInviteSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type IdentityTotpStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IdentityTotpStatusQuery = { identity: { me: { totpEnabled: boolean } } };

export type IdentityStartTotpSetupMutationVariables = Exact<{ [key: string]: never; }>;


export type IdentityStartTotpSetupMutation = { identity: { startTotpSetup:
      | { __typename: 'StartTotpSetupError', message: string, code: string, details: unknown }
      | { __typename: 'StartTotpSetupSuccess', message: string, secret: string, otpauthUrl: string }
     } };

export type IdentityConfirmTotpMutationVariables = Exact<{
  code: string;
}>;


export type IdentityConfirmTotpMutation = { identity: { confirmTotp:
      | { __typename: 'ConfirmTotpError', message: string, code: string, details: unknown }
      | { __typename: 'ConfirmTotpSuccess', message: string, user: { id: string, totpEnabled: boolean } }
     } };

export type IdentityDisableTotpMutationVariables = Exact<{
  password: string;
}>;


export type IdentityDisableTotpMutation = { identity: { disableTotp:
      | { __typename: 'DisableTotpError', message: string, code: string, details: unknown }
      | { __typename: 'DisableTotpSuccess', message: string, user: { id: string, totpEnabled: boolean } }
     } };

export type IntegrationListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type IntegrationListQuery = { integration: { list: { totalCount: number | null, items: Array<{ id: string, name: string, provider: IntegrationProviderEnum, direction: IntegrationDirectionEnum, authType: IntegrationAuthTypeEnum, isActive: boolean, lastSyncedAt: string | null, hasCredentials: boolean, settings: unknown, feedUrl: string | null }> } } };

export type IntegrationNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type IntegrationNodeQuery = { integration: { node: { id: string, name: string, provider: IntegrationProviderEnum, direction: IntegrationDirectionEnum, authType: IntegrationAuthTypeEnum, isActive: boolean, settings: unknown, lastSyncedAt: string | null, hasCredentials: boolean, feedUrl: string | null } | null } };

export type IntegrationPreviewSrealityAdvertQueryVariables = Exact<{
  propertyId: string | number;
}>;


export type IntegrationPreviewSrealityAdvertQuery = { integration: { previewSrealityAdvert: unknown } };

export type IntegrationCheckPortalExportQueryVariables = Exact<{
  propertyId: string | number;
  provider: IntegrationProviderEnum;
}>;


export type IntegrationCheckPortalExportQuery = { integration: { checkPortalExport: { ok: boolean, fieldsOk: boolean, photosOk: boolean, blockingError: string | null, missingMandatory: Array<string>, gaps: Array<{ key: string, label: string, group: string, severity: string, crmField: string, storage: string, hint: string | null, dataType: string, editable: boolean }>, photos: { readyCount: number, minRequired: number, ok: boolean } } } };

export type IntegrationPortalFieldMatrixQueryVariables = Exact<{
  propertyId?: string | number | null | undefined;
  live?: boolean | null | undefined;
  propertyType?: PropertyTypeEnum | null | undefined;
  category?: PropertyCategoryEnum | null | undefined;
}>;


export type IntegrationPortalFieldMatrixQuery = { integration: { portalFieldMatrix: { providers: Array<IntegrationProviderEnum>, checked: boolean, ok: boolean | null, fields: Array<{ crmField: string, label: string, portals: Array<{ provider: IntegrationProviderEnum, level: string, status: string, key: string, label: string, hint: string | null }> }> } } };

export type IntegrationOrgListingPortalsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationOrgListingPortalsQuery = { integration: { orgListingPortals: Array<{ provider: IntegrationProviderEnum, isAllowed: boolean, readiness: string, hasConnection: boolean, connectionId: string | null }> } };

export type IntegrationCreateMutationVariables = Exact<{
  input: CreateIntegrationConnectionInput;
}>;


export type IntegrationCreateMutation = { integration: { create:
      | { __typename: 'CreateIntegrationConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'CreateIntegrationConnectionSuccess', message: string, connection: { id: string } }
     } };

export type IntegrationUpdateMutationVariables = Exact<{
  input: UpdateIntegrationConnectionInput;
}>;


export type IntegrationUpdateMutation = { integration: { update:
      | { __typename: 'UpdateIntegrationConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateIntegrationConnectionSuccess', message: string, connection: { id: string } }
     } };

export type IntegrationUpsertPortalConnectionMutationVariables = Exact<{
  input: UpsertPortalConnectionInput;
}>;


export type IntegrationUpsertPortalConnectionMutation = { integration: { upsertPortalConnection:
      | { __typename: 'UpsertPortalConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertPortalConnectionSuccess', message: string, connection: { id: string, name: string, provider: IntegrationProviderEnum, isActive: boolean, lastSyncedAt: string | null, hasCredentials: boolean, settings: unknown, feedUrl: string | null } }
     } };

export type IntegrationTestPortalConnectionMutationVariables = Exact<{
  provider: IntegrationProviderEnum;
  connectionId?: string | number | null | undefined;
}>;


export type IntegrationTestPortalConnectionMutation = { integration: { testPortalConnection:
      | { __typename: 'TestPortalConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'TestPortalConnectionSuccess', ok: boolean, dryRun: boolean, status: number, message: string }
     } };

export type IntegrationSetOrgListingPortalAllowedMutationVariables = Exact<{
  provider: IntegrationProviderEnum;
  isAllowed: boolean;
}>;


export type IntegrationSetOrgListingPortalAllowedMutation = { integration: { setOrgListingPortalAllowed:
      | { __typename: 'SetOrgListingPortalAllowedError', message: string, code: string, details: unknown }
      | { __typename: 'SetOrgListingPortalAllowedSuccess', message: string, portal: { provider: IntegrationProviderEnum, isAllowed: boolean, readiness: string, hasConnection: boolean, connectionId: string | null } }
     } };

export type IntegrationUpsertSklikConnectionMutationVariables = Exact<{
  input: UpsertSklikConnectionInput;
}>;


export type IntegrationUpsertSklikConnectionMutation = { integration: { upsertSklikConnection:
      | { __typename: 'UpsertSklikConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertSklikConnectionSuccess', message: string, connection: { id: string, name: string, isActive: boolean, hasCredentials: boolean, settings: unknown } }
     } };

export type IntegrationTestSklikConnectionMutationVariables = Exact<{
  connectionId?: string | number | null | undefined;
}>;


export type IntegrationTestSklikConnectionMutation = { integration: { testSklikConnection:
      | { __typename: 'TestSklikConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'TestSklikConnectionSuccess', ok: boolean, dryRun: boolean, status: number, message: string, account: unknown, credit: unknown }
     } };

export type IntegrationRefreshSklikStatsMutationVariables = Exact<{
  connectionId?: string | number | null | undefined;
  days?: number | null | undefined;
}>;


export type IntegrationRefreshSklikStatsMutation = { integration: { refreshSklikStats:
      | { __typename: 'RefreshSklikStatsError', message: string, code: string, details: unknown }
      | { __typename: 'RefreshSklikStatsSuccess', message: string, dateFrom: string, dateTo: string, impressions: number | null, clicks: number | null, ctr: number | null, price: number | null, conversions: number | null, conversionValue: number | null }
     } };

export type IntegrationSklikStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationSklikStatusQuery = { integration: { sklikStatus: { configured: boolean, connected: boolean, isActive: boolean, connectionId: string | null, name: string | null, dryRun: boolean, semS2sId: number | null, conversionEventName: string | null, retargetingListId: number | null, autoConvertLeads: boolean, autoRetargetLeads: boolean, lastStats: unknown, lastSyncedAt: string | null, message: string | null } } };

export type IntegrationRunsQueryVariables = Exact<{
  connectionId: string | number;
  limit?: number;
  offset?: number;
}>;


export type IntegrationRunsQuery = { integration: { runs: { totalCount: number, items: Array<{ id: string, connectionId: string, status: IntegrationRunStatusEnum, triggerType: string | null, startedAt: string, finishedAt: string | null, recordsRead: number | null, recordsCreated: number | null, recordsUpdated: number | null, recordsFailed: number | null, errorSummary: string | null }> } } };

export type IntegrationExportPropertyToSrealityMutationVariables = Exact<{
  input: ExportPropertyToSrealityInput;
}>;


export type IntegrationExportPropertyToSrealityMutation = { integration: { exportPropertyToSreality:
      | { __typename: 'ExportPropertyToSrealityError', message: string, code: string, details: unknown }
      | { __typename: 'ExportPropertyToSrealitySuccess', propertyId: string, status: IntegrationSyncStatusEnum, message: string, externalListingId: string | null, dryRun: boolean }
     } };

export type IntegrationPullSrealityInquiriesMutationVariables = Exact<{
  days?: number | null | undefined;
  connectionId?: string | number | null | undefined;
}>;


export type IntegrationPullSrealityInquiriesMutation = { integration: { pullSrealityInquiries:
      | { __typename: 'PullSrealityInquiriesError', message: string, code: string, details: unknown }
      | { __typename: 'PullSrealityInquiriesSuccess', connections: number, fetched: number, created: number, updated: number, skipped: number, errors: number, days: number, message: string }
     } };

export type IntegrationSearchAresQueryVariables = Exact<{
  query: string;
  limit?: number;
}>;


export type IntegrationSearchAresQuery = { integration: { searchAres: Array<{ ico: string, companyName: string, legalForm: string | null, seatAddress: string | null }> } };

export type IntegrationLookupAresByIcoQueryVariables = Exact<{
  ico: string;
}>;


export type IntegrationLookupAresByIcoQuery = { integration: { lookupAresByIco: { ico: string, companyName: string, dic: string | null, legalForm: string | null, seatAddress: string | null, seatStreet: string | null, seatHouseNumber: string | null, seatOrientationNumber: string | null, seatCity: string | null, seatDistrict: string | null, seatRegion: string | null, seatPostalCode: string | null, suggestedFirstName: string, suggestedLastName: string } | null } };

export type IntegrationSuggestRuianAddressQueryVariables = Exact<{
  text: string;
  limit?: number;
  purpose?: RuianLookupPurposeEnum | null | undefined;
}>;


export type IntegrationSuggestRuianAddressQuery = { integration: { suggestRuianAddress: Array<{ text: string, magicKey: string, ruianType: string | null }> } };

export type IntegrationResolveRuianAddressQueryVariables = Exact<{
  magicKey: string;
  text?: string | null | undefined;
}>;


export type IntegrationResolveRuianAddressQuery = { integration: { resolveRuianAddress: { addressLine: string, street: string | null, houseNumber: string | null, orientationNumber: string | null, city: string, district: string | null, postalCode: string | null, countryCode: string, latitude: number, longitude: number, ruian: number, ruianLevel: number, ruianType: string | null, suggestedPropertyType: PropertyTypeEnum | null } | null } };

export type IntegrationKnHealthQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationKnHealthQuery = { integration: { knHealth: { status: number, lastCheck: string | null, dataValidAt: string | null } | null } };

export type IntegrationKnAccountStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationKnAccountStatusQuery = { integration: { knAccountStatus: { configured: boolean, authenticated: boolean | null, serviceId: string | null, callCount: number | null, callLimit: number | null, currentPeriod: string | null, apiKeyExpiresAt: string | null } } };

export type IntegrationKnBuildingByAdresniMistoQueryVariables = Exact<{
  kod: number;
}>;


export type IntegrationKnBuildingByAdresniMistoQuery = { integration: { knBuildingByAdresniMisto: { id: number, houseNumbers: Array<number>, parcelIds: Array<number>, unitIds: Array<number>, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationKnBuildingByRuianQueryVariables = Exact<{
  ruian: number;
  ruianLevel?: number;
}>;


export type IntegrationKnBuildingByRuianQuery = { integration: { knBuildingByRuian: { id: number, houseNumbers: Array<number>, parcelIds: Array<number>, unitIds: Array<number>, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationKnSearchParcelsQueryVariables = Exact<{
  ku: number;
  cislo: number;
  druhCislovani?: number;
  poddeleni?: number | null | undefined;
  puvodZe?: number | null | undefined;
  typParcely?: string;
}>;


export type IntegrationKnSearchParcelsQuery = { integration: { knSearchParcels: { items: Array<{ id: number, parcelNumber: number, parcelSubdivision: number | null, areaM2: number | null, buildingId: number | null, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null }>, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationKnParcelByIdQueryVariables = Exact<{
  id: number;
}>;


export type IntegrationKnParcelByIdQuery = { integration: { knParcelById: { id: number, parcelNumber: number, parcelSubdivision: number | null, areaM2: number | null, buildingId: number | null, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationKnSearchUnitsQueryVariables = Exact<{
  castObce: number;
  cisloDomovni: number;
  cisloJednotky: number;
  typStavby?: number;
}>;


export type IntegrationKnSearchUnitsQuery = { integration: { knSearchUnits: { items: Array<{ id: number, unitNumber: number | null, buildingId: number | null, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null }>, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationKnUnitByIdQueryVariables = Exact<{
  id: number;
}>;


export type IntegrationKnUnitByIdQuery = { integration: { knUnitById: { id: number, unitNumber: number | null, buildingId: number | null, lv: { id: number | null, cislo: number | null, kuKod: number | null, kuName: string | null } | null, meta: { callCount: number | null, dataAsOf: string | null, messages: Array<{ code: number, severity: string, text: string }> } } | null } };

export type IntegrationLookupIsirQueryVariables = Exact<{
  input: IsirLookupInput;
}>;


export type IntegrationLookupIsirQuery = { integration: { lookupIsir: { configured: boolean, empty: boolean, errorCode: string | null, errorText: string | null, resultCount: number | null, syncedAt: string | null, publicSearchUrl: string, summary: string | null, hits: Array<{ caseRef: string, status: string | null, statusLabel: string | null, court: string | null, detailUrl: string | null, ico: string | null, firstName: string | null, lastName: string | null, birthDate: string | null, city: string | null, openedAt: string | null, closedAt: string | null }> } } };

export type IntegrationCeeAccountStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationCeeAccountStatusQuery = { integration: { ceeAccountStatus: { configured: boolean, enabled: boolean, provider: string, publicUrl: string, message: string | null } } };

export type IntegrationLookupCeeByIcoQueryVariables = Exact<{
  ico: string;
}>;


export type IntegrationLookupCeeByIcoQuery = { integration: { lookupCeeByIco: { configured: boolean, empty: boolean, hitCount: number | null, summary: string | null, detailUrl: string | null, errorText: string | null, publicUrl: string, creditsCharged: number } } };

export type IntegrationWsdpAccountStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationWsdpAccountStatusQuery = { integration: { wsdpAccountStatus: { configured: boolean, enabled: boolean, message: string | null } } };

export type IntegrationFetchKnLvExcerptMutationVariables = Exact<{
  input: FetchKnLvExcerptInput;
}>;


export type IntegrationFetchKnLvExcerptMutation = { integration: { fetchKnLvExcerpt:
      | { __typename: 'FetchKnLvExcerptError', message: string, code: string, details: unknown }
      | { __typename: 'FetchKnLvExcerptSuccess', message: string, result: { configured: boolean, success: boolean, errorText: string | null, reportId: string | null, kuKod: number | null, lvCislo: number | null, lvId: number | null, creditsCharged: number, documentId: string | null } }
     } };

export type IntegrationLookupCeeByIcoPaidMutationVariables = Exact<{
  ico: string;
  idempotencyKey?: string | null | undefined;
}>;


export type IntegrationLookupCeeByIcoPaidMutation = { integration: { lookupCeeByIcoPaid:
      | { __typename: 'LookupCeeByIcoPaidError', message: string, code: string, details: unknown }
      | { __typename: 'LookupCeeByIcoPaidSuccess', message: string, result: { configured: boolean, empty: boolean, hitCount: number | null, summary: string | null, detailUrl: string | null, errorText: string | null, publicUrl: string, creditsCharged: number } }
     } };

export type IntegrationMetaStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationMetaStatusQuery = { integration: { metaStatus: { configured: boolean, connected: boolean, stub: boolean, setupComplete: boolean, pendingPageSelection: boolean, connectionId: string | null, pageId: string | null, pageName: string | null, igUserId: string | null, igUsername: string | null, message: string, availablePages: Array<{ id: string, name: string }> | null } } };

export type IntegrationConnectMetaMutationVariables = Exact<{
  returnTo?: string | null | undefined;
}>;


export type IntegrationConnectMetaMutation = { integration: { connectMeta:
      | { __typename: 'ConnectMetaError', message: string, code: string, details: unknown }
      | { __typename: 'ConnectMetaSuccess', message: string, oauthStart: { provider: string, authorizationUrl: string | null, stub: boolean } }
     } };

export type IntegrationCompleteMetaSetupMutationVariables = Exact<{
  input: CompleteMetaSetupInput;
}>;


export type IntegrationCompleteMetaSetupMutation = { integration: { completeMetaSetup:
      | { __typename: 'CompleteMetaSetupError', message: string, code: string, details: unknown }
      | { __typename: 'CompleteMetaSetupSuccess', message: string, connection: { id: string, name: string, provider: IntegrationProviderEnum, isActive: boolean, settings: unknown } }
     } };

export type IntegrationGoogleBusinessStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationGoogleBusinessStatusQuery = { integration: { googleBusinessStatus: { configured: boolean, connected: boolean, stub: boolean, connectionId: string | null, accountId: string | null, locationId: string | null, message: string } } };

export type IntegrationGoogleAdsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationGoogleAdsStatusQuery = { integration: { googleAdsStatus: { configured: boolean, connected: boolean, customerId: string | null, connectionId: string | null, message: string } } };

export type IntegrationGoogleBusinessAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type IntegrationGoogleBusinessAccountsQuery = { integration: { googleBusinessAccounts: Array<{ name: string | null, accountName: string | null, type: string | null }> } };

export type IntegrationGoogleBusinessLocationsQueryVariables = Exact<{
  accountName: string;
}>;


export type IntegrationGoogleBusinessLocationsQuery = { integration: { googleBusinessLocations: Array<{ name: string | null, title: string | null, address: Array<string> | null }> } };

export type IntegrationConnectGoogleBusinessMutationVariables = Exact<{
  returnTo?: string | null | undefined;
}>;


export type IntegrationConnectGoogleBusinessMutation = { integration: { connectGoogleBusiness:
      | { __typename: 'ConnectGoogleBusinessError', message: string, code: string, details: unknown }
      | { __typename: 'ConnectGoogleBusinessSuccess', message: string, oauthStart: { authorizationUrl: string | null, stub: boolean } }
     } };

export type IntegrationSelectGoogleBusinessLocationMutationVariables = Exact<{
  input: SelectGoogleBusinessLocationInput;
}>;


export type IntegrationSelectGoogleBusinessLocationMutation = { integration: { selectGoogleBusinessLocation:
      | { __typename: 'SelectGoogleBusinessLocationError', message: string, code: string, details: unknown }
      | { __typename: 'SelectGoogleBusinessLocationSuccess', message: string, connection: { id: string, settings: unknown, isActive: boolean } }
     } };

export type IntegrationCreateGoogleBusinessPostMutationVariables = Exact<{
  input: CreateGoogleBusinessPostInput;
}>;


export type IntegrationCreateGoogleBusinessPostMutation = { integration: { createGoogleBusinessPost:
      | { __typename: 'CreateGoogleBusinessPostError', message: string, code: string, details: unknown }
      | { __typename: 'CreateGoogleBusinessPostSuccess', message: string, name: string | null, searchUrl: string | null, state: string | null }
     } };

export type IntegrationUpsertGoogleAdsConnectionMutationVariables = Exact<{
  input: UpsertGoogleAdsConnectionInput;
}>;


export type IntegrationUpsertGoogleAdsConnectionMutation = { integration: { upsertGoogleAdsConnection:
      | { __typename: 'UpsertGoogleAdsConnectionError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertGoogleAdsConnectionSuccess', message: string, connection: { id: string, name: string, provider: IntegrationProviderEnum, isActive: boolean, settings: unknown, hasCredentials: boolean } }
     } };

export type IntegrationLustraceHistoryQueryVariables = Exact<{
  clientId?: string | number | null | undefined;
  registry?: LustraceRegistryEnum | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type IntegrationLustraceHistoryQuery = { integration: { lustraceHistory: Array<{ id: string, registry: LustraceRegistryEnum, resultSummary: string, hitCount: number | null, query: unknown, clientId: string | null, propertyId: string | null, actorId: string | null, createdAt: string | null }> } };

export type IntegrationImportTokensQueryVariables = Exact<{
  includeRevoked?: boolean;
}>;


export type IntegrationImportTokensQuery = { integration: { importTokens: Array<{ id: string, name: string, tokenPrefix: string, createdById: string, expiresAt: string | null, revokedAt: string | null, lastUsedAt: string | null, notes: string | null, createdAt: string | null }> } };

export type IntegrationCreateImportTokenMutationVariables = Exact<{
  input: CreateImportTokenInput;
}>;


export type IntegrationCreateImportTokenMutation = { integration: { createImportToken:
      | { __typename: 'CreateImportTokenError', message: string, code: string, details: unknown }
      | { __typename: 'CreateImportTokenSuccess', message: string, token: string, record: { id: string, name: string, tokenPrefix: string, createdById: string, expiresAt: string | null, revokedAt: string | null, lastUsedAt: string | null, notes: string | null, createdAt: string | null } }
     } };

export type IntegrationRevokeImportTokenMutationVariables = Exact<{
  tokenId: string | number;
}>;


export type IntegrationRevokeImportTokenMutation = { integration: { revokeImportToken:
      | { __typename: 'RevokeImportTokenError', message: string, code: string, details: unknown }
      | { __typename: 'RevokeImportTokenSuccess', message: string, record: { id: string, name: string, tokenPrefix: string, revokedAt: string | null } }
     } };

export type LeadListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: LeadFilter | null | undefined;
  order?: LeadOrder | null | undefined;
}>;


export type LeadListQuery = { lead: { list: { totalCount: number | null, items: Array<{ id: string, status: LeadStatusEnum, source: LeadSourceEnum, firstName: string, lastName: string, email: string | null, phone: string | null, message: string | null, propertyId: string | null, assignedAgentId: string | null, score: number | null, createdAt: string | null }> } } };

export type LeadNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type LeadNodeQuery = { lead: { node: { id: string, status: LeadStatusEnum, source: LeadSourceEnum, sourceLabel: string | null, firstName: string, lastName: string, email: string | null, phone: string | null, message: string | null, notes: string | null, clientId: string | null, propertyId: string | null, assignedAgentId: string | null, convertedClientId: string | null, campaignId: string | null, campaignName: string | null, utmSource: string | null, utmMedium: string | null, utmCampaign: string | null, externalId: string | null, extra: unknown, score: number | null, qualifiedAt: string | null, convertedAt: string | null, lostReason: string | null } | null } };

export type LeadCreateMutationVariables = Exact<{
  input: CreateLeadInput;
}>;


export type LeadCreateMutation = { lead: { create:
      | { __typename: 'CreateLeadError', message: string, code: string, details: unknown }
      | { __typename: 'CreateLeadSuccess', message: string, lead: { id: string } }
     } };

export type LeadUpdateMutationVariables = Exact<{
  input: UpdateLeadInput;
}>;


export type LeadUpdateMutation = { lead: { update:
      | { __typename: 'UpdateLeadError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateLeadSuccess', message: string, lead: { id: string, status: LeadStatusEnum, convertedClientId: string | null, convertedAt: string | null, clientId: string | null, assignedAgentId: string | null } }
     } };

export type LeadAssignMutationVariables = Exact<{
  input: AssignLeadInput;
}>;


export type LeadAssignMutation = { lead: { assign:
      | { __typename: 'AssignLeadError', message: string, code: string, details: unknown }
      | { __typename: 'AssignLeadSuccess', message: string, lead: { id: string, assignedAgentId: string | null } }
     } };

export type LeadDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type LeadDeleteMutation = { lead: { delete:
      | { __typename: 'DeleteLeadError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteLeadSuccess', message: string, success: boolean }
     } };

export type EntityPickerLeadsQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type EntityPickerLeadsQuery = { lead: { list: { items: Array<{ id: string, firstName: string, lastName: string, email: string | null, phone: string | null, status: LeadStatusEnum, source: LeadSourceEnum }> } } };

export type ListingProjectListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type ListingProjectListQuery = { listingProject: { list: { totalCount: number | null, items: Array<{ id: string, name: string, annotation: string, description: string, localityDescription: string, localityCity: string, localityStreet: string | null, localityCitypart: string | null, localityCp: string | null, localityCo: string | null, localityRuian: number | null, localityRuianLevel: number | null, latitude: number | null, longitude: number | null, developerIc: string, projectRkid: string, projectUrl: string | null, projectMatterportUrl: string | null, projectLifetime: number, projectActive: boolean, srealityProjectId: number | null, lastSyncedAt: string | null, lastSyncError: string | null, syncStatus: number | null, createdAt: string | null, updatedAt: string | null }> } } };

export type ListingProjectNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type ListingProjectNodeQuery = { listingProject: { node: { id: string, name: string, annotation: string, description: string, localityDescription: string, localityCity: string, localityStreet: string | null, localityCitypart: string | null, localityCp: string | null, localityCo: string | null, localityRuian: number | null, localityRuianLevel: number | null, latitude: number | null, longitude: number | null, developerIc: string, projectRkid: string, projectUrl: string | null, projectMatterportUrl: string | null, projectLifetime: number, projectActive: boolean, srealityProjectId: number | null, lastSyncedAt: string | null, lastSyncError: string | null, syncStatus: number | null, createdAt: string | null, updatedAt: string | null, images: Array<{ id: string, position: number, caption: string | null, uploadStatus: UploadStatusEnum, contentType: string | null, bytesSize: number | null, originalUrl: string | null, photoRkid: string | null, excludeFromPortalExport: boolean }>, videos: Array<{ id: string, position: number, caption: string | null, description: string | null, uploadStatus: UploadStatusEnum, contentType: string | null, bytesSize: number | null, originalUrl: string | null, videoRkid: string | null, excludeFromPortalExport: boolean }> } | null } };

export type ListingProjectCreateMutationVariables = Exact<{
  input: CreateListingProjectInput;
}>;


export type ListingProjectCreateMutation = { listingProject: { create:
      | { __typename: 'CreateListingProjectError', message: string, code: string, details: unknown }
      | { __typename: 'CreateListingProjectSuccess', message: string, listingProject: { id: string, name: string, projectRkid: string, developerIc: string, localityCity: string, projectLifetime: number, projectActive: boolean, srealityProjectId: number | null } }
     } };

export type ListingProjectUpdateMutationVariables = Exact<{
  input: UpdateListingProjectInput;
}>;


export type ListingProjectUpdateMutation = { listingProject: { update:
      | { __typename: 'UpdateListingProjectError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateListingProjectSuccess', message: string, listingProject: { id: string, name: string, projectRkid: string, developerIc: string, localityCity: string, projectLifetime: number, projectActive: boolean, srealityProjectId: number | null, lastSyncedAt: string | null, lastSyncError: string | null, syncStatus: number | null } }
     } };

export type ListingProjectDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type ListingProjectDeleteMutation = { listingProject: { delete:
      | { __typename: 'DeleteListingProjectError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteListingProjectSuccess', message: string, success: boolean }
     } };

export type ListingProjectSyncToSrealityMutationVariables = Exact<{
  id: string | number;
}>;


export type ListingProjectSyncToSrealityMutation = { listingProject: { syncToSreality:
      | { __typename: 'SyncListingProjectToSrealityError', message: string, code: string, details: unknown }
      | { __typename: 'SyncListingProjectToSrealitySuccess', message: string, listingProject: { id: string, srealityProjectId: number | null, lastSyncedAt: string | null, lastSyncError: string | null, syncStatus: number | null, projectRkid: string } }
     } };

export type ListingProjectCreateImageUploadIntentMutationVariables = Exact<{
  listingProjectId: string | number;
  contentType: string;
  caption?: string | null | undefined;
  position?: number | null | undefined;
  sizeBytes?: number | null | undefined;
}>;


export type ListingProjectCreateImageUploadIntentMutation = { listingProject: { createImageUploadIntent:
      | { __typename: 'CreateListingProjectImageUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateListingProjectImageUploadIntentSuccess', message: string, image: { id: string, uploadStatus: UploadStatusEnum, position: number }, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type ListingProjectFinalizeImageUploadMutationVariables = Exact<{
  imageId: string | number;
}>;


export type ListingProjectFinalizeImageUploadMutation = { listingProject: { finalizeImageUpload:
      | { __typename: 'FinalizeListingProjectImageUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeListingProjectImageUploadSuccess', message: string, image: { id: string, uploadStatus: UploadStatusEnum, originalUrl: string | null } }
     } };

export type ListingProjectDeleteImageMutationVariables = Exact<{
  imageId: string | number;
}>;


export type ListingProjectDeleteImageMutation = { listingProject: { deleteImage:
      | { __typename: 'DeleteListingProjectImageError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteListingProjectImageSuccess', message: string, success: boolean }
     } };

export type ListingProjectCreateVideoUploadIntentMutationVariables = Exact<{
  listingProjectId: string | number;
  contentType: string;
  caption?: string | null | undefined;
  description?: string | null | undefined;
  position?: number | null | undefined;
  sizeBytes?: number | null | undefined;
}>;


export type ListingProjectCreateVideoUploadIntentMutation = { listingProject: { createVideoUploadIntent:
      | { __typename: 'CreateListingProjectVideoUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateListingProjectVideoUploadIntentSuccess', message: string, video: { id: string, uploadStatus: UploadStatusEnum, position: number }, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type ListingProjectFinalizeVideoUploadMutationVariables = Exact<{
  videoId: string | number;
}>;


export type ListingProjectFinalizeVideoUploadMutation = { listingProject: { finalizeVideoUpload:
      | { __typename: 'FinalizeListingProjectVideoUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizeListingProjectVideoUploadSuccess', message: string, video: { id: string, uploadStatus: UploadStatusEnum, originalUrl: string | null } }
     } };

export type ListingProjectDeleteVideoMutationVariables = Exact<{
  videoId: string | number;
}>;


export type ListingProjectDeleteVideoMutation = { listingProject: { deleteVideo:
      | { __typename: 'DeleteListingProjectVideoError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteListingProjectVideoSuccess', message: string, success: boolean }
     } };

export type NotificationInboxQueryVariables = Exact<{
  unreadOnly?: boolean;
  limit?: number;
  offset?: number;
}>;


export type NotificationInboxQuery = { notification: { inbox: { totalCount: number, items: Array<{ id: string, type: NotificationKindEnum, title: string, body: string | null, entityType: string | null, entityId: string | null, readAt: string | null, createdAt: string | null }> } } };

export type NotificationUnreadCountQueryVariables = Exact<{ [key: string]: never; }>;


export type NotificationUnreadCountQuery = { notification: { unreadCount: number } };

export type NotificationMarkReadMutationVariables = Exact<{
  id: string | number;
}>;


export type NotificationMarkReadMutation = { notification: { markRead:
      | { __typename: 'MarkNotificationReadError', message: string, code: string, details: unknown }
      | { __typename: 'MarkNotificationReadSuccess', message: string, notification: { id: string, readAt: string | null } }
     } };

export type NotificationMarkAllReadMutationVariables = Exact<{ [key: string]: never; }>;


export type NotificationMarkAllReadMutation = { notification: { markAllRead:
      | { __typename: 'MarkAllNotificationsReadError', message: string, code: string, details: unknown }
      | { __typename: 'MarkAllNotificationsReadSuccess', message: string }
     } };

export type DealCreatePaymentMutationVariables = Exact<{
  input: CreatePaymentInput;
}>;


export type DealCreatePaymentMutation = { deal: { createPayment:
      | { __typename: 'CreateDealPaymentError', message: string, code: string, details: unknown }
      | { __typename: 'CreateDealPaymentSuccess', message: string, payment: { id: string, type: PaymentTypeEnum, amount: string, currency: string, dueAt: string | null, paidAt: string | null, status: PaymentStatusEnum, payerClientId: string, payeeUserId: string | null, dealId: string, propertyId: string | null, variableSymbol: string | null, documentId: string | null } }
     } };

export type DealUpdatePaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type DealUpdatePaymentMutation = { deal: { updatePayment:
      | { __typename: 'UpdateDealPaymentError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateDealPaymentSuccess', message: string, payment: { id: string, type: PaymentTypeEnum, amount: string, currency: string, dueAt: string | null, paidAt: string | null, status: PaymentStatusEnum, payerClientId: string, payeeUserId: string | null, dealId: string, propertyId: string | null, variableSymbol: string | null, documentId: string | null } }
     } };

export type DealSettlePaymentMutationVariables = Exact<{
  id: string | number;
}>;


export type DealSettlePaymentMutation = { deal: { settlePayment:
      | { __typename: 'SettleDealPaymentError', message: string, code: string, details: unknown }
      | { __typename: 'SettleDealPaymentSuccess', message: string, payment: { id: string, status: PaymentStatusEnum, paidAt: string | null } }
     } };

export type DealDeletePaymentMutationVariables = Exact<{
  id: string | number;
}>;


export type DealDeletePaymentMutation = { deal: { deletePayment:
      | { __typename: 'DeleteDealPaymentError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteDealPaymentSuccess', message: string, success: boolean }
     } };

export type PortalMeQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalMeQuery = { portal: { me: { id: string, loginEmail: string, firstName: string, lastName: string, selectedOrganizationId: string | null, selectedClientId: string | null } } };

export type PortalOrganizationsQueryVariables = Exact<{ [key: string]: never; }>;


export type PortalOrganizationsQuery = { portal: { organizations: Array<{ clientId: string, organizationId: string, organizationName: string, organizationSlug: string }> } };

export type PortalLoginMutationVariables = Exact<{
  email: string;
  password: string;
}>;


export type PortalLoginMutation = { portal: { login:
      | { __typename: 'PortalLoginError', message: string, code: string, details: unknown }
      | { __typename: 'PortalLoginSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type PortalRefreshMutationVariables = Exact<{
  refreshToken: string;
}>;


export type PortalRefreshMutation = { portal: { refresh:
      | { __typename: 'PortalRefreshError', message: string, code: string, details: unknown }
      | { __typename: 'PortalRefreshSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type PortalLogoutMutationVariables = Exact<{
  refreshToken?: string | null | undefined;
  allSessions?: boolean | null | undefined;
}>;


export type PortalLogoutMutation = { portal: { logout:
      | { __typename: 'PortalLogoutError', message: string, code: string, details: unknown }
      | { __typename: 'PortalLogoutSuccess', message: string, success: boolean }
     } };

export type PortalAcceptInviteMutationVariables = Exact<{
  token: string;
  password: string;
}>;


export type PortalAcceptInviteMutation = { portal: { acceptInvite:
      | { __typename: 'PortalAcceptInviteError', message: string, code: string, details: unknown }
      | { __typename: 'PortalAcceptInviteSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type PortalSelectOrganizationMutationVariables = Exact<{
  organizationId: string | number;
}>;


export type PortalSelectOrganizationMutation = { portal: { selectOrganization:
      | { __typename: 'PortalSelectOrganizationError', message: string, code: string, details: unknown }
      | { __typename: 'PortalSelectOrganizationSuccess', message: string, accessToken: string, refreshToken: string, accessExpiresAt: string, refreshExpiresAt: string, mustResetPassword: boolean }
     } };

export type ClientInvitePortalAccessMutationVariables = Exact<{
  clientId: string | number;
  loginEmail?: string | null | undefined;
}>;


export type ClientInvitePortalAccessMutation = { client: { invitePortalAccess:
      | { __typename: 'InvitePortalAccessError', message: string, code: string, details: unknown }
      | { __typename: 'InvitePortalAccessSuccess', message: string, inviteUrl: string | null, inviteEmailSent: boolean, portalAccountId: string | null, client: { id: string, portalAccountId: string | null } }
     } };

export type ClientRevokePortalAccessMutationVariables = Exact<{
  clientId: string | number;
}>;


export type ClientRevokePortalAccessMutation = { client: { revokePortalAccess:
      | { __typename: 'RevokePortalAccessError', message: string, code: string, details: unknown }
      | { __typename: 'RevokePortalAccessSuccess', message: string, client: { id: string, portalAccountId: string | null } }
     } };

export type PropertyListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: PropertyFilter | null | undefined;
  order?: PropertyOrder | null | undefined;
}>;


export type PropertyListQuery = { property: { list: { totalCount: number | null, items: Array<{ id: string, title: unknown, localizedTitle: string | null, listingCode: string | null, propertyType: PropertyTypeEnum, category: PropertyCategoryEnum, status: PropertyStatusEnum, price: string | null, rentPrice: string | null, priceUnit: PriceUnitEnum | null, currency: string, layout: PropertyLayoutEnum | null, usableArea: string | null, isPublished: boolean, webVisibility: PropertyWebVisibilityEnum, locationPrivacy: LocationPrivacyEnum, assignedAgentId: string, createdAt: string | null, updatedAt: string | null, coverThumbUrl: string | null, coverDisplayUrl: string | null, location: { street: string | null, city: string, district: string | null, addressLine: string, latitude: number, longitude: number, ruian: number | null, ruianLevel: number | null } | null, marketDetails: { listingCode: string | null, priceOnRequest: boolean } | null, catalogCard: { documentId: string | null, originalName: string | null, locale: string | null, generatedAt: string | null, downloadUrl: string | null } | null }> } } };

export type PropertyNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type PropertyNodeQuery = { property: { node: { id: string, title: unknown, localizedTitle: string | null, listingCode: string | null, description: unknown, localizedDescription: string | null, marketingText: unknown, localizedMarketingText: string | null, propertyType: PropertyTypeEnum, category: PropertyCategoryEnum, status: PropertyStatusEnum, price: string | null, rentPrice: string | null, currency: string, priceNotes: unknown, localizedPriceNotes: string | null, priceUnit: PriceUnitEnum | null, roomCount: AdvertRoomCountEnum | null, ownershipType: OwnershipTypeEnum, layout: PropertyLayoutEnum | null, usableArea: string | null, floorArea: string | null, lotSize: string | null, balconyArea: string | null, terraceArea: string | null, loggiaArea: string | null, cellarArea: string | null, gardenArea: string | null, basinArea: string | null, buildingArea: string | null, ceilingHeight: string | null, floor: number | null, totalFloors: number | null, undergroundFloors: number | null, yearBuilt: number | null, acceptanceYear: number | null, reconstructionYear: number | null, apartmentNumber: number | null, parkingCount: number | null, garageCount: number | null, buildingType: BuildingTypeEnum | null, objectType: ObjectTypeEnum | null, availableFrom: string | null, occupiedUntil: string | null, contractValidUntil: string | null, energyClass: EnergyClassEnum | null, condition: PropertyConditionEnum | null, hasBalcony: boolean, hasTerrace: boolean, hasLoggia: boolean, hasParking: boolean, hasGarage: boolean, hasCellar: boolean, hasElevator: boolean, hasBasin: boolean, furnished: FurnishedEnum | null, seoTitle: unknown, seoDescription: unknown, seoKeywords: unknown, localizedSeoTitle: string | null, localizedSeoDescription: string | null, localizedSeoKeywords: Array<string>, isPublished: boolean, publishedAt: string | null, unpublishedAt: string | null, webVisibility: PropertyWebVisibilityEnum, locationPrivacy: LocationPrivacyEnum, exportToPortals: boolean, internalNotes: string | null, aiLocaleMeta: unknown, assignedAgentId: string, ownerContactId: string | null, coverThumbUrl: string | null, coverDisplayUrl: string | null, allowedPortalProviders: Array<IntegrationProviderEnum>, createdAt: string | null, updatedAt: string | null, location: { addressLine: string, city: string, district: string | null, region: string | null, postalCode: string | null, countryCode: string, latitude: number, longitude: number, street: string | null, houseNumber: string | null, orientationNumber: string | null, ruian: number | null, ruianLevel: number | null, lvCislo: number | null, kuKod: number | null, knLvId: number | null, knBuildingId: number | null } | null, marketDetails: { listingCode: string | null, projectRkid: string | null, matterportUrl: string | null, mapyPanoramaUrl: string | null, priceNegotiable: boolean, priceOnRequest: boolean, priceHidden: boolean, exclusiveListing: boolean, listingExtraInfo: ListingExtraInfoEnum | null, lowEnergy: boolean, mortgage: boolean, mortgagePercent: string | null, commission: string | null, solarPanels: boolean, ftvPanels: boolean, annuity: number | null, beginningDate: string | null, bidding: BiddingEnum | null, circuitBreaker: CircuitBreakerEnum | null, costOfLiving: string | null, easyAccess: CodebookYesNoEnum | null, electricity: Array<ElectricityEnum>, energyPerformanceCertificate: EnergyPerformanceCertificateEnum | null, energyPerformanceSummary: string | null, finishDate: string | null, firstTourDate: string | null, firstTourDateTo: string | null, flatClass: FlatClassEnum | null, gas: Array<GasSupplyEnum>, gully: Array<GullyEnum>, heatingElement: Array<HeatingElementEnum>, heatingSource: Array<HeatingSourceEnum>, internetConnectionProvider: string | null, internetConnectionSpeed: number | null, internetConnectionType: Array<InternetConnectionTypeEnum>, neighbourhoodPresence: Array<NeighbourhoodPresenceEnum>, noliveTotalArea: string | null, numOwners: number | null, objectKind: ObjectKindEnum | null, objectLocation: ObjectLocationEnum | null, officesArea: string | null, personal: CodebookYesNoEnum | null, phaseDistributions: PhaseDistributionEnum | null, priceAuctionPrincipal: string | null, priceExpertReport: string | null, priceMinimumBid: string | null, productionArea: string | null, protection: ProtectionEnum | null, refundableDeposit: string | null, roadType: Array<RoadTypeEnum>, saleDate: string | null, shopArea: string | null, sporPercent: string | null, steps: string | null, storeArea: string | null, surroundingsType: SurroundingsTypeEnum | null, telecommunication: Array<TelecommunicationEnum>, tenantNotPayCommission: boolean, transport: Array<TransportEnum>, water: Array<WaterSupplyEnum>, waterHeatSource: Array<WaterHeatSourceEnum>, wellType: Array<WellTypeEnum>, workshopArea: string | null, auctionKind: AuctionKindEnum | null, auctionDate: string | null, auctionPlace: string | null, auctionDateTour: string | null, auctionDateTour2: string | null, extraAttributes: unknown } | null, images: Array<{ id: string, position: number, isMain: boolean, caption: string | null, roomType: PhotoRoomTypeEnum | null, uploadStatus: UploadStatusEnum, uploadError: string | null, originalUrl: string | null, thumbUrl: string | null, displayUrl: string | null, sourceImageId: string | null, variantKind: ImageVariantKindEnum | null, excludeFromPortalExport: boolean }>, videos: Array<{ id: string, position: number, caption: string | null, description: string | null, uploadStatus: UploadStatusEnum, uploadError: string | null, originalUrl: string | null, posterUrl: string | null, bytesSize: number | null, contentType: string | null, durationSeconds: number | null, excludeFromPortalExport: boolean, videoRkid: string | null }>, contracts: Array<{ id: string, title: string, contractType: PropertyContractTypeEnum, status: PropertyContractStatusEnum, contractNumber: string | null, counterpartyName: string | null, counterpartyContactId: string | null, primaryDocumentId: string | null, assignedAgentId: string | null, validFrom: string | null, validUntil: string | null, signedAt: string | null, terminatedAt: string | null, notes: string | null, createdAt: string | null, updatedAt: string | null }>, parties: Array<{ id: string, role: PropertyPartyRoleEnum, displayName: string | null, clientId: string | null, ownershipSharePercent: string | null, position: number, notes: string | null, createdAt: string | null, updatedAt: string | null }>, links: Array<{ id: string, type: PropertyLinkTypeEnum, url: string, label: string | null, position: number, createdAt: string | null, updatedAt: string | null }>, portalExports: Array<{ id: string, provider: IntegrationProviderEnum, isEnabled: boolean, status: IntegrationSyncStatusEnum, externalListingId: string | null, lastExportedAt: string | null, lastError: string | null, publicationStatus: PortalPublicationStatusEnum, lastVerifiedAt: string | null, lastVerificationError: string | null, bumpEnabled: boolean, bumpDays: Array<number>, bumpAfterHour: number | null, bumpPriority: PortalBumpPriorityEnum, bumpLastAttemptAt: string | null, bumpLastOutcome: string | null, bumpLastMessage: string | null, createdAt: string | null, updatedAt: string | null }>, socialPostImage: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, sizeBytes: number | null, downloadUrl: string | null } | null, demandMatches: Array<{ id: string, requirementId: string, clientId: string, propertyId: string, score: number, reasons: Array<string>, reasonLabels: Array<string>, taskId: string | null, createdAt: string | null, property: { id: string, localizedTitle: string | null, listingCode: string | null, price: string | null, rentPrice: string | null, currency: string, category: PropertyCategoryEnum, layout: PropertyLayoutEnum | null, usableArea: string | null, coverThumbUrl: string | null, location: { city: string, district: string | null, addressLine: string } | null } | null }>, messages: Array<{ id: string, status: PropertyMessageStatusEnum, provider: IntegrationProviderEnum, senderName: string, senderEmail: string | null, senderPhone: string | null, body: string | null, receivedAt: string, readAt: string | null, propertyId: string | null, leadId: string | null, assignedAgentId: string | null }> } | null } };

export type EntityPickerPropertiesQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
}>;


export type EntityPickerPropertiesQuery = { property: { list: { items: Array<{ id: string, localizedTitle: string | null, listingCode: string | null, price: string | null, rentPrice: string | null, currency: string, category: PropertyCategoryEnum, layout: PropertyLayoutEnum | null, coverThumbUrl: string | null, location: { city: string, district: string | null, addressLine: string } | null, marketDetails: { listingCode: string | null } | null }> } } };

export type PropertyAllowedPortalProvidersQueryVariables = Exact<{
  category: PropertyCategoryEnum;
}>;


export type PropertyAllowedPortalProvidersQuery = { property: { allowedPortalProviders: Array<IntegrationProviderEnum> } };

export type PropertySrealityAttributeCatalogQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertySrealityAttributeCatalogQuery = { property: { srealityAttributeCatalog: unknown } };

export type PropertyPortalPublicationEventsQueryVariables = Exact<{
  propertyId: string | number;
  limit?: number | null | undefined;
}>;


export type PropertyPortalPublicationEventsQuery = { property: { portalPublicationEvents: Array<{ id: string, propertyId: string, provider: IntegrationProviderEnum, kind: PortalPublicationEventKindEnum, success: boolean, mismatchType: PortalMismatchTypeEnum | null, payload: unknown, actorId: string | null, createdAt: string | null, updatedAt: string | null }> } };

export type PropertyPortalSyncHealthQueryVariables = Exact<{
  propertyId: string | number;
}>;


export type PropertyPortalSyncHealthQuery = { property: { portalSyncHealth: Array<{ propertyId: string, provider: IntegrationProviderEnum, isEnabled: boolean, crmExpectsLive: boolean, crmReason: string, publicationStatus: PortalPublicationStatusEnum, exportStatus: string | null, externalListingId: string | null, lastExportedAt: string | null, lastVerifiedAt: string | null, mismatch: PortalMismatchTypeEnum | null, mismatchDetectedAt: string | null, inSync: boolean, verificationSupported: boolean, verificationCapability: PortalVerificationCapabilityEnum | null, lastVerificationError: string | null, lastError: string | null }> } };

export type PropertyPortalSyncOverviewQueryVariables = Exact<{
  mismatchesOnly?: boolean | null | undefined;
  limit?: number | null | undefined;
}>;


export type PropertyPortalSyncOverviewQuery = { property: { portalSyncOverview: Array<{ propertyId: string, provider: IntegrationProviderEnum, isEnabled: boolean, crmExpectsLive: boolean, crmReason: string, publicationStatus: PortalPublicationStatusEnum, exportStatus: string | null, externalListingId: string | null, lastExportedAt: string | null, lastVerifiedAt: string | null, mismatch: PortalMismatchTypeEnum | null, mismatchDetectedAt: string | null, inSync: boolean, verificationSupported: boolean, verificationCapability: PortalVerificationCapabilityEnum | null, lastVerificationError: string | null, lastError: string | null }> } };

export type PropertyImagesQueryVariables = Exact<{
  id: string | number;
}>;


export type PropertyImagesQuery = { property: { node: { id: string, images: Array<{ id: string, position: number, isMain: boolean, caption: string | null, roomType: PhotoRoomTypeEnum | null, uploadStatus: UploadStatusEnum, uploadError: string | null, originalUrl: string | null, thumbUrl: string | null, displayUrl: string | null, sourceImageId: string | null, variantKind: ImageVariantKindEnum | null, excludeFromPortalExport: boolean }> } | null } };

export type PropertyCreateMutationVariables = Exact<{
  input: CreatePropertyInput;
}>;


export type PropertyCreateMutation = { property: { create:
      | { __typename: 'CreatePropertyError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertySuccess', message: string, property: { id: string } }
     } };

export type PropertyUpdateMutationVariables = Exact<{
  input: UpdatePropertyInput;
}>;


export type PropertyUpdateMutation = { property: { update:
      | { __typename: 'UpdatePropertyError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertySuccess', message: string, property: { id: string } }
     } };

export type PropertyPublishMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyPublishMutation = { property: { publish:
      | { __typename: 'PublishPropertyError', message: string, code: string, details: unknown }
      | { __typename: 'PublishPropertySuccess', message: string, property: { id: string, isPublished: boolean } }
     } };

export type PropertyUnpublishMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyUnpublishMutation = { property: { unpublish:
      | { __typename: 'UnpublishPropertyError', message: string, code: string, details: unknown }
      | { __typename: 'UnpublishPropertySuccess', message: string, property: { id: string, isPublished: boolean } }
     } };

export type PropertyDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyDeleteMutation = { property: { delete:
      | { __typename: 'DeletePropertyError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertySuccess', message: string, success: boolean }
     } };

export type PropertyRunDemandMatchingMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyRunDemandMatchingMutation = { property: { runDemandMatching:
      | { __typename: 'RunPropertyDemandMatchingError', message: string, code: string, details: unknown }
      | { __typename: 'RunPropertyDemandMatchingSuccess', message: string, created: number, updated: number, tasksCreated: number, staleRemoved: number, matches: Array<{ id: string, propertyId: string, requirementId: string, clientId: string, score: number, reasons: Array<string>, taskId: string | null }> }
     } };

export type PropertyCreateImageUploadIntentMutationVariables = Exact<{
  propertyId: string | number;
  contentType: string;
  caption?: string | null | undefined;
  position?: number | null | undefined;
  sizeBytes?: number | null | undefined;
}>;


export type PropertyCreateImageUploadIntentMutation = { property: { createImageUploadIntent:
      | { __typename: 'CreatePropertyImageUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyImageUploadIntentSuccess', message: string, image: { id: string, uploadStatus: UploadStatusEnum, position: number, isMain: boolean }, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type PropertyFinalizeImageUploadMutationVariables = Exact<{
  imageId: string | number;
}>;


export type PropertyFinalizeImageUploadMutation = { property: { finalizeImageUpload:
      | { __typename: 'FinalizePropertyImageUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizePropertyImageUploadSuccess', message: string, image: { id: string, uploadStatus: UploadStatusEnum, uploadError: string | null } }
     } };

export type PropertyAbortImageUploadMutationVariables = Exact<{
  imageId: string | number;
}>;


export type PropertyAbortImageUploadMutation = { property: { abortImageUpload:
      | { __typename: 'AbortPropertyImageUploadError', message: string, code: string, details: unknown }
      | { __typename: 'AbortPropertyImageUploadSuccess', message: string, success: boolean }
     } };

export type PropertyVideosQueryVariables = Exact<{
  id: string | number;
}>;


export type PropertyVideosQuery = { property: { node: { id: string, videos: Array<{ id: string, position: number, caption: string | null, description: string | null, uploadStatus: UploadStatusEnum, uploadError: string | null, originalUrl: string | null, posterUrl: string | null, bytesSize: number | null, contentType: string | null, durationSeconds: number | null, excludeFromPortalExport: boolean, videoRkid: string | null }> } | null } };

export type PropertyCreateVideoUploadIntentMutationVariables = Exact<{
  propertyId: string | number;
  contentType: string;
  caption?: string | null | undefined;
  description?: string | null | undefined;
  position?: number | null | undefined;
  sizeBytes?: number | null | undefined;
}>;


export type PropertyCreateVideoUploadIntentMutation = { property: { createVideoUploadIntent:
      | { __typename: 'CreatePropertyVideoUploadIntentError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyVideoUploadIntentSuccess', message: string, video: { id: string, uploadStatus: UploadStatusEnum, position: number }, upload: { url: string, method: string, headers: unknown, expiresAt: string, maxBytes: number } }
     } };

export type PropertyFinalizeVideoUploadMutationVariables = Exact<{
  videoId: string | number;
}>;


export type PropertyFinalizeVideoUploadMutation = { property: { finalizeVideoUpload:
      | { __typename: 'FinalizePropertyVideoUploadError', message: string, code: string, details: unknown }
      | { __typename: 'FinalizePropertyVideoUploadSuccess', message: string, video: { id: string, uploadStatus: UploadStatusEnum, uploadError: string | null } }
     } };

export type PropertyAbortVideoUploadMutationVariables = Exact<{
  videoId: string | number;
}>;


export type PropertyAbortVideoUploadMutation = { property: { abortVideoUpload:
      | { __typename: 'AbortPropertyVideoUploadError', message: string, code: string, details: unknown }
      | { __typename: 'AbortPropertyVideoUploadSuccess', message: string, success: boolean }
     } };

export type PropertyDeleteVideoMutationVariables = Exact<{
  videoId: string | number;
}>;


export type PropertyDeleteVideoMutation = { property: { deleteVideo:
      | { __typename: 'DeletePropertyVideoError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertyVideoSuccess', message: string, success: boolean }
     } };

export type PropertyReorderVideosMutationVariables = Exact<{
  propertyId: string | number;
  videoIds: Array<string | number> | string | number;
}>;


export type PropertyReorderVideosMutation = { property: { reorderVideos:
      | { __typename: 'ReorderPropertyVideosError', message: string, code: string, details: unknown }
      | { __typename: 'ReorderPropertyVideosSuccess', message: string, videos: Array<{ id: string, position: number }> }
     } };

export type PropertyUpdateVideoMutationVariables = Exact<{
  videoId: string | number;
  caption?: string | null | undefined;
  description?: string | null | undefined;
  excludeFromPortalExport?: boolean | null | undefined;
}>;


export type PropertyUpdateVideoMutation = { property: { updateVideo:
      | { __typename: 'UpdatePropertyVideoError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertyVideoSuccess', message: string, video: { id: string, caption: string | null, description: string | null, excludeFromPortalExport: boolean } }
     } };

export type PropertyDeleteImageMutationVariables = Exact<{
  imageId: string | number;
}>;


export type PropertyDeleteImageMutation = { property: { deleteImage:
      | { __typename: 'DeletePropertyImageError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertyImageSuccess', message: string, success: boolean }
     } };

export type PropertyReorderImagesMutationVariables = Exact<{
  propertyId: string | number;
  imageIds: Array<string | number> | string | number;
}>;


export type PropertyReorderImagesMutation = { property: { reorderImages:
      | { __typename: 'ReorderPropertyImagesError', message: string, code: string, details: unknown }
      | { __typename: 'ReorderPropertyImagesSuccess', message: string, images: Array<{ id: string, position: number, isMain: boolean }> }
     } };

export type PropertyPromoteImageToGalleryMutationVariables = Exact<{
  imageId: string | number;
}>;


export type PropertyPromoteImageToGalleryMutation = { property: { promoteImageToGallery:
      | { __typename: 'PromotePropertyImageToGalleryError', message: string, code: string, details: unknown }
      | { __typename: 'PromotePropertyImageToGallerySuccess', message: string, image: { id: string, isMain: boolean, position: number, excludeFromPortalExport: boolean, variantKind: ImageVariantKindEnum | null, sourceImageId: string | null } }
     } };

export type PropertyDemoteImageFromGalleryMutationVariables = Exact<{
  imageId: string | number;
}>;


export type PropertyDemoteImageFromGalleryMutation = { property: { demoteImageFromGallery:
      | { __typename: 'DemotePropertyImageFromGalleryError', message: string, code: string, details: unknown }
      | { __typename: 'DemotePropertyImageFromGallerySuccess', message: string, image: { id: string, isMain: boolean, excludeFromPortalExport: boolean, variantKind: ImageVariantKindEnum | null, sourceImageId: string | null } }
     } };

export type PropertyUpdateImageMutationVariables = Exact<{
  imageId: string | number;
  caption?: string | null | undefined;
  roomType?: PhotoRoomTypeEnum | null | undefined;
}>;


export type PropertyUpdateImageMutation = { property: { updateImage:
      | { __typename: 'UpdatePropertyImageError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertyImageSuccess', message: string, image: { id: string, caption: string | null, roomType: PhotoRoomTypeEnum | null } }
     } };

export type PropertyCreateContractMutationVariables = Exact<{
  input: CreatePropertyContractInput;
}>;


export type PropertyCreateContractMutation = { property: { createContract:
      | { __typename: 'CreatePropertyContractError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyContractSuccess', message: string, contract: { id: string, title: string, contractType: PropertyContractTypeEnum, status: PropertyContractStatusEnum } }
     } };

export type PropertyUpdateContractMutationVariables = Exact<{
  input: UpdatePropertyContractInput;
}>;


export type PropertyUpdateContractMutation = { property: { updateContract:
      | { __typename: 'UpdatePropertyContractError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertyContractSuccess', message: string, contract: { id: string, title: string, contractType: PropertyContractTypeEnum, status: PropertyContractStatusEnum } }
     } };

export type PropertyDeleteContractMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyDeleteContractMutation = { property: { deleteContract:
      | { __typename: 'DeletePropertyContractError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertyContractSuccess', message: string, success: boolean }
     } };

export type PropertyCreatePartyMutationVariables = Exact<{
  input: CreatePropertyPartyInput;
}>;


export type PropertyCreatePartyMutation = { property: { createParty:
      | { __typename: 'CreatePropertyPartyError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyPartySuccess', message: string, party: { id: string, role: PropertyPartyRoleEnum, displayName: string | null } }
     } };

export type PropertyUpdatePartyMutationVariables = Exact<{
  input: UpdatePropertyPartyInput;
}>;


export type PropertyUpdatePartyMutation = { property: { updateParty:
      | { __typename: 'UpdatePropertyPartyError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertyPartySuccess', message: string, party: { id: string, role: PropertyPartyRoleEnum, displayName: string | null } }
     } };

export type PropertyDeletePartyMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyDeletePartyMutation = { property: { deleteParty:
      | { __typename: 'DeletePropertyPartyError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertyPartySuccess', message: string, success: boolean }
     } };

export type PropertyCreateLinkMutationVariables = Exact<{
  input: CreatePropertyLinkInput;
}>;


export type PropertyCreateLinkMutation = { property: { createLink:
      | { __typename: 'CreatePropertyLinkError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyLinkSuccess', message: string, link: { id: string, type: PropertyLinkTypeEnum, url: string, label: string | null } }
     } };

export type PropertyStartYoutubeExportMutationVariables = Exact<{
  input: StartYoutubeExportInput;
}>;


export type PropertyStartYoutubeExportMutation = { property: { startYoutubeExport:
      | { __typename: 'StartPropertyYoutubeExportError', message: string, code: string, details: unknown }
      | { __typename: 'StartPropertyYoutubeExportSuccess', message: string, uploadUri: string, creditsCharged: number, privacyStatus: string }
     } };

export type PropertyCompleteYoutubeExportMutationVariables = Exact<{
  input: CompleteYoutubeExportInput;
}>;


export type PropertyCompleteYoutubeExportMutation = { property: { completeYoutubeExport:
      | { __typename: 'CompletePropertyYoutubeExportError', message: string, code: string, details: unknown }
      | { __typename: 'CompletePropertyYoutubeExportSuccess', message: string, linkId: string, url: string, youtubeVideoId: string }
     } };

export type PropertyGenerateSocialCaptionMutationVariables = Exact<{
  input: GenerateSocialCaptionInput;
}>;


export type PropertyGenerateSocialCaptionMutation = { property: { generateSocialCaption:
      | { __typename: 'GeneratePropertySocialCaptionError', message: string, code: string, details: unknown }
      | { __typename: 'GeneratePropertySocialCaptionSuccess', message: string, caption: string, hashtags: Array<string>, creditsCharged: number, locale: string, platform: string }
     } };

export type PropertyTranslateSocialCaptionMutationVariables = Exact<{
  input: TranslateSocialCaptionInput;
}>;


export type PropertyTranslateSocialCaptionMutation = { property: { translateSocialCaption:
      | { __typename: 'TranslatePropertySocialCaptionError', message: string, code: string, details: unknown }
      | { __typename: 'TranslatePropertySocialCaptionSuccess', message: string, captions: unknown, creditsCharged: number, sourceLocale: string }
     } };

export type PropertyPolishSocialCaptionMutationVariables = Exact<{
  input: PolishSocialCaptionInput;
}>;


export type PropertyPolishSocialCaptionMutation = { property: { polishSocialCaption:
      | { __typename: 'PolishPropertySocialCaptionError', message: string, code: string, details: unknown }
      | { __typename: 'PolishPropertySocialCaptionSuccess', message: string, caption: string, hashtags: Array<string>, creditsCharged: number, locale: string, platform: string }
     } };

export type PropertyStartMetaPublishMutationVariables = Exact<{
  input: StartMetaPublishInput;
}>;


export type PropertyStartMetaPublishMutation = { property: { startMetaPublish:
      | { __typename: 'StartPropertyMetaPublishError', message: string, code: string, details: unknown }
      | { __typename: 'StartPropertyMetaPublishSuccess', stub: boolean, message: string, platform: string, mediaType: string, creditsCharged: number, uploadUrl: string | null, uploadKey: string | null, imageUrl: string | null, videoUrl: string | null, igContainerId: string | null }
     } };

export type PropertyCompleteMetaPublishMutationVariables = Exact<{
  input: CompleteMetaPublishInput;
}>;


export type PropertyCompleteMetaPublishMutation = { property: { completeMetaPublish:
      | { __typename: 'CompletePropertyMetaPublishError', message: string, code: string, details: unknown }
      | { __typename: 'CompletePropertyMetaPublishSuccess', stub: boolean, message: string, linkId: string | null, url: string, postId: string, platform: string }
     } };

export type PropertyGenerateSocialPostImageMutationVariables = Exact<{
  input: GenerateSocialPostImageInput;
}>;


export type PropertyGenerateSocialPostImageMutation = { property: { generateSocialPostImage:
      | { __typename: 'GeneratePropertySocialPostImageError', message: string, code: string, details: unknown }
      | { __typename: 'GeneratePropertySocialPostImageSuccess', message: string, socialPostImage: { propertyId: string, queued: boolean, documentId: string | null, downloadUrl: string | null } }
     } };

export type PropertyGenerateCustomSocialPostImageMutationVariables = Exact<{
  input: GenerateCustomSocialPostImageInput;
}>;


export type PropertyGenerateCustomSocialPostImageMutation = { property: { generateCustomSocialPostImage:
      | { __typename: 'GenerateCustomSocialPostImageError', message: string, code: string, details: unknown }
      | { __typename: 'GenerateCustomSocialPostImageSuccess', message: string, customSocialPostImage: { requestId: string, queued: boolean, documentId: string | null, downloadUrl: string | null } }
     } };

export type PropertyCustomSocialPostImageQueryVariables = Exact<{
  requestId: string;
}>;


export type PropertyCustomSocialPostImageQuery = { property: { customSocialPostImage: { requestId: string, queued: boolean, documentId: string | null, originalName: string | null, templateId: string | null, generatedAt: string | null, sizeBytes: number | null, downloadUrl: string | null } | null } };

export type PropertySocialPostImageQueryVariables = Exact<{
  id: string | number;
  templateId?: string | null | undefined;
}>;


export type PropertySocialPostImageQuery = { property: { node: { id: string, socialPostImage: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, sizeBytes: number | null, downloadUrl: string | null, generationError: string | null } | null } | null } };

export type PropertyUpdateLinkMutationVariables = Exact<{
  input: UpdatePropertyLinkInput;
}>;


export type PropertyUpdateLinkMutation = { property: { updateLink:
      | { __typename: 'UpdatePropertyLinkError', message: string, code: string, details: unknown }
      | { __typename: 'UpdatePropertyLinkSuccess', message: string, link: { id: string, type: PropertyLinkTypeEnum, url: string, label: string | null } }
     } };

export type PropertyDeleteLinkMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyDeleteLinkMutation = { property: { deleteLink:
      | { __typename: 'DeletePropertyLinkError', message: string, code: string, details: unknown }
      | { __typename: 'DeletePropertyLinkSuccess', message: string, success: boolean }
     } };

export type PropertySetPortalExportMutationVariables = Exact<{
  input: SetPortalExportInput;
}>;


export type PropertySetPortalExportMutation = { property: { setPortalExport:
      | { __typename: 'SetPropertyPortalExportError', message: string, code: string, details: unknown }
      | { __typename: 'SetPropertyPortalExportSuccess', message: string, property: { id: string, portalExports: Array<{ id: string, provider: IntegrationProviderEnum, isEnabled: boolean, status: IntegrationSyncStatusEnum }> } }
     } };

export type PropertySetPortalBumpScheduleMutationVariables = Exact<{
  input: SetPortalBumpScheduleInput;
}>;


export type PropertySetPortalBumpScheduleMutation = { property: { setPortalBumpSchedule:
      | { __typename: 'SetPropertyPortalBumpScheduleError', message: string, code: string, details: unknown }
      | { __typename: 'SetPropertyPortalBumpScheduleSuccess', message: string, property: { id: string, portalExports: Array<{ id: string, provider: IntegrationProviderEnum, bumpEnabled: boolean, bumpDays: Array<number>, bumpAfterHour: number | null, bumpPriority: PortalBumpPriorityEnum }> } }
     } };

export type PropertyMarkUnavailableMutationVariables = Exact<{
  input: MarkUnavailableInput;
}>;


export type PropertyMarkUnavailableMutation = { property: { markUnavailable:
      | { __typename: 'MarkPropertyUnavailableError', message: string, code: string, details: unknown }
      | { __typename: 'MarkPropertyUnavailableSuccess', message: string, property: { id: string, status: PropertyStatusEnum, isPublished: boolean, unpublishedAt: string | null } }
     } };

export type PropertyVerifyPortalPublicationMutationVariables = Exact<{
  input: VerifyPortalPublicationInput;
}>;


export type PropertyVerifyPortalPublicationMutation = { property: { verifyPortalPublication:
      | { __typename: 'VerifyPropertyPortalPublicationError', message: string, code: string, details: unknown }
      | { __typename: 'VerifyPropertyPortalPublicationSuccess', message: string, portalExport: { id: string, provider: IntegrationProviderEnum, publicationStatus: PortalPublicationStatusEnum, lastVerifiedAt: string | null, lastVerificationError: string | null, status: IntegrationSyncStatusEnum, lastError: string | null } }
     } };

export type PropertyVerifyAllPortalPublicationsMutationVariables = Exact<{
  propertyId: string | number;
}>;


export type PropertyVerifyAllPortalPublicationsMutation = { property: { verifyAllPortalPublications:
      | { __typename: 'VerifyAllPropertyPortalPublicationsError', message: string, code: string, details: unknown }
      | { __typename: 'VerifyAllPropertyPortalPublicationsSuccess', message: string, portalExports: Array<{ id: string, provider: IntegrationProviderEnum, publicationStatus: PortalPublicationStatusEnum, lastVerifiedAt: string | null, lastVerificationError: string | null, status: IntegrationSyncStatusEnum, lastError: string | null, externalListingId: string | null }> }
     } };

export type PropertyReconcilePortalPublicationsMutationVariables = Exact<{ [key: string]: never; }>;


export type PropertyReconcilePortalPublicationsMutation = { property: { reconcilePortalPublications:
      | { __typename: 'ReconcilePropertyPortalPublicationsError', message: string, code: string, details: unknown }
      | { __typename: 'ReconcilePropertyPortalPublicationsSuccess', message: string, checked: number, mismatches: number, remediated: number, tasksCreated: number, unsupported: number, errors: number }
     } };

export type PropertyTranslateWithAiMutationVariables = Exact<{
  id: string | number;
  sourceLocale?: string;
  targetLocales?: Array<string> | string | null | undefined;
  fields?: Array<string> | string | null | undefined;
  overwrite?: boolean;
  idempotencyKey?: string | null | undefined;
}>;


export type PropertyTranslateWithAiMutation = { property: { translateWithAi:
      | { __typename: 'TranslatePropertyWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'TranslatePropertyWithAiSuccess', message: string, propertyId: string, queued: boolean }
     } };

export type PropertyGenerateDescriptionWithAiMutationVariables = Exact<{
  id: string | number;
  locale?: string;
  overwrite?: boolean;
  idempotencyKey?: string | null | undefined;
}>;


export type PropertyGenerateDescriptionWithAiMutation = { property: { generateDescriptionWithAi:
      | { __typename: 'GeneratePropertyDescriptionWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'GeneratePropertyDescriptionWithAiSuccess', message: string, propertyId: string, queued: boolean, locale: string }
     } };

export type PropertyConfirmAiTranslationMutationVariables = Exact<{
  id: string | number;
  locale: string;
}>;


export type PropertyConfirmAiTranslationMutation = { property: { confirmAiTranslation:
      | { __typename: 'ConfirmPropertyAiTranslationError', message: string, code: string, details: unknown }
      | { __typename: 'ConfirmPropertyAiTranslationSuccess', message: string, propertyId: string, locale: string, confirmed: boolean }
     } };

export type PropertyEnhanceImageWithAiMutationVariables = Exact<{
  imageId: string | number;
  mode?: EnhanceModeEnum;
  prompt?: string | null | undefined;
  idempotencyKey?: string | null | undefined;
}>;


export type PropertyEnhanceImageWithAiMutation = { property: { enhanceImageWithAi:
      | { __typename: 'EnhancePropertyImageWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'EnhancePropertyImageWithAiSuccess', message: string, propertyId: string, imageId: string, queued: boolean }
     } };

export type PropertyStageImageWithAiMutationVariables = Exact<{
  imageId: string | number;
  style?: StagingStyleEnum;
  prompt?: string | null | undefined;
  idempotencyKey?: string | null | undefined;
}>;


export type PropertyStageImageWithAiMutation = { property: { stageImageWithAi:
      | { __typename: 'StagePropertyImageWithAiError', message: string, code: string, details: unknown }
      | { __typename: 'StagePropertyImageWithAiSuccess', message: string, propertyId: string, imageId: string, style: string, queued: boolean }
     } };

export type PropertyGenerateCatalogCardMutationVariables = Exact<{
  id: string | number;
  locale?: string;
  brokerId?: string | number | null | undefined;
  templateId?: string | null | undefined;
  overrides?: unknown;
}>;


export type PropertyGenerateCatalogCardMutation = { property: { generateCatalogCard:
      | { __typename: 'GeneratePropertyCatalogCardError', message: string, code: string, details: unknown }
      | { __typename: 'GeneratePropertyCatalogCardSuccess', message: string, catalogCard: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, downloadUrl: string | null } }
     } };

export type PropertyCatalogCardQueryVariables = Exact<{
  id: string | number;
}>;


export type PropertyCatalogCardQuery = { property: { node: { id: string, catalogCard: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, sizeBytes: number | null, downloadUrl: string | null, generationError: string | null } | null } | null } };

export type PropertyGenerateLegalDocumentMutationVariables = Exact<{
  input: GenerateLegalDocumentInput;
}>;


export type PropertyGenerateLegalDocumentMutation = { property: { generateLegalDocument:
      | { __typename: 'GeneratePropertyLegalDocumentError', message: string, code: string, details: unknown }
      | { __typename: 'GeneratePropertyLegalDocumentSuccess', message: string, legalDocument: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, downloadUrl: string | null } }
     } };

export type PropertyBulkTransferMutationVariables = Exact<{
  input: BulkTransferInput;
}>;


export type PropertyBulkTransferMutation = { property: { bulkTransfer:
      | { __typename: 'BulkTransferPropertiesError', message: string, code: string, details: unknown }
      | { __typename: 'BulkTransferPropertiesSuccess', message: string, transferredCount: number, transferredPropertyIds: Array<string>, skippedPropertyIds: Array<string>, dealsTransferred: number, tasksTransferred: number, srealityReprovisionQueuedCount: number }
     } };

export type PropertyLegalDocumentQueryVariables = Exact<{
  id: string | number;
  templateId?: string | null | undefined;
}>;


export type PropertyLegalDocumentQuery = { property: { node: { id: string, legalDocument: { propertyId: string, queued: boolean, documentId: string | null, originalName: string | null, locale: string | null, templateId: string | null, generatedAt: string | null, sizeBytes: number | null, downloadUrl: string | null, generationError: string | null } | null } | null } };

export type PropertyDocumentDraftQueryVariables = Exact<{
  id: string | number;
  kind: RenderTemplateKindEnum;
  templateId?: string | null | undefined;
  locale?: string;
  brokerId?: string | number | null | undefined;
  overrides?: unknown;
}>;


export type PropertyDocumentDraftQuery = { property: { node: { id: string, documentDraft: { kind: RenderTemplateKindEnum, schemaId: string, contextType: RenderContextTypeEnum, contextId: string | null, values: unknown, template: { id: string, slug: string, name: string, kind: string, isDefault: boolean }, fields: Array<{ key: string, value: unknown, source: RenderValueSourceEnum, autofilledFrom: string | null, def: { key: string, label: string, description: string | null, valueType: RenderFieldValueTypeEnum, group: RenderFieldGroupEnum, required: boolean, overridable: boolean, autofill: { sources: Array<string> } | null } }>, availableMedia: Array<{ imageId: string, position: number, caption: string | null, thumbUrl: string | null, isMain: boolean }>, mediaSlots: Array<{ key: string, label: string, maxCount: number, required: boolean, imageIds: Array<string>, source: RenderValueSourceEnum }> } | null } | null } };

export type PropertyMessageTilesQueryVariables = Exact<{ [key: string]: never; }>;


export type PropertyMessageTilesQuery = { propertyMessage: { tiles: Array<{ provider: IntegrationProviderEnum, totalCount: number, unreadCount: number, latestAt: string | null }> } };

export type PropertyMessageInboxQueryVariables = Exact<{
  provider?: IntegrationProviderEnum | null | undefined;
  propertyId?: string | number | null | undefined;
  unreadOnly?: boolean;
  includeArchived?: boolean;
  limit?: number;
  offset?: number;
}>;


export type PropertyMessageInboxQuery = { propertyMessage: { inbox: { totalCount: number, items: Array<{ id: string, provider: IntegrationProviderEnum, direction: PropertyMessageDirectionEnum, status: PropertyMessageStatusEnum, senderName: string, senderEmail: string | null, senderPhone: string | null, body: string | null, receivedAt: string, readAt: string | null, propertyId: string | null, leadId: string | null, threadKey: string }> } } };

export type PropertyMessageMarkReadMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyMessageMarkReadMutation = { propertyMessage: { markRead:
      | { __typename: 'MarkPropertyMessageReadError', message: string, code: string, details: unknown }
      | { __typename: 'MarkPropertyMessageReadSuccess', message: string, propertyMessage: { id: string, status: PropertyMessageStatusEnum, readAt: string | null } }
     } };

export type PropertyMessageArchiveMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyMessageArchiveMutation = { propertyMessage: { archive:
      | { __typename: 'ArchivePropertyMessageError', message: string, code: string, details: unknown }
      | { __typename: 'ArchivePropertyMessageSuccess', message: string, propertyMessage: { id: string, status: PropertyMessageStatusEnum } }
     } };

export type PropertyMessageCreateLeadMutationVariables = Exact<{
  id: string | number;
}>;


export type PropertyMessageCreateLeadMutation = { propertyMessage: { createLead:
      | { __typename: 'CreatePropertyMessageLeadError', message: string, code: string, details: unknown }
      | { __typename: 'CreatePropertyMessageLeadSuccess', message: string, leadId: string, propertyMessage: { id: string, leadId: string | null, status: PropertyMessageStatusEnum } }
     } };

export type PropertyMessageReplyMutationVariables = Exact<{
  id: string | number;
  body: string;
}>;


export type PropertyMessageReplyMutation = { propertyMessage: { reply:
      | { __typename: 'ReplyPropertyMessageError', message: string, code: string, details: unknown }
      | { __typename: 'ReplyPropertyMessageSuccess', message: string, propertyMessage: { id: string, status: PropertyMessageStatusEnum, readAt: string | null }, reply: { id: string, direction: PropertyMessageDirectionEnum, status: PropertyMessageStatusEnum, body: string | null, receivedAt: string, senderName: string } }
     } };

export type PublicAgentBySlugQueryVariables = Exact<{
  slug: string;
  locale?: string;
  organizationSlug?: string | null | undefined;
}>;


export type PublicAgentBySlugQuery = { publicAgent: { bySlug: { id: string, slug: string | null, displayName: string, title: string | null, email: string | null, phone: string | null, bio: string | null, avatarUrl: string | null } | null } };

export type PublicBlogSearchQueryVariables = Exact<{
  input?: PublicBlogSearchInput | null | undefined;
}>;


export type PublicBlogSearchQuery = { publicBlog: { search: { totalCount: number, items: Array<{ id: string, slug: string, locale: string, title: string, excerpt: string | null, coverUrl: string | null, tags: Array<string>, publishedAt: string | null, author: { slug: string | null, displayName: string, avatarUrl: string | null } | null }> } } };

export type PublicBlogBySlugQueryVariables = Exact<{
  slug: string;
  locale?: string;
  organizationSlug: string;
}>;


export type PublicBlogBySlugQuery = { publicBlog: { bySlug: { id: string, slug: string, locale: string, title: string, excerpt: string | null, contentHtml: string | null, contentMarkdown: string | null, coverUrl: string | null, tags: Array<string>, seoTitle: string | null, seoDescription: string | null, publishedAt: string | null, author: { slug: string | null, displayName: string, title: string | null, avatarUrl: string | null } | null } | null } };

export type PublicDocumentResolveShareQueryVariables = Exact<{
  token: string;
  password?: string | null | undefined;
  limit?: number;
  offset?: number;
}>;


export type PublicDocumentResolveShareQuery = { publicDocument: { resolveShare: { shareId: string, scope: DmsShareScopeEnum, nodeId: string, nodeName: string, allowDownload: boolean, passwordRequired: boolean, totalFiles: number, files: Array<{ nodeId: string, documentId: string, name: string, mimeType: string, sizeBytes: number }> } } };

export type PublicDocumentDownloadQueryVariables = Exact<{
  token: string;
  documentId: string | number;
  password?: string | null | undefined;
}>;


export type PublicDocumentDownloadQuery = { publicDocument: { download: { documentId: string, name: string, mimeType: string, sizeBytes: number, downloadUrl: string } } };

export type PublicPropertySearchQueryVariables = Exact<{
  input?: PublicPropertySearchInput | null | undefined;
}>;


export type PublicPropertySearchQuery = { publicProperty: { search: { totalCount: number, items: Array<{ id: string, slug: string | null, title: string, locale: string, category: PropertyCategoryEnum, propertyType: PropertyTypeEnum, price: string | null, currency: string, priceUnit: PriceUnitEnum | null, priceOnRequest: boolean, locationPrivacy: LocationPrivacyEnum, coverUrl: string | null, map: { latitude: number | null, longitude: number | null, showPin: boolean, isExact: boolean, city: string | null, district: string | null, addressLine: string | null }, agent: { slug: string | null, displayName: string, avatarUrl: string | null } | null }> } } };

export type PublicPropertyBySlugQueryVariables = Exact<{
  slug: string;
  locale?: string;
  organizationSlug?: string | null | undefined;
}>;


export type PublicPropertyBySlugQuery = { publicProperty: { bySlug: { id: string, slug: string | null, title: string, locale: string, category: PropertyCategoryEnum, propertyType: PropertyTypeEnum, price: string | null, currency: string, priceUnit: PriceUnitEnum | null, priceOnRequest: boolean, locationPrivacy: LocationPrivacyEnum, description: string | null, marketingText: string | null, layout: PropertyLayoutEnum | null, usableArea: string | null, floorArea: string | null, lotSize: string | null, floor: number | null, totalFloors: number | null, yearBuilt: number | null, energyClass: EnergyClassEnum | null, condition: PropertyConditionEnum | null, hasBalcony: boolean, hasTerrace: boolean, hasParking: boolean, hasElevator: boolean, coverUrl: string | null, map: { latitude: number | null, longitude: number | null, showPin: boolean, isExact: boolean, city: string | null, district: string | null, addressLine: string | null }, agent: { slug: string | null, displayName: string, title: string | null, email: string | null, phone: string | null, avatarUrl: string | null } | null, images: Array<{ caption: string | null, isMain: boolean, thumbUrl: string | null, displayUrl: string | null }>, links: Array<{ type: PropertyLinkTypeEnum, url: string, label: string | null }> } | null } };

export type PublicSiteQueryVariables = Exact<{
  organizationSlug?: string | null | undefined;
}>;


export type PublicSiteQuery = { publicSite: { get: { organizationSlug: string, name: string, brand: string, logoUrl: string | null, template: string, legalName: string | null, address: string | null, phone: string | null, email: string | null, palette: { primary: string | null, background: string | null, foreground: string | null }, team: Array<{ id: string, slug: string | null, displayName: string, title: string | null, email: string | null, phone: string | null, bio: string | null, avatarUrl: string | null }>, venues: Array<{ name: string, slug: string, address: string | null, phone: string | null, email: string | null }> } } };

export type UserEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type UserEventsSubscription = { userEvents: { kind: string, event: string, entityType: string | null, entityId: string | null, occurredAt: string | null, payload: unknown, notification: { id: string, type: NotificationKindEnum, title: string, body: string | null, entityType: string | null, entityId: string | null, readAt: string | null, createdAt: string | null } | null } };

export type PortalEventsSubscriptionVariables = Exact<{ [key: string]: never; }>;


export type PortalEventsSubscription = { portalEvents: { kind: string, event: string, entityType: string | null, entityId: string | null, occurredAt: string | null, payload: unknown, notification: { id: string, type: NotificationKindEnum, title: string, body: string | null, entityType: string | null, entityId: string | null, readAt: string | null, createdAt: string | null } | null } };

export type RenderTemplateListQueryVariables = Exact<{
  kind?: RenderTemplateKindEnum | null | undefined;
  includeInactive?: boolean | null | undefined;
}>;


export type RenderTemplateListQuery = { renderTemplate: { list: Array<{ id: string, slug: string, name: string, kind: string, format: string, aspectRatio: string, locale: string, version: number, isSystem: boolean, isDefault: boolean, isActive: boolean, settings: unknown, source: string | null, typUrl: string | null }> } };

export type RenderTemplateNodeQueryVariables = Exact<{
  id?: string | number | null | undefined;
  slug?: string | null | undefined;
}>;


export type RenderTemplateNodeQuery = { renderTemplate: { node: { id: string, slug: string, name: string, kind: string, format: string, aspectRatio: string, locale: string, version: number, isSystem: boolean, isDefault: boolean, isActive: boolean, settings: unknown, source: string | null, typUrl: string | null } | null } };

export type RenderFieldContractQueryVariables = Exact<{
  kind: RenderTemplateKindEnum;
  schemaId?: string | null | undefined;
}>;


export type RenderFieldContractQuery = { renderTemplate: { fieldContract: { schemaId: string, kind: RenderTemplateKindEnum, fields: Array<{ key: string, label: string, description: string | null, valueType: RenderFieldValueTypeEnum, group: RenderFieldGroupEnum, required: boolean, overridable: boolean, autofill: { sources: Array<string> } | null }>, mediaSlots: Array<{ key: string, label: string, maxCount: number, required: boolean, autofillSource: string, group: RenderFieldGroupEnum }> } } };

export type RenderBlockCatalogQueryVariables = Exact<{
  kind?: RenderTemplateKindEnum | null | undefined;
}>;


export type RenderBlockCatalogQuery = { renderTemplate: { blockCatalog: unknown } };

export type RenderTemplateUpsertMutationVariables = Exact<{
  input: UpsertRenderTemplateInput;
  typFile?: unknown;
}>;


export type RenderTemplateUpsertMutation = { renderTemplate: { upsert:
      | { __typename: 'UpsertRenderTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'UpsertRenderTemplateSuccess', message: string, renderTemplate: { id: string, slug: string, name: string, kind: string, format: string, aspectRatio: string, locale: string, version: number, isSystem: boolean, isDefault: boolean, isActive: boolean, settings: unknown, source: string | null, typUrl: string | null } }
     } };

export type RenderTemplateForkMutationVariables = Exact<{
  input: ForkRenderTemplateInput;
}>;


export type RenderTemplateForkMutation = { renderTemplate: { fork:
      | { __typename: 'ForkRenderTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'ForkRenderTemplateSuccess', message: string, renderTemplate: { id: string, slug: string, name: string, kind: string, format: string, aspectRatio: string, locale: string, version: number, isSystem: boolean, isDefault: boolean, isActive: boolean, source: string | null, typUrl: string | null } }
     } };

export type RenderTemplateSetDefaultMutationVariables = Exact<{
  id: string | number;
}>;


export type RenderTemplateSetDefaultMutation = { renderTemplate: { setDefault:
      | { __typename: 'SetDefaultRenderTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'SetDefaultRenderTemplateSuccess', message: string, renderTemplate: { id: string, slug: string, name: string, kind: string, isDefault: boolean } }
     } };

export type RenderTemplatePreviewMutationVariables = Exact<{
  input: PreviewRenderTemplateInput;
}>;


export type RenderTemplatePreviewMutation = { renderTemplate: { preview:
      | { __typename: 'PreviewRenderTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'PreviewRenderTemplateSuccess', message: string, preview: { compileOk: boolean, compileError: string | null, downloadUrl: string | null, contentType: string | null, format: string | null } }
     } };

export type RenderCompileLayoutMutationVariables = Exact<{
  input: CompileLayoutInput;
}>;


export type RenderCompileLayoutMutation = { renderTemplate: { compileLayout:
      | { __typename: 'CompileRenderTemplateLayoutError', message: string, code: string, details: unknown }
      | { __typename: 'CompileRenderTemplateLayoutSuccess', message: string, result: { source: string, layout: unknown, compileOk: boolean, compileError: string | null, preview: { downloadUrl: string | null, contentType: string | null, format: string | null } | null } }
     } };

export type RenderCompileMarkupMutationVariables = Exact<{
  input: CompileMarkupInput;
}>;


export type RenderCompileMarkupMutation = { renderTemplate: { compileMarkup:
      | { __typename: 'CompileRenderTemplateMarkupError', message: string, code: string, details: unknown }
      | { __typename: 'CompileRenderTemplateMarkupSuccess', message: string, result: { source: string, layout: unknown, compileOk: boolean, compileError: string | null, preview: { downloadUrl: string | null, contentType: string | null, format: string | null } | null } }
     } };

export type RenderTemplateDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type RenderTemplateDeleteMutation = { renderTemplate: { delete:
      | { __typename: 'DeleteRenderTemplateError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteRenderTemplateSuccess', message: string, success: boolean }
     } };

export type RenderTemplateAssistTypstMutationVariables = Exact<{
  input: AssistTypstInput;
}>;


export type RenderTemplateAssistTypstMutation = { renderTemplate: { assistTypst:
      | { __typename: 'AssistRenderTemplateTypstError', message: string, code: string, details: unknown }
      | { __typename: 'AssistRenderTemplateTypstSuccess', message: string, result: { source: string, layout: unknown, outputFormat: string, provider: string, model: string, creditsCharged: number, extractedTextPreview: string | null, compileOk: boolean, compileError: string | null, blockCatalog: unknown } }
     } };

export type ReportDashboardQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportDashboardQuery = { report: { dashboard: { newLeads: number, activeClients: number, activeDeals: number, closedDeals: number, closedVolume: string, conversionRate: number, avgDealCycleDays: number | null, periodStart: string, periodEnd: string } } };

export type ReportLeadSourcesQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportLeadSourcesQuery = { report: { leadSources: Array<{ source: LeadSourceEnum, count: number, convertedCount: number, conversionRate: number }> } };

export type ReportAgentPerformanceQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportAgentPerformanceQuery = { report: { agentPerformance: Array<{ agentId: string, agentName: string, leadsCount: number, dealsWon: number, dealsLost: number, wonVolume: string, conversionRate: number, avgDealCycleDays: number | null }> } };

export type ReportPipelineStagesQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportPipelineStagesQuery = { report: { pipelineStages: Array<{ stageId: string, stageName: string, pipelineId: string | null, position: number, dealCount: number, expectedValue: string, pipelineValue: string, isWon: boolean, isLost: boolean }> } };

export type ReportCampaignPerformanceQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportCampaignPerformanceQuery = { report: { campaignPerformance: Array<{ utmCampaign: string, leadsCount: number, convertedCount: number, conversionRate: number }> } };

export type ReportProvisionByAgentQueryVariables = Exact<{
  input?: ReportFilterInput | null | undefined;
}>;


export type ReportProvisionByAgentQuery = { report: { provisionByAgent: Array<{ agentId: string, agentName: string, wonProvision: string, expectedProvision: string }> } };

export type SmsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type SmsStatusQuery = { sms: { smsStatus: unknown } };

export type SmsListMessagesQueryVariables = Exact<{
  clientId: string | number;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type SmsListMessagesQuery = { sms: { listSmsMessages: Array<{ id: string, toPhone: string, templateKey: string, body: string, status: SmsMessageStatusEnum, providerId: string | null, clientId: string | null, viewingId: string | null, propertyId: string | null, sentAt: string | null, error: string | null, createdAt: string | null }> } };

export type SmsTestSendMutationVariables = Exact<{
  toPhone: string;
  templateKey?: string | null | undefined;
  context?: unknown;
}>;


export type SmsTestSendMutation = { sms: { testSmsSend:
      | { __typename: 'TestSmsSendError', message: string, code: string, details: unknown }
      | { __typename: 'TestSmsSendSuccess', message: string, smsMessage: { id: string, toPhone: string, templateKey: string, body: string, status: SmsMessageStatusEnum, error: string | null, sentAt: string | null } }
     } };

export type TaskListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
  filters?: TaskFilter | null | undefined;
  order?: TaskOrder | null | undefined;
  scope?: CalendarScopeEnum;
  venueId?: string | number | null | undefined;
}>;


export type TaskListQuery = { task: { list: { totalCount: number | null, items: Array<{ id: string, title: string, status: TaskStatusEnum, category: TaskCategoryEnum, priority: PriorityEnum, startAt: string | null, endAt: string | null, dueAt: string | null, allDay: boolean, assigneeId: string, isOverdue: boolean, calendarProvider: CalendarProviderEnum, syncStatus: CalendarSyncStatusEnum, syncExportable: boolean, pipelineId: string | null, stageId: string | null }> } } };

export type TaskNodeQueryVariables = Exact<{
  id: string | number;
}>;


export type TaskNodeQuery = { task: { node: { id: string, title: string, description: string | null, status: TaskStatusEnum, priority: PriorityEnum, category: TaskCategoryEnum, assigneeId: string, creatorId: string, startAt: string | null, endAt: string | null, allDay: boolean, dueAt: string | null, locationLabel: string | null, clientId: string | null, propertyId: string | null, dealId: string | null, leadId: string | null, isOverdue: boolean, pipelineId: string | null, stageId: string | null, calendarProvider: CalendarProviderEnum, syncStatus: CalendarSyncStatusEnum, syncExportable: boolean, externalCalendarId: string | null, externalEventId: string | null, icalUid: string | null, lastSyncedAt: string | null, syncError: string | null, reminders: Array<{ id: string, channel: ReminderChannelEnum, remindAt: string }> } | null } };

export type TaskPipelineQueryVariables = Exact<{
  id?: string | number | null | undefined;
}>;


export type TaskPipelineQuery = { task: { pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } | null } };

export type TaskPipelinesQueryVariables = Exact<{
  includeArchived?: boolean;
  kind?: TaskPipelineKindEnum | null | undefined;
}>;


export type TaskPipelinesQuery = { task: { pipelines: Array<{ ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } }> } };

export type TaskPipelineFieldsFragment = { id: string, name: string, isDefault: boolean, isArchived: boolean, position: number, teamId: string | null, kind: TaskPipelineKindEnum, itemCount: number, stages: Array<{ id: string, name: string, color: string | null, position: number, mapsStatus: TaskStatusEnum, isOpen: boolean, isDone: boolean, isCancelled: boolean, itemCount: number }> } & { ' $fragmentName'?: 'TaskPipelineFieldsFragment' };

export type TaskExternalEventsQueryVariables = Exact<{
  start?: string | null | undefined;
  end?: string | null | undefined;
  limit?: number;
  userId?: string | number | null | undefined;
}>;


export type TaskExternalEventsQuery = { task: { externalEvents: Array<{ id: string, userId: string, provider: CalendarProviderEnum, externalId: string, title: string | null, startAt: string, endAt: string | null, allDay: boolean, isBusy: boolean, isPrivate: boolean, originTaskId: string | null }> } };

export type TaskCreateMutationVariables = Exact<{
  input: CreateTaskInput;
}>;


export type TaskCreateMutation = { task: { create:
      | { __typename: 'CreateTaskError', message: string, code: string, details: unknown }
      | { __typename: 'CreateTaskSuccess', message: string, task: { id: string, syncStatus: CalendarSyncStatusEnum, calendarProvider: CalendarProviderEnum, syncExportable: boolean, stageId: string | null, pipelineId: string | null } }
     } };

export type TaskUpdateMutationVariables = Exact<{
  input: UpdateTaskInput;
}>;


export type TaskUpdateMutation = { task: { update:
      | { __typename: 'UpdateTaskError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateTaskSuccess', message: string, task: { id: string } }
     } };

export type TaskCompleteMutationVariables = Exact<{
  id: string | number;
}>;


export type TaskCompleteMutation = { task: { complete:
      | { __typename: 'CompleteTaskError', message: string, code: string, details: unknown }
      | { __typename: 'CompleteTaskSuccess', message: string, task: { id: string, status: TaskStatusEnum, stageId: string | null } }
     } };

export type TaskCancelMutationVariables = Exact<{
  id: string | number;
}>;


export type TaskCancelMutation = { task: { cancel:
      | { __typename: 'CancelTaskError', message: string, code: string, details: unknown }
      | { __typename: 'CancelTaskSuccess', message: string, task: { id: string, status: TaskStatusEnum, stageId: string | null } }
     } };

export type TaskChangeStageMutationVariables = Exact<{
  id: string | number;
  stageId: string | number;
}>;


export type TaskChangeStageMutation = { task: { changeStage:
      | { __typename: 'ChangeTaskStageError', message: string, code: string, details: unknown }
      | { __typename: 'ChangeTaskStageSuccess', message: string, task: { id: string, status: TaskStatusEnum, stageId: string | null, pipelineId: string | null } }
     } };

export type TaskSetPipelineMutationVariables = Exact<{
  id: string | number;
  pipelineId: string | number;
}>;


export type TaskSetPipelineMutation = { task: { setPipeline:
      | { __typename: 'SetTaskPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'SetTaskPipelineSuccess', message: string, task: { id: string, pipelineId: string | null, stageId: string | null, status: TaskStatusEnum } }
     } };

export type TaskCreatePipelineMutationVariables = Exact<{
  name: string;
  isDefault?: boolean;
  withDefaultStages?: boolean;
  teamId?: string | number | null | undefined;
  cloneFromId?: string | number | null | undefined;
  kind?: TaskPipelineKindEnum;
}>;


export type TaskCreatePipelineMutation = { task: { createPipeline:
      | { __typename: 'CreateTaskPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'CreateTaskPipelineSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskUpdatePipelineMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  isDefault?: boolean | null | undefined;
  position?: number | null | undefined;
  teamId?: string | number | null | undefined;
  kind?: TaskPipelineKindEnum | null | undefined;
}>;


export type TaskUpdatePipelineMutation = { task: { updatePipeline:
      | { __typename: 'UpdateTaskPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateTaskPipelineSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskArchivePipelineMutationVariables = Exact<{
  id: string | number;
}>;


export type TaskArchivePipelineMutation = { task: { archivePipeline:
      | { __typename: 'ArchiveTaskPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'ArchiveTaskPipelineSuccess', message: string, pipeline: { id: string, isArchived: boolean } }
     } };

export type TaskDeletePipelineMutationVariables = Exact<{
  id: string | number;
  targetPipelineId?: string | number | null | undefined;
  mappings?: Array<StageMappingInput> | StageMappingInput | null | undefined;
}>;


export type TaskDeletePipelineMutation = { task: { deletePipeline:
      | { __typename: 'DeleteTaskPipelineError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteTaskPipelineSuccess', message: string, success: boolean }
     } };

export type TaskMovePipelineItemsMutationVariables = Exact<{
  fromPipelineId: string | number;
  toPipelineId: string | number;
  mappings: Array<StageMappingInput> | StageMappingInput;
}>;


export type TaskMovePipelineItemsMutation = { task: { movePipelineItems:
      | { __typename: 'MoveTaskPipelineItemsError', message: string, code: string, details: unknown }
      | { __typename: 'MoveTaskPipelineItemsSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskAddPipelineStageMutationVariables = Exact<{
  pipelineId: string | number;
  name: string;
  color?: string | null | undefined;
  mapsStatus?: TaskStatusEnum;
  isOpen?: boolean;
  isDone?: boolean;
  isCancelled?: boolean;
  position?: number | null | undefined;
}>;


export type TaskAddPipelineStageMutation = { task: { addPipelineStage:
      | { __typename: 'AddTaskPipelineStageError', message: string, code: string, details: unknown }
      | { __typename: 'AddTaskPipelineStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskUpdatePipelineStageMutationVariables = Exact<{
  id: string | number;
  name?: string | null | undefined;
  color?: string | null | undefined;
  mapsStatus?: TaskStatusEnum | null | undefined;
  isOpen?: boolean | null | undefined;
  isDone?: boolean | null | undefined;
  isCancelled?: boolean | null | undefined;
}>;


export type TaskUpdatePipelineStageMutation = { task: { updatePipelineStage:
      | { __typename: 'UpdateTaskPipelineStageError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateTaskPipelineStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskDeletePipelineStageMutationVariables = Exact<{
  id: string | number;
  moveToStageId?: string | number | null | undefined;
}>;


export type TaskDeletePipelineStageMutation = { task: { deletePipelineStage:
      | { __typename: 'DeleteTaskPipelineStageError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteTaskPipelineStageSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskReorderPipelineStagesMutationVariables = Exact<{
  pipelineId: string | number;
  stageIds: Array<string | number> | string | number;
}>;


export type TaskReorderPipelineStagesMutation = { task: { reorderPipelineStages:
      | { __typename: 'ReorderTaskPipelineStagesError', message: string, code: string, details: unknown }
      | { __typename: 'ReorderTaskPipelineStagesSuccess', message: string, pipeline: { ' $fragmentRefs'?: { 'TaskPipelineFieldsFragment': TaskPipelineFieldsFragment } } }
     } };

export type TaskSetSyncExportableMutationVariables = Exact<{
  id: string | number;
  exportable: boolean;
  removeFromExternal?: boolean;
}>;


export type TaskSetSyncExportableMutation = { task: { setSyncExportable:
      | { __typename: 'SetTaskSyncExportableError', message: string, code: string, details: unknown }
      | { __typename: 'SetTaskSyncExportableSuccess', message: string, task: { id: string, syncExportable: boolean, syncStatus: CalendarSyncStatusEnum, externalEventId: string | null } }
     } };

export type TaskAddReminderMutationVariables = Exact<{
  input: AddTaskReminderInput;
}>;


export type TaskAddReminderMutation = { task: { addReminder:
      | { __typename: 'AddTaskReminderError', message: string, code: string, details: unknown }
      | { __typename: 'AddTaskReminderSuccess', message: string, task: { id: string, reminders: Array<{ id: string, channel: ReminderChannelEnum, remindAt: string }> } }
     } };

export type TaskSyncToCalendarMutationVariables = Exact<{
  input: SyncTaskToCalendarInput;
}>;


export type TaskSyncToCalendarMutation = { task: { syncToCalendar:
      | { __typename: 'SyncTaskToCalendarError', message: string, code: string, details: unknown }
      | { __typename: 'SyncTaskToCalendarSuccess', message: string, task: { id: string, syncStatus: CalendarSyncStatusEnum, syncExportable: boolean, externalEventId: string | null, lastSyncedAt: string | null, syncError: string | null } }
     } };

export type TaskSyncRangeToCalendarMutationVariables = Exact<{
  input: SyncTasksToCalendarInput;
}>;


export type TaskSyncRangeToCalendarMutation = { task: { syncRangeToCalendar:
      | { __typename: 'SyncTaskRangeToCalendarError', message: string, code: string, details: unknown }
      | { __typename: 'SyncTaskRangeToCalendarSuccess', message: string, queued: number, skipped: number, cooldownUntil: string | null, lastManualSyncAt: string | null }
     } };

export type TaskRemoveFromCalendarMutationVariables = Exact<{
  id: string | number;
}>;


export type TaskRemoveFromCalendarMutation = { task: { removeFromCalendar:
      | { __typename: 'RemoveTaskFromCalendarError', message: string, code: string, details: unknown }
      | { __typename: 'RemoveTaskFromCalendarSuccess', message: string, task: { id: string, syncStatus: CalendarSyncStatusEnum, calendarProvider: CalendarProviderEnum } }
     } };

export type TaskDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type TaskDeleteMutation = { task: { delete:
      | { __typename: 'DeleteTaskError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteTaskSuccess', message: string, success: boolean }
     } };

export type TaskGenerateViewingProtocolMutationVariables = Exact<{
  input: GenerateViewingProtocolInput;
}>;


export type TaskGenerateViewingProtocolMutation = { task: { generateViewingProtocol:
      | { __typename: 'GenerateViewingProtocolError', message: string, code: string, details: unknown }
      | { __typename: 'GenerateViewingProtocolSuccess', message: string, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type TaskSendViewingProtocolForSigningMutationVariables = Exact<{
  documentId: string | number;
  deliveryMode: ViewingProtocolSigningDeliveryMode;
  signers?: Array<ViewingProtocolSignerInput> | ViewingProtocolSignerInput | null | undefined;
}>;


export type TaskSendViewingProtocolForSigningMutation = { task: { sendViewingProtocolForSigning:
      | { __typename: 'SendViewingProtocolForSigningError', message: string, code: string, details: unknown }
      | { __typename: 'SendViewingProtocolForSigningSuccess', message: string, creditsCharged: number, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type TaskRefreshViewingProtocolSigningMutationVariables = Exact<{
  documentId: string | number;
}>;


export type TaskRefreshViewingProtocolSigningMutation = { task: { refreshViewingProtocolSigning:
      | { __typename: 'RefreshViewingProtocolSigningError', message: string, code: string, details: unknown }
      | { __typename: 'RefreshViewingProtocolSigningSuccess', message: string, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type TaskCancelViewingProtocolSigningMutationVariables = Exact<{
  documentId: string | number;
}>;


export type TaskCancelViewingProtocolSigningMutation = { task: { cancelViewingProtocolSigning:
      | { __typename: 'CancelViewingProtocolSigningError', message: string, code: string, details: unknown }
      | { __typename: 'CancelViewingProtocolSigningSuccess', message: string, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type TaskDownloadViewingProtocolAuditTrailMutationVariables = Exact<{
  documentId: string | number;
}>;


export type TaskDownloadViewingProtocolAuditTrailMutation = { task: { downloadViewingProtocolAuditTrail:
      | { __typename: 'DownloadViewingProtocolAuditTrailError', message: string, code: string, details: unknown }
      | { __typename: 'DownloadViewingProtocolAuditTrailSuccess', message: string, document: { id: string, originalName: string, downloadUrl: string | null } }
     } };

export type TaskCompleteViewingProtocolSigningMutationVariables = Exact<{
  documentId: string | number;
}>;


export type TaskCompleteViewingProtocolSigningMutation = { task: { completeViewingProtocolSigning:
      | { __typename: 'CompleteViewingProtocolSigningError', message: string, code: string, details: unknown }
      | { __typename: 'CompleteViewingProtocolSigningSuccess', message: string, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type TaskViewingProtocolQueryVariables = Exact<{
  taskId: string | number;
}>;


export type TaskViewingProtocolQuery = { task: { viewingProtocol: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } | null } };

export type TaskSigningInboxQueryVariables = Exact<{
  status?: string | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type TaskSigningInboxQuery = { task: { signingInbox: { totalCount: number, items: Array<{ id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, signingTaskId: string | null, updatedAt: string | null, downloadUrl: string | null, metadata: unknown }> } } };

export type TaskSigningCandidatesQueryVariables = Exact<{
  search?: string | null | undefined;
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type TaskSigningCandidatesQuery = { task: { signingCandidates: { totalCount: number, items: Array<{ id: string, originalName: string, category: DocumentCategoryEnum, signingStatus: string | null, updatedAt: string | null, downloadUrl: string | null }> } } };

export type TaskSendDocumentForSigningMutationVariables = Exact<{
  documentId: string | number;
  deliveryMode: ViewingProtocolSigningDeliveryMode;
  signers?: Array<ViewingProtocolSignerInput> | ViewingProtocolSignerInput | null | undefined;
}>;


export type TaskSendDocumentForSigningMutation = { task: { sendDocumentForSigning:
      | { __typename: 'SendDocumentForSigningError', message: string, code: string, details: unknown }
      | { __typename: 'SendDocumentForSigningSuccess', message: string, creditsCharged: number, document: { id: string, originalName: string, signingStatus: string | null, signingProvider: string | null, signingDeliveryMode: string | null, downloadUrl: string | null, metadata: unknown, signingLinks: Array<{ email: string, url: string }> } }
     } };

export type EntityPickerTasksQueryVariables = Exact<{
  query?: string | null | undefined;
  limit?: number | null | undefined;
  scope?: CalendarScopeEnum;
}>;


export type EntityPickerTasksQuery = { task: { list: { items: Array<{ id: string, title: string, status: TaskStatusEnum, category: TaskCategoryEnum, dueAt: string | null, assigneeId: string }> } } };

export type ViewingListForPropertyQueryVariables = Exact<{
  propertyId: string | number;
}>;


export type ViewingListForPropertyQuery = { viewing: { listForProperty: Array<{ id: string, propertyId: string, clientId: string, dealId: string | null, agentId: string, scheduledAt: string, status: ViewingStatusEnum, reasonNotPurchased: ViewingNotPurchaseReasonEnum | null, reasonNote: string | null, taskId: string | null, feedback: string | null, suppressSms: boolean, createdAt: string | null, updatedAt: string | null }> } };

export type ViewingListQueryVariables = Exact<{
  limit?: number | null | undefined;
  offset?: number | null | undefined;
}>;


export type ViewingListQuery = { viewing: { list: Array<{ id: string, propertyId: string, clientId: string, dealId: string | null, agentId: string, scheduledAt: string, status: ViewingStatusEnum, reasonNotPurchased: ViewingNotPurchaseReasonEnum | null, reasonNote: string | null, taskId: string | null, feedback: string | null, suppressSms: boolean, createdAt: string | null, updatedAt: string | null }> } };

export type ViewingOwnerReportQueryVariables = Exact<{
  propertyId: string | number;
}>;


export type ViewingOwnerReportQuery = { viewing: { ownerReport: { total: number, attended: number, notPurchased: number, reasons: unknown } } };

export type ViewingCreateMutationVariables = Exact<{
  input: CreateViewingInput;
}>;


export type ViewingCreateMutation = { viewing: { create:
      | { __typename: 'CreateViewingError', message: string, code: string, details: unknown }
      | { __typename: 'CreateViewingSuccess', message: string, viewing: { id: string, propertyId: string, clientId: string, agentId: string, scheduledAt: string, status: ViewingStatusEnum, suppressSms: boolean } }
     } };

export type ViewingUpdateMutationVariables = Exact<{
  input: UpdateViewingInput;
}>;


export type ViewingUpdateMutation = { viewing: { update:
      | { __typename: 'UpdateViewingError', message: string, code: string, details: unknown }
      | { __typename: 'UpdateViewingSuccess', message: string, viewing: { id: string, scheduledAt: string, agentId: string, feedback: string | null, suppressSms: boolean, reasonNote: string | null } }
     } };

export type ViewingTransitionStatusMutationVariables = Exact<{
  input: TransitionViewingStatusInput;
}>;


export type ViewingTransitionStatusMutation = { viewing: { transitionStatus:
      | { __typename: 'TransitionViewingStatusError', message: string, code: string, details: unknown }
      | { __typename: 'TransitionViewingStatusSuccess', message: string, viewing: { id: string, status: ViewingStatusEnum, reasonNotPurchased: ViewingNotPurchaseReasonEnum | null, reasonNote: string | null, feedback: string | null } }
     } };

export type ViewingDeleteMutationVariables = Exact<{
  id: string | number;
}>;


export type ViewingDeleteMutation = { viewing: { delete:
      | { __typename: 'DeleteViewingError', message: string, code: string, details: unknown }
      | { __typename: 'DeleteViewingSuccess', message: string, success: boolean }
     } };

export class TypedDocumentString<TResult, TVariables>
  extends String
  implements DocumentTypeDecoration<TResult, TVariables>
{
  __apiType?: NonNullable<DocumentTypeDecoration<TResult, TVariables>['__apiType']>;
  private value: string;
  public __meta__?: Record<string, any> | undefined;

  constructor(value: string, __meta__?: Record<string, any> | undefined) {
    super(value);
    this.value = value;
    this.__meta__ = __meta__;
  }

  override toString(): string & DocumentTypeDecoration<TResult, TVariables> {
    return this.value;
  }
}
export const DealPipelineFieldsFragmentDoc = new TypedDocumentString(`
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}
    `, {"fragmentName":"DealPipelineFields"}) as unknown as TypedDocumentString<DealPipelineFieldsFragment, unknown>;
export const TaskPipelineFieldsFragmentDoc = new TypedDocumentString(`
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}
    `, {"fragmentName":"TaskPipelineFields"}) as unknown as TypedDocumentString<TaskPipelineFieldsFragment, unknown>;
export const ActivityTimelineDocument = new TypedDocumentString(`
    query ActivityTimeline($input: ActivityTimelineInput!) {
  activity {
    timeline(input: $input) {
      id
      type
      title
      body
      occurredAt
      createdAt
      actorId
      clientId
      propertyId
      dealId
      leadId
      taskId
    }
  }
}
    `) as unknown as TypedDocumentString<ActivityTimelineQuery, ActivityTimelineQueryVariables>;
export const ActivityListDocument = new TypedDocumentString(`
    query ActivityList($limit: Int, $offset: Int, $filters: ActivityFilter) {
  activity {
    list(limit: $limit, offset: $offset, filters: $filters) {
      items {
        id
        type
        body
        occurredAt
        createdAt
        actorId
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<ActivityListQuery, ActivityListQueryVariables>;
export const ActivityNodeDocument = new TypedDocumentString(`
    query ActivityNode($id: ID!) {
  activity {
    node(id: $id) {
      id
      type
      body
      occurredAt
      createdAt
      actorId
    }
  }
}
    `) as unknown as TypedDocumentString<ActivityNodeQuery, ActivityNodeQueryVariables>;
export const ActivityCreateDocument = new TypedDocumentString(`
    mutation ActivityCreate($input: CreateActivityInput!) {
  activity {
    create(input: $input) {
      __typename
      ... on CreateActivitySuccess {
        message
        activity {
          id
          type
        }
      }
      ... on CreateActivityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ActivityCreateMutation, ActivityCreateMutationVariables>;
export const AuditListDocument = new TypedDocumentString(`
    query AuditList($limit: Int! = 50, $offset: Int! = 0, $actorId: ID, $entityType: AuditEntityTypeEnum, $entityId: UUID, $actionKey: String, $createdAfter: DateTime, $createdBefore: DateTime) {
  audit {
    list(
      limit: $limit
      offset: $offset
      actorId: $actorId
      entityType: $entityType
      entityId: $entityId
      actionKey: $actionKey
      createdAfter: $createdAfter
      createdBefore: $createdBefore
    ) {
      totalCount
      items {
        id
        action
        actionKey
        summary
        entityType
        entityId
        entityLabel
        actorId
        actor {
          id
          displayName
        }
        changes
        metadata
        createdAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AuditListQuery, AuditListQueryVariables>;
export const AutomationWorkflowsDocument = new TypedDocumentString(`
    query AutomationWorkflows($limit: Int, $offset: Int, $filters: WorkflowFilter) {
  automation {
    workflows(limit: $limit, offset: $offset, filters: $filters) {
      items {
        id
        name
        isActive
        description
        status
        version
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationWorkflowsQuery, AutomationWorkflowsQueryVariables>;
export const AutomationWorkflowDocument = new TypedDocumentString(`
    query AutomationWorkflow($id: ID!) {
  automation {
    workflow(id: $id) {
      id
      name
      isActive
      description
      status
      version
      latestRevisionId
      lockedBy
      lockedAt
      webhookToken
      createdById
      updatedById
      nodes {
        id
        nodeType
        position
        config
        label
        actionType
        continueOnError
        isActive
      }
      edges {
        id
        sourceNodeId
        targetNodeId
        label
        config
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationWorkflowQuery, AutomationWorkflowQueryVariables>;
export const AutomationRunsDocument = new TypedDocumentString(`
    query AutomationRuns($limit: Int, $offset: Int, $filters: WorkflowRunFilter) {
  automation {
    runs(limit: $limit, offset: $offset, filters: $filters) {
      items {
        id
        workflowId
        status
        triggerType
        triggerKey
        startedAt
        finishedAt
        summary
        errorMessage
        actionRuns {
          id
          position
          actionType
          status
          startedAt
          finishedAt
          errorMessage
          output
          configSnapshot
          resultEntityType
          resultEntityId
        }
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationRunsQuery, AutomationRunsQueryVariables>;
export const AutomationRunDocument = new TypedDocumentString(`
    query AutomationRun($id: ID!) {
  automation {
    run(id: $id) {
      id
      workflowId
      revisionId
      status
      triggerType
      triggerKey
      startedAt
      finishedAt
      summary
      errorMessage
      context
      planSnapshot
      actionRuns {
        id
        position
        actionType
        status
        startedAt
        finishedAt
        errorMessage
        output
        configSnapshot
        resultEntityType
        resultEntityId
        nodeId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationRunQuery, AutomationRunQueryVariables>;
export const AutomationWorkflowTemplatesDocument = new TypedDocumentString(`
    query AutomationWorkflowTemplates {
  automation {
    workflowTemplates {
      slug
      name
      description
      category
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationWorkflowTemplatesQuery, AutomationWorkflowTemplatesQueryVariables>;
export const AutomationCreateWorkflowDocument = new TypedDocumentString(`
    mutation AutomationCreateWorkflow($input: CreateWorkflowInput!) {
  automation {
    createWorkflow(input: $input) {
      __typename
      ... on CreateWorkflowSuccess {
        message
        workflow {
          id
          name
          isActive
          description
          status
          version
        }
      }
      ... on CreateWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationCreateWorkflowMutation, AutomationCreateWorkflowMutationVariables>;
export const AutomationCreateWorkflowFromTemplateDocument = new TypedDocumentString(`
    mutation AutomationCreateWorkflowFromTemplate($input: CreateWorkflowFromTemplateInput!) {
  automation {
    createWorkflowFromTemplate(input: $input) {
      __typename
      ... on CreateWorkflowFromTemplateSuccess {
        message
        workflow {
          id
          name
          isActive
          description
          status
          version
        }
      }
      ... on CreateWorkflowFromTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationCreateWorkflowFromTemplateMutation, AutomationCreateWorkflowFromTemplateMutationVariables>;
export const AutomationUpdateWorkflowDocument = new TypedDocumentString(`
    mutation AutomationUpdateWorkflow($input: UpdateWorkflowInput!) {
  automation {
    updateWorkflow(input: $input) {
      __typename
      ... on UpdateWorkflowSuccess {
        message
        workflow {
          id
          name
          isActive
          description
          status
          version
        }
      }
      ... on UpdateWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationUpdateWorkflowMutation, AutomationUpdateWorkflowMutationVariables>;
export const AutomationUpdateWorkflowConnectionsDocument = new TypedDocumentString(`
    mutation AutomationUpdateWorkflowConnections($input: UpdateWorkflowConnectionsInput!) {
  automation {
    updateWorkflowConnections(input: $input) {
      __typename
      ... on UpdateWorkflowConnectionsSuccess {
        message
        workflow {
          id
          name
          isActive
          description
          status
          version
          webhookToken
          nodes {
            id
            nodeType
            position
            config
            label
            actionType
            continueOnError
            isActive
          }
          edges {
            id
            sourceNodeId
            targetNodeId
            label
            config
          }
        }
      }
      ... on UpdateWorkflowConnectionsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationUpdateWorkflowConnectionsMutation, AutomationUpdateWorkflowConnectionsMutationVariables>;
export const AutomationLockWorkflowDocument = new TypedDocumentString(`
    mutation AutomationLockWorkflow($input: LockWorkflowInput!) {
  automation {
    lockWorkflow(input: $input) {
      __typename
      ... on LockWorkflowSuccess {
        message
        workflow {
          id
          status
          version
          lockedBy
          lockedAt
        }
      }
      ... on LockWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationLockWorkflowMutation, AutomationLockWorkflowMutationVariables>;
export const AutomationUnlockWorkflowDocument = new TypedDocumentString(`
    mutation AutomationUnlockWorkflow($input: UnlockWorkflowInput!) {
  automation {
    unlockWorkflow(input: $input) {
      __typename
      ... on UnlockWorkflowSuccess {
        message
        workflow {
          id
          status
          version
          lockedBy
          lockedAt
        }
      }
      ... on UnlockWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationUnlockWorkflowMutation, AutomationUnlockWorkflowMutationVariables>;
export const AutomationForceUnlockWorkflowDocument = new TypedDocumentString(`
    mutation AutomationForceUnlockWorkflow($input: ForceUnlockWorkflowInput!) {
  automation {
    forceUnlockWorkflow(input: $input) {
      __typename
      ... on ForceUnlockWorkflowSuccess {
        message
        workflow {
          id
          status
          version
          lockedBy
          lockedAt
        }
      }
      ... on ForceUnlockWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationForceUnlockWorkflowMutation, AutomationForceUnlockWorkflowMutationVariables>;
export const AutomationPublishWorkflowDocument = new TypedDocumentString(`
    mutation AutomationPublishWorkflow($input: PublishWorkflowInput!) {
  automation {
    publishWorkflow(input: $input) {
      __typename
      ... on PublishWorkflowSuccess {
        message
        workflow {
          id
          status
          version
          latestRevisionId
          webhookToken
        }
      }
      ... on PublishWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationPublishWorkflowMutation, AutomationPublishWorkflowMutationVariables>;
export const AutomationArchiveWorkflowDocument = new TypedDocumentString(`
    mutation AutomationArchiveWorkflow($input: ArchiveWorkflowInput!) {
  automation {
    archiveWorkflow(input: $input) {
      __typename
      ... on ArchiveWorkflowSuccess {
        message
        workflow {
          id
          status
          version
        }
      }
      ... on ArchiveWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationArchiveWorkflowMutation, AutomationArchiveWorkflowMutationVariables>;
export const AutomationDeleteWorkflowDocument = new TypedDocumentString(`
    mutation AutomationDeleteWorkflow($input: DeleteWorkflowInput!) {
  automation {
    deleteWorkflow(input: $input) {
      __typename
      ... on DeleteWorkflowSuccess {
        message
        success
      }
      ... on DeleteWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationDeleteWorkflowMutation, AutomationDeleteWorkflowMutationVariables>;
export const AutomationRunWorkflowDocument = new TypedDocumentString(`
    mutation AutomationRunWorkflow($input: RunWorkflowInput!) {
  automation {
    runWorkflow(input: $input) {
      __typename
      ... on RunWorkflowSuccess {
        message
        workflowRun {
          id
          workflowId
          status
          startedAt
          actionRuns {
            id
            position
            actionType
            status
            startedAt
            finishedAt
            errorMessage
          }
        }
      }
      ... on RunWorkflowError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationRunWorkflowMutation, AutomationRunWorkflowMutationVariables>;
export const AutomationRegenerateWorkflowWebhookTokenDocument = new TypedDocumentString(`
    mutation AutomationRegenerateWorkflowWebhookToken($input: RegenerateWorkflowWebhookTokenInput!) {
  automation {
    regenerateWorkflowWebhookToken(input: $input) {
      __typename
      ... on RegenerateWorkflowWebhookTokenSuccess {
        message
        workflow {
          id
          webhookToken
          version
        }
      }
      ... on RegenerateWorkflowWebhookTokenError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<AutomationRegenerateWorkflowWebhookTokenMutation, AutomationRegenerateWorkflowWebhookTokenMutationVariables>;
export const BillingMeDocument = new TypedDocumentString(`
    query BillingMe {
  billing {
    me {
      personalAvailable
      orgAllocationLimit
      orgAllocationUsed
      orgAllocationRemaining
      availableTotal
      billingMode
    }
  }
}
    `) as unknown as TypedDocumentString<BillingMeQuery, BillingMeQueryVariables>;
export const BillingOrgDocument = new TypedDocumentString(`
    query BillingOrg {
  billing {
    org {
      orgPoolBalance
      invoiceAccrued
      invoiceCreditCap
      billingMode
    }
  }
}
    `) as unknown as TypedDocumentString<BillingOrgQuery, BillingOrgQueryVariables>;
export const BillingFeatureCostsDocument = new TypedDocumentString(`
    query BillingFeatureCosts {
  billing {
    featureCosts {
      feature
      creditsPerUnit
      label
    }
  }
}
    `) as unknown as TypedDocumentString<BillingFeatureCostsQuery, BillingFeatureCostsQueryVariables>;
export const BillingLedgerDocument = new TypedDocumentString(`
    query BillingLedger($limit: Int! = 50, $offset: Int! = 0, $userId: ID) {
  billing {
    ledger(limit: $limit, offset: $offset, userId: $userId) {
      totalCount
      items {
        id
        entryType
        status
        amount
        feature
        note
        createdAt
        userId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingLedgerQuery, BillingLedgerQueryVariables>;
export const BillingGrantOrgCreditsDocument = new TypedDocumentString(`
    mutation BillingGrantOrgCredits($amount: Int!, $note: String) {
  billing {
    grantOrgCredits(amount: $amount, note: $note) {
      __typename
      ... on GrantOrgCreditsSuccess {
        message
        wallet {
          id
          kind
          ownerId
        }
      }
      ... on GrantOrgCreditsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingGrantOrgCreditsMutation, BillingGrantOrgCreditsMutationVariables>;
export const BillingSetUserAllocationDocument = new TypedDocumentString(`
    mutation BillingSetUserAllocation($userId: ID!, $limitCredits: Int!, $period: CreditAllocationPeriodEnum! = FOREVER) {
  billing {
    setUserAllocation(userId: $userId, limitCredits: $limitCredits, period: $period) {
      __typename
      ... on SetUserAllocationSuccess {
        message
        allocation {
          id
          userId
          period
          limitCredits
          resetAt
        }
      }
      ... on SetUserAllocationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingSetUserAllocationMutation, BillingSetUserAllocationMutationVariables>;
export const BillingSetBillingModeDocument = new TypedDocumentString(`
    mutation BillingSetBillingMode($mode: BillingModeEnum!, $invoiceCreditCap: Int) {
  billing {
    setBillingMode(mode: $mode, invoiceCreditCap: $invoiceCreditCap) {
      __typename
      ... on SetBillingModeSuccess {
        message
        organization {
          billingMode
          invoiceCreditCap
          aiFeaturesEnabled
        }
      }
      ... on SetBillingModeError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingSetBillingModeMutation, BillingSetBillingModeMutationVariables>;
export const BillingTopUpPersonalDocument = new TypedDocumentString(`
    mutation BillingTopUpPersonal($amount: Int!, $note: String, $postImmediately: Boolean! = false) {
  billing {
    topUpPersonal(amount: $amount, note: $note, postImmediately: $postImmediately) {
      __typename
      ... on TopUpPersonalSuccess {
        message
        stub
        paymentUrl
        ledgerEntry {
          id
          entryType
          status
          amount
          note
          createdAt
        }
      }
      ... on TopUpPersonalError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingTopUpPersonalMutation, BillingTopUpPersonalMutationVariables>;
export const BillingSyncGopayPaymentDocument = new TypedDocumentString(`
    mutation BillingSyncGopayPayment($paymentId: String!) {
  billing {
    syncGopayPayment(paymentId: $paymentId) {
      __typename
      ... on SyncGopayPaymentSuccess {
        message
        ledgerEntry {
          id
          status
          amount
        }
      }
      ... on SyncGopayPaymentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingSyncGopayPaymentMutation, BillingSyncGopayPaymentMutationVariables>;
export const BillingPostTopUpDocument = new TypedDocumentString(`
    mutation BillingPostTopUp($id: ID!) {
  billing {
    postTopUp(id: $id) {
      __typename
      ... on PostTopUpSuccess {
        message
        ledgerEntry {
          id
          status
          amount
        }
      }
      ... on PostTopUpError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingPostTopUpMutation, BillingPostTopUpMutationVariables>;
export const BillingPlansDocument = new TypedDocumentString(`
    query BillingPlans {
  billing {
    plans {
      id
      code
      name
      description
      priceAmount
      currency
      billingPeriod
      includedCredits
      seatLimit
      isActive
      isPublic
    }
  }
}
    `) as unknown as TypedDocumentString<BillingPlansQuery, BillingPlansQueryVariables>;
export const BillingSubscriptionDocument = new TypedDocumentString(`
    query BillingSubscription {
  billing {
    subscription {
      subscription {
        id
        status
        currentPeriodStart
        currentPeriodEnd
        cancelAtPeriodEnd
        plan {
          id
          code
          name
          priceAmount
          currency
          includedCredits
          seatLimit
        }
      }
      plan {
        id
        code
        name
        priceAmount
        currency
        includedCredits
        seatLimit
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingSubscriptionQuery, BillingSubscriptionQueryVariables>;
export const BillingInvoicesDocument = new TypedDocumentString(`
    query BillingInvoices($limit: Int! = 50, $offset: Int! = 0) {
  billing {
    invoices(limit: $limit, offset: $offset) {
      totalCount
      items {
        id
        number
        status
        issueDate
        dueDate
        currency
        subtotalAmount
        vatRate
        vatAmount
        totalAmount
        paidAt
        pdfDocumentId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingInvoicesQuery, BillingInvoicesQueryVariables>;
export const BillingSetPlanDocument = new TypedDocumentString(`
    mutation BillingSetPlan($planCode: String!, $issueInvoice: Boolean! = true) {
  billing {
    setPlan(planCode: $planCode, issueInvoice: $issueInvoice) {
      __typename
      ... on SetPlanSuccess {
        message
        subscription {
          subscription {
            id
            status
            currentPeriodStart
            currentPeriodEnd
            plan {
              id
              code
              name
              priceAmount
              currency
              includedCredits
            }
          }
          plan {
            id
            code
            name
            priceAmount
            currency
            includedCredits
          }
        }
      }
      ... on SetPlanError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BillingSetPlanMutation, BillingSetPlanMutationVariables>;
export const BlogListDocument = new TypedDocumentString(`
    query BlogList($limit: Int, $offset: Int, $filters: BlogPostFilter, $order: BlogPostOrder) {
  blog {
    list(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        status
        title
        excerpt
        coverUrl
        tags
        publishedAt
        createdAt
        updatedAt
        authorId
        slugs {
          locale
          slug
        }
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<BlogListQuery, BlogListQueryVariables>;
export const BlogConnectionDocument = new TypedDocumentString(`
    query BlogConnection($first: Int!, $after: String, $filters: BlogPostFilter, $order: BlogPostOrder) {
  blog {
    connection(first: $first, after: $after, filters: $filters, order: $order) {
      edges {
        cursor
        node {
          id
          status
          title
          excerpt
          coverUrl
          tags
          publishedAt
          createdAt
          updatedAt
          authorId
          slugs {
            locale
            slug
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<BlogConnectionQuery, BlogConnectionQueryVariables>;
export const BlogNodeDocument = new TypedDocumentString(`
    query BlogNode($id: ID!) {
  blog {
    node(id: $id) {
      id
      status
      title
      excerpt
      content
      bodyMd
      localeMeta
      resolvedContent
      resolvedMarkdown
      coverUrl
      tags
      seoTitle
      seoDescription
      publishedAt
      createdAt
      updatedAt
      authorId
      slugs {
        locale
        slug
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogNodeQuery, BlogNodeQueryVariables>;
export const BlogCreateDocument = new TypedDocumentString(`
    mutation BlogCreate($input: CreateBlogPostInput!) {
  blog {
    create(input: $input) {
      __typename
      ... on CreateBlogPostSuccess {
        message
        blogPost {
          id
        }
      }
      ... on CreateBlogPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogCreateMutation, BlogCreateMutationVariables>;
export const BlogUpdateDocument = new TypedDocumentString(`
    mutation BlogUpdate($input: UpdateBlogPostInput!) {
  blog {
    update(input: $input) {
      __typename
      ... on UpdateBlogPostSuccess {
        message
        blogPost {
          id
        }
      }
      ... on UpdateBlogPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogUpdateMutation, BlogUpdateMutationVariables>;
export const BlogPublishDocument = new TypedDocumentString(`
    mutation BlogPublish($id: ID!) {
  blog {
    publish(id: $id) {
      __typename
      ... on PublishBlogPostSuccess {
        message
        blogPost {
          id
          status
          publishedAt
        }
      }
      ... on PublishBlogPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogPublishMutation, BlogPublishMutationVariables>;
export const BlogUnpublishDocument = new TypedDocumentString(`
    mutation BlogUnpublish($id: ID!) {
  blog {
    unpublish(id: $id) {
      __typename
      ... on UnpublishBlogPostSuccess {
        message
        blogPost {
          id
          status
        }
      }
      ... on UnpublishBlogPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogUnpublishMutation, BlogUnpublishMutationVariables>;
export const BlogDeleteDocument = new TypedDocumentString(`
    mutation BlogDelete($id: ID!) {
  blog {
    delete(id: $id) {
      __typename
      ... on DeleteBlogPostSuccess {
        message
        success
      }
      ... on DeleteBlogPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogDeleteMutation, BlogDeleteMutationVariables>;
export const BlogCreateAssetUploadIntentDocument = new TypedDocumentString(`
    mutation BlogCreateAssetUploadIntent($postId: ID!, $kind: BlogPostAssetKindEnum!, $contentType: String!, $sizeBytes: Int) {
  blog {
    createAssetUploadIntent(
      postId: $postId
      kind: $kind
      contentType: $contentType
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateBlogPostAssetUploadIntentSuccess {
        message
        uploadIntent {
          asset {
            id
          }
          displayUrl
          upload {
            url
            method
            headers
            storageKey
            expiresAt
            maxBytes
          }
        }
      }
      ... on CreateBlogPostAssetUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogCreateAssetUploadIntentMutation, BlogCreateAssetUploadIntentMutationVariables>;
export const BlogFinalizeAssetUploadDocument = new TypedDocumentString(`
    mutation BlogFinalizeAssetUpload($assetId: ID!) {
  blog {
    finalizeAssetUpload(assetId: $assetId) {
      __typename
      ... on FinalizeBlogPostAssetUploadSuccess {
        message
        asset {
          id
          displayUrl
        }
      }
      ... on FinalizeBlogPostAssetUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogFinalizeAssetUploadMutation, BlogFinalizeAssetUploadMutationVariables>;
export const BlogCreateCoverUploadIntentDocument = new TypedDocumentString(`
    mutation BlogCreateCoverUploadIntent($postId: ID!, $contentType: String!, $sizeBytes: Int) {
  blog {
    createCoverUploadIntent(
      postId: $postId
      contentType: $contentType
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateBlogPostAssetUploadIntentSuccess {
        message
        uploadIntent {
          asset {
            id
          }
          displayUrl
          upload {
            url
            method
            headers
            storageKey
            expiresAt
            maxBytes
          }
        }
      }
      ... on CreateBlogPostAssetUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogCreateCoverUploadIntentMutation, BlogCreateCoverUploadIntentMutationVariables>;
export const BlogFinalizeCoverUploadDocument = new TypedDocumentString(`
    mutation BlogFinalizeCoverUpload($postId: ID!) {
  blog {
    finalizeCoverUpload(postId: $postId) {
      __typename
      ... on FinalizeBlogPostCoverUploadSuccess {
        message
        blogPost {
          id
          coverUrl
        }
      }
      ... on FinalizeBlogPostCoverUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogFinalizeCoverUploadMutation, BlogFinalizeCoverUploadMutationVariables>;
export const BlogMarkdownToHtmlDocument = new TypedDocumentString(`
    query BlogMarkdownToHtml($markdown: String!) {
  blog {
    markdownToHtml(markdown: $markdown)
  }
}
    `) as unknown as TypedDocumentString<BlogMarkdownToHtmlQuery, BlogMarkdownToHtmlQueryVariables>;
export const BlogHtmlToMarkdownDocument = new TypedDocumentString(`
    query BlogHtmlToMarkdown($html: String!) {
  blog {
    htmlToMarkdown(html: $html)
  }
}
    `) as unknown as TypedDocumentString<BlogHtmlToMarkdownQuery, BlogHtmlToMarkdownQueryVariables>;
export const BlogTranslateWithAiDocument = new TypedDocumentString(`
    mutation BlogTranslateWithAi($id: ID!, $sourceLocale: String! = "cs", $targetLocales: [String!], $fields: [String!], $overwrite: Boolean! = false, $idempotencyKey: String) {
  blog {
    translateWithAi(
      id: $id
      sourceLocale: $sourceLocale
      targetLocales: $targetLocales
      fields: $fields
      overwrite: $overwrite
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on TranslateBlogPostWithAiSuccess {
        message
        job {
          postId
          queued
          locale
        }
      }
      ... on TranslateBlogPostWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogTranslateWithAiMutation, BlogTranslateWithAiMutationVariables>;
export const BlogPolishWithAiDocument = new TypedDocumentString(`
    mutation BlogPolishWithAi($id: ID!, $locale: String! = "cs", $fields: [String!], $idempotencyKey: String) {
  blog {
    polishWithAi(
      id: $id
      locale: $locale
      fields: $fields
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on PolishBlogPostWithAiSuccess {
        message
        job {
          postId
          queued
          locale
        }
      }
      ... on PolishBlogPostWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogPolishWithAiMutation, BlogPolishWithAiMutationVariables>;
export const BlogGenerateWithAiDocument = new TypedDocumentString(`
    mutation BlogGenerateWithAi($id: ID!, $locale: String! = "cs", $brief: String, $overwrite: Boolean! = false, $idempotencyKey: String) {
  blog {
    generateWithAi(
      id: $id
      locale: $locale
      brief: $brief
      overwrite: $overwrite
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on GenerateBlogPostWithAiSuccess {
        message
        job {
          postId
          queued
          locale
        }
      }
      ... on GenerateBlogPostWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogGenerateWithAiMutation, BlogGenerateWithAiMutationVariables>;
export const BlogConfirmAiTranslationDocument = new TypedDocumentString(`
    mutation BlogConfirmAiTranslation($id: ID!, $locale: String!) {
  blog {
    confirmAiTranslation(id: $id, locale: $locale) {
      __typename
      ... on ConfirmBlogPostAiTranslationSuccess {
        message
        result {
          postId
          locale
          confirmed
        }
      }
      ... on ConfirmBlogPostAiTranslationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<BlogConfirmAiTranslationMutation, BlogConfirmAiTranslationMutationVariables>;
export const ChatDirectoryDocument = new TypedDocumentString(`
    query ChatDirectory($limit: Int = 100, $offset: Int = 0) {
  chat {
    directory(limit: $limit, offset: $offset) {
      id
      firstName
      lastName
      loginEmail
      venueId
    }
  }
}
    `) as unknown as TypedDocumentString<ChatDirectoryQuery, ChatDirectoryQueryVariables>;
export const ChatConversationsDocument = new TypedDocumentString(`
    query ChatConversations($limit: Int = 50, $offset: Int = 0) {
  chat {
    conversations(limit: $limit, offset: $offset) {
      id
      kind
      title
      lastMessageAt
      createdAt
      createdById
      peerDeliveredAt
      peerReadAt
      participants {
        id
        userId
        portalAccountId
        lastReadAt
        lastDeliveredAt
        joinedAt
        isPinned
        displayName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatConversationsQuery, ChatConversationsQueryVariables>;
export const ChatConversationDocument = new TypedDocumentString(`
    query ChatConversation($id: ID!) {
  chat {
    conversation(id: $id) {
      id
      kind
      title
      lastMessageAt
      createdAt
      createdById
      peerDeliveredAt
      peerReadAt
      participants {
        id
        userId
        portalAccountId
        lastReadAt
        lastDeliveredAt
        joinedAt
        isPinned
        displayName
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatConversationQuery, ChatConversationQueryVariables>;
export const ChatMessagesDocument = new TypedDocumentString(`
    query ChatMessages($conversationId: ID!, $limit: Int = 50, $offset: Int = 0, $before: DateTime) {
  chat {
    messages(
      conversationId: $conversationId
      limit: $limit
      offset: $offset
      before: $before
    ) {
      id
      conversationId
      senderId
      senderPortalAccountId
      clientMessageId
      body
      isSystem
      createdAt
      attachments {
        id
        entityType
        entityId
        snapshot
      }
      files {
        id
        originalName
        mimeType
        sizeBytes
        uploadStatus
        isImage
        downloadUrl
        previewUrl
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatMessagesQuery, ChatMessagesQueryVariables>;
export const ChatMessagesConnectionDocument = new TypedDocumentString(`
    query ChatMessagesConnection($conversationId: ID!, $first: Int = 30, $before: DateTime, $after: DateTime) {
  chat {
    messagesConnection(
      conversationId: $conversationId
      first: $first
      before: $before
      after: $after
    ) {
      hasOlder
      oldestCreatedAt
      newestCreatedAt
      items {
        id
        conversationId
        senderId
        senderPortalAccountId
        clientMessageId
        body
        isSystem
        createdAt
        attachments {
          id
          entityType
          entityId
          snapshot
        }
        files {
          id
          originalName
          mimeType
          sizeBytes
          uploadStatus
          isImage
          downloadUrl
          previewUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatMessagesConnectionQuery, ChatMessagesConnectionQueryVariables>;
export const ChatUnreadCountsDocument = new TypedDocumentString(`
    query ChatUnreadCounts {
  chat {
    unreadCounts {
      conversationId
      unreadCount
    }
  }
}
    `) as unknown as TypedDocumentString<ChatUnreadCountsQuery, ChatUnreadCountsQueryVariables>;
export const ChatStartDirectDocument = new TypedDocumentString(`
    mutation ChatStartDirect($peerUserId: ID!) {
  chat {
    startDirect(peerUserId: $peerUserId) {
      __typename
      ... on StartDirectChatSuccess {
        message
        conversation {
          id
          kind
          title
          lastMessageAt
          participants {
            id
            userId
            portalAccountId
            isPinned
            displayName
          }
        }
      }
      ... on StartDirectChatError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatStartDirectMutation, ChatStartDirectMutationVariables>;
export const ChatStartDirectWithClientDocument = new TypedDocumentString(`
    mutation ChatStartDirectWithClient($clientId: ID!) {
  chat {
    startDirectWithClient(clientId: $clientId) {
      __typename
      ... on StartDirectChatWithClientSuccess {
        message
        conversation {
          id
          kind
          title
          lastMessageAt
          participants {
            id
            userId
            portalAccountId
            isPinned
            displayName
          }
        }
      }
      ... on StartDirectChatWithClientError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatStartDirectWithClientMutation, ChatStartDirectWithClientMutationVariables>;
export const ChatStartGroupDocument = new TypedDocumentString(`
    mutation ChatStartGroup($participantIds: [ID!]!, $title: String) {
  chat {
    startGroup(participantIds: $participantIds, title: $title) {
      __typename
      ... on StartGroupChatSuccess {
        message
        conversation {
          id
          kind
          title
          lastMessageAt
          participants {
            id
            userId
            portalAccountId
            isPinned
            displayName
          }
        }
      }
      ... on StartGroupChatError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatStartGroupMutation, ChatStartGroupMutationVariables>;
export const ChatSetTitleDocument = new TypedDocumentString(`
    mutation ChatSetTitle($conversationId: ID!, $title: String) {
  chat {
    setTitle(conversationId: $conversationId, title: $title) {
      __typename
      ... on SetTitleChatSuccess {
        message
        conversation {
          id
          title
          kind
        }
      }
      ... on SetTitleChatError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatSetTitleMutation, ChatSetTitleMutationVariables>;
export const ChatSetPinnedDocument = new TypedDocumentString(`
    mutation ChatSetPinned($conversationId: ID!, $pinned: Boolean!) {
  chat {
    setPinned(conversationId: $conversationId, pinned: $pinned) {
      __typename
      ... on SetPinnedChatSuccess {
        message
        conversation {
          id
          kind
          title
          lastMessageAt
          participants {
            id
            userId
            portalAccountId
            isPinned
            displayName
          }
        }
      }
      ... on SetPinnedChatError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatSetPinnedMutation, ChatSetPinnedMutationVariables>;
export const ChatAddParticipantsDocument = new TypedDocumentString(`
    mutation ChatAddParticipants($conversationId: ID!, $userIds: [ID!]!) {
  chat {
    addParticipants(conversationId: $conversationId, userIds: $userIds) {
      __typename
      ... on AddChatParticipantsSuccess {
        message
        conversation {
          id
          kind
          title
          participants {
            id
            userId
            portalAccountId
            isPinned
            displayName
          }
        }
      }
      ... on AddChatParticipantsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatAddParticipantsMutation, ChatAddParticipantsMutationVariables>;
export const ChatCreateFileUploadIntentDocument = new TypedDocumentString(`
    mutation ChatCreateFileUploadIntent($conversationId: ID!, $mimeType: String!, $originalName: String!, $sizeBytes: Int) {
  chat {
    createFileUploadIntent(
      conversationId: $conversationId
      mimeType: $mimeType
      originalName: $originalName
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateChatFileUploadIntentSuccess {
        message
        uploadIntent {
          file {
            id
            originalName
            mimeType
            sizeBytes
            uploadStatus
            isImage
          }
          upload {
            url
            method
            headers
            storageKey
            expiresAt
            maxBytes
          }
        }
      }
      ... on CreateChatFileUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatCreateFileUploadIntentMutation, ChatCreateFileUploadIntentMutationVariables>;
export const ChatFinalizeFileUploadDocument = new TypedDocumentString(`
    mutation ChatFinalizeFileUpload($fileId: ID!) {
  chat {
    finalizeFileUpload(fileId: $fileId) {
      __typename
      ... on FinalizeChatFileUploadSuccess {
        message
        file {
          id
          originalName
          mimeType
          sizeBytes
          uploadStatus
          isImage
        }
      }
      ... on FinalizeChatFileUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatFinalizeFileUploadMutation, ChatFinalizeFileUploadMutationVariables>;
export const ChatSendMessageDocument = new TypedDocumentString(`
    mutation ChatSendMessage($conversationId: ID!, $body: String, $attachments: [ChatAttachmentInput!], $fileIds: [ID!], $clientMessageId: String) {
  chat {
    sendMessage(
      conversationId: $conversationId
      body: $body
      attachments: $attachments
      fileIds: $fileIds
      clientMessageId: $clientMessageId
    ) {
      __typename
      ... on SendChatMessageSuccess {
        message
        chatMessage {
          id
          conversationId
          senderId
          senderPortalAccountId
          clientMessageId
          body
          isSystem
          createdAt
          attachments {
            id
            entityType
            entityId
            snapshot
          }
          files {
            id
            originalName
            mimeType
            sizeBytes
            uploadStatus
            isImage
            downloadUrl
            previewUrl
          }
        }
      }
      ... on SendChatMessageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatSendMessageMutation, ChatSendMessageMutationVariables>;
export const ChatMarkReadDocument = new TypedDocumentString(`
    mutation ChatMarkRead($conversationId: ID!) {
  chat {
    markRead(conversationId: $conversationId) {
      __typename
      ... on MarkChatReadSuccess {
        message
        conversation {
          id
          peerDeliveredAt
          peerReadAt
          participants {
            id
            userId
            lastReadAt
            lastDeliveredAt
          }
        }
      }
      ... on MarkChatReadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatMarkReadMutation, ChatMarkReadMutationVariables>;
export const ChatAckDeliveredDocument = new TypedDocumentString(`
    mutation ChatAckDelivered($conversationId: ID!, $upToCreatedAt: DateTime!) {
  chat {
    ackDelivered(conversationId: $conversationId, upToCreatedAt: $upToCreatedAt) {
      __typename
      ... on AckChatDeliveredSuccess {
        message
        conversation {
          id
          peerDeliveredAt
          peerReadAt
          participants {
            id
            userId
            lastReadAt
            lastDeliveredAt
          }
        }
      }
      ... on AckChatDeliveredError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatAckDeliveredMutation, ChatAckDeliveredMutationVariables>;
export const ChatTransferClientDocument = new TypedDocumentString(`
    mutation ChatTransferClient($conversationId: ID!, $clientId: ID!, $toUserId: ID!) {
  chat {
    transferClient(
      conversationId: $conversationId
      clientId: $clientId
      toUserId: $toUserId
    ) {
      __typename
      ... on TransferChatClientSuccess {
        message
        chatMessage {
          id
          body
          isSystem
          createdAt
        }
      }
      ... on TransferChatClientError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatTransferClientMutation, ChatTransferClientMutationVariables>;
export const ChatTransferTaskDocument = new TypedDocumentString(`
    mutation ChatTransferTask($conversationId: ID!, $taskId: ID!, $toUserId: ID!) {
  chat {
    transferTask(
      conversationId: $conversationId
      taskId: $taskId
      toUserId: $toUserId
    ) {
      __typename
      ... on TransferChatTaskSuccess {
        message
        chatMessage {
          id
          body
          isSystem
          createdAt
        }
      }
      ... on TransferChatTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatTransferTaskMutation, ChatTransferTaskMutationVariables>;
export const ChatTransferPropertyDocument = new TypedDocumentString(`
    mutation ChatTransferProperty($conversationId: ID!, $propertyId: ID!, $toUserId: ID!) {
  chat {
    transferProperty(
      conversationId: $conversationId
      propertyId: $propertyId
      toUserId: $toUserId
    ) {
      __typename
      ... on TransferChatPropertySuccess {
        message
        chatMessage {
          id
          body
          isSystem
          createdAt
        }
      }
      ... on TransferChatPropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ChatTransferPropertyMutation, ChatTransferPropertyMutationVariables>;
export const ClientListDocument = new TypedDocumentString(`
    query ClientList($limit: Int, $offset: Int, $filters: ClientFilter, $order: ClientOrder) {
  client {
    list(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        firstName
        lastName
        type
        status
        priority
        source
        assignedAgentId
        createdAt
        updatedAt
        roles {
          id
          role
        }
        tags {
          id
          tag
          tagId
          catalogTag {
            id
            name
          }
        }
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<ClientListQuery, ClientListQueryVariables>;
export const ClientNodeDocument = new TypedDocumentString(`
    query ClientNode($id: ID!) {
  client {
    node(id: $id) {
      id
      firstName
      lastName
      notes
      type
      status
      priority
      source
      preferredCommunicationMethod
      preferredLanguage
      leadScore
      intentScore
      propertyMatchScore
      recencyScore
      assignedAgentId
      portalAccountId
      createdAt
      updatedAt
      roles {
        id
        role
      }
      tags {
        id
        tag
        tagId
        catalogTag {
          id
          name
        }
      }
      contacts {
        id
        type
        value
        label
        isPrimary
      }
      consents {
        id
        channel
        consentType
        grantedAt
        source
        wording
        withdrawnAt
      }
      communicationProfile {
        id
        preferredMethod
        preferredLanguage
        timezone
      }
      notificationPreferences {
        id
        channel
        category
        enabled
      }
      suppressions {
        id
        channel
        address
        reason
        source
        note
        expiresAt
      }
      investorProfile {
        id
        strategy
        purpose
        expectedReturn
        riskLevel
        assetType
        financingMethod
        horizon
        appreciationPotential
        occupancy
      }
      requirements {
        id
        name
        transactionType
        isPrimary
        priority
        localityId
        locationAddress
        latitude
        longitude
        radiusKm
        budgetMin
        budgetMax
        currency
        propertyType
        propertyCategory
        preferredLayouts
        usableAreaMin
        usableAreaMax
        financingStatus
        notes
        isActive
        matchingProperties(limit: 20) {
          id
          propertyId
          score
          reasons
          reasonLabels
          taskId
          createdAt
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientNodeQuery, ClientNodeQueryVariables>;
export const ClientDemandListDocument = new TypedDocumentString(`
    query ClientDemandList($limit: Int, $offset: Int, $filters: ClientFilter) {
  client {
    list(
      limit: $limit
      offset: $offset
      filters: $filters
      order: { updatedAt: DESC }
    ) {
      items {
        id
        firstName
        lastName
        type
        status
        requirements {
          id
          name
          transactionType
          isPrimary
          isActive
          priority
          localityId
          locationAddress
          latitude
          longitude
          radiusKm
          budgetMin
          budgetMax
          currency
          propertyType
          propertyCategory
          preferredLayouts
          usableAreaMin
          usableAreaMax
          financingStatus
          notes
          matchingPropertiesCount
          matchingProperties(limit: 5) {
            id
            propertyId
            score
            reasons
            reasonLabels
            taskId
            createdAt
          }
        }
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<ClientDemandListQuery, ClientDemandListQueryVariables>;
export const ClientRequirementDocument = new TypedDocumentString(`
    query ClientRequirement($id: ID!) {
  client {
    requirement(id: $id) {
      id
      clientId
      name
      transactionType
      isPrimary
      isActive
      priority
      localityId
      locationAddress
      latitude
      longitude
      radiusKm
      budgetMin
      budgetMax
      currency
      propertyType
      propertyCategory
      preferredLayouts
      usableAreaMin
      usableAreaMax
      financingStatus
      notes
      matchingProperties(limit: 20) {
        id
        propertyId
        score
        reasons
        reasonLabels
        taskId
        createdAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientRequirementQuery, ClientRequirementQueryVariables>;
export const ClientLocalitiesDocument = new TypedDocumentString(`
    query ClientLocalities($query: String! = "", $limit: Int! = 20) {
  client {
    localities(query: $query, limit: $limit) {
      id
      city
      district
      region
      countryCode
    }
  }
}
    `) as unknown as TypedDocumentString<ClientLocalitiesQuery, ClientLocalitiesQueryVariables>;
export const ClientCreateDocument = new TypedDocumentString(`
    mutation ClientCreate($input: CreateClientInput!) {
  client {
    create(input: $input) {
      __typename
      ... on CreateClientSuccess {
        message
        client {
          id
          type
          roles {
            id
            role
          }
          tags {
            id
            tag
            tagId
            catalogTag {
              id
              name
            }
          }
        }
      }
      ... on CreateClientError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientCreateMutation, ClientCreateMutationVariables>;
export const ClientUpdateDocument = new TypedDocumentString(`
    mutation ClientUpdate($input: UpdateClientInput!) {
  client {
    update(input: $input) {
      __typename
      ... on UpdateClientSuccess {
        message
        client {
          id
          type
          roles {
            id
            role
          }
          tags {
            id
            tag
            tagId
            catalogTag {
              id
              name
            }
          }
        }
      }
      ... on UpdateClientError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientUpdateMutation, ClientUpdateMutationVariables>;
export const ClientGrantConsentDocument = new TypedDocumentString(`
    mutation ClientGrantConsent($input: GrantClientConsentInput!) {
  client {
    grantConsent(input: $input) {
      __typename
      ... on GrantClientConsentSuccess {
        message
        consent {
          id
          channel
          consentType
          grantedAt
          source
          wording
          withdrawnAt
        }
      }
      ... on GrantClientConsentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientGrantConsentMutation, ClientGrantConsentMutationVariables>;
export const ClientWithdrawConsentDocument = new TypedDocumentString(`
    mutation ClientWithdrawConsent($input: WithdrawClientConsentInput!) {
  client {
    withdrawConsent(input: $input) {
      __typename
      ... on WithdrawClientConsentSuccess {
        message
        consent {
          id
          channel
          consentType
          grantedAt
          source
          wording
          withdrawnAt
        }
      }
      ... on WithdrawClientConsentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientWithdrawConsentMutation, ClientWithdrawConsentMutationVariables>;
export const ClientDeleteDocument = new TypedDocumentString(`
    mutation ClientDelete($id: ID!) {
  client {
    delete(id: $id) {
      __typename
      ... on DeleteClientSuccess {
        message
        success
      }
      ... on DeleteClientError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientDeleteMutation, ClientDeleteMutationVariables>;
export const ClientCreateRequirementDocument = new TypedDocumentString(`
    mutation ClientCreateRequirement($input: CreateClientRequirementInput!) {
  client {
    createRequirement(input: $input) {
      __typename
      ... on CreateClientRequirementSuccess {
        message
        requirement {
          id
          name
          isActive
        }
      }
      ... on CreateClientRequirementError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientCreateRequirementMutation, ClientCreateRequirementMutationVariables>;
export const ClientUpdateRequirementDocument = new TypedDocumentString(`
    mutation ClientUpdateRequirement($input: UpdateClientRequirementInput!) {
  client {
    updateRequirement(input: $input) {
      __typename
      ... on UpdateClientRequirementSuccess {
        message
        requirement {
          id
          name
          isActive
        }
      }
      ... on UpdateClientRequirementError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientUpdateRequirementMutation, ClientUpdateRequirementMutationVariables>;
export const ClientDeleteRequirementDocument = new TypedDocumentString(`
    mutation ClientDeleteRequirement($id: ID!) {
  client {
    deleteRequirement(id: $id) {
      __typename
      ... on DeleteClientRequirementSuccess {
        message
        success
      }
      ... on DeleteClientRequirementError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientDeleteRequirementMutation, ClientDeleteRequirementMutationVariables>;
export const ClientRunDemandMatchingDocument = new TypedDocumentString(`
    mutation ClientRunDemandMatching($requirementId: ID!) {
  client {
    runDemandMatching(requirementId: $requirementId) {
      __typename
      ... on RunClientDemandMatchingSuccess {
        message
        created
        updated
        tasksCreated
        staleRemoved
        matches {
          id
          propertyId
          requirementId
          clientId
          score
          reasons
          reasonLabels
          taskId
        }
      }
      ... on RunClientDemandMatchingError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientRunDemandMatchingMutation, ClientRunDemandMatchingMutationVariables>;
export const ClientExportCsvDocument = new TypedDocumentString(`
    query ClientExportCsv {
  client {
    exportCsv {
      filename
      content
      mimeType
    }
  }
}
    `) as unknown as TypedDocumentString<ClientExportCsvQuery, ClientExportCsvQueryVariables>;
export const ClientCreateLocalityDocument = new TypedDocumentString(`
    mutation ClientCreateLocality($city: String!, $district: String! = "", $region: String! = "", $countryCode: String! = "CZ") {
  client {
    createLocality(
      city: $city
      district: $district
      region: $region
      countryCode: $countryCode
    ) {
      __typename
      ... on CreateLocalitySuccess {
        message
        locality {
          id
          city
          district
          region
          countryCode
        }
      }
      ... on CreateLocalityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientCreateLocalityMutation, ClientCreateLocalityMutationVariables>;
export const ClientMergeDocument = new TypedDocumentString(`
    mutation ClientMerge($input: MergeClientsInput!) {
  client {
    merge(input: $input) {
      __typename
      ... on MergeClientsSuccess {
        message
        client {
          id
          firstName
          lastName
          status
        }
      }
      ... on MergeClientsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientMergeMutation, ClientMergeMutationVariables>;
export const ClientUpsertInvestorProfileDocument = new TypedDocumentString(`
    mutation ClientUpsertInvestorProfile($input: UpsertClientInvestorProfileInput!) {
  client {
    upsertInvestorProfile(input: $input) {
      __typename
      ... on UpsertClientInvestorProfileSuccess {
        message
        investorProfile {
          id
          strategy
          purpose
          expectedReturn
          riskLevel
          assetType
          financingMethod
          horizon
          appreciationPotential
          occupancy
        }
      }
      ... on UpsertClientInvestorProfileError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientUpsertInvestorProfileMutation, ClientUpsertInvestorProfileMutationVariables>;
export const ClientUpsertCommunicationProfileDocument = new TypedDocumentString(`
    mutation ClientUpsertCommunicationProfile($input: UpsertClientCommunicationProfileInput!) {
  client {
    upsertCommunicationProfile(input: $input) {
      __typename
      ... on UpsertClientCommunicationProfileSuccess {
        message
        communicationProfile {
          id
          preferredMethod
          preferredLanguage
          timezone
        }
      }
      ... on UpsertClientCommunicationProfileError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientUpsertCommunicationProfileMutation, ClientUpsertCommunicationProfileMutationVariables>;
export const ClientSetNotificationPreferenceDocument = new TypedDocumentString(`
    mutation ClientSetNotificationPreference($input: SetClientNotificationPreferenceInput!) {
  client {
    setNotificationPreference(input: $input) {
      __typename
      ... on SetClientNotificationPreferenceSuccess {
        message
        notificationPreference {
          id
          channel
          category
          enabled
        }
      }
      ... on SetClientNotificationPreferenceError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientSetNotificationPreferenceMutation, ClientSetNotificationPreferenceMutationVariables>;
export const ClientSuppressContactDocument = new TypedDocumentString(`
    mutation ClientSuppressContact($input: SuppressContactInput!) {
  client {
    suppressContact(input: $input) {
      __typename
      ... on SuppressContactSuccess {
        message
        suppression {
          id
          channel
          address
          reason
          source
          note
          expiresAt
        }
      }
      ... on SuppressContactError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientSuppressContactMutation, ClientSuppressContactMutationVariables>;
export const ClientLiftContactSuppressionDocument = new TypedDocumentString(`
    mutation ClientLiftContactSuppression($input: LiftContactSuppressionInput!) {
  client {
    liftContactSuppression(input: $input) {
      __typename
      ... on LiftContactSuppressionSuccess {
        message
        success
      }
      ... on LiftContactSuppressionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientLiftContactSuppressionMutation, ClientLiftContactSuppressionMutationVariables>;
export const EntityPickerClientsDocument = new TypedDocumentString(`
    query EntityPickerClients($query: String, $limit: Int = 20) {
  client {
    list(
      limit: $limit
      offset: 0
      filters: { nameSearch: $query }
      order: { updatedAt: DESC }
    ) {
      items {
        id
        firstName
        lastName
        type
        status
        contacts {
          type
          value
          isPrimary
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EntityPickerClientsQuery, EntityPickerClientsQueryVariables>;
export const ClientTagListDocument = new TypedDocumentString(`
    query ClientTagList($limit: Int, $offset: Int) {
  client {
    tag {
      list(limit: $limit, offset: $offset) {
        items {
          id
          name
          color
          clientCount
          createdAt
          updatedAt
        }
        totalCount
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientTagListQuery, ClientTagListQueryVariables>;
export const ClientTagCreateDocument = new TypedDocumentString(`
    mutation ClientTagCreate($input: CreateTagInput!) {
  client {
    tag {
      create(input: $input) {
        __typename
        ... on CreateTagSuccess {
          message
          tag {
            id
            name
            color
            clientCount
          }
        }
        ... on CreateTagError {
          message
          code
          details
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientTagCreateMutation, ClientTagCreateMutationVariables>;
export const ClientTagUpdateDocument = new TypedDocumentString(`
    mutation ClientTagUpdate($input: UpdateTagInput!) {
  client {
    tag {
      update(input: $input) {
        __typename
        ... on UpdateTagSuccess {
          message
          tag {
            id
            name
            color
            clientCount
          }
        }
        ... on UpdateTagError {
          message
          code
          details
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientTagUpdateMutation, ClientTagUpdateMutationVariables>;
export const ClientTagDeleteDocument = new TypedDocumentString(`
    mutation ClientTagDelete($id: ID!) {
  client {
    tag {
      delete(id: $id) {
        __typename
        ... on DeleteTagSuccess {
          message
          success
        }
        ... on DeleteTagError {
          message
          code
          details
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientTagDeleteMutation, ClientTagDeleteMutationVariables>;
export const DealPipelineDocument = new TypedDocumentString(`
    query DealPipeline($id: ID) {
  deal {
    pipeline(id: $id) {
      ...DealPipelineFields
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealPipelineQuery, DealPipelineQueryVariables>;
export const DealPipelinesDocument = new TypedDocumentString(`
    query DealPipelines($includeArchived: Boolean! = false) {
  deal {
    pipelines(includeArchived: $includeArchived) {
      ...DealPipelineFields
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealPipelinesQuery, DealPipelinesQueryVariables>;
export const DealCreatePipelineDocument = new TypedDocumentString(`
    mutation DealCreatePipeline($name: String!, $isDefault: Boolean! = false, $withDefaultStages: Boolean! = true, $cloneFromId: ID) {
  deal {
    createPipeline(
      name: $name
      isDefault: $isDefault
      withDefaultStages: $withDefaultStages
      cloneFromId: $cloneFromId
    ) {
      __typename
      ... on CreateDealPipelineSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on CreateDealPipelineError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealCreatePipelineMutation, DealCreatePipelineMutationVariables>;
export const DealUpdatePipelineDocument = new TypedDocumentString(`
    mutation DealUpdatePipeline($id: ID!, $name: String, $isDefault: Boolean, $position: Int) {
  deal {
    updatePipeline(id: $id, name: $name, isDefault: $isDefault, position: $position) {
      __typename
      ... on UpdateDealPipelineSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on UpdateDealPipelineError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealUpdatePipelineMutation, DealUpdatePipelineMutationVariables>;
export const DealArchivePipelineDocument = new TypedDocumentString(`
    mutation DealArchivePipeline($id: ID!) {
  deal {
    archivePipeline(id: $id) {
      __typename
      ... on ArchiveDealPipelineSuccess {
        message
        pipeline {
          id
          isArchived
        }
      }
      ... on ArchiveDealPipelineError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealArchivePipelineMutation, DealArchivePipelineMutationVariables>;
export const DealDeletePipelineDocument = new TypedDocumentString(`
    mutation DealDeletePipeline($id: ID!, $targetPipelineId: ID, $mappings: [StageMappingInput!]) {
  deal {
    deletePipeline(
      id: $id
      targetPipelineId: $targetPipelineId
      mappings: $mappings
    ) {
      __typename
      ... on DeleteDealPipelineSuccess {
        message
        success
      }
      ... on DeleteDealPipelineError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealDeletePipelineMutation, DealDeletePipelineMutationVariables>;
export const DealMovePipelineItemsDocument = new TypedDocumentString(`
    mutation DealMovePipelineItems($fromPipelineId: ID!, $toPipelineId: ID!, $mappings: [StageMappingInput!]!) {
  deal {
    movePipelineItems(
      fromPipelineId: $fromPipelineId
      toPipelineId: $toPipelineId
      mappings: $mappings
    ) {
      __typename
      ... on MoveDealPipelineItemsSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on MoveDealPipelineItemsError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealMovePipelineItemsMutation, DealMovePipelineItemsMutationVariables>;
export const DealAddStageDocument = new TypedDocumentString(`
    mutation DealAddStage($pipelineId: ID!, $name: String!, $color: String, $position: Int, $isWon: Boolean! = false, $isLost: Boolean! = false) {
  deal {
    addStage(
      pipelineId: $pipelineId
      name: $name
      color: $color
      position: $position
      isWon: $isWon
      isLost: $isLost
    ) {
      __typename
      ... on AddDealStageSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on AddDealStageError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealAddStageMutation, DealAddStageMutationVariables>;
export const DealUpdateStageDocument = new TypedDocumentString(`
    mutation DealUpdateStage($id: ID!, $name: String, $color: String, $isWon: Boolean, $isLost: Boolean) {
  deal {
    updateStage(id: $id, name: $name, color: $color, isWon: $isWon, isLost: $isLost) {
      __typename
      ... on UpdateDealStageSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on UpdateDealStageError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealUpdateStageMutation, DealUpdateStageMutationVariables>;
export const DealDeleteStageDocument = new TypedDocumentString(`
    mutation DealDeleteStage($id: ID!, $moveToStageId: ID) {
  deal {
    deleteStage(id: $id, moveToStageId: $moveToStageId) {
      __typename
      ... on DeleteDealStageSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on DeleteDealStageError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealDeleteStageMutation, DealDeleteStageMutationVariables>;
export const DealReorderStagesDocument = new TypedDocumentString(`
    mutation DealReorderStages($pipelineId: ID!, $stageIds: [ID!]!) {
  deal {
    reorderStages(pipelineId: $pipelineId, stageIds: $stageIds) {
      __typename
      ... on ReorderDealStagesSuccess {
        message
        pipeline {
          ...DealPipelineFields
        }
      }
      ... on ReorderDealStagesError {
        message
        code
        details
      }
    }
  }
}
    fragment DealPipelineFields on PipelineType {
  id
  name
  isDefault
  isArchived
  position
  itemCount
  stages {
    id
    name
    color
    position
    isWon
    isLost
    itemCount
  }
}`) as unknown as TypedDocumentString<DealReorderStagesMutation, DealReorderStagesMutationVariables>;
export const DealListDocument = new TypedDocumentString(`
    query DealList($limit: Int, $offset: Int, $filters: DealFilter, $order: DealOrder) {
  deal {
    list(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        title
        stageId
        pipelineId
        clientId
        propertyId
        assignedAgentId
        expectedValue
        pipelineValue
        provisionAmount
        provisionPercent
        currency
        transactionType
        nextStep
        nextStepAt
        expectedCloseDate
        lostReason
        updatedAt
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<DealListQuery, DealListQueryVariables>;
export const DealNodeDocument = new TypedDocumentString(`
    query DealNode($id: ID!) {
  deal {
    node(id: $id) {
      id
      title
      pipelineId
      stageId
      clientId
      propertyId
      leadId
      assignedAgentId
      expectedValue
      actualValue
      pipelineValue
      provisionAmount
      provisionPercent
      provisionNotes
      currency
      nextStep
      nextStepAt
      expectedCloseDate
      actualCloseDate
      lostReason
      transactionType
      description
      provisionSplits {
        id
        dealId
        userId
        percent
        amount
        notes
      }
      payments {
        id
        type
        amount
        currency
        dueAt
        paidAt
        status
        payerClientId
        payeeUserId
        dealId
        propertyId
        variableSymbol
        documentId
        createdAt
        updatedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealNodeQuery, DealNodeQueryVariables>;
export const DealCreateDocument = new TypedDocumentString(`
    mutation DealCreate($input: CreateDealInput!) {
  deal {
    create(input: $input) {
      __typename
      ... on CreateDealSuccess {
        message
        deal {
          id
        }
      }
      ... on CreateDealError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealCreateMutation, DealCreateMutationVariables>;
export const DealUpdateDocument = new TypedDocumentString(`
    mutation DealUpdate($input: UpdateDealInput!) {
  deal {
    update(input: $input) {
      __typename
      ... on UpdateDealSuccess {
        message
        deal {
          id
        }
      }
      ... on UpdateDealError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealUpdateMutation, DealUpdateMutationVariables>;
export const DealChangeStageDocument = new TypedDocumentString(`
    mutation DealChangeStage($input: ChangeDealStageInput!) {
  deal {
    changeStage(input: $input) {
      __typename
      ... on ChangeDealStageSuccess {
        message
        deal {
          id
          stageId
        }
      }
      ... on ChangeDealStageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealChangeStageMutation, DealChangeStageMutationVariables>;
export const DealSetNextStepDocument = new TypedDocumentString(`
    mutation DealSetNextStep($input: SetDealNextStepInput!) {
  deal {
    setNextStep(input: $input) {
      __typename
      ... on SetDealNextStepSuccess {
        message
        deal {
          id
          nextStep
          nextStepAt
        }
      }
      ... on SetDealNextStepError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealSetNextStepMutation, DealSetNextStepMutationVariables>;
export const DealMarkWonDocument = new TypedDocumentString(`
    mutation DealMarkWon($input: MarkDealWonInput!) {
  deal {
    markWon(input: $input) {
      __typename
      ... on MarkDealWonSuccess {
        message
        deal {
          id
        }
      }
      ... on MarkDealWonError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealMarkWonMutation, DealMarkWonMutationVariables>;
export const DealMarkLostDocument = new TypedDocumentString(`
    mutation DealMarkLost($input: MarkDealLostInput!) {
  deal {
    markLost(input: $input) {
      __typename
      ... on MarkDealLostSuccess {
        message
        deal {
          id
          lostReason
        }
      }
      ... on MarkDealLostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealMarkLostMutation, DealMarkLostMutationVariables>;
export const DealDeleteDocument = new TypedDocumentString(`
    mutation DealDelete($id: ID!) {
  deal {
    delete(id: $id) {
      __typename
      ... on DeleteDealSuccess {
        message
        success
      }
      ... on DeleteDealError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealDeleteMutation, DealDeleteMutationVariables>;
export const DealCreateProvisionSplitDocument = new TypedDocumentString(`
    mutation DealCreateProvisionSplit($input: CreateDealProvisionSplitInput!) {
  deal {
    createProvisionSplit(input: $input) {
      __typename
      ... on CreateDealProvisionSplitSuccess {
        message
        provisionSplit {
          id
          dealId
          userId
          percent
          amount
          notes
        }
      }
      ... on CreateDealProvisionSplitError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealCreateProvisionSplitMutation, DealCreateProvisionSplitMutationVariables>;
export const DealUpdateProvisionSplitDocument = new TypedDocumentString(`
    mutation DealUpdateProvisionSplit($input: UpdateDealProvisionSplitInput!) {
  deal {
    updateProvisionSplit(input: $input) {
      __typename
      ... on UpdateDealProvisionSplitSuccess {
        message
        provisionSplit {
          id
          dealId
          userId
          percent
          amount
          notes
        }
      }
      ... on UpdateDealProvisionSplitError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealUpdateProvisionSplitMutation, DealUpdateProvisionSplitMutationVariables>;
export const DealDeleteProvisionSplitDocument = new TypedDocumentString(`
    mutation DealDeleteProvisionSplit($id: ID!) {
  deal {
    deleteProvisionSplit(id: $id) {
      __typename
      ... on DeleteDealProvisionSplitSuccess {
        message
        success
      }
      ... on DeleteDealProvisionSplitError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealDeleteProvisionSplitMutation, DealDeleteProvisionSplitMutationVariables>;
export const EntityPickerDealsDocument = new TypedDocumentString(`
    query EntityPickerDeals($query: String, $limit: Int = 20) {
  deal {
    list(
      limit: $limit
      offset: 0
      filters: { title: { icontains: $query } }
      order: { updatedAt: DESC }
    ) {
      items {
        id
        title
        transactionType
        expectedCloseDate
        clientId
        propertyId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EntityPickerDealsQuery, EntityPickerDealsQueryVariables>;
export const DocumentNodeDocument = new TypedDocumentString(`
    query DocumentNode($id: ID!) {
  document {
    node(id: $id) {
      id
      kind
      name
      path
      depth
      parentId
      rootId
      documentId
      propertyId
      clientId
      dealId
      createdById
      createdAt
      updatedAt
      deletedAt
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentNodeQuery, DocumentNodeQueryVariables>;
export const DocumentChildrenDocument = new TypedDocumentString(`
    query DocumentChildren($folderId: ID!, $limit: Int! = 50, $offset: Int! = 0) {
  document {
    children(folderId: $folderId, limit: $limit, offset: $offset) {
      items {
        id
        kind
        name
        path
        depth
        parentId
        rootId
        documentId
        propertyId
        clientId
        dealId
        createdAt
        updatedAt
      }
      total
      limit
      offset
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentChildrenQuery, DocumentChildrenQueryVariables>;
export const DocumentRootsDocument = new TypedDocumentString(`
    query DocumentRoots($limit: Int! = 50, $offset: Int! = 0, $entityKind: String = null, $orderBy: String! = "name", $descending: Boolean! = false) {
  document {
    roots(
      limit: $limit
      offset: $offset
      entityKind: $entityKind
      orderBy: $orderBy
      descending: $descending
    ) {
      items {
        id
        kind
        name
        path
        depth
        parentId
        rootId
        propertyId
        clientId
        dealId
        entityLabel
        entityKind
        createdAt
        updatedAt
      }
      total
      limit
      offset
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentRootsQuery, DocumentRootsQueryVariables>;
export const DocumentRootCountsDocument = new TypedDocumentString(`
    query DocumentRootCounts {
  document {
    rootCounts {
      all
      property
      client
      deal
      other
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentRootCountsQuery, DocumentRootCountsQueryVariables>;
export const DocumentSubtreeFilesDocument = new TypedDocumentString(`
    query DocumentSubtreeFiles($folderId: ID!, $limit: Int! = 50, $offset: Int! = 0) {
  document {
    subtreeFiles(folderId: $folderId, limit: $limit, offset: $offset) {
      items {
        id
        kind
        name
        documentId
        parentId
        path
        createdAt
      }
      total
      limit
      offset
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentSubtreeFilesQuery, DocumentSubtreeFilesQueryVariables>;
export const DocumentSearchDocument = new TypedDocumentString(`
    query DocumentSearch($query: String!, $folderId: ID, $limit: Int! = 50, $offset: Int! = 0) {
  document {
    search(query: $query, folderId: $folderId, limit: $limit, offset: $offset) {
      items {
        id
        kind
        name
        path
        depth
        parentId
        rootId
        documentId
        propertyId
        clientId
        dealId
        entityLabel
        entityKind
        createdAt
      }
      total
      limit
      offset
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentSearchQuery, DocumentSearchQueryVariables>;
export const DocumentAncestorsDocument = new TypedDocumentString(`
    query DocumentAncestors($id: ID!) {
  document {
    ancestors(id: $id) {
      id
      kind
      name
      parentId
      depth
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentAncestorsQuery, DocumentAncestorsQueryVariables>;
export const DocumentSharesDocument = new TypedDocumentString(`
    query DocumentShares($nodeId: ID!) {
  document {
    shares(nodeId: $nodeId) {
      id
      dmsNodeId
      label
      scope
      allowDownload
      hasPassword
      expiresAt
      maxDownloads
      downloadCount
      revokedAt
      createdById
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentSharesQuery, DocumentSharesQueryVariables>;
export const DocumentTrashDocument = new TypedDocumentString(`
    query DocumentTrash($limit: Int! = 50, $offset: Int! = 0) {
  document {
    trash(limit: $limit, offset: $offset) {
      items {
        id
        kind
        name
        path
        documentId
        propertyId
        clientId
        dealId
        deletedAt
        createdAt
      }
      total
      limit
      offset
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentTrashQuery, DocumentTrashQueryVariables>;
export const DocumentVersionsDocument = new TypedDocumentString(`
    query DocumentVersions($id: ID!) {
  document {
    versions(id: $id) {
      id
      filename
      originalName
      mimeType
      sizeBytes
      version
      supersedesId
      uploadStatus
      downloadUrl
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentVersionsQuery, DocumentVersionsQueryVariables>;
export const DocumentBlobDocument = new TypedDocumentString(`
    query DocumentBlob($id: ID!) {
  document {
    document(id: $id) {
      id
      filename
      originalName
      mimeType
      sizeBytes
      category
      isPublic
      uploadStatus
      uploadError
      downloadUrl
      version
      supersedesId
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentBlobQuery, DocumentBlobQueryVariables>;
export const DocumentCreateUploadIntentDocument = new TypedDocumentString(`
    mutation DocumentCreateUploadIntent($category: DocumentCategoryEnum!, $mimeType: String!, $originalName: String!, $folderId: ID, $propertyId: ID, $isPublic: Boolean! = false, $sizeBytes: Int) {
  document {
    createUploadIntent(
      category: $category
      mimeType: $mimeType
      originalName: $originalName
      folderId: $folderId
      propertyId: $propertyId
      isPublic: $isPublic
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateDocumentUploadIntentSuccess {
        message
        uploadIntent {
          document {
            id
            uploadStatus
            originalName
          }
          upload {
            url
            method
            headers
            expiresAt
            maxBytes
          }
        }
      }
      ... on CreateDocumentUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentCreateUploadIntentMutation, DocumentCreateUploadIntentMutationVariables>;
export const DocumentFinalizeUploadDocument = new TypedDocumentString(`
    mutation DocumentFinalizeUpload($id: ID!) {
  document {
    finalizeUpload(id: $id) {
      __typename
      ... on FinalizeDocumentUploadSuccess {
        message
        document {
          id
          uploadStatus
          uploadError
          downloadUrl
          originalName
        }
      }
      ... on FinalizeDocumentUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentFinalizeUploadMutation, DocumentFinalizeUploadMutationVariables>;
export const DocumentAbortUploadDocument = new TypedDocumentString(`
    mutation DocumentAbortUpload($id: ID!) {
  document {
    abortUpload(id: $id) {
      __typename
      ... on AbortDocumentUploadSuccess {
        message
        success
      }
      ... on AbortDocumentUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentAbortUploadMutation, DocumentAbortUploadMutationVariables>;
export const DocumentCreateFolderDocument = new TypedDocumentString(`
    mutation DocumentCreateFolder($name: String!, $parentId: ID, $propertyId: ID, $clientId: ID, $dealId: ID) {
  document {
    createFolder(
      name: $name
      parentId: $parentId
      propertyId: $propertyId
      clientId: $clientId
      dealId: $dealId
    ) {
      __typename
      ... on CreateDocumentFolderSuccess {
        message
        node {
          id
          kind
          name
          parentId
          path
        }
      }
      ... on CreateDocumentFolderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentCreateFolderMutation, DocumentCreateFolderMutationVariables>;
export const DocumentEnsurePropertyFolderDocument = new TypedDocumentString(`
    mutation DocumentEnsurePropertyFolder($propertyId: ID!, $name: String! = "Documents") {
  document {
    ensurePropertyFolder(propertyId: $propertyId, name: $name) {
      __typename
      ... on EnsurePropertyDocumentFolderSuccess {
        message
        node {
          id
          kind
          name
          propertyId
          path
        }
      }
      ... on EnsurePropertyDocumentFolderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentEnsurePropertyFolderMutation, DocumentEnsurePropertyFolderMutationVariables>;
export const DocumentEnsureClientFolderDocument = new TypedDocumentString(`
    mutation DocumentEnsureClientFolder($clientId: ID!, $name: String! = "Documents") {
  document {
    ensureClientFolder(clientId: $clientId, name: $name) {
      __typename
      ... on EnsureClientDocumentFolderSuccess {
        message
        node {
          id
          kind
          name
          clientId
          path
        }
      }
      ... on EnsureClientDocumentFolderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentEnsureClientFolderMutation, DocumentEnsureClientFolderMutationVariables>;
export const DocumentEnsureDealFolderDocument = new TypedDocumentString(`
    mutation DocumentEnsureDealFolder($dealId: ID!, $name: String! = "Documents") {
  document {
    ensureDealFolder(dealId: $dealId, name: $name) {
      __typename
      ... on EnsureDealDocumentFolderSuccess {
        message
        node {
          id
          kind
          name
          dealId
          path
        }
      }
      ... on EnsureDealDocumentFolderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentEnsureDealFolderMutation, DocumentEnsureDealFolderMutationVariables>;
export const DocumentPlaceInFolderDocument = new TypedDocumentString(`
    mutation DocumentPlaceInFolder($documentId: ID!, $folderId: ID!, $name: String) {
  document {
    placeDocumentInFolder(documentId: $documentId, folderId: $folderId, name: $name) {
      __typename
      ... on PlaceDocumentInFolderSuccess {
        message
        node {
          id
          kind
          name
          documentId
          parentId
        }
      }
      ... on PlaceDocumentInFolderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentPlaceInFolderMutation, DocumentPlaceInFolderMutationVariables>;
export const DocumentRenameNodeDocument = new TypedDocumentString(`
    mutation DocumentRenameNode($id: ID!, $name: String!) {
  document {
    renameNode(id: $id, name: $name) {
      __typename
      ... on RenameDocumentNodeSuccess {
        message
        node {
          id
          name
        }
      }
      ... on RenameDocumentNodeError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentRenameNodeMutation, DocumentRenameNodeMutationVariables>;
export const DocumentMoveNodeDocument = new TypedDocumentString(`
    mutation DocumentMoveNode($id: ID!, $newParentId: ID!) {
  document {
    moveNode(id: $id, newParentId: $newParentId) {
      __typename
      ... on MoveDocumentNodeSuccess {
        message
        node {
          id
          parentId
          path
        }
      }
      ... on MoveDocumentNodeError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentMoveNodeMutation, DocumentMoveNodeMutationVariables>;
export const DocumentDeleteNodeDocument = new TypedDocumentString(`
    mutation DocumentDeleteNode($id: ID!) {
  document {
    deleteNode(id: $id) {
      __typename
      ... on DeleteDocumentNodeSuccess {
        message
        success
      }
      ... on DeleteDocumentNodeError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentDeleteNodeMutation, DocumentDeleteNodeMutationVariables>;
export const DocumentRestoreNodeDocument = new TypedDocumentString(`
    mutation DocumentRestoreNode($id: ID!) {
  document {
    restoreNode(id: $id) {
      __typename
      ... on RestoreDocumentNodeSuccess {
        message
        node {
          id
          name
          deletedAt
          parentId
        }
      }
      ... on RestoreDocumentNodeError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentRestoreNodeMutation, DocumentRestoreNodeMutationVariables>;
export const DocumentReplaceFileDocument = new TypedDocumentString(`
    mutation DocumentReplaceFile($nodeId: ID!, $documentId: ID!, $name: String) {
  document {
    replaceFile(nodeId: $nodeId, documentId: $documentId, name: $name) {
      __typename
      ... on ReplaceDocumentFileSuccess {
        message
        node {
          id
          name
          documentId
        }
      }
      ... on ReplaceDocumentFileError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentReplaceFileMutation, DocumentReplaceFileMutationVariables>;
export const DocumentCreateShareDocument = new TypedDocumentString(`
    mutation DocumentCreateShare($nodeId: ID!, $label: String, $password: String, $allowDownload: Boolean! = true, $expiresAt: DateTime, $expiresInHours: Int, $maxDownloads: Int) {
  document {
    createShare(
      nodeId: $nodeId
      label: $label
      password: $password
      allowDownload: $allowDownload
      expiresAt: $expiresAt
      expiresInHours: $expiresInHours
      maxDownloads: $maxDownloads
    ) {
      __typename
      ... on CreateDocumentShareSuccess {
        message
        share {
          share {
            id
            label
            scope
            allowDownload
            hasPassword
            expiresAt
            maxDownloads
          }
          token
          url
          urlPath
        }
      }
      ... on CreateDocumentShareError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentCreateShareMutation, DocumentCreateShareMutationVariables>;
export const DocumentRevokeShareDocument = new TypedDocumentString(`
    mutation DocumentRevokeShare($id: ID!) {
  document {
    revokeShare(id: $id) {
      __typename
      ... on RevokeDocumentShareSuccess {
        message
        success
      }
      ... on RevokeDocumentShareError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentRevokeShareMutation, DocumentRevokeShareMutationVariables>;
export const DocumentCreateFolderZipDocument = new TypedDocumentString(`
    mutation DocumentCreateFolderZip($folderId: ID!) {
  document {
    createFolderZip(folderId: $folderId) {
      __typename
      ... on CreateDocumentFolderZipSuccess {
        message
        job {
          queued
          folderId
          fileCount
        }
      }
      ... on CreateDocumentFolderZipError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentCreateFolderZipMutation, DocumentCreateFolderZipMutationVariables>;
export const DocumentAttachToPropertyDocument = new TypedDocumentString(`
    mutation DocumentAttachToProperty($documentId: ID!, $propertyId: ID!) {
  document {
    attachToProperty(documentId: $documentId, propertyId: $propertyId) {
      __typename
      ... on AttachDocumentToPropertySuccess {
        message
        document {
          id
          originalName
        }
      }
      ... on AttachDocumentToPropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DocumentAttachToPropertyMutation, DocumentAttachToPropertyMutationVariables>;
export const IdentityLicenseOrganizationsDocument = new TypedDocumentString(`
    query IdentityLicenseOrganizations {
  identity {
    licenseOrganizations {
      id
      name
      slug
      createdAt
      modelType
      licenseStatus
      licenseBundling
      subscriptionStatus
      trialEndsAt
      userCount
      venueCount
      listingCount
      accessActive
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLicenseOrganizationsQuery, IdentityLicenseOrganizationsQueryVariables>;
export const IdentityCreateLicenseOrganizationDocument = new TypedDocumentString(`
    mutation IdentityCreateLicenseOrganization($name: String!, $bundling: LicenseBundlingEnum!, $ownerLoginEmail: String!, $ownerFirstName: String!, $ownerLastName: String!, $ownerPassword: String!, $slug: String, $timezone: String, $locale: String, $childModelType: OrganizationModelTypeEnum) {
  identity {
    createLicenseOrganization(
      name: $name
      bundling: $bundling
      ownerLoginEmail: $ownerLoginEmail
      ownerFirstName: $ownerFirstName
      ownerLastName: $ownerLastName
      ownerPassword: $ownerPassword
      slug: $slug
      timezone: $timezone
      locale: $locale
      childModelType: $childModelType
    ) {
      __typename
      ... on CreateLicenseOrganizationSuccess {
        message
        organization {
          id
          name
          slug
          modelType
          licenseStatus
          licenseBundling
        }
      }
      ... on CreateLicenseOrganizationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateLicenseOrganizationMutation, IdentityCreateLicenseOrganizationMutationVariables>;
export const IdentitySuspendLicenseDocument = new TypedDocumentString(`
    mutation IdentitySuspendLicense($organizationId: ID!) {
  identity {
    suspendLicense(organizationId: $organizationId) {
      __typename
      ... on SuspendLicenseSuccess {
        message
        organization {
          id
          name
          licenseStatus
        }
      }
      ... on SuspendLicenseError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySuspendLicenseMutation, IdentitySuspendLicenseMutationVariables>;
export const IdentityReactivateLicenseDocument = new TypedDocumentString(`
    mutation IdentityReactivateLicense($organizationId: ID!) {
  identity {
    reactivateLicense(organizationId: $organizationId) {
      __typename
      ... on ReactivateLicenseSuccess {
        message
        organization {
          id
          name
          licenseStatus
        }
      }
      ... on ReactivateLicenseError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityReactivateLicenseMutation, IdentityReactivateLicenseMutationVariables>;
export const IdentityCreateOrganizationDocument = new TypedDocumentString(`
    mutation IdentityCreateOrganization($input: CreateOrganizationInput!) {
  identity {
    createOrganization(input: $input) {
      __typename
      ... on CreateOrganizationSuccess {
        message
        organization {
          id
          name
          slug
          modelType
        }
        user {
          id
          loginEmail
          role
        }
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
      }
      ... on CreateOrganizationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateOrganizationMutation, IdentityCreateOrganizationMutationVariables>;
export const IdentityPublicSignupEnabledDocument = new TypedDocumentString(`
    query IdentityPublicSignupEnabled {
  identity {
    publicSignupEnabled
  }
}
    `) as unknown as TypedDocumentString<IdentityPublicSignupEnabledQuery, IdentityPublicSignupEnabledQueryVariables>;
export const IdentitySignupPlansDocument = new TypedDocumentString(`
    query IdentitySignupPlans {
  identity {
    signupPlans {
      id
      code
      name
      description
      priceAmount
      currency
      billingPeriod
      includedCredits
      seatLimit
      isPublic
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySignupPlansQuery, IdentitySignupPlansQueryVariables>;
export const IdentitySignupLookupAresDocument = new TypedDocumentString(`
    query IdentitySignupLookupAres($ico: String!) {
  identity {
    signupLookupAres(ico: $ico) {
      ico
      dic
      companyName
      legalForm
      seatAddress
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySignupLookupAresQuery, IdentitySignupLookupAresQueryVariables>;
export const IdentityLoginDocument = new TypedDocumentString(`
    mutation IdentityLogin($input: LoginInput!) {
  identity {
    login(input: $input) {
      __typename
      ... on LoginSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on LoginError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLoginMutation, IdentityLoginMutationVariables>;
export const IdentityRefreshDocument = new TypedDocumentString(`
    mutation IdentityRefresh($input: RefreshInput!) {
  identity {
    refresh(input: $input) {
      __typename
      ... on RefreshSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on RefreshError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityRefreshMutation, IdentityRefreshMutationVariables>;
export const IdentityLogoutDocument = new TypedDocumentString(`
    mutation IdentityLogout($refreshToken: String, $allSessions: Boolean) {
  identity {
    logout(refreshToken: $refreshToken, allSessions: $allSessions) {
      __typename
      ... on LogoutSuccess {
        message
        success
      }
      ... on LogoutError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLogoutMutation, IdentityLogoutMutationVariables>;
export const IdentityChangePasswordDocument = new TypedDocumentString(`
    mutation IdentityChangePassword($input: ChangePasswordInput!) {
  identity {
    changePassword(input: $input) {
      __typename
      ... on ChangePasswordSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on ChangePasswordError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityChangePasswordMutation, IdentityChangePasswordMutationVariables>;
export const IdentityRequestPasswordResetDocument = new TypedDocumentString(`
    mutation IdentityRequestPasswordReset($input: RequestPasswordResetInput!) {
  identity {
    requestPasswordReset(input: $input) {
      __typename
      ... on RequestPasswordResetSuccess {
        message
        success
      }
      ... on RequestPasswordResetError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityRequestPasswordResetMutation, IdentityRequestPasswordResetMutationVariables>;
export const IdentityResetPasswordDocument = new TypedDocumentString(`
    mutation IdentityResetPassword($input: ResetPasswordInput!) {
  identity {
    resetPassword(input: $input) {
      __typename
      ... on ResetPasswordSuccess {
        message
        success
      }
      ... on ResetPasswordError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityResetPasswordMutation, IdentityResetPasswordMutationVariables>;
export const IdentityCompleteOauthLoginDocument = new TypedDocumentString(`
    mutation IdentityCompleteOauthLogin($pendingToken: String!, $totpCode: String!) {
  identity {
    completeOauthLogin(pendingToken: $pendingToken, totpCode: $totpCode) {
      __typename
      ... on CompleteOauthLoginSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on CompleteOauthLoginError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCompleteOauthLoginMutation, IdentityCompleteOauthLoginMutationVariables>;
export const IdentityMeDocument = new TypedDocumentString(`
    query IdentityMe {
  identity {
    me {
      id
      loginEmail
      firstName
      lastName
      role
      isActive
      avatarUrl
      publicSlug
      publicTitle
      publicEmail
      publicPhone
      publicBio
      showPublicProfile
      mustResetPassword
      totpEnabled
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityMeQuery, IdentityMeQueryVariables>;
export const IdentityUsersDocument = new TypedDocumentString(`
    query IdentityUsers($limit: Int, $offset: Int, $filters: UserFilter, $order: UserOrder) {
  identity {
    users(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        loginEmail
        firstName
        lastName
        role
        isActive
        venueId
        avatarUrl
        publicPhone
        createdAt
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUsersQuery, IdentityUsersQueryVariables>;
export const IdentityCalendarFeedUrlDocument = new TypedDocumentString(`
    query IdentityCalendarFeedUrl {
  identity {
    calendarFeedUrl
  }
}
    `) as unknown as TypedDocumentString<IdentityCalendarFeedUrlQuery, IdentityCalendarFeedUrlQueryVariables>;
export const IdentityReadyDocument = new TypedDocumentString(`
    query IdentityReady {
  identity {
    ready
  }
}
    `) as unknown as TypedDocumentString<IdentityReadyQuery, IdentityReadyQueryVariables>;
export const IdentityGoogleLoginEligibleDocument = new TypedDocumentString(`
    query IdentityGoogleLoginEligible($loginEmail: String, $organizationSlug: String) {
  identity {
    googleLoginEligible(
      loginEmail: $loginEmail
      organizationSlug: $organizationSlug
    )
  }
}
    `) as unknown as TypedDocumentString<IdentityGoogleLoginEligibleQuery, IdentityGoogleLoginEligibleQueryVariables>;
export const IdentityMetaLoginEligibleDocument = new TypedDocumentString(`
    query IdentityMetaLoginEligible($loginEmail: String, $organizationSlug: String) {
  identity {
    metaLoginEligible(loginEmail: $loginEmail, organizationSlug: $organizationSlug)
  }
}
    `) as unknown as TypedDocumentString<IdentityMetaLoginEligibleQuery, IdentityMetaLoginEligibleQueryVariables>;
export const IdentityTeamsDocument = new TypedDocumentString(`
    query IdentityTeams($limit: Int! = 200, $offset: Int! = 0, $venueId: ID) {
  identity {
    teams(limit: $limit, offset: $offset, venueId: $venueId) {
      id
      name
      venueId
      leaderId
      memberIds
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityTeamsQuery, IdentityTeamsQueryVariables>;
export const IdentityTeamDocument = new TypedDocumentString(`
    query IdentityTeam($id: ID!) {
  identity {
    team(id: $id) {
      id
      name
      leaderId
      memberIds
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityTeamQuery, IdentityTeamQueryVariables>;
export const IdentityCreateUserDocument = new TypedDocumentString(`
    mutation IdentityCreateUser($loginEmail: String!, $firstName: String!, $lastName: String!, $password: String, $role: UserRoleEnum!, $isActive: Boolean! = true, $venueId: ID, $provisionSrealitySeller: Boolean, $alreadyRegisteredOnSreality: Boolean = false, $srealityClientLogin: String, $srealityContactGsm: String, $srealityClientIc: String, $srealityIsEmployee: Boolean = true, $idempotencyKey: String) {
  identity {
    createUser(
      loginEmail: $loginEmail
      firstName: $firstName
      lastName: $lastName
      password: $password
      role: $role
      isActive: $isActive
      venueId: $venueId
      provisionSrealitySeller: $provisionSrealitySeller
      alreadyRegisteredOnSreality: $alreadyRegisteredOnSreality
      srealityClientLogin: $srealityClientLogin
      srealityContactGsm: $srealityContactGsm
      srealityClientIc: $srealityClientIc
      srealityIsEmployee: $srealityIsEmployee
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on CreateUserSuccess {
        message
        inviteUrl
        inviteEmailSent
        mustResetPassword
        user {
          id
          loginEmail
          firstName
          lastName
          role
          isActive
          venueId
          mustResetPassword
        }
      }
      ... on CreateUserError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateUserMutation, IdentityCreateUserMutationVariables>;
export const IdentityUpdateUserDocument = new TypedDocumentString(`
    mutation IdentityUpdateUser($id: ID!, $firstName: String, $lastName: String, $loginEmail: String, $role: UserRoleEnum, $isActive: Boolean, $password: String, $venueId: ID, $provisionSrealitySeller: Boolean, $alreadyRegisteredOnSreality: Boolean, $srealityClientLogin: String, $srealityContactGsm: String, $srealityClientIc: String, $srealityIsEmployee: Boolean) {
  identity {
    updateUser(
      id: $id
      firstName: $firstName
      lastName: $lastName
      loginEmail: $loginEmail
      role: $role
      isActive: $isActive
      password: $password
      venueId: $venueId
      provisionSrealitySeller: $provisionSrealitySeller
      alreadyRegisteredOnSreality: $alreadyRegisteredOnSreality
      srealityClientLogin: $srealityClientLogin
      srealityContactGsm: $srealityContactGsm
      srealityClientIc: $srealityClientIc
      srealityIsEmployee: $srealityIsEmployee
    ) {
      __typename
      ... on UpdateUserSuccess {
        message
        user {
          id
          loginEmail
          firstName
          lastName
          role
          isActive
          venueId
        }
      }
      ... on UpdateUserError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateUserMutation, IdentityUpdateUserMutationVariables>;
export const IdentitySetUserActiveDocument = new TypedDocumentString(`
    mutation IdentitySetUserActive($id: ID!, $isActive: Boolean!) {
  identity {
    setUserActive(id: $id, isActive: $isActive) {
      __typename
      ... on SetUserActiveSuccess {
        message
        user {
          id
          isActive
        }
      }
      ... on SetUserActiveError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySetUserActiveMutation, IdentitySetUserActiveMutationVariables>;
export const IdentityCreateTeamDocument = new TypedDocumentString(`
    mutation IdentityCreateTeam($name: String!, $leaderId: ID, $venueId: ID) {
  identity {
    createTeam(name: $name, leaderId: $leaderId, venueId: $venueId) {
      __typename
      ... on CreateTeamSuccess {
        message
        team {
          id
          name
          venueId
          leaderId
          memberIds
        }
      }
      ... on CreateTeamError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateTeamMutation, IdentityCreateTeamMutationVariables>;
export const IdentityUpdateTeamDocument = new TypedDocumentString(`
    mutation IdentityUpdateTeam($id: ID!, $name: String, $leaderId: ID) {
  identity {
    updateTeam(id: $id, name: $name, leaderId: $leaderId) {
      __typename
      ... on UpdateTeamSuccess {
        message
        team {
          id
          name
          leaderId
          memberIds
        }
      }
      ... on UpdateTeamError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateTeamMutation, IdentityUpdateTeamMutationVariables>;
export const IdentityAddTeamMemberDocument = new TypedDocumentString(`
    mutation IdentityAddTeamMember($teamId: ID!, $userId: ID!) {
  identity {
    addTeamMember(teamId: $teamId, userId: $userId) {
      __typename
      ... on AddTeamMemberSuccess {
        message
        team {
          id
          memberIds
        }
      }
      ... on AddTeamMemberError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityAddTeamMemberMutation, IdentityAddTeamMemberMutationVariables>;
export const IdentityRemoveTeamMemberDocument = new TypedDocumentString(`
    mutation IdentityRemoveTeamMember($teamId: ID!, $userId: ID!) {
  identity {
    removeTeamMember(teamId: $teamId, userId: $userId) {
      __typename
      ... on RemoveTeamMemberSuccess {
        message
        team {
          id
          leaderId
          memberIds
        }
      }
      ... on RemoveTeamMemberError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityRemoveTeamMemberMutation, IdentityRemoveTeamMemberMutationVariables>;
export const IdentityDeleteTeamDocument = new TypedDocumentString(`
    mutation IdentityDeleteTeam($id: ID!, $memberTeamId: ID) {
  identity {
    deleteTeam(id: $id, memberTeamId: $memberTeamId) {
      __typename
      ... on DeleteTeamSuccess {
        message
        success
      }
      ... on DeleteTeamError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDeleteTeamMutation, IdentityDeleteTeamMutationVariables>;
export const IdentityCreateAvatarUploadIntentDocument = new TypedDocumentString(`
    mutation IdentityCreateAvatarUploadIntent($input: AvatarUploadIntentInput!) {
  identity {
    createAvatarUploadIntent(input: $input) {
      __typename
      ... on CreateAvatarUploadIntentSuccess {
        message
        storageKey
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreateAvatarUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateAvatarUploadIntentMutation, IdentityCreateAvatarUploadIntentMutationVariables>;
export const IdentityFinalizeAvatarUploadDocument = new TypedDocumentString(`
    mutation IdentityFinalizeAvatarUpload($input: FinalizeAvatarInput!) {
  identity {
    finalizeAvatarUpload(input: $input) {
      __typename
      ... on FinalizeAvatarUploadSuccess {
        message
        user {
          id
          avatarUrl
        }
      }
      ... on FinalizeAvatarUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityFinalizeAvatarUploadMutation, IdentityFinalizeAvatarUploadMutationVariables>;
export const IdentityAbortAvatarUploadDocument = new TypedDocumentString(`
    mutation IdentityAbortAvatarUpload($input: AbortAvatarInput!) {
  identity {
    abortAvatarUpload(input: $input) {
      __typename
      ... on AbortAvatarUploadSuccess {
        message
        success
      }
      ... on AbortAvatarUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityAbortAvatarUploadMutation, IdentityAbortAvatarUploadMutationVariables>;
export const IdentityCreateOrgLogoUploadIntentDocument = new TypedDocumentString(`
    mutation IdentityCreateOrgLogoUploadIntent($input: OrgLogoUploadIntentInput!) {
  identity {
    createOrgLogoUploadIntent(input: $input) {
      __typename
      ... on CreateOrgLogoUploadIntentSuccess {
        message
        storageKey
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreateOrgLogoUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateOrgLogoUploadIntentMutation, IdentityCreateOrgLogoUploadIntentMutationVariables>;
export const IdentityFinalizeOrgLogoUploadDocument = new TypedDocumentString(`
    mutation IdentityFinalizeOrgLogoUpload($input: FinalizeOrgLogoInput!) {
  identity {
    finalizeOrgLogoUpload(input: $input) {
      __typename
      ... on FinalizeOrgLogoUploadSuccess {
        message
        organization {
          id
          branding
        }
      }
      ... on FinalizeOrgLogoUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityFinalizeOrgLogoUploadMutation, IdentityFinalizeOrgLogoUploadMutationVariables>;
export const IdentityAbortOrgLogoUploadDocument = new TypedDocumentString(`
    mutation IdentityAbortOrgLogoUpload($input: AbortOrgLogoInput!) {
  identity {
    abortOrgLogoUpload(input: $input) {
      __typename
      ... on AbortOrgLogoUploadSuccess {
        message
        success
      }
      ... on AbortOrgLogoUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityAbortOrgLogoUploadMutation, IdentityAbortOrgLogoUploadMutationVariables>;
export const IdentityClearOrgLogoDocument = new TypedDocumentString(`
    mutation IdentityClearOrgLogo {
  identity {
    clearOrgLogo {
      __typename
      ... on ClearOrgLogoSuccess {
        message
        organization {
          id
          branding
        }
      }
      ... on ClearOrgLogoError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityClearOrgLogoMutation, IdentityClearOrgLogoMutationVariables>;
export const IdentityUpdatePublicProfileDocument = new TypedDocumentString(`
    mutation IdentityUpdatePublicProfile($input: UpdatePublicProfileInput!) {
  identity {
    updatePublicProfile(input: $input) {
      __typename
      ... on UpdatePublicProfileSuccess {
        message
        user {
          id
          firstName
          lastName
          publicSlug
          publicTitle
          publicEmail
          publicPhone
          publicBio
          showPublicProfile
        }
      }
      ... on UpdatePublicProfileError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdatePublicProfileMutation, IdentityUpdatePublicProfileMutationVariables>;
export const IdentitySettingsDocument = new TypedDocumentString(`
    query IdentitySettings($userId: ID) {
  identity {
    settings(userId: $userId) {
      locale
      theme
      timezone
      dateFormat
      defaultCalendarScope
      taskListDefaultScope
      preferredTaskPipelineId
      notifyPrefs
      messagesLayout
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySettingsQuery, IdentitySettingsQueryVariables>;
export const IdentityUpdateSettingsDocument = new TypedDocumentString(`
    mutation IdentityUpdateSettings($locale: String, $theme: String, $timezone: String, $dateFormat: String, $defaultCalendarScope: CalendarScopeEnum, $taskListDefaultScope: CalendarScopeEnum, $preferredTaskPipelineId: ID, $notifyPrefs: JSON, $messagesLayout: JSON, $userId: ID) {
  identity {
    updateSettings(
      locale: $locale
      theme: $theme
      timezone: $timezone
      dateFormat: $dateFormat
      defaultCalendarScope: $defaultCalendarScope
      taskListDefaultScope: $taskListDefaultScope
      preferredTaskPipelineId: $preferredTaskPipelineId
      notifyPrefs: $notifyPrefs
      messagesLayout: $messagesLayout
      userId: $userId
    ) {
      __typename
      ... on UpdateSettingsSuccess {
        message
        settings {
          locale
          theme
          timezone
          dateFormat
          defaultCalendarScope
          taskListDefaultScope
          preferredTaskPipelineId
          notifyPrefs
          messagesLayout
        }
      }
      ... on UpdateSettingsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateSettingsMutation, IdentityUpdateSettingsMutationVariables>;
export const IdentityCalendarSyncDocument = new TypedDocumentString(`
    query IdentityCalendarSync($userId: ID) {
  identity {
    calendarSync(userId: $userId) {
      userId
      provider
      syncInbound
      syncOutbound
      externalCalendarId
      exportOwnTasksDefault
      includeTeamExportable
      skipPrivateInbound
      lastManualSyncAt
      manualSyncCooldownUntil
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCalendarSyncQuery, IdentityCalendarSyncQueryVariables>;
export const IdentityUpdateCalendarSyncDocument = new TypedDocumentString(`
    mutation IdentityUpdateCalendarSync($provider: CalendarProviderEnum, $syncInbound: Boolean, $syncOutbound: Boolean, $externalCalendarId: String, $exportOwnTasksDefault: Boolean, $includeTeamExportable: Boolean, $skipPrivateInbound: Boolean, $userId: ID) {
  identity {
    updateCalendarSync(
      provider: $provider
      syncInbound: $syncInbound
      syncOutbound: $syncOutbound
      externalCalendarId: $externalCalendarId
      exportOwnTasksDefault: $exportOwnTasksDefault
      includeTeamExportable: $includeTeamExportable
      skipPrivateInbound: $skipPrivateInbound
      userId: $userId
    ) {
      __typename
      ... on UpdateCalendarSyncSuccess {
        message
        settings {
          userId
          provider
          syncInbound
          syncOutbound
          externalCalendarId
          exportOwnTasksDefault
          includeTeamExportable
          skipPrivateInbound
          lastManualSyncAt
          manualSyncCooldownUntil
        }
      }
      ... on UpdateCalendarSyncError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateCalendarSyncMutation, IdentityUpdateCalendarSyncMutationVariables>;
export const IdentityConnectCalendarDocument = new TypedDocumentString(`
    mutation IdentityConnectCalendar($provider: CalendarProviderEnum! = GOOGLE, $returnTo: String) {
  identity {
    connectCalendar(provider: $provider, returnTo: $returnTo) {
      __typename
      ... on ConnectCalendarSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on ConnectCalendarError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityConnectCalendarMutation, IdentityConnectCalendarMutationVariables>;
export const IdentityConnectGoogleDocument = new TypedDocumentString(`
    mutation IdentityConnectGoogle($returnTo: String) {
  identity {
    connectGoogle(returnTo: $returnTo) {
      __typename
      ... on ConnectGoogleSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on ConnectGoogleError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityConnectGoogleMutation, IdentityConnectGoogleMutationVariables>;
export const IdentityDisconnectGoogleDocument = new TypedDocumentString(`
    mutation IdentityDisconnectGoogle {
  identity {
    disconnectGoogle {
      __typename
      ... on DisconnectGoogleSuccess {
        message
        success
      }
      ... on DisconnectGoogleError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDisconnectGoogleMutation, IdentityDisconnectGoogleMutationVariables>;
export const IdentityUnlinkGoogleDocument = new TypedDocumentString(`
    mutation IdentityUnlinkGoogle {
  identity {
    unlinkGoogle {
      __typename
      ... on UnlinkGoogleSuccess {
        message
        success
      }
      ... on UnlinkGoogleError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUnlinkGoogleMutation, IdentityUnlinkGoogleMutationVariables>;
export const IdentityConnectPersonalMetaDocument = new TypedDocumentString(`
    mutation IdentityConnectPersonalMeta($returnTo: String) {
  identity {
    connectPersonalMeta(returnTo: $returnTo) {
      __typename
      ... on ConnectPersonalMetaSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on ConnectPersonalMetaError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityConnectPersonalMetaMutation, IdentityConnectPersonalMetaMutationVariables>;
export const IdentityUnlinkPersonalMetaDocument = new TypedDocumentString(`
    mutation IdentityUnlinkPersonalMeta {
  identity {
    unlinkPersonalMeta {
      __typename
      ... on UnlinkPersonalMetaSuccess {
        message
        success
      }
      ... on UnlinkPersonalMetaError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUnlinkPersonalMetaMutation, IdentityUnlinkPersonalMetaMutationVariables>;
export const IdentityCompletePersonalMetaSetupDocument = new TypedDocumentString(`
    mutation IdentityCompletePersonalMetaSetup($input: CompleteMetaSetupInput!) {
  identity {
    completePersonalMetaSetup(input: $input) {
      __typename
      ... on CompletePersonalMetaSetupSuccess {
        message
        status {
          configured
          connected
          stub
          setupComplete
          pendingPageSelection
          connectionId
          pageId
          pageName
          igUserId
          igUsername
          availablePages {
            id
            name
          }
        }
      }
      ... on CompletePersonalMetaSetupError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCompletePersonalMetaSetupMutation, IdentityCompletePersonalMetaSetupMutationVariables>;
export const IdentityPersonalMetaStatusDocument = new TypedDocumentString(`
    query IdentityPersonalMetaStatus {
  identity {
    personalMetaStatus {
      configured
      connected
      stub
      setupComplete
      pendingPageSelection
      connectionId
      pageId
      pageName
      igUserId
      igUsername
      message
      availablePages {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityPersonalMetaStatusQuery, IdentityPersonalMetaStatusQueryVariables>;
export const IdentityStartGoogleLoginDocument = new TypedDocumentString(`
    mutation IdentityStartGoogleLogin($organizationSlug: String, $returnTo: String) {
  identity {
    startGoogleLogin(organizationSlug: $organizationSlug, returnTo: $returnTo) {
      __typename
      ... on StartGoogleLoginSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on StartGoogleLoginError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityStartGoogleLoginMutation, IdentityStartGoogleLoginMutationVariables>;
export const IdentityLoginWithGoogleDocument = new TypedDocumentString(`
    mutation IdentityLoginWithGoogle($code: String!, $state: String!, $totpCode: String) {
  identity {
    loginWithGoogle(code: $code, state: $state, totpCode: $totpCode) {
      __typename
      ... on LoginWithGoogleSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on LoginWithGoogleError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLoginWithGoogleMutation, IdentityLoginWithGoogleMutationVariables>;
export const IdentityStartMetaLoginDocument = new TypedDocumentString(`
    mutation IdentityStartMetaLogin($organizationSlug: String, $returnTo: String) {
  identity {
    startMetaLogin(organizationSlug: $organizationSlug, returnTo: $returnTo) {
      __typename
      ... on StartMetaLoginSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on StartMetaLoginError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityStartMetaLoginMutation, IdentityStartMetaLoginMutationVariables>;
export const IdentityLoginWithMetaDocument = new TypedDocumentString(`
    mutation IdentityLoginWithMeta($code: String!, $state: String!, $totpCode: String) {
  identity {
    loginWithMeta(code: $code, state: $state, totpCode: $totpCode) {
      __typename
      ... on LoginWithMetaSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on LoginWithMetaError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLoginWithMetaMutation, IdentityLoginWithMetaMutationVariables>;
export const IdentityDisconnectCalendarDocument = new TypedDocumentString(`
    mutation IdentityDisconnectCalendar($provider: CalendarProviderEnum! = GOOGLE) {
  identity {
    disconnectCalendar(provider: $provider) {
      __typename
      ... on DisconnectCalendarSuccess {
        message
        success
      }
      ... on DisconnectCalendarError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDisconnectCalendarMutation, IdentityDisconnectCalendarMutationVariables>;
export const IdentityCalendarOAuthStatusDocument = new TypedDocumentString(`
    query IdentityCalendarOAuthStatus {
  identity {
    calendarOauthStatus {
      googleConfigured
      microsoftConfigured
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCalendarOAuthStatusQuery, IdentityCalendarOAuthStatusQueryVariables>;
export const IdentityCredentialsDocument = new TypedDocumentString(`
    query IdentityCredentials($userId: ID) {
  identity {
    credentials(userId: $userId) {
      id
      provider
      authType
      externalId
      status
      hasCredential
      lastError
      lastSyncedAt
      settings
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCredentialsQuery, IdentityCredentialsQueryVariables>;
export const IdentitySrealitySellersDocument = new TypedDocumentString(`
    query IdentitySrealitySellers {
  identity {
    srealitySellers {
      sellerId
      clientLogin
      clientName
      contactGsm
      clientIsEmployee
    }
  }
}
    `) as unknown as TypedDocumentString<IdentitySrealitySellersQuery, IdentitySrealitySellersQueryVariables>;
export const IdentityOrganizationDocument = new TypedDocumentString(`
    query IdentityOrganization {
  identity {
    organization {
      id
      name
      slug
      timezone
      locale
      aiFeaturesEnabled
      branding
      legalEntityId
      modelType
      parentOrganizationId
      licenseStatus
      licenseBundling
      subscriptionStatus
      trialEndsAt
      legalEntity {
        id
        name
        ico
        dic
        address
        phone
        email
        website
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityOrganizationQuery, IdentityOrganizationQueryVariables>;
export const IdentityUpdateOrganizationDocument = new TypedDocumentString(`
    mutation IdentityUpdateOrganization($name: String, $slug: String, $timezone: String, $locale: String, $aiFeaturesEnabled: Boolean, $branding: JSON, $legalEntityId: ID) {
  identity {
    updateOrganization(
      name: $name
      slug: $slug
      timezone: $timezone
      locale: $locale
      aiFeaturesEnabled: $aiFeaturesEnabled
      branding: $branding
      legalEntityId: $legalEntityId
    ) {
      __typename
      ... on UpdateOrganizationSuccess {
        message
        organization {
          id
          name
          slug
          timezone
          locale
          aiFeaturesEnabled
          branding
          legalEntityId
          modelType
          parentOrganizationId
          licenseStatus
          licenseBundling
          subscriptionStatus
          trialEndsAt
          legalEntity {
            id
            name
            ico
            dic
            address
            phone
            email
            website
          }
        }
      }
      ... on UpdateOrganizationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateOrganizationMutation, IdentityUpdateOrganizationMutationVariables>;
export const IdentityVenuesDocument = new TypedDocumentString(`
    query IdentityVenues($limit: Int! = 200, $offset: Int! = 0) {
  identity {
    venues(limit: $limit, offset: $offset) {
      id
      name
      slug
      isActive
      legalEntityId
      inheritsLegalEntity
      userIds
      legalEntity {
        id
        name
        ico
        dic
        address
        phone
        email
        website
      }
      effectiveLegalEntity {
        id
        name
        ico
        dic
        address
        phone
        email
        website
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityVenuesQuery, IdentityVenuesQueryVariables>;
export const IdentityLegalEntitiesDocument = new TypedDocumentString(`
    query IdentityLegalEntities($limit: Int! = 200, $offset: Int! = 0) {
  identity {
    legalEntities(limit: $limit, offset: $offset) {
      id
      name
      ico
      dic
      address
      phone
      email
      website
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityLegalEntitiesQuery, IdentityLegalEntitiesQueryVariables>;
export const IdentityCreateLegalEntityDocument = new TypedDocumentString(`
    mutation IdentityCreateLegalEntity($name: String!, $ico: String, $dic: String, $address: String, $phone: String, $email: String, $website: String) {
  identity {
    createLegalEntity(
      name: $name
      ico: $ico
      dic: $dic
      address: $address
      phone: $phone
      email: $email
      website: $website
    ) {
      __typename
      ... on CreateLegalEntitySuccess {
        message
        legalEntity {
          id
          name
          ico
          dic
          address
          phone
          email
          website
        }
      }
      ... on CreateLegalEntityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateLegalEntityMutation, IdentityCreateLegalEntityMutationVariables>;
export const IdentityUpdateLegalEntityDocument = new TypedDocumentString(`
    mutation IdentityUpdateLegalEntity($id: ID!, $name: String, $ico: String, $dic: String, $address: String, $phone: String, $email: String, $website: String) {
  identity {
    updateLegalEntity(
      id: $id
      name: $name
      ico: $ico
      dic: $dic
      address: $address
      phone: $phone
      email: $email
      website: $website
    ) {
      __typename
      ... on UpdateLegalEntitySuccess {
        message
        legalEntity {
          id
          name
          ico
          dic
          address
          phone
          email
          website
        }
      }
      ... on UpdateLegalEntityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateLegalEntityMutation, IdentityUpdateLegalEntityMutationVariables>;
export const IdentityDeleteLegalEntityDocument = new TypedDocumentString(`
    mutation IdentityDeleteLegalEntity($id: ID!) {
  identity {
    deleteLegalEntity(id: $id) {
      __typename
      ... on DeleteLegalEntitySuccess {
        message
        success
      }
      ... on DeleteLegalEntityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDeleteLegalEntityMutation, IdentityDeleteLegalEntityMutationVariables>;
export const IdentityCreateVenueDocument = new TypedDocumentString(`
    mutation IdentityCreateVenue($name: String!, $slug: String, $isActive: Boolean! = true, $legalEntityId: ID) {
  identity {
    createVenue(
      name: $name
      slug: $slug
      isActive: $isActive
      legalEntityId: $legalEntityId
    ) {
      __typename
      ... on CreateVenueSuccess {
        message
        venue {
          id
          name
          slug
          isActive
          legalEntityId
          inheritsLegalEntity
          userIds
          legalEntity {
            id
            name
            ico
            dic
            address
            phone
            email
            website
          }
          effectiveLegalEntity {
            id
            name
            ico
            dic
            address
            phone
            email
            website
          }
        }
      }
      ... on CreateVenueError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityCreateVenueMutation, IdentityCreateVenueMutationVariables>;
export const IdentityUpdateVenueDocument = new TypedDocumentString(`
    mutation IdentityUpdateVenue($id: ID!, $name: String, $slug: String, $isActive: Boolean, $legalEntityId: ID) {
  identity {
    updateVenue(
      id: $id
      name: $name
      slug: $slug
      isActive: $isActive
      legalEntityId: $legalEntityId
    ) {
      __typename
      ... on UpdateVenueSuccess {
        message
        venue {
          id
          name
          slug
          isActive
          legalEntityId
          inheritsLegalEntity
          userIds
          legalEntity {
            id
            name
            ico
            dic
            address
            phone
            email
            website
          }
          effectiveLegalEntity {
            id
            name
            ico
            dic
            address
            phone
            email
            website
          }
        }
      }
      ... on UpdateVenueError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityUpdateVenueMutation, IdentityUpdateVenueMutationVariables>;
export const IdentityDeleteVenueDocument = new TypedDocumentString(`
    mutation IdentityDeleteVenue($id: ID!, $memberVenueId: ID) {
  identity {
    deleteVenue(id: $id, memberVenueId: $memberVenueId) {
      __typename
      ... on DeleteVenueSuccess {
        message
        success
      }
      ... on DeleteVenueError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDeleteVenueMutation, IdentityDeleteVenueMutationVariables>;
export const IdentityProvisionSrealitySellerDocument = new TypedDocumentString(`
    mutation IdentityProvisionSrealitySeller($userId: ID!, $clientLogin: String!, $contactGsm: String!, $clientIc: String, $isEmployee: Boolean = true, $alreadyRegisteredOnSreality: Boolean = false) {
  identity {
    provisionSrealitySeller(
      userId: $userId
      clientLogin: $clientLogin
      contactGsm: $contactGsm
      clientIc: $clientIc
      isEmployee: $isEmployee
      alreadyRegisteredOnSreality: $alreadyRegisteredOnSreality
    ) {
      __typename
      ... on ProvisionSrealitySellerSuccess {
        message
        credential {
          id
          provider
          status
          externalId
          lastError
          hasCredential
        }
      }
      ... on ProvisionSrealitySellerError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityProvisionSrealitySellerMutation, IdentityProvisionSrealitySellerMutationVariables>;
export const IdentityAcceptInviteDocument = new TypedDocumentString(`
    mutation IdentityAcceptInvite($token: String!, $password: String!) {
  identity {
    acceptInvite(token: $token, password: $password) {
      __typename
      ... on AcceptInviteSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on AcceptInviteError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityAcceptInviteMutation, IdentityAcceptInviteMutationVariables>;
export const IdentityTotpStatusDocument = new TypedDocumentString(`
    query IdentityTotpStatus {
  identity {
    me {
      totpEnabled
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityTotpStatusQuery, IdentityTotpStatusQueryVariables>;
export const IdentityStartTotpSetupDocument = new TypedDocumentString(`
    mutation IdentityStartTotpSetup {
  identity {
    startTotpSetup {
      __typename
      ... on StartTotpSetupSuccess {
        message
        secret
        otpauthUrl
      }
      ... on StartTotpSetupError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityStartTotpSetupMutation, IdentityStartTotpSetupMutationVariables>;
export const IdentityConfirmTotpDocument = new TypedDocumentString(`
    mutation IdentityConfirmTotp($code: String!) {
  identity {
    confirmTotp(code: $code) {
      __typename
      ... on ConfirmTotpSuccess {
        message
        user {
          id
          totpEnabled
        }
      }
      ... on ConfirmTotpError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityConfirmTotpMutation, IdentityConfirmTotpMutationVariables>;
export const IdentityDisableTotpDocument = new TypedDocumentString(`
    mutation IdentityDisableTotp($password: String!) {
  identity {
    disableTotp(password: $password) {
      __typename
      ... on DisableTotpSuccess {
        message
        user {
          id
          totpEnabled
        }
      }
      ... on DisableTotpError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IdentityDisableTotpMutation, IdentityDisableTotpMutationVariables>;
export const IntegrationListDocument = new TypedDocumentString(`
    query IntegrationList($limit: Int, $offset: Int) {
  integration {
    list(limit: $limit, offset: $offset) {
      items {
        id
        name
        provider
        direction
        authType
        isActive
        lastSyncedAt
        hasCredentials
        settings
        feedUrl
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationListQuery, IntegrationListQueryVariables>;
export const IntegrationNodeDocument = new TypedDocumentString(`
    query IntegrationNode($id: ID!) {
  integration {
    node(id: $id) {
      id
      name
      provider
      direction
      authType
      isActive
      settings
      lastSyncedAt
      hasCredentials
      feedUrl
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationNodeQuery, IntegrationNodeQueryVariables>;
export const IntegrationPreviewSrealityAdvertDocument = new TypedDocumentString(`
    query IntegrationPreviewSrealityAdvert($propertyId: ID!) {
  integration {
    previewSrealityAdvert(propertyId: $propertyId)
  }
}
    `) as unknown as TypedDocumentString<IntegrationPreviewSrealityAdvertQuery, IntegrationPreviewSrealityAdvertQueryVariables>;
export const IntegrationCheckPortalExportDocument = new TypedDocumentString(`
    query IntegrationCheckPortalExport($propertyId: ID!, $provider: IntegrationProviderEnum!) {
  integration {
    checkPortalExport(propertyId: $propertyId, provider: $provider) {
      ok
      fieldsOk
      photosOk
      blockingError
      missingMandatory
      gaps {
        key
        label
        group
        severity
        crmField
        storage
        hint
        dataType
        editable
      }
      photos {
        readyCount
        minRequired
        ok
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCheckPortalExportQuery, IntegrationCheckPortalExportQueryVariables>;
export const IntegrationPortalFieldMatrixDocument = new TypedDocumentString(`
    query IntegrationPortalFieldMatrix($propertyId: ID, $live: Boolean = true, $propertyType: PropertyTypeEnum, $category: PropertyCategoryEnum) {
  integration {
    portalFieldMatrix(
      propertyId: $propertyId
      live: $live
      propertyType: $propertyType
      category: $category
    ) {
      providers
      checked
      ok
      fields {
        crmField
        label
        portals {
          provider
          level
          status
          key
          label
          hint
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationPortalFieldMatrixQuery, IntegrationPortalFieldMatrixQueryVariables>;
export const IntegrationOrgListingPortalsDocument = new TypedDocumentString(`
    query IntegrationOrgListingPortals {
  integration {
    orgListingPortals {
      provider
      isAllowed
      readiness
      hasConnection
      connectionId
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationOrgListingPortalsQuery, IntegrationOrgListingPortalsQueryVariables>;
export const IntegrationCreateDocument = new TypedDocumentString(`
    mutation IntegrationCreate($input: CreateIntegrationConnectionInput!) {
  integration {
    create(input: $input) {
      __typename
      ... on CreateIntegrationConnectionSuccess {
        message
        connection {
          id
        }
      }
      ... on CreateIntegrationConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCreateMutation, IntegrationCreateMutationVariables>;
export const IntegrationUpdateDocument = new TypedDocumentString(`
    mutation IntegrationUpdate($input: UpdateIntegrationConnectionInput!) {
  integration {
    update(input: $input) {
      __typename
      ... on UpdateIntegrationConnectionSuccess {
        message
        connection {
          id
        }
      }
      ... on UpdateIntegrationConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationUpdateMutation, IntegrationUpdateMutationVariables>;
export const IntegrationUpsertPortalConnectionDocument = new TypedDocumentString(`
    mutation IntegrationUpsertPortalConnection($input: UpsertPortalConnectionInput!) {
  integration {
    upsertPortalConnection(input: $input) {
      __typename
      ... on UpsertPortalConnectionSuccess {
        message
        connection {
          id
          name
          provider
          isActive
          lastSyncedAt
          hasCredentials
          settings
          feedUrl
        }
      }
      ... on UpsertPortalConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationUpsertPortalConnectionMutation, IntegrationUpsertPortalConnectionMutationVariables>;
export const IntegrationTestPortalConnectionDocument = new TypedDocumentString(`
    mutation IntegrationTestPortalConnection($provider: IntegrationProviderEnum!, $connectionId: ID) {
  integration {
    testPortalConnection(provider: $provider, connectionId: $connectionId) {
      __typename
      ... on TestPortalConnectionSuccess {
        ok
        dryRun
        status
        message
      }
      ... on TestPortalConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationTestPortalConnectionMutation, IntegrationTestPortalConnectionMutationVariables>;
export const IntegrationSetOrgListingPortalAllowedDocument = new TypedDocumentString(`
    mutation IntegrationSetOrgListingPortalAllowed($provider: IntegrationProviderEnum!, $isAllowed: Boolean!) {
  integration {
    setOrgListingPortalAllowed(provider: $provider, isAllowed: $isAllowed) {
      __typename
      ... on SetOrgListingPortalAllowedSuccess {
        message
        portal {
          provider
          isAllowed
          readiness
          hasConnection
          connectionId
        }
      }
      ... on SetOrgListingPortalAllowedError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationSetOrgListingPortalAllowedMutation, IntegrationSetOrgListingPortalAllowedMutationVariables>;
export const IntegrationUpsertSklikConnectionDocument = new TypedDocumentString(`
    mutation IntegrationUpsertSklikConnection($input: UpsertSklikConnectionInput!) {
  integration {
    upsertSklikConnection(input: $input) {
      __typename
      ... on UpsertSklikConnectionSuccess {
        message
        connection {
          id
          name
          isActive
          hasCredentials
          settings
        }
      }
      ... on UpsertSklikConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationUpsertSklikConnectionMutation, IntegrationUpsertSklikConnectionMutationVariables>;
export const IntegrationTestSklikConnectionDocument = new TypedDocumentString(`
    mutation IntegrationTestSklikConnection($connectionId: ID) {
  integration {
    testSklikConnection(connectionId: $connectionId) {
      __typename
      ... on TestSklikConnectionSuccess {
        ok
        dryRun
        status
        message
        account
        credit
      }
      ... on TestSklikConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationTestSklikConnectionMutation, IntegrationTestSklikConnectionMutationVariables>;
export const IntegrationRefreshSklikStatsDocument = new TypedDocumentString(`
    mutation IntegrationRefreshSklikStats($connectionId: ID, $days: Int = 30) {
  integration {
    refreshSklikStats(connectionId: $connectionId, days: $days) {
      __typename
      ... on RefreshSklikStatsSuccess {
        message
        dateFrom
        dateTo
        impressions
        clicks
        ctr
        price
        conversions
        conversionValue
      }
      ... on RefreshSklikStatsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationRefreshSklikStatsMutation, IntegrationRefreshSklikStatsMutationVariables>;
export const IntegrationSklikStatusDocument = new TypedDocumentString(`
    query IntegrationSklikStatus {
  integration {
    sklikStatus {
      configured
      connected
      isActive
      connectionId
      name
      dryRun
      semS2sId
      conversionEventName
      retargetingListId
      autoConvertLeads
      autoRetargetLeads
      lastStats
      lastSyncedAt
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationSklikStatusQuery, IntegrationSklikStatusQueryVariables>;
export const IntegrationRunsDocument = new TypedDocumentString(`
    query IntegrationRuns($connectionId: ID!, $limit: Int! = 50, $offset: Int! = 0) {
  integration {
    runs(connectionId: $connectionId, limit: $limit, offset: $offset) {
      totalCount
      items {
        id
        connectionId
        status
        triggerType
        startedAt
        finishedAt
        recordsRead
        recordsCreated
        recordsUpdated
        recordsFailed
        errorSummary
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationRunsQuery, IntegrationRunsQueryVariables>;
export const IntegrationExportPropertyToSrealityDocument = new TypedDocumentString(`
    mutation IntegrationExportPropertyToSreality($input: ExportPropertyToSrealityInput!) {
  integration {
    exportPropertyToSreality(input: $input) {
      __typename
      ... on ExportPropertyToSrealitySuccess {
        propertyId
        status
        message
        externalListingId
        dryRun
      }
      ... on ExportPropertyToSrealityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationExportPropertyToSrealityMutation, IntegrationExportPropertyToSrealityMutationVariables>;
export const IntegrationPullSrealityInquiriesDocument = new TypedDocumentString(`
    mutation IntegrationPullSrealityInquiries($days: Int, $connectionId: ID) {
  integration {
    pullSrealityInquiries(days: $days, connectionId: $connectionId) {
      __typename
      ... on PullSrealityInquiriesSuccess {
        connections
        fetched
        created
        updated
        skipped
        errors
        days
        message
      }
      ... on PullSrealityInquiriesError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationPullSrealityInquiriesMutation, IntegrationPullSrealityInquiriesMutationVariables>;
export const IntegrationSearchAresDocument = new TypedDocumentString(`
    query IntegrationSearchAres($query: String!, $limit: Int! = 10) {
  integration {
    searchAres(query: $query, limit: $limit) {
      ico
      companyName
      legalForm
      seatAddress
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationSearchAresQuery, IntegrationSearchAresQueryVariables>;
export const IntegrationLookupAresByIcoDocument = new TypedDocumentString(`
    query IntegrationLookupAresByIco($ico: String!) {
  integration {
    lookupAresByIco(ico: $ico) {
      ico
      companyName
      dic
      legalForm
      seatAddress
      seatStreet
      seatHouseNumber
      seatOrientationNumber
      seatCity
      seatDistrict
      seatRegion
      seatPostalCode
      suggestedFirstName
      suggestedLastName
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationLookupAresByIcoQuery, IntegrationLookupAresByIcoQueryVariables>;
export const IntegrationSuggestRuianAddressDocument = new TypedDocumentString(`
    query IntegrationSuggestRuianAddress($text: String!, $limit: Int! = 10, $purpose: RuianLookupPurposeEnum) {
  integration {
    suggestRuianAddress(text: $text, limit: $limit, purpose: $purpose) {
      text
      magicKey
      ruianType
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationSuggestRuianAddressQuery, IntegrationSuggestRuianAddressQueryVariables>;
export const IntegrationResolveRuianAddressDocument = new TypedDocumentString(`
    query IntegrationResolveRuianAddress($magicKey: String!, $text: String) {
  integration {
    resolveRuianAddress(magicKey: $magicKey, text: $text) {
      addressLine
      street
      houseNumber
      orientationNumber
      city
      district
      postalCode
      countryCode
      latitude
      longitude
      ruian
      ruianLevel
      ruianType
      suggestedPropertyType
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationResolveRuianAddressQuery, IntegrationResolveRuianAddressQueryVariables>;
export const IntegrationKnHealthDocument = new TypedDocumentString(`
    query IntegrationKnHealth {
  integration {
    knHealth {
      status
      lastCheck
      dataValidAt
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnHealthQuery, IntegrationKnHealthQueryVariables>;
export const IntegrationKnAccountStatusDocument = new TypedDocumentString(`
    query IntegrationKnAccountStatus {
  integration {
    knAccountStatus {
      configured
      authenticated
      serviceId
      callCount
      callLimit
      currentPeriod
      apiKeyExpiresAt
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnAccountStatusQuery, IntegrationKnAccountStatusQueryVariables>;
export const IntegrationKnBuildingByAdresniMistoDocument = new TypedDocumentString(`
    query IntegrationKnBuildingByAdresniMisto($kod: Int!) {
  integration {
    knBuildingByAdresniMisto(kod: $kod) {
      id
      houseNumbers
      parcelIds
      unitIds
      lv {
        id
        cislo
        kuKod
        kuName
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnBuildingByAdresniMistoQuery, IntegrationKnBuildingByAdresniMistoQueryVariables>;
export const IntegrationKnBuildingByRuianDocument = new TypedDocumentString(`
    query IntegrationKnBuildingByRuian($ruian: Int!, $ruianLevel: Int! = 1) {
  integration {
    knBuildingByRuian(ruian: $ruian, ruianLevel: $ruianLevel) {
      id
      houseNumbers
      parcelIds
      unitIds
      lv {
        id
        cislo
        kuKod
        kuName
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnBuildingByRuianQuery, IntegrationKnBuildingByRuianQueryVariables>;
export const IntegrationKnSearchParcelsDocument = new TypedDocumentString(`
    query IntegrationKnSearchParcels($ku: Int!, $cislo: Int!, $druhCislovani: Int! = 2, $poddeleni: Int, $puvodZe: Int, $typParcely: String! = "PKN") {
  integration {
    knSearchParcels(
      ku: $ku
      cislo: $cislo
      druhCislovani: $druhCislovani
      poddeleni: $poddeleni
      puvodZe: $puvodZe
      typParcely: $typParcely
    ) {
      items {
        id
        parcelNumber
        parcelSubdivision
        areaM2
        buildingId
        lv {
          id
          cislo
          kuKod
          kuName
        }
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnSearchParcelsQuery, IntegrationKnSearchParcelsQueryVariables>;
export const IntegrationKnParcelByIdDocument = new TypedDocumentString(`
    query IntegrationKnParcelById($id: Int!) {
  integration {
    knParcelById(id: $id) {
      id
      parcelNumber
      parcelSubdivision
      areaM2
      buildingId
      lv {
        id
        cislo
        kuKod
        kuName
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnParcelByIdQuery, IntegrationKnParcelByIdQueryVariables>;
export const IntegrationKnSearchUnitsDocument = new TypedDocumentString(`
    query IntegrationKnSearchUnits($castObce: Int!, $cisloDomovni: Int!, $cisloJednotky: Int!, $typStavby: Int! = 1) {
  integration {
    knSearchUnits(
      castObce: $castObce
      cisloDomovni: $cisloDomovni
      cisloJednotky: $cisloJednotky
      typStavby: $typStavby
    ) {
      items {
        id
        unitNumber
        buildingId
        lv {
          id
          cislo
          kuKod
          kuName
        }
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnSearchUnitsQuery, IntegrationKnSearchUnitsQueryVariables>;
export const IntegrationKnUnitByIdDocument = new TypedDocumentString(`
    query IntegrationKnUnitById($id: Int!) {
  integration {
    knUnitById(id: $id) {
      id
      unitNumber
      buildingId
      lv {
        id
        cislo
        kuKod
        kuName
      }
      meta {
        callCount
        dataAsOf
        messages {
          code
          severity
          text
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationKnUnitByIdQuery, IntegrationKnUnitByIdQueryVariables>;
export const IntegrationLookupIsirDocument = new TypedDocumentString(`
    query IntegrationLookupIsir($input: IsirLookupInput!) {
  integration {
    lookupIsir(input: $input) {
      configured
      empty
      errorCode
      errorText
      resultCount
      syncedAt
      publicSearchUrl
      summary
      hits {
        caseRef
        status
        statusLabel
        court
        detailUrl
        ico
        firstName
        lastName
        birthDate
        city
        openedAt
        closedAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationLookupIsirQuery, IntegrationLookupIsirQueryVariables>;
export const IntegrationCeeAccountStatusDocument = new TypedDocumentString(`
    query IntegrationCeeAccountStatus {
  integration {
    ceeAccountStatus {
      configured
      enabled
      provider
      publicUrl
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCeeAccountStatusQuery, IntegrationCeeAccountStatusQueryVariables>;
export const IntegrationLookupCeeByIcoDocument = new TypedDocumentString(`
    query IntegrationLookupCeeByIco($ico: String!) {
  integration {
    lookupCeeByIco(ico: $ico) {
      configured
      empty
      hitCount
      summary
      detailUrl
      errorText
      publicUrl
      creditsCharged
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationLookupCeeByIcoQuery, IntegrationLookupCeeByIcoQueryVariables>;
export const IntegrationWsdpAccountStatusDocument = new TypedDocumentString(`
    query IntegrationWsdpAccountStatus {
  integration {
    wsdpAccountStatus {
      configured
      enabled
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationWsdpAccountStatusQuery, IntegrationWsdpAccountStatusQueryVariables>;
export const IntegrationFetchKnLvExcerptDocument = new TypedDocumentString(`
    mutation IntegrationFetchKnLvExcerpt($input: FetchKnLvExcerptInput!) {
  integration {
    fetchKnLvExcerpt(input: $input) {
      __typename
      ... on FetchKnLvExcerptSuccess {
        message
        result {
          configured
          success
          errorText
          reportId
          kuKod
          lvCislo
          lvId
          creditsCharged
          documentId
        }
      }
      ... on FetchKnLvExcerptError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationFetchKnLvExcerptMutation, IntegrationFetchKnLvExcerptMutationVariables>;
export const IntegrationLookupCeeByIcoPaidDocument = new TypedDocumentString(`
    mutation IntegrationLookupCeeByIcoPaid($ico: String!, $idempotencyKey: String) {
  integration {
    lookupCeeByIcoPaid(ico: $ico, idempotencyKey: $idempotencyKey) {
      __typename
      ... on LookupCeeByIcoPaidSuccess {
        message
        result {
          configured
          empty
          hitCount
          summary
          detailUrl
          errorText
          publicUrl
          creditsCharged
        }
      }
      ... on LookupCeeByIcoPaidError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationLookupCeeByIcoPaidMutation, IntegrationLookupCeeByIcoPaidMutationVariables>;
export const IntegrationMetaStatusDocument = new TypedDocumentString(`
    query IntegrationMetaStatus {
  integration {
    metaStatus {
      configured
      connected
      stub
      setupComplete
      pendingPageSelection
      connectionId
      pageId
      pageName
      igUserId
      igUsername
      message
      availablePages {
        id
        name
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationMetaStatusQuery, IntegrationMetaStatusQueryVariables>;
export const IntegrationConnectMetaDocument = new TypedDocumentString(`
    mutation IntegrationConnectMeta($returnTo: String) {
  integration {
    connectMeta(returnTo: $returnTo) {
      __typename
      ... on ConnectMetaSuccess {
        message
        oauthStart {
          provider
          authorizationUrl
          stub
        }
      }
      ... on ConnectMetaError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationConnectMetaMutation, IntegrationConnectMetaMutationVariables>;
export const IntegrationCompleteMetaSetupDocument = new TypedDocumentString(`
    mutation IntegrationCompleteMetaSetup($input: CompleteMetaSetupInput!) {
  integration {
    completeMetaSetup(input: $input) {
      __typename
      ... on CompleteMetaSetupSuccess {
        message
        connection {
          id
          name
          provider
          isActive
          settings
        }
      }
      ... on CompleteMetaSetupError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCompleteMetaSetupMutation, IntegrationCompleteMetaSetupMutationVariables>;
export const IntegrationGoogleBusinessStatusDocument = new TypedDocumentString(`
    query IntegrationGoogleBusinessStatus {
  integration {
    googleBusinessStatus {
      configured
      connected
      stub
      connectionId
      accountId
      locationId
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationGoogleBusinessStatusQuery, IntegrationGoogleBusinessStatusQueryVariables>;
export const IntegrationGoogleAdsStatusDocument = new TypedDocumentString(`
    query IntegrationGoogleAdsStatus {
  integration {
    googleAdsStatus {
      configured
      connected
      customerId
      connectionId
      message
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationGoogleAdsStatusQuery, IntegrationGoogleAdsStatusQueryVariables>;
export const IntegrationGoogleBusinessAccountsDocument = new TypedDocumentString(`
    query IntegrationGoogleBusinessAccounts {
  integration {
    googleBusinessAccounts {
      name
      accountName
      type
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationGoogleBusinessAccountsQuery, IntegrationGoogleBusinessAccountsQueryVariables>;
export const IntegrationGoogleBusinessLocationsDocument = new TypedDocumentString(`
    query IntegrationGoogleBusinessLocations($accountName: String!) {
  integration {
    googleBusinessLocations(accountName: $accountName) {
      name
      title
      address
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationGoogleBusinessLocationsQuery, IntegrationGoogleBusinessLocationsQueryVariables>;
export const IntegrationConnectGoogleBusinessDocument = new TypedDocumentString(`
    mutation IntegrationConnectGoogleBusiness($returnTo: String) {
  integration {
    connectGoogleBusiness(returnTo: $returnTo) {
      __typename
      ... on ConnectGoogleBusinessSuccess {
        message
        oauthStart {
          authorizationUrl
          stub
        }
      }
      ... on ConnectGoogleBusinessError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationConnectGoogleBusinessMutation, IntegrationConnectGoogleBusinessMutationVariables>;
export const IntegrationSelectGoogleBusinessLocationDocument = new TypedDocumentString(`
    mutation IntegrationSelectGoogleBusinessLocation($input: SelectGoogleBusinessLocationInput!) {
  integration {
    selectGoogleBusinessLocation(input: $input) {
      __typename
      ... on SelectGoogleBusinessLocationSuccess {
        message
        connection {
          id
          settings
          isActive
        }
      }
      ... on SelectGoogleBusinessLocationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationSelectGoogleBusinessLocationMutation, IntegrationSelectGoogleBusinessLocationMutationVariables>;
export const IntegrationCreateGoogleBusinessPostDocument = new TypedDocumentString(`
    mutation IntegrationCreateGoogleBusinessPost($input: CreateGoogleBusinessPostInput!) {
  integration {
    createGoogleBusinessPost(input: $input) {
      __typename
      ... on CreateGoogleBusinessPostSuccess {
        message
        name
        searchUrl
        state
      }
      ... on CreateGoogleBusinessPostError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCreateGoogleBusinessPostMutation, IntegrationCreateGoogleBusinessPostMutationVariables>;
export const IntegrationUpsertGoogleAdsConnectionDocument = new TypedDocumentString(`
    mutation IntegrationUpsertGoogleAdsConnection($input: UpsertGoogleAdsConnectionInput!) {
  integration {
    upsertGoogleAdsConnection(input: $input) {
      __typename
      ... on UpsertGoogleAdsConnectionSuccess {
        message
        connection {
          id
          name
          provider
          isActive
          settings
          hasCredentials
        }
      }
      ... on UpsertGoogleAdsConnectionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationUpsertGoogleAdsConnectionMutation, IntegrationUpsertGoogleAdsConnectionMutationVariables>;
export const IntegrationLustraceHistoryDocument = new TypedDocumentString(`
    query IntegrationLustraceHistory($clientId: ID, $registry: LustraceRegistryEnum, $limit: Int = 50, $offset: Int = 0) {
  integration {
    lustraceHistory(
      clientId: $clientId
      registry: $registry
      limit: $limit
      offset: $offset
    ) {
      id
      registry
      resultSummary
      hitCount
      query
      clientId
      propertyId
      actorId
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationLustraceHistoryQuery, IntegrationLustraceHistoryQueryVariables>;
export const IntegrationImportTokensDocument = new TypedDocumentString(`
    query IntegrationImportTokens($includeRevoked: Boolean! = false) {
  integration {
    importTokens(includeRevoked: $includeRevoked) {
      id
      name
      tokenPrefix
      createdById
      expiresAt
      revokedAt
      lastUsedAt
      notes
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationImportTokensQuery, IntegrationImportTokensQueryVariables>;
export const IntegrationCreateImportTokenDocument = new TypedDocumentString(`
    mutation IntegrationCreateImportToken($input: CreateImportTokenInput!) {
  integration {
    createImportToken(input: $input) {
      __typename
      ... on CreateImportTokenSuccess {
        message
        token
        record {
          id
          name
          tokenPrefix
          createdById
          expiresAt
          revokedAt
          lastUsedAt
          notes
          createdAt
        }
      }
      ... on CreateImportTokenError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationCreateImportTokenMutation, IntegrationCreateImportTokenMutationVariables>;
export const IntegrationRevokeImportTokenDocument = new TypedDocumentString(`
    mutation IntegrationRevokeImportToken($tokenId: ID!) {
  integration {
    revokeImportToken(tokenId: $tokenId) {
      __typename
      ... on RevokeImportTokenSuccess {
        message
        record {
          id
          name
          tokenPrefix
          revokedAt
        }
      }
      ... on RevokeImportTokenError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<IntegrationRevokeImportTokenMutation, IntegrationRevokeImportTokenMutationVariables>;
export const LeadListDocument = new TypedDocumentString(`
    query LeadList($limit: Int, $offset: Int, $filters: LeadFilter, $order: LeadOrder) {
  lead {
    list(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        status
        source
        firstName
        lastName
        email
        phone
        message
        propertyId
        assignedAgentId
        score
        createdAt
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<LeadListQuery, LeadListQueryVariables>;
export const LeadNodeDocument = new TypedDocumentString(`
    query LeadNode($id: ID!) {
  lead {
    node(id: $id) {
      id
      status
      source
      sourceLabel
      firstName
      lastName
      email
      phone
      message
      notes
      clientId
      propertyId
      assignedAgentId
      convertedClientId
      campaignId
      campaignName
      utmSource
      utmMedium
      utmCampaign
      externalId
      extra
      score
      qualifiedAt
      convertedAt
      lostReason
    }
  }
}
    `) as unknown as TypedDocumentString<LeadNodeQuery, LeadNodeQueryVariables>;
export const LeadCreateDocument = new TypedDocumentString(`
    mutation LeadCreate($input: CreateLeadInput!) {
  lead {
    create(input: $input) {
      __typename
      ... on CreateLeadSuccess {
        message
        lead {
          id
        }
      }
      ... on CreateLeadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LeadCreateMutation, LeadCreateMutationVariables>;
export const LeadUpdateDocument = new TypedDocumentString(`
    mutation LeadUpdate($input: UpdateLeadInput!) {
  lead {
    update(input: $input) {
      __typename
      ... on UpdateLeadSuccess {
        message
        lead {
          id
          status
          convertedClientId
          convertedAt
          clientId
          assignedAgentId
        }
      }
      ... on UpdateLeadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LeadUpdateMutation, LeadUpdateMutationVariables>;
export const LeadAssignDocument = new TypedDocumentString(`
    mutation LeadAssign($input: AssignLeadInput!) {
  lead {
    assign(input: $input) {
      __typename
      ... on AssignLeadSuccess {
        message
        lead {
          id
          assignedAgentId
        }
      }
      ... on AssignLeadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LeadAssignMutation, LeadAssignMutationVariables>;
export const LeadDeleteDocument = new TypedDocumentString(`
    mutation LeadDelete($id: ID!) {
  lead {
    delete(id: $id) {
      __typename
      ... on DeleteLeadSuccess {
        message
        success
      }
      ... on DeleteLeadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<LeadDeleteMutation, LeadDeleteMutationVariables>;
export const EntityPickerLeadsDocument = new TypedDocumentString(`
    query EntityPickerLeads($query: String, $limit: Int = 20) {
  lead {
    list(
      limit: $limit
      offset: 0
      filters: { nameSearch: $query }
      order: { updatedAt: DESC }
    ) {
      items {
        id
        firstName
        lastName
        email
        phone
        status
        source
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EntityPickerLeadsQuery, EntityPickerLeadsQueryVariables>;
export const ListingProjectListDocument = new TypedDocumentString(`
    query ListingProjectList($limit: Int, $offset: Int) {
  listingProject {
    list(limit: $limit, offset: $offset) {
      items {
        id
        name
        annotation
        description
        localityDescription
        localityCity
        localityStreet
        localityCitypart
        localityCp
        localityCo
        localityRuian
        localityRuianLevel
        latitude
        longitude
        developerIc
        projectRkid
        projectUrl
        projectMatterportUrl
        projectLifetime
        projectActive
        srealityProjectId
        lastSyncedAt
        lastSyncError
        syncStatus
        createdAt
        updatedAt
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectListQuery, ListingProjectListQueryVariables>;
export const ListingProjectNodeDocument = new TypedDocumentString(`
    query ListingProjectNode($id: ID!) {
  listingProject {
    node(id: $id) {
      id
      name
      annotation
      description
      localityDescription
      localityCity
      localityStreet
      localityCitypart
      localityCp
      localityCo
      localityRuian
      localityRuianLevel
      latitude
      longitude
      developerIc
      projectRkid
      projectUrl
      projectMatterportUrl
      projectLifetime
      projectActive
      srealityProjectId
      lastSyncedAt
      lastSyncError
      syncStatus
      createdAt
      updatedAt
      images {
        id
        position
        caption
        uploadStatus
        contentType
        bytesSize
        originalUrl
        photoRkid
        excludeFromPortalExport
      }
      videos {
        id
        position
        caption
        description
        uploadStatus
        contentType
        bytesSize
        originalUrl
        videoRkid
        excludeFromPortalExport
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectNodeQuery, ListingProjectNodeQueryVariables>;
export const ListingProjectCreateDocument = new TypedDocumentString(`
    mutation ListingProjectCreate($input: CreateListingProjectInput!) {
  listingProject {
    create(input: $input) {
      __typename
      ... on CreateListingProjectSuccess {
        message
        listingProject {
          id
          name
          projectRkid
          developerIc
          localityCity
          projectLifetime
          projectActive
          srealityProjectId
        }
      }
      ... on CreateListingProjectError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectCreateMutation, ListingProjectCreateMutationVariables>;
export const ListingProjectUpdateDocument = new TypedDocumentString(`
    mutation ListingProjectUpdate($input: UpdateListingProjectInput!) {
  listingProject {
    update(input: $input) {
      __typename
      ... on UpdateListingProjectSuccess {
        message
        listingProject {
          id
          name
          projectRkid
          developerIc
          localityCity
          projectLifetime
          projectActive
          srealityProjectId
          lastSyncedAt
          lastSyncError
          syncStatus
        }
      }
      ... on UpdateListingProjectError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectUpdateMutation, ListingProjectUpdateMutationVariables>;
export const ListingProjectDeleteDocument = new TypedDocumentString(`
    mutation ListingProjectDelete($id: ID!) {
  listingProject {
    delete(id: $id) {
      __typename
      ... on DeleteListingProjectSuccess {
        message
        success
      }
      ... on DeleteListingProjectError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectDeleteMutation, ListingProjectDeleteMutationVariables>;
export const ListingProjectSyncToSrealityDocument = new TypedDocumentString(`
    mutation ListingProjectSyncToSreality($id: ID!) {
  listingProject {
    syncToSreality(id: $id) {
      __typename
      ... on SyncListingProjectToSrealitySuccess {
        message
        listingProject {
          id
          srealityProjectId
          lastSyncedAt
          lastSyncError
          syncStatus
          projectRkid
        }
      }
      ... on SyncListingProjectToSrealityError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectSyncToSrealityMutation, ListingProjectSyncToSrealityMutationVariables>;
export const ListingProjectCreateImageUploadIntentDocument = new TypedDocumentString(`
    mutation ListingProjectCreateImageUploadIntent($listingProjectId: ID!, $contentType: String!, $caption: String, $position: Int, $sizeBytes: Int) {
  listingProject {
    createImageUploadIntent(
      listingProjectId: $listingProjectId
      contentType: $contentType
      caption: $caption
      position: $position
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateListingProjectImageUploadIntentSuccess {
        message
        image {
          id
          uploadStatus
          position
        }
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreateListingProjectImageUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectCreateImageUploadIntentMutation, ListingProjectCreateImageUploadIntentMutationVariables>;
export const ListingProjectFinalizeImageUploadDocument = new TypedDocumentString(`
    mutation ListingProjectFinalizeImageUpload($imageId: ID!) {
  listingProject {
    finalizeImageUpload(imageId: $imageId) {
      __typename
      ... on FinalizeListingProjectImageUploadSuccess {
        message
        image {
          id
          uploadStatus
          originalUrl
        }
      }
      ... on FinalizeListingProjectImageUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectFinalizeImageUploadMutation, ListingProjectFinalizeImageUploadMutationVariables>;
export const ListingProjectDeleteImageDocument = new TypedDocumentString(`
    mutation ListingProjectDeleteImage($imageId: ID!) {
  listingProject {
    deleteImage(imageId: $imageId) {
      __typename
      ... on DeleteListingProjectImageSuccess {
        message
        success
      }
      ... on DeleteListingProjectImageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectDeleteImageMutation, ListingProjectDeleteImageMutationVariables>;
export const ListingProjectCreateVideoUploadIntentDocument = new TypedDocumentString(`
    mutation ListingProjectCreateVideoUploadIntent($listingProjectId: ID!, $contentType: String!, $caption: String, $description: String, $position: Int, $sizeBytes: Int) {
  listingProject {
    createVideoUploadIntent(
      listingProjectId: $listingProjectId
      contentType: $contentType
      caption: $caption
      description: $description
      position: $position
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreateListingProjectVideoUploadIntentSuccess {
        message
        video {
          id
          uploadStatus
          position
        }
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreateListingProjectVideoUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectCreateVideoUploadIntentMutation, ListingProjectCreateVideoUploadIntentMutationVariables>;
export const ListingProjectFinalizeVideoUploadDocument = new TypedDocumentString(`
    mutation ListingProjectFinalizeVideoUpload($videoId: ID!) {
  listingProject {
    finalizeVideoUpload(videoId: $videoId) {
      __typename
      ... on FinalizeListingProjectVideoUploadSuccess {
        message
        video {
          id
          uploadStatus
          originalUrl
        }
      }
      ... on FinalizeListingProjectVideoUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectFinalizeVideoUploadMutation, ListingProjectFinalizeVideoUploadMutationVariables>;
export const ListingProjectDeleteVideoDocument = new TypedDocumentString(`
    mutation ListingProjectDeleteVideo($videoId: ID!) {
  listingProject {
    deleteVideo(videoId: $videoId) {
      __typename
      ... on DeleteListingProjectVideoSuccess {
        message
        success
      }
      ... on DeleteListingProjectVideoError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ListingProjectDeleteVideoMutation, ListingProjectDeleteVideoMutationVariables>;
export const NotificationInboxDocument = new TypedDocumentString(`
    query NotificationInbox($unreadOnly: Boolean! = false, $limit: Int! = 50, $offset: Int! = 0) {
  notification {
    inbox(unreadOnly: $unreadOnly, limit: $limit, offset: $offset) {
      totalCount
      items {
        id
        type
        title
        body
        entityType
        entityId
        readAt
        createdAt
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NotificationInboxQuery, NotificationInboxQueryVariables>;
export const NotificationUnreadCountDocument = new TypedDocumentString(`
    query NotificationUnreadCount {
  notification {
    unreadCount
  }
}
    `) as unknown as TypedDocumentString<NotificationUnreadCountQuery, NotificationUnreadCountQueryVariables>;
export const NotificationMarkReadDocument = new TypedDocumentString(`
    mutation NotificationMarkRead($id: ID!) {
  notification {
    markRead(id: $id) {
      __typename
      ... on MarkNotificationReadSuccess {
        message
        notification {
          id
          readAt
        }
      }
      ... on MarkNotificationReadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NotificationMarkReadMutation, NotificationMarkReadMutationVariables>;
export const NotificationMarkAllReadDocument = new TypedDocumentString(`
    mutation NotificationMarkAllRead {
  notification {
    markAllRead {
      __typename
      ... on MarkAllNotificationsReadSuccess {
        message
      }
      ... on MarkAllNotificationsReadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<NotificationMarkAllReadMutation, NotificationMarkAllReadMutationVariables>;
export const DealCreatePaymentDocument = new TypedDocumentString(`
    mutation DealCreatePayment($input: CreatePaymentInput!) {
  deal {
    createPayment(input: $input) {
      __typename
      ... on CreateDealPaymentSuccess {
        message
        payment {
          id
          type
          amount
          currency
          dueAt
          paidAt
          status
          payerClientId
          payeeUserId
          dealId
          propertyId
          variableSymbol
          documentId
        }
      }
      ... on CreateDealPaymentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealCreatePaymentMutation, DealCreatePaymentMutationVariables>;
export const DealUpdatePaymentDocument = new TypedDocumentString(`
    mutation DealUpdatePayment($input: UpdatePaymentInput!) {
  deal {
    updatePayment(input: $input) {
      __typename
      ... on UpdateDealPaymentSuccess {
        message
        payment {
          id
          type
          amount
          currency
          dueAt
          paidAt
          status
          payerClientId
          payeeUserId
          dealId
          propertyId
          variableSymbol
          documentId
        }
      }
      ... on UpdateDealPaymentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealUpdatePaymentMutation, DealUpdatePaymentMutationVariables>;
export const DealSettlePaymentDocument = new TypedDocumentString(`
    mutation DealSettlePayment($id: ID!) {
  deal {
    settlePayment(id: $id) {
      __typename
      ... on SettleDealPaymentSuccess {
        message
        payment {
          id
          status
          paidAt
        }
      }
      ... on SettleDealPaymentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealSettlePaymentMutation, DealSettlePaymentMutationVariables>;
export const DealDeletePaymentDocument = new TypedDocumentString(`
    mutation DealDeletePayment($id: ID!) {
  deal {
    deletePayment(id: $id) {
      __typename
      ... on DeleteDealPaymentSuccess {
        message
        success
      }
      ... on DeleteDealPaymentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<DealDeletePaymentMutation, DealDeletePaymentMutationVariables>;
export const PortalMeDocument = new TypedDocumentString(`
    query PortalMe {
  portal {
    me {
      id
      loginEmail
      firstName
      lastName
      selectedOrganizationId
      selectedClientId
    }
  }
}
    `) as unknown as TypedDocumentString<PortalMeQuery, PortalMeQueryVariables>;
export const PortalOrganizationsDocument = new TypedDocumentString(`
    query PortalOrganizations {
  portal {
    organizations {
      clientId
      organizationId
      organizationName
      organizationSlug
    }
  }
}
    `) as unknown as TypedDocumentString<PortalOrganizationsQuery, PortalOrganizationsQueryVariables>;
export const PortalLoginDocument = new TypedDocumentString(`
    mutation PortalLogin($email: String!, $password: String!) {
  portal {
    login(email: $email, password: $password) {
      __typename
      ... on PortalLoginSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on PortalLoginError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PortalLoginMutation, PortalLoginMutationVariables>;
export const PortalRefreshDocument = new TypedDocumentString(`
    mutation PortalRefresh($refreshToken: String!) {
  portal {
    refresh(refreshToken: $refreshToken) {
      __typename
      ... on PortalRefreshSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on PortalRefreshError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PortalRefreshMutation, PortalRefreshMutationVariables>;
export const PortalLogoutDocument = new TypedDocumentString(`
    mutation PortalLogout($refreshToken: String, $allSessions: Boolean) {
  portal {
    logout(refreshToken: $refreshToken, allSessions: $allSessions) {
      __typename
      ... on PortalLogoutSuccess {
        message
        success
      }
      ... on PortalLogoutError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PortalLogoutMutation, PortalLogoutMutationVariables>;
export const PortalAcceptInviteDocument = new TypedDocumentString(`
    mutation PortalAcceptInvite($token: String!, $password: String!) {
  portal {
    acceptInvite(token: $token, password: $password) {
      __typename
      ... on PortalAcceptInviteSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on PortalAcceptInviteError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PortalAcceptInviteMutation, PortalAcceptInviteMutationVariables>;
export const PortalSelectOrganizationDocument = new TypedDocumentString(`
    mutation PortalSelectOrganization($organizationId: ID!) {
  portal {
    selectOrganization(organizationId: $organizationId) {
      __typename
      ... on PortalSelectOrganizationSuccess {
        message
        accessToken
        refreshToken
        accessExpiresAt
        refreshExpiresAt
        mustResetPassword
      }
      ... on PortalSelectOrganizationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PortalSelectOrganizationMutation, PortalSelectOrganizationMutationVariables>;
export const ClientInvitePortalAccessDocument = new TypedDocumentString(`
    mutation ClientInvitePortalAccess($clientId: ID!, $loginEmail: String) {
  client {
    invitePortalAccess(clientId: $clientId, loginEmail: $loginEmail) {
      __typename
      ... on InvitePortalAccessSuccess {
        message
        inviteUrl
        inviteEmailSent
        portalAccountId
        client {
          id
          portalAccountId
        }
      }
      ... on InvitePortalAccessError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientInvitePortalAccessMutation, ClientInvitePortalAccessMutationVariables>;
export const ClientRevokePortalAccessDocument = new TypedDocumentString(`
    mutation ClientRevokePortalAccess($clientId: ID!) {
  client {
    revokePortalAccess(clientId: $clientId) {
      __typename
      ... on RevokePortalAccessSuccess {
        message
        client {
          id
          portalAccountId
        }
      }
      ... on RevokePortalAccessError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ClientRevokePortalAccessMutation, ClientRevokePortalAccessMutationVariables>;
export const PropertyListDocument = new TypedDocumentString(`
    query PropertyList($limit: Int, $offset: Int, $filters: PropertyFilter, $order: PropertyOrder) {
  property {
    list(limit: $limit, offset: $offset, filters: $filters, order: $order) {
      items {
        id
        title
        localizedTitle
        listingCode
        propertyType
        category
        status
        price
        rentPrice
        priceUnit
        currency
        layout
        usableArea
        isPublished
        webVisibility
        locationPrivacy
        assignedAgentId
        createdAt
        updatedAt
        location {
          street
          city
          district
          addressLine
          latitude
          longitude
          ruian
          ruianLevel
        }
        marketDetails {
          listingCode
          priceOnRequest
        }
        coverThumbUrl
        coverDisplayUrl
        catalogCard {
          documentId
          originalName
          locale
          generatedAt
          downloadUrl
        }
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyListQuery, PropertyListQueryVariables>;
export const PropertyNodeDocument = new TypedDocumentString(`
    query PropertyNode($id: ID!) {
  property {
    node(id: $id) {
      id
      title
      localizedTitle
      listingCode
      description
      localizedDescription
      marketingText
      localizedMarketingText
      propertyType
      category
      status
      price
      rentPrice
      currency
      priceNotes
      localizedPriceNotes
      priceUnit
      roomCount
      ownershipType
      layout
      usableArea
      floorArea
      lotSize
      balconyArea
      terraceArea
      loggiaArea
      cellarArea
      gardenArea
      basinArea
      buildingArea
      ceilingHeight
      floor
      totalFloors
      undergroundFloors
      yearBuilt
      acceptanceYear
      reconstructionYear
      apartmentNumber
      parkingCount
      garageCount
      buildingType
      objectType
      availableFrom
      occupiedUntil
      contractValidUntil
      energyClass
      condition
      hasBalcony
      hasTerrace
      hasLoggia
      hasParking
      hasGarage
      hasCellar
      hasElevator
      hasBasin
      furnished
      seoTitle
      seoDescription
      seoKeywords
      localizedSeoTitle
      localizedSeoDescription
      localizedSeoKeywords
      isPublished
      publishedAt
      unpublishedAt
      webVisibility
      locationPrivacy
      exportToPortals
      internalNotes
      aiLocaleMeta
      assignedAgentId
      ownerContactId
      coverThumbUrl
      coverDisplayUrl
      location {
        addressLine
        city
        district
        region
        postalCode
        countryCode
        latitude
        longitude
        street
        houseNumber
        orientationNumber
        ruian
        ruianLevel
        lvCislo
        kuKod
        knLvId
        knBuildingId
      }
      marketDetails {
        listingCode
        projectRkid
        matterportUrl
        mapyPanoramaUrl
        priceNegotiable
        priceOnRequest
        priceHidden
        exclusiveListing
        listingExtraInfo
        lowEnergy
        mortgage
        mortgagePercent
        commission
        solarPanels
        ftvPanels
        annuity
        beginningDate
        bidding
        circuitBreaker
        costOfLiving
        easyAccess
        electricity
        energyPerformanceCertificate
        energyPerformanceSummary
        finishDate
        firstTourDate
        firstTourDateTo
        flatClass
        gas
        gully
        heatingElement
        heatingSource
        internetConnectionProvider
        internetConnectionSpeed
        internetConnectionType
        neighbourhoodPresence
        noliveTotalArea
        numOwners
        objectKind
        objectLocation
        officesArea
        personal
        phaseDistributions
        priceAuctionPrincipal
        priceExpertReport
        priceMinimumBid
        productionArea
        protection
        refundableDeposit
        roadType
        saleDate
        shopArea
        sporPercent
        steps
        storeArea
        surroundingsType
        telecommunication
        tenantNotPayCommission
        transport
        water
        waterHeatSource
        wellType
        workshopArea
        auctionKind
        auctionDate
        auctionPlace
        auctionDateTour
        auctionDateTour2
        extraAttributes
      }
      images {
        id
        position
        isMain
        caption
        roomType
        uploadStatus
        uploadError
        originalUrl
        thumbUrl
        displayUrl
        sourceImageId
        variantKind
        excludeFromPortalExport
      }
      videos {
        id
        position
        caption
        description
        uploadStatus
        uploadError
        originalUrl
        posterUrl
        bytesSize
        contentType
        durationSeconds
        excludeFromPortalExport
        videoRkid
      }
      contracts {
        id
        title
        contractType
        status
        contractNumber
        counterpartyName
        counterpartyContactId
        primaryDocumentId
        assignedAgentId
        validFrom
        validUntil
        signedAt
        terminatedAt
        notes
        createdAt
        updatedAt
      }
      parties {
        id
        role
        displayName
        clientId
        ownershipSharePercent
        position
        notes
        createdAt
        updatedAt
      }
      links {
        id
        type
        url
        label
        position
        createdAt
        updatedAt
      }
      portalExports {
        id
        provider
        isEnabled
        status
        externalListingId
        lastExportedAt
        lastError
        publicationStatus
        lastVerifiedAt
        lastVerificationError
        bumpEnabled
        bumpDays
        bumpAfterHour
        bumpPriority
        bumpLastAttemptAt
        bumpLastOutcome
        bumpLastMessage
        createdAt
        updatedAt
      }
      allowedPortalProviders
      socialPostImage {
        propertyId
        queued
        documentId
        originalName
        locale
        templateId
        generatedAt
        sizeBytes
        downloadUrl
      }
      demandMatches(limit: 20) {
        id
        requirementId
        clientId
        propertyId
        score
        reasons
        reasonLabels
        taskId
        createdAt
        property {
          id
          localizedTitle
          listingCode
          price
          rentPrice
          currency
          category
          layout
          usableArea
          coverThumbUrl
          location {
            city
            district
            addressLine
          }
        }
      }
      messages(limit: 50) {
        id
        status
        provider
        senderName
        senderEmail
        senderPhone
        body
        receivedAt
        readAt
        propertyId
        leadId
        assignedAgentId
      }
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyNodeQuery, PropertyNodeQueryVariables>;
export const EntityPickerPropertiesDocument = new TypedDocumentString(`
    query EntityPickerProperties($query: String, $limit: Int = 20) {
  property {
    list(
      limit: $limit
      offset: 0
      filters: { titleSearch: $query }
      order: { updatedAt: DESC }
    ) {
      items {
        id
        localizedTitle
        listingCode
        price
        rentPrice
        currency
        category
        layout
        coverThumbUrl
        location {
          city
          district
          addressLine
        }
        marketDetails {
          listingCode
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EntityPickerPropertiesQuery, EntityPickerPropertiesQueryVariables>;
export const PropertyAllowedPortalProvidersDocument = new TypedDocumentString(`
    query PropertyAllowedPortalProviders($category: PropertyCategoryEnum!) {
  property {
    allowedPortalProviders(category: $category)
  }
}
    `) as unknown as TypedDocumentString<PropertyAllowedPortalProvidersQuery, PropertyAllowedPortalProvidersQueryVariables>;
export const PropertySrealityAttributeCatalogDocument = new TypedDocumentString(`
    query PropertySrealityAttributeCatalog {
  property {
    srealityAttributeCatalog
  }
}
    `) as unknown as TypedDocumentString<PropertySrealityAttributeCatalogQuery, PropertySrealityAttributeCatalogQueryVariables>;
export const PropertyPortalPublicationEventsDocument = new TypedDocumentString(`
    query PropertyPortalPublicationEvents($propertyId: ID!, $limit: Int = 50) {
  property {
    portalPublicationEvents(propertyId: $propertyId, limit: $limit) {
      id
      propertyId
      provider
      kind
      success
      mismatchType
      payload
      actorId
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPortalPublicationEventsQuery, PropertyPortalPublicationEventsQueryVariables>;
export const PropertyPortalSyncHealthDocument = new TypedDocumentString(`
    query PropertyPortalSyncHealth($propertyId: ID!) {
  property {
    portalSyncHealth(propertyId: $propertyId) {
      propertyId
      provider
      isEnabled
      crmExpectsLive
      crmReason
      publicationStatus
      exportStatus
      externalListingId
      lastExportedAt
      lastVerifiedAt
      mismatch
      mismatchDetectedAt
      inSync
      verificationSupported
      verificationCapability
      lastVerificationError
      lastError
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPortalSyncHealthQuery, PropertyPortalSyncHealthQueryVariables>;
export const PropertyPortalSyncOverviewDocument = new TypedDocumentString(`
    query PropertyPortalSyncOverview($mismatchesOnly: Boolean = true, $limit: Int = 100) {
  property {
    portalSyncOverview(mismatchesOnly: $mismatchesOnly, limit: $limit) {
      propertyId
      provider
      isEnabled
      crmExpectsLive
      crmReason
      publicationStatus
      exportStatus
      externalListingId
      lastExportedAt
      lastVerifiedAt
      mismatch
      mismatchDetectedAt
      inSync
      verificationSupported
      verificationCapability
      lastVerificationError
      lastError
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPortalSyncOverviewQuery, PropertyPortalSyncOverviewQueryVariables>;
export const PropertyImagesDocument = new TypedDocumentString(`
    query PropertyImages($id: ID!) {
  property {
    node(id: $id) {
      id
      images {
        id
        position
        isMain
        caption
        roomType
        uploadStatus
        uploadError
        originalUrl
        thumbUrl
        displayUrl
        sourceImageId
        variantKind
        excludeFromPortalExport
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyImagesQuery, PropertyImagesQueryVariables>;
export const PropertyCreateDocument = new TypedDocumentString(`
    mutation PropertyCreate($input: CreatePropertyInput!) {
  property {
    create(input: $input) {
      __typename
      ... on CreatePropertySuccess {
        message
        property {
          id
        }
      }
      ... on CreatePropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreateMutation, PropertyCreateMutationVariables>;
export const PropertyUpdateDocument = new TypedDocumentString(`
    mutation PropertyUpdate($input: UpdatePropertyInput!) {
  property {
    update(input: $input) {
      __typename
      ... on UpdatePropertySuccess {
        message
        property {
          id
        }
      }
      ... on UpdatePropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdateMutation, PropertyUpdateMutationVariables>;
export const PropertyPublishDocument = new TypedDocumentString(`
    mutation PropertyPublish($id: ID!) {
  property {
    publish(id: $id) {
      __typename
      ... on PublishPropertySuccess {
        message
        property {
          id
          isPublished
        }
      }
      ... on PublishPropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPublishMutation, PropertyPublishMutationVariables>;
export const PropertyUnpublishDocument = new TypedDocumentString(`
    mutation PropertyUnpublish($id: ID!) {
  property {
    unpublish(id: $id) {
      __typename
      ... on UnpublishPropertySuccess {
        message
        property {
          id
          isPublished
        }
      }
      ... on UnpublishPropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUnpublishMutation, PropertyUnpublishMutationVariables>;
export const PropertyDeleteDocument = new TypedDocumentString(`
    mutation PropertyDelete($id: ID!) {
  property {
    delete(id: $id) {
      __typename
      ... on DeletePropertySuccess {
        message
        success
      }
      ... on DeletePropertyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeleteMutation, PropertyDeleteMutationVariables>;
export const PropertyRunDemandMatchingDocument = new TypedDocumentString(`
    mutation PropertyRunDemandMatching($id: ID!) {
  property {
    runDemandMatching(id: $id) {
      __typename
      ... on RunPropertyDemandMatchingSuccess {
        message
        created
        updated
        tasksCreated
        staleRemoved
        matches {
          id
          propertyId
          requirementId
          clientId
          score
          reasons
          taskId
        }
      }
      ... on RunPropertyDemandMatchingError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyRunDemandMatchingMutation, PropertyRunDemandMatchingMutationVariables>;
export const PropertyCreateImageUploadIntentDocument = new TypedDocumentString(`
    mutation PropertyCreateImageUploadIntent($propertyId: ID!, $contentType: String!, $caption: String, $position: Int, $sizeBytes: Int) {
  property {
    createImageUploadIntent(
      propertyId: $propertyId
      contentType: $contentType
      caption: $caption
      position: $position
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreatePropertyImageUploadIntentSuccess {
        message
        image {
          id
          uploadStatus
          position
          isMain
        }
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreatePropertyImageUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreateImageUploadIntentMutation, PropertyCreateImageUploadIntentMutationVariables>;
export const PropertyFinalizeImageUploadDocument = new TypedDocumentString(`
    mutation PropertyFinalizeImageUpload($imageId: ID!) {
  property {
    finalizeImageUpload(imageId: $imageId) {
      __typename
      ... on FinalizePropertyImageUploadSuccess {
        message
        image {
          id
          uploadStatus
          uploadError
        }
      }
      ... on FinalizePropertyImageUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyFinalizeImageUploadMutation, PropertyFinalizeImageUploadMutationVariables>;
export const PropertyAbortImageUploadDocument = new TypedDocumentString(`
    mutation PropertyAbortImageUpload($imageId: ID!) {
  property {
    abortImageUpload(imageId: $imageId) {
      __typename
      ... on AbortPropertyImageUploadSuccess {
        message
        success
      }
      ... on AbortPropertyImageUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyAbortImageUploadMutation, PropertyAbortImageUploadMutationVariables>;
export const PropertyVideosDocument = new TypedDocumentString(`
    query PropertyVideos($id: ID!) {
  property {
    node(id: $id) {
      id
      videos {
        id
        position
        caption
        description
        uploadStatus
        uploadError
        originalUrl
        posterUrl
        bytesSize
        contentType
        durationSeconds
        excludeFromPortalExport
        videoRkid
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyVideosQuery, PropertyVideosQueryVariables>;
export const PropertyCreateVideoUploadIntentDocument = new TypedDocumentString(`
    mutation PropertyCreateVideoUploadIntent($propertyId: ID!, $contentType: String!, $caption: String, $description: String, $position: Int, $sizeBytes: Int) {
  property {
    createVideoUploadIntent(
      propertyId: $propertyId
      contentType: $contentType
      caption: $caption
      description: $description
      position: $position
      sizeBytes: $sizeBytes
    ) {
      __typename
      ... on CreatePropertyVideoUploadIntentSuccess {
        message
        video {
          id
          uploadStatus
          position
        }
        upload {
          url
          method
          headers
          expiresAt
          maxBytes
        }
      }
      ... on CreatePropertyVideoUploadIntentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreateVideoUploadIntentMutation, PropertyCreateVideoUploadIntentMutationVariables>;
export const PropertyFinalizeVideoUploadDocument = new TypedDocumentString(`
    mutation PropertyFinalizeVideoUpload($videoId: ID!) {
  property {
    finalizeVideoUpload(videoId: $videoId) {
      __typename
      ... on FinalizePropertyVideoUploadSuccess {
        message
        video {
          id
          uploadStatus
          uploadError
        }
      }
      ... on FinalizePropertyVideoUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyFinalizeVideoUploadMutation, PropertyFinalizeVideoUploadMutationVariables>;
export const PropertyAbortVideoUploadDocument = new TypedDocumentString(`
    mutation PropertyAbortVideoUpload($videoId: ID!) {
  property {
    abortVideoUpload(videoId: $videoId) {
      __typename
      ... on AbortPropertyVideoUploadSuccess {
        message
        success
      }
      ... on AbortPropertyVideoUploadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyAbortVideoUploadMutation, PropertyAbortVideoUploadMutationVariables>;
export const PropertyDeleteVideoDocument = new TypedDocumentString(`
    mutation PropertyDeleteVideo($videoId: ID!) {
  property {
    deleteVideo(videoId: $videoId) {
      __typename
      ... on DeletePropertyVideoSuccess {
        message
        success
      }
      ... on DeletePropertyVideoError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeleteVideoMutation, PropertyDeleteVideoMutationVariables>;
export const PropertyReorderVideosDocument = new TypedDocumentString(`
    mutation PropertyReorderVideos($propertyId: ID!, $videoIds: [ID!]!) {
  property {
    reorderVideos(propertyId: $propertyId, videoIds: $videoIds) {
      __typename
      ... on ReorderPropertyVideosSuccess {
        message
        videos {
          id
          position
        }
      }
      ... on ReorderPropertyVideosError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyReorderVideosMutation, PropertyReorderVideosMutationVariables>;
export const PropertyUpdateVideoDocument = new TypedDocumentString(`
    mutation PropertyUpdateVideo($videoId: ID!, $caption: String, $description: String, $excludeFromPortalExport: Boolean) {
  property {
    updateVideo(
      videoId: $videoId
      caption: $caption
      description: $description
      excludeFromPortalExport: $excludeFromPortalExport
    ) {
      __typename
      ... on UpdatePropertyVideoSuccess {
        message
        video {
          id
          caption
          description
          excludeFromPortalExport
        }
      }
      ... on UpdatePropertyVideoError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdateVideoMutation, PropertyUpdateVideoMutationVariables>;
export const PropertyDeleteImageDocument = new TypedDocumentString(`
    mutation PropertyDeleteImage($imageId: ID!) {
  property {
    deleteImage(imageId: $imageId) {
      __typename
      ... on DeletePropertyImageSuccess {
        message
        success
      }
      ... on DeletePropertyImageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeleteImageMutation, PropertyDeleteImageMutationVariables>;
export const PropertyReorderImagesDocument = new TypedDocumentString(`
    mutation PropertyReorderImages($propertyId: ID!, $imageIds: [ID!]!) {
  property {
    reorderImages(propertyId: $propertyId, imageIds: $imageIds) {
      __typename
      ... on ReorderPropertyImagesSuccess {
        message
        images {
          id
          position
          isMain
        }
      }
      ... on ReorderPropertyImagesError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyReorderImagesMutation, PropertyReorderImagesMutationVariables>;
export const PropertyPromoteImageToGalleryDocument = new TypedDocumentString(`
    mutation PropertyPromoteImageToGallery($imageId: ID!) {
  property {
    promoteImageToGallery(imageId: $imageId) {
      __typename
      ... on PromotePropertyImageToGallerySuccess {
        message
        image {
          id
          isMain
          position
          excludeFromPortalExport
          variantKind
          sourceImageId
        }
      }
      ... on PromotePropertyImageToGalleryError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPromoteImageToGalleryMutation, PropertyPromoteImageToGalleryMutationVariables>;
export const PropertyDemoteImageFromGalleryDocument = new TypedDocumentString(`
    mutation PropertyDemoteImageFromGallery($imageId: ID!) {
  property {
    demoteImageFromGallery(imageId: $imageId) {
      __typename
      ... on DemotePropertyImageFromGallerySuccess {
        message
        image {
          id
          isMain
          excludeFromPortalExport
          variantKind
          sourceImageId
        }
      }
      ... on DemotePropertyImageFromGalleryError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDemoteImageFromGalleryMutation, PropertyDemoteImageFromGalleryMutationVariables>;
export const PropertyUpdateImageDocument = new TypedDocumentString(`
    mutation PropertyUpdateImage($imageId: ID!, $caption: String, $roomType: PhotoRoomTypeEnum) {
  property {
    updateImage(imageId: $imageId, caption: $caption, roomType: $roomType) {
      __typename
      ... on UpdatePropertyImageSuccess {
        message
        image {
          id
          caption
          roomType
        }
      }
      ... on UpdatePropertyImageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdateImageMutation, PropertyUpdateImageMutationVariables>;
export const PropertyCreateContractDocument = new TypedDocumentString(`
    mutation PropertyCreateContract($input: CreatePropertyContractInput!) {
  property {
    createContract(input: $input) {
      __typename
      ... on CreatePropertyContractSuccess {
        message
        contract {
          id
          title
          contractType
          status
        }
      }
      ... on CreatePropertyContractError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreateContractMutation, PropertyCreateContractMutationVariables>;
export const PropertyUpdateContractDocument = new TypedDocumentString(`
    mutation PropertyUpdateContract($input: UpdatePropertyContractInput!) {
  property {
    updateContract(input: $input) {
      __typename
      ... on UpdatePropertyContractSuccess {
        message
        contract {
          id
          title
          contractType
          status
        }
      }
      ... on UpdatePropertyContractError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdateContractMutation, PropertyUpdateContractMutationVariables>;
export const PropertyDeleteContractDocument = new TypedDocumentString(`
    mutation PropertyDeleteContract($id: ID!) {
  property {
    deleteContract(id: $id) {
      __typename
      ... on DeletePropertyContractSuccess {
        message
        success
      }
      ... on DeletePropertyContractError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeleteContractMutation, PropertyDeleteContractMutationVariables>;
export const PropertyCreatePartyDocument = new TypedDocumentString(`
    mutation PropertyCreateParty($input: CreatePropertyPartyInput!) {
  property {
    createParty(input: $input) {
      __typename
      ... on CreatePropertyPartySuccess {
        message
        party {
          id
          role
          displayName
        }
      }
      ... on CreatePropertyPartyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreatePartyMutation, PropertyCreatePartyMutationVariables>;
export const PropertyUpdatePartyDocument = new TypedDocumentString(`
    mutation PropertyUpdateParty($input: UpdatePropertyPartyInput!) {
  property {
    updateParty(input: $input) {
      __typename
      ... on UpdatePropertyPartySuccess {
        message
        party {
          id
          role
          displayName
        }
      }
      ... on UpdatePropertyPartyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdatePartyMutation, PropertyUpdatePartyMutationVariables>;
export const PropertyDeletePartyDocument = new TypedDocumentString(`
    mutation PropertyDeleteParty($id: ID!) {
  property {
    deleteParty(id: $id) {
      __typename
      ... on DeletePropertyPartySuccess {
        message
        success
      }
      ... on DeletePropertyPartyError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeletePartyMutation, PropertyDeletePartyMutationVariables>;
export const PropertyCreateLinkDocument = new TypedDocumentString(`
    mutation PropertyCreateLink($input: CreatePropertyLinkInput!) {
  property {
    createLink(input: $input) {
      __typename
      ... on CreatePropertyLinkSuccess {
        message
        link {
          id
          type
          url
          label
        }
      }
      ... on CreatePropertyLinkError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCreateLinkMutation, PropertyCreateLinkMutationVariables>;
export const PropertyStartYoutubeExportDocument = new TypedDocumentString(`
    mutation PropertyStartYoutubeExport($input: StartYoutubeExportInput!) {
  property {
    startYoutubeExport(input: $input) {
      __typename
      ... on StartPropertyYoutubeExportSuccess {
        message
        uploadUri
        creditsCharged
        privacyStatus
      }
      ... on StartPropertyYoutubeExportError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyStartYoutubeExportMutation, PropertyStartYoutubeExportMutationVariables>;
export const PropertyCompleteYoutubeExportDocument = new TypedDocumentString(`
    mutation PropertyCompleteYoutubeExport($input: CompleteYoutubeExportInput!) {
  property {
    completeYoutubeExport(input: $input) {
      __typename
      ... on CompletePropertyYoutubeExportSuccess {
        message
        linkId
        url
        youtubeVideoId
      }
      ... on CompletePropertyYoutubeExportError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCompleteYoutubeExportMutation, PropertyCompleteYoutubeExportMutationVariables>;
export const PropertyGenerateSocialCaptionDocument = new TypedDocumentString(`
    mutation PropertyGenerateSocialCaption($input: GenerateSocialCaptionInput!) {
  property {
    generateSocialCaption(input: $input) {
      __typename
      ... on GeneratePropertySocialCaptionSuccess {
        message
        caption
        hashtags
        creditsCharged
        locale
        platform
      }
      ... on GeneratePropertySocialCaptionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateSocialCaptionMutation, PropertyGenerateSocialCaptionMutationVariables>;
export const PropertyTranslateSocialCaptionDocument = new TypedDocumentString(`
    mutation PropertyTranslateSocialCaption($input: TranslateSocialCaptionInput!) {
  property {
    translateSocialCaption(input: $input) {
      __typename
      ... on TranslatePropertySocialCaptionSuccess {
        message
        captions
        creditsCharged
        sourceLocale
      }
      ... on TranslatePropertySocialCaptionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyTranslateSocialCaptionMutation, PropertyTranslateSocialCaptionMutationVariables>;
export const PropertyPolishSocialCaptionDocument = new TypedDocumentString(`
    mutation PropertyPolishSocialCaption($input: PolishSocialCaptionInput!) {
  property {
    polishSocialCaption(input: $input) {
      __typename
      ... on PolishPropertySocialCaptionSuccess {
        message
        caption
        hashtags
        creditsCharged
        locale
        platform
      }
      ... on PolishPropertySocialCaptionError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyPolishSocialCaptionMutation, PropertyPolishSocialCaptionMutationVariables>;
export const PropertyStartMetaPublishDocument = new TypedDocumentString(`
    mutation PropertyStartMetaPublish($input: StartMetaPublishInput!) {
  property {
    startMetaPublish(input: $input) {
      __typename
      ... on StartPropertyMetaPublishSuccess {
        stub
        message
        platform
        mediaType
        creditsCharged
        uploadUrl
        uploadKey
        imageUrl
        videoUrl
        igContainerId
      }
      ... on StartPropertyMetaPublishError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyStartMetaPublishMutation, PropertyStartMetaPublishMutationVariables>;
export const PropertyCompleteMetaPublishDocument = new TypedDocumentString(`
    mutation PropertyCompleteMetaPublish($input: CompleteMetaPublishInput!) {
  property {
    completeMetaPublish(input: $input) {
      __typename
      ... on CompletePropertyMetaPublishSuccess {
        stub
        message
        linkId
        url
        postId
        platform
      }
      ... on CompletePropertyMetaPublishError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCompleteMetaPublishMutation, PropertyCompleteMetaPublishMutationVariables>;
export const PropertyGenerateSocialPostImageDocument = new TypedDocumentString(`
    mutation PropertyGenerateSocialPostImage($input: GenerateSocialPostImageInput!) {
  property {
    generateSocialPostImage(input: $input) {
      __typename
      ... on GeneratePropertySocialPostImageSuccess {
        message
        socialPostImage {
          propertyId
          queued
          documentId
          downloadUrl
        }
      }
      ... on GeneratePropertySocialPostImageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateSocialPostImageMutation, PropertyGenerateSocialPostImageMutationVariables>;
export const PropertyGenerateCustomSocialPostImageDocument = new TypedDocumentString(`
    mutation PropertyGenerateCustomSocialPostImage($input: GenerateCustomSocialPostImageInput!) {
  property {
    generateCustomSocialPostImage(input: $input) {
      __typename
      ... on GenerateCustomSocialPostImageSuccess {
        message
        customSocialPostImage {
          requestId
          queued
          documentId
          downloadUrl
        }
      }
      ... on GenerateCustomSocialPostImageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateCustomSocialPostImageMutation, PropertyGenerateCustomSocialPostImageMutationVariables>;
export const PropertyCustomSocialPostImageDocument = new TypedDocumentString(`
    query PropertyCustomSocialPostImage($requestId: String!) {
  property {
    customSocialPostImage(requestId: $requestId) {
      requestId
      queued
      documentId
      originalName
      templateId
      generatedAt
      sizeBytes
      downloadUrl
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCustomSocialPostImageQuery, PropertyCustomSocialPostImageQueryVariables>;
export const PropertySocialPostImageDocument = new TypedDocumentString(`
    query PropertySocialPostImage($id: ID!, $templateId: String) {
  property {
    node(id: $id) {
      id
      socialPostImage(templateId: $templateId) {
        propertyId
        queued
        documentId
        originalName
        locale
        templateId
        generatedAt
        sizeBytes
        downloadUrl
        generationError
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertySocialPostImageQuery, PropertySocialPostImageQueryVariables>;
export const PropertyUpdateLinkDocument = new TypedDocumentString(`
    mutation PropertyUpdateLink($input: UpdatePropertyLinkInput!) {
  property {
    updateLink(input: $input) {
      __typename
      ... on UpdatePropertyLinkSuccess {
        message
        link {
          id
          type
          url
          label
        }
      }
      ... on UpdatePropertyLinkError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyUpdateLinkMutation, PropertyUpdateLinkMutationVariables>;
export const PropertyDeleteLinkDocument = new TypedDocumentString(`
    mutation PropertyDeleteLink($id: ID!) {
  property {
    deleteLink(id: $id) {
      __typename
      ... on DeletePropertyLinkSuccess {
        message
        success
      }
      ... on DeletePropertyLinkError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDeleteLinkMutation, PropertyDeleteLinkMutationVariables>;
export const PropertySetPortalExportDocument = new TypedDocumentString(`
    mutation PropertySetPortalExport($input: SetPortalExportInput!) {
  property {
    setPortalExport(input: $input) {
      __typename
      ... on SetPropertyPortalExportSuccess {
        message
        property {
          id
          portalExports {
            id
            provider
            isEnabled
            status
          }
        }
      }
      ... on SetPropertyPortalExportError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertySetPortalExportMutation, PropertySetPortalExportMutationVariables>;
export const PropertySetPortalBumpScheduleDocument = new TypedDocumentString(`
    mutation PropertySetPortalBumpSchedule($input: SetPortalBumpScheduleInput!) {
  property {
    setPortalBumpSchedule(input: $input) {
      __typename
      ... on SetPropertyPortalBumpScheduleSuccess {
        message
        property {
          id
          portalExports {
            id
            provider
            bumpEnabled
            bumpDays
            bumpAfterHour
            bumpPriority
          }
        }
      }
      ... on SetPropertyPortalBumpScheduleError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertySetPortalBumpScheduleMutation, PropertySetPortalBumpScheduleMutationVariables>;
export const PropertyMarkUnavailableDocument = new TypedDocumentString(`
    mutation PropertyMarkUnavailable($input: MarkUnavailableInput!) {
  property {
    markUnavailable(input: $input) {
      __typename
      ... on MarkPropertyUnavailableSuccess {
        message
        property {
          id
          status
          isPublished
          unpublishedAt
        }
      }
      ... on MarkPropertyUnavailableError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMarkUnavailableMutation, PropertyMarkUnavailableMutationVariables>;
export const PropertyVerifyPortalPublicationDocument = new TypedDocumentString(`
    mutation PropertyVerifyPortalPublication($input: VerifyPortalPublicationInput!) {
  property {
    verifyPortalPublication(input: $input) {
      __typename
      ... on VerifyPropertyPortalPublicationSuccess {
        message
        portalExport {
          id
          provider
          publicationStatus
          lastVerifiedAt
          lastVerificationError
          status
          lastError
        }
      }
      ... on VerifyPropertyPortalPublicationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyVerifyPortalPublicationMutation, PropertyVerifyPortalPublicationMutationVariables>;
export const PropertyVerifyAllPortalPublicationsDocument = new TypedDocumentString(`
    mutation PropertyVerifyAllPortalPublications($propertyId: ID!) {
  property {
    verifyAllPortalPublications(propertyId: $propertyId) {
      __typename
      ... on VerifyAllPropertyPortalPublicationsSuccess {
        message
        portalExports {
          id
          provider
          publicationStatus
          lastVerifiedAt
          lastVerificationError
          status
          lastError
          externalListingId
        }
      }
      ... on VerifyAllPropertyPortalPublicationsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyVerifyAllPortalPublicationsMutation, PropertyVerifyAllPortalPublicationsMutationVariables>;
export const PropertyReconcilePortalPublicationsDocument = new TypedDocumentString(`
    mutation PropertyReconcilePortalPublications {
  property {
    reconcilePortalPublications {
      __typename
      ... on ReconcilePropertyPortalPublicationsSuccess {
        message
        checked
        mismatches
        remediated
        tasksCreated
        unsupported
        errors
      }
      ... on ReconcilePropertyPortalPublicationsError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyReconcilePortalPublicationsMutation, PropertyReconcilePortalPublicationsMutationVariables>;
export const PropertyTranslateWithAiDocument = new TypedDocumentString(`
    mutation PropertyTranslateWithAi($id: ID!, $sourceLocale: String! = "cs", $targetLocales: [String!], $fields: [String!], $overwrite: Boolean! = false, $idempotencyKey: String) {
  property {
    translateWithAi(
      id: $id
      sourceLocale: $sourceLocale
      targetLocales: $targetLocales
      fields: $fields
      overwrite: $overwrite
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on TranslatePropertyWithAiSuccess {
        message
        propertyId
        queued
      }
      ... on TranslatePropertyWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyTranslateWithAiMutation, PropertyTranslateWithAiMutationVariables>;
export const PropertyGenerateDescriptionWithAiDocument = new TypedDocumentString(`
    mutation PropertyGenerateDescriptionWithAi($id: ID!, $locale: String! = "cs", $overwrite: Boolean! = false, $idempotencyKey: String) {
  property {
    generateDescriptionWithAi(
      id: $id
      locale: $locale
      overwrite: $overwrite
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on GeneratePropertyDescriptionWithAiSuccess {
        message
        propertyId
        queued
        locale
      }
      ... on GeneratePropertyDescriptionWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateDescriptionWithAiMutation, PropertyGenerateDescriptionWithAiMutationVariables>;
export const PropertyConfirmAiTranslationDocument = new TypedDocumentString(`
    mutation PropertyConfirmAiTranslation($id: ID!, $locale: String!) {
  property {
    confirmAiTranslation(id: $id, locale: $locale) {
      __typename
      ... on ConfirmPropertyAiTranslationSuccess {
        message
        propertyId
        locale
        confirmed
      }
      ... on ConfirmPropertyAiTranslationError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyConfirmAiTranslationMutation, PropertyConfirmAiTranslationMutationVariables>;
export const PropertyEnhanceImageWithAiDocument = new TypedDocumentString(`
    mutation PropertyEnhanceImageWithAi($imageId: ID!, $mode: EnhanceModeEnum! = AUTO, $prompt: String, $idempotencyKey: String) {
  property {
    enhanceImageWithAi(
      imageId: $imageId
      mode: $mode
      prompt: $prompt
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on EnhancePropertyImageWithAiSuccess {
        message
        propertyId
        imageId
        queued
      }
      ... on EnhancePropertyImageWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyEnhanceImageWithAiMutation, PropertyEnhanceImageWithAiMutationVariables>;
export const PropertyStageImageWithAiDocument = new TypedDocumentString(`
    mutation PropertyStageImageWithAi($imageId: ID!, $style: StagingStyleEnum! = MODERN, $prompt: String, $idempotencyKey: String) {
  property {
    stageImageWithAi(
      imageId: $imageId
      style: $style
      prompt: $prompt
      idempotencyKey: $idempotencyKey
    ) {
      __typename
      ... on StagePropertyImageWithAiSuccess {
        message
        propertyId
        imageId
        style
        queued
      }
      ... on StagePropertyImageWithAiError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyStageImageWithAiMutation, PropertyStageImageWithAiMutationVariables>;
export const PropertyGenerateCatalogCardDocument = new TypedDocumentString(`
    mutation PropertyGenerateCatalogCard($id: ID!, $locale: String! = "cs", $brokerId: ID, $templateId: String, $overrides: JSON) {
  property {
    generateCatalogCard(
      id: $id
      locale: $locale
      brokerId: $brokerId
      templateId: $templateId
      overrides: $overrides
    ) {
      __typename
      ... on GeneratePropertyCatalogCardSuccess {
        message
        catalogCard {
          propertyId
          queued
          documentId
          originalName
          locale
          templateId
          generatedAt
          downloadUrl
        }
      }
      ... on GeneratePropertyCatalogCardError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateCatalogCardMutation, PropertyGenerateCatalogCardMutationVariables>;
export const PropertyCatalogCardDocument = new TypedDocumentString(`
    query PropertyCatalogCard($id: ID!) {
  property {
    node(id: $id) {
      id
      catalogCard {
        propertyId
        queued
        documentId
        originalName
        locale
        templateId
        generatedAt
        sizeBytes
        downloadUrl
        generationError
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyCatalogCardQuery, PropertyCatalogCardQueryVariables>;
export const PropertyGenerateLegalDocumentDocument = new TypedDocumentString(`
    mutation PropertyGenerateLegalDocument($input: GenerateLegalDocumentInput!) {
  property {
    generateLegalDocument(input: $input) {
      __typename
      ... on GeneratePropertyLegalDocumentSuccess {
        message
        legalDocument {
          propertyId
          queued
          documentId
          originalName
          locale
          templateId
          generatedAt
          downloadUrl
        }
      }
      ... on GeneratePropertyLegalDocumentError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyGenerateLegalDocumentMutation, PropertyGenerateLegalDocumentMutationVariables>;
export const PropertyBulkTransferDocument = new TypedDocumentString(`
    mutation PropertyBulkTransfer($input: BulkTransferInput!) {
  property {
    bulkTransfer(input: $input) {
      __typename
      ... on BulkTransferPropertiesSuccess {
        message
        transferredCount
        transferredPropertyIds
        skippedPropertyIds
        dealsTransferred
        tasksTransferred
        srealityReprovisionQueuedCount
      }
      ... on BulkTransferPropertiesError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyBulkTransferMutation, PropertyBulkTransferMutationVariables>;
export const PropertyLegalDocumentDocument = new TypedDocumentString(`
    query PropertyLegalDocument($id: ID!, $templateId: String) {
  property {
    node(id: $id) {
      id
      legalDocument(templateId: $templateId) {
        propertyId
        queued
        documentId
        originalName
        locale
        templateId
        generatedAt
        sizeBytes
        downloadUrl
        generationError
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyLegalDocumentQuery, PropertyLegalDocumentQueryVariables>;
export const PropertyDocumentDraftDocument = new TypedDocumentString(`
    query PropertyDocumentDraft($id: ID!, $kind: RenderTemplateKindEnum!, $templateId: String, $locale: String! = "cs", $brokerId: ID, $overrides: JSON) {
  property {
    node(id: $id) {
      id
      documentDraft(
        kind: $kind
        templateId: $templateId
        locale: $locale
        brokerId: $brokerId
        overrides: $overrides
      ) {
        kind
        schemaId
        contextType
        contextId
        values
        template {
          id
          slug
          name
          kind
          isDefault
        }
        fields {
          key
          value
          source
          autofilledFrom
          def {
            key
            label
            description
            valueType
            group
            required
            overridable
            autofill {
              sources
            }
          }
        }
        availableMedia {
          imageId
          position
          caption
          thumbUrl
          isMain
        }
        mediaSlots {
          key
          label
          maxCount
          required
          imageIds
          source
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyDocumentDraftQuery, PropertyDocumentDraftQueryVariables>;
export const PropertyMessageTilesDocument = new TypedDocumentString(`
    query PropertyMessageTiles {
  propertyMessage {
    tiles {
      provider
      totalCount
      unreadCount
      latestAt
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageTilesQuery, PropertyMessageTilesQueryVariables>;
export const PropertyMessageInboxDocument = new TypedDocumentString(`
    query PropertyMessageInbox($provider: IntegrationProviderEnum, $propertyId: ID, $unreadOnly: Boolean! = false, $includeArchived: Boolean! = false, $limit: Int! = 50, $offset: Int! = 0) {
  propertyMessage {
    inbox(
      provider: $provider
      propertyId: $propertyId
      unreadOnly: $unreadOnly
      includeArchived: $includeArchived
      limit: $limit
      offset: $offset
    ) {
      totalCount
      items {
        id
        provider
        direction
        status
        senderName
        senderEmail
        senderPhone
        body
        receivedAt
        readAt
        propertyId
        leadId
        threadKey
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageInboxQuery, PropertyMessageInboxQueryVariables>;
export const PropertyMessageMarkReadDocument = new TypedDocumentString(`
    mutation PropertyMessageMarkRead($id: ID!) {
  propertyMessage {
    markRead(id: $id) {
      __typename
      ... on MarkPropertyMessageReadSuccess {
        message
        propertyMessage {
          id
          status
          readAt
        }
      }
      ... on MarkPropertyMessageReadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageMarkReadMutation, PropertyMessageMarkReadMutationVariables>;
export const PropertyMessageArchiveDocument = new TypedDocumentString(`
    mutation PropertyMessageArchive($id: ID!) {
  propertyMessage {
    archive(id: $id) {
      __typename
      ... on ArchivePropertyMessageSuccess {
        message
        propertyMessage {
          id
          status
        }
      }
      ... on ArchivePropertyMessageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageArchiveMutation, PropertyMessageArchiveMutationVariables>;
export const PropertyMessageCreateLeadDocument = new TypedDocumentString(`
    mutation PropertyMessageCreateLead($id: ID!) {
  propertyMessage {
    createLead(id: $id) {
      __typename
      ... on CreatePropertyMessageLeadSuccess {
        message
        leadId
        propertyMessage {
          id
          leadId
          status
        }
      }
      ... on CreatePropertyMessageLeadError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageCreateLeadMutation, PropertyMessageCreateLeadMutationVariables>;
export const PropertyMessageReplyDocument = new TypedDocumentString(`
    mutation PropertyMessageReply($id: ID!, $body: String!) {
  propertyMessage {
    reply(id: $id, body: $body) {
      __typename
      ... on ReplyPropertyMessageSuccess {
        message
        propertyMessage {
          id
          status
          readAt
        }
        reply {
          id
          direction
          status
          body
          receivedAt
          senderName
        }
      }
      ... on ReplyPropertyMessageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PropertyMessageReplyMutation, PropertyMessageReplyMutationVariables>;
export const PublicAgentBySlugDocument = new TypedDocumentString(`
    query PublicAgentBySlug($slug: String!, $locale: String! = "cs", $organizationSlug: String) {
  publicAgent {
    bySlug(slug: $slug, locale: $locale, organizationSlug: $organizationSlug) {
      id
      slug
      displayName
      title
      email
      phone
      bio
      avatarUrl
    }
  }
}
    `) as unknown as TypedDocumentString<PublicAgentBySlugQuery, PublicAgentBySlugQueryVariables>;
export const PublicBlogSearchDocument = new TypedDocumentString(`
    query PublicBlogSearch($input: PublicBlogSearchInput) {
  publicBlog {
    search(input: $input) {
      totalCount
      items {
        id
        slug
        locale
        title
        excerpt
        coverUrl
        tags
        publishedAt
        author {
          slug
          displayName
          avatarUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicBlogSearchQuery, PublicBlogSearchQueryVariables>;
export const PublicBlogBySlugDocument = new TypedDocumentString(`
    query PublicBlogBySlug($slug: String!, $locale: String! = "cs", $organizationSlug: String!) {
  publicBlog {
    bySlug(slug: $slug, locale: $locale, organizationSlug: $organizationSlug) {
      id
      slug
      locale
      title
      excerpt
      contentHtml
      contentMarkdown
      coverUrl
      tags
      seoTitle
      seoDescription
      publishedAt
      author {
        slug
        displayName
        title
        avatarUrl
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicBlogBySlugQuery, PublicBlogBySlugQueryVariables>;
export const PublicDocumentResolveShareDocument = new TypedDocumentString(`
    query PublicDocumentResolveShare($token: String!, $password: String, $limit: Int! = 50, $offset: Int! = 0) {
  publicDocument {
    resolveShare(token: $token, password: $password, limit: $limit, offset: $offset) {
      shareId
      scope
      nodeId
      nodeName
      allowDownload
      passwordRequired
      totalFiles
      files {
        nodeId
        documentId
        name
        mimeType
        sizeBytes
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicDocumentResolveShareQuery, PublicDocumentResolveShareQueryVariables>;
export const PublicDocumentDownloadDocument = new TypedDocumentString(`
    query PublicDocumentDownload($token: String!, $documentId: ID!, $password: String) {
  publicDocument {
    download(token: $token, documentId: $documentId, password: $password) {
      documentId
      name
      mimeType
      sizeBytes
      downloadUrl
    }
  }
}
    `) as unknown as TypedDocumentString<PublicDocumentDownloadQuery, PublicDocumentDownloadQueryVariables>;
export const PublicPropertySearchDocument = new TypedDocumentString(`
    query PublicPropertySearch($input: PublicPropertySearchInput) {
  publicProperty {
    search(input: $input) {
      totalCount
      items {
        id
        slug
        title
        locale
        category
        propertyType
        price
        currency
        priceUnit
        priceOnRequest
        locationPrivacy
        coverUrl
        map {
          latitude
          longitude
          showPin
          isExact
          city
          district
          addressLine
        }
        agent {
          slug
          displayName
          avatarUrl
        }
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicPropertySearchQuery, PublicPropertySearchQueryVariables>;
export const PublicPropertyBySlugDocument = new TypedDocumentString(`
    query PublicPropertyBySlug($slug: String!, $locale: String! = "cs", $organizationSlug: String) {
  publicProperty {
    bySlug(slug: $slug, locale: $locale, organizationSlug: $organizationSlug) {
      id
      slug
      title
      locale
      category
      propertyType
      price
      currency
      priceUnit
      priceOnRequest
      locationPrivacy
      description
      marketingText
      layout
      usableArea
      floorArea
      lotSize
      floor
      totalFloors
      yearBuilt
      energyClass
      condition
      hasBalcony
      hasTerrace
      hasParking
      hasElevator
      coverUrl
      map {
        latitude
        longitude
        showPin
        isExact
        city
        district
        addressLine
      }
      agent {
        slug
        displayName
        title
        email
        phone
        avatarUrl
      }
      images {
        caption
        isMain
        thumbUrl
        displayUrl
      }
      links {
        type
        url
        label
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicPropertyBySlugQuery, PublicPropertyBySlugQueryVariables>;
export const PublicSiteDocument = new TypedDocumentString(`
    query PublicSite($organizationSlug: String) {
  publicSite {
    get(organizationSlug: $organizationSlug) {
      organizationSlug
      name
      brand
      logoUrl
      palette {
        primary
        background
        foreground
      }
      template
      legalName
      address
      phone
      email
      team {
        id
        slug
        displayName
        title
        email
        phone
        bio
        avatarUrl
      }
      venues {
        name
        slug
        address
        phone
        email
      }
    }
  }
}
    `) as unknown as TypedDocumentString<PublicSiteQuery, PublicSiteQueryVariables>;
export const UserEventsDocument = new TypedDocumentString(`
    subscription UserEvents {
  userEvents {
    kind
    event
    entityType
    entityId
    occurredAt
    payload
    notification {
      id
      type
      title
      body
      entityType
      entityId
      readAt
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<UserEventsSubscription, UserEventsSubscriptionVariables>;
export const PortalEventsDocument = new TypedDocumentString(`
    subscription PortalEvents {
  portalEvents {
    kind
    event
    entityType
    entityId
    occurredAt
    payload
    notification {
      id
      type
      title
      body
      entityType
      entityId
      readAt
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<PortalEventsSubscription, PortalEventsSubscriptionVariables>;
export const RenderTemplateListDocument = new TypedDocumentString(`
    query RenderTemplateList($kind: RenderTemplateKindEnum, $includeInactive: Boolean = false) {
  renderTemplate {
    list(kind: $kind, includeInactive: $includeInactive) {
      id
      slug
      name
      kind
      format
      aspectRatio
      locale
      version
      isSystem
      isDefault
      isActive
      settings
      source
      typUrl
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateListQuery, RenderTemplateListQueryVariables>;
export const RenderTemplateNodeDocument = new TypedDocumentString(`
    query RenderTemplateNode($id: ID, $slug: String) {
  renderTemplate {
    node(id: $id, slug: $slug) {
      id
      slug
      name
      kind
      format
      aspectRatio
      locale
      version
      isSystem
      isDefault
      isActive
      settings
      source
      typUrl
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateNodeQuery, RenderTemplateNodeQueryVariables>;
export const RenderFieldContractDocument = new TypedDocumentString(`
    query RenderFieldContract($kind: RenderTemplateKindEnum!, $schemaId: String) {
  renderTemplate {
    fieldContract(kind: $kind, schemaId: $schemaId) {
      schemaId
      kind
      fields {
        key
        label
        description
        valueType
        group
        required
        overridable
        autofill {
          sources
        }
      }
      mediaSlots {
        key
        label
        maxCount
        required
        autofillSource
        group
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderFieldContractQuery, RenderFieldContractQueryVariables>;
export const RenderBlockCatalogDocument = new TypedDocumentString(`
    query RenderBlockCatalog($kind: RenderTemplateKindEnum) {
  renderTemplate {
    blockCatalog(kind: $kind)
  }
}
    `) as unknown as TypedDocumentString<RenderBlockCatalogQuery, RenderBlockCatalogQueryVariables>;
export const RenderTemplateUpsertDocument = new TypedDocumentString(`
    mutation RenderTemplateUpsert($input: UpsertRenderTemplateInput!, $typFile: Upload) {
  renderTemplate {
    upsert(input: $input, typFile: $typFile) {
      __typename
      ... on UpsertRenderTemplateSuccess {
        message
        renderTemplate {
          id
          slug
          name
          kind
          format
          aspectRatio
          locale
          version
          isSystem
          isDefault
          isActive
          settings
          source
          typUrl
        }
      }
      ... on UpsertRenderTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateUpsertMutation, RenderTemplateUpsertMutationVariables>;
export const RenderTemplateForkDocument = new TypedDocumentString(`
    mutation RenderTemplateFork($input: ForkRenderTemplateInput!) {
  renderTemplate {
    fork(input: $input) {
      __typename
      ... on ForkRenderTemplateSuccess {
        message
        renderTemplate {
          id
          slug
          name
          kind
          format
          aspectRatio
          locale
          version
          isSystem
          isDefault
          isActive
          source
          typUrl
        }
      }
      ... on ForkRenderTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateForkMutation, RenderTemplateForkMutationVariables>;
export const RenderTemplateSetDefaultDocument = new TypedDocumentString(`
    mutation RenderTemplateSetDefault($id: ID!) {
  renderTemplate {
    setDefault(id: $id) {
      __typename
      ... on SetDefaultRenderTemplateSuccess {
        message
        renderTemplate {
          id
          slug
          name
          kind
          isDefault
        }
      }
      ... on SetDefaultRenderTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateSetDefaultMutation, RenderTemplateSetDefaultMutationVariables>;
export const RenderTemplatePreviewDocument = new TypedDocumentString(`
    mutation RenderTemplatePreview($input: PreviewRenderTemplateInput!) {
  renderTemplate {
    preview(input: $input) {
      __typename
      ... on PreviewRenderTemplateSuccess {
        message
        preview {
          compileOk
          compileError
          downloadUrl
          contentType
          format
        }
      }
      ... on PreviewRenderTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplatePreviewMutation, RenderTemplatePreviewMutationVariables>;
export const RenderCompileLayoutDocument = new TypedDocumentString(`
    mutation RenderCompileLayout($input: CompileLayoutInput!) {
  renderTemplate {
    compileLayout(input: $input) {
      __typename
      ... on CompileRenderTemplateLayoutSuccess {
        message
        result {
          source
          layout
          compileOk
          compileError
          preview {
            downloadUrl
            contentType
            format
          }
        }
      }
      ... on CompileRenderTemplateLayoutError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderCompileLayoutMutation, RenderCompileLayoutMutationVariables>;
export const RenderCompileMarkupDocument = new TypedDocumentString(`
    mutation RenderCompileMarkup($input: CompileMarkupInput!) {
  renderTemplate {
    compileMarkup(input: $input) {
      __typename
      ... on CompileRenderTemplateMarkupSuccess {
        message
        result {
          source
          layout
          compileOk
          compileError
          preview {
            downloadUrl
            contentType
            format
          }
        }
      }
      ... on CompileRenderTemplateMarkupError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderCompileMarkupMutation, RenderCompileMarkupMutationVariables>;
export const RenderTemplateDeleteDocument = new TypedDocumentString(`
    mutation RenderTemplateDelete($id: ID!) {
  renderTemplate {
    delete(id: $id) {
      __typename
      ... on DeleteRenderTemplateSuccess {
        message
        success
      }
      ... on DeleteRenderTemplateError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateDeleteMutation, RenderTemplateDeleteMutationVariables>;
export const RenderTemplateAssistTypstDocument = new TypedDocumentString(`
    mutation RenderTemplateAssistTypst($input: AssistTypstInput!) {
  renderTemplate {
    assistTypst(input: $input) {
      __typename
      ... on AssistRenderTemplateTypstSuccess {
        message
        result {
          source
          layout
          outputFormat
          provider
          model
          creditsCharged
          extractedTextPreview
          compileOk
          compileError
          blockCatalog
        }
      }
      ... on AssistRenderTemplateTypstError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<RenderTemplateAssistTypstMutation, RenderTemplateAssistTypstMutationVariables>;
export const ReportDashboardDocument = new TypedDocumentString(`
    query ReportDashboard($input: ReportFilterInput) {
  report {
    dashboard(input: $input) {
      newLeads
      activeClients
      activeDeals
      closedDeals
      closedVolume
      conversionRate
      avgDealCycleDays
      periodStart
      periodEnd
    }
  }
}
    `) as unknown as TypedDocumentString<ReportDashboardQuery, ReportDashboardQueryVariables>;
export const ReportLeadSourcesDocument = new TypedDocumentString(`
    query ReportLeadSources($input: ReportFilterInput) {
  report {
    leadSources(input: $input) {
      source
      count
      convertedCount
      conversionRate
    }
  }
}
    `) as unknown as TypedDocumentString<ReportLeadSourcesQuery, ReportLeadSourcesQueryVariables>;
export const ReportAgentPerformanceDocument = new TypedDocumentString(`
    query ReportAgentPerformance($input: ReportFilterInput) {
  report {
    agentPerformance(input: $input) {
      agentId
      agentName
      leadsCount
      dealsWon
      dealsLost
      wonVolume
      conversionRate
      avgDealCycleDays
    }
  }
}
    `) as unknown as TypedDocumentString<ReportAgentPerformanceQuery, ReportAgentPerformanceQueryVariables>;
export const ReportPipelineStagesDocument = new TypedDocumentString(`
    query ReportPipelineStages($input: ReportFilterInput) {
  report {
    pipelineStages(input: $input) {
      stageId
      stageName
      pipelineId
      position
      dealCount
      expectedValue
      pipelineValue
      isWon
      isLost
    }
  }
}
    `) as unknown as TypedDocumentString<ReportPipelineStagesQuery, ReportPipelineStagesQueryVariables>;
export const ReportCampaignPerformanceDocument = new TypedDocumentString(`
    query ReportCampaignPerformance($input: ReportFilterInput) {
  report {
    campaignPerformance(input: $input) {
      utmCampaign
      leadsCount
      convertedCount
      conversionRate
    }
  }
}
    `) as unknown as TypedDocumentString<ReportCampaignPerformanceQuery, ReportCampaignPerformanceQueryVariables>;
export const ReportProvisionByAgentDocument = new TypedDocumentString(`
    query ReportProvisionByAgent($input: ReportFilterInput) {
  report {
    provisionByAgent(input: $input) {
      agentId
      agentName
      wonProvision
      expectedProvision
    }
  }
}
    `) as unknown as TypedDocumentString<ReportProvisionByAgentQuery, ReportProvisionByAgentQueryVariables>;
export const SmsStatusDocument = new TypedDocumentString(`
    query SmsStatus {
  sms {
    smsStatus
  }
}
    `) as unknown as TypedDocumentString<SmsStatusQuery, SmsStatusQueryVariables>;
export const SmsListMessagesDocument = new TypedDocumentString(`
    query SmsListMessages($clientId: ID!, $limit: Int = 50, $offset: Int = 0) {
  sms {
    listSmsMessages(clientId: $clientId, limit: $limit, offset: $offset) {
      id
      toPhone
      templateKey
      body
      status
      providerId
      clientId
      viewingId
      propertyId
      sentAt
      error
      createdAt
    }
  }
}
    `) as unknown as TypedDocumentString<SmsListMessagesQuery, SmsListMessagesQueryVariables>;
export const SmsTestSendDocument = new TypedDocumentString(`
    mutation SmsTestSend($toPhone: String!, $templateKey: String = "inquiry_received", $context: JSON) {
  sms {
    testSmsSend(toPhone: $toPhone, templateKey: $templateKey, context: $context) {
      __typename
      ... on TestSmsSendSuccess {
        message
        smsMessage {
          id
          toPhone
          templateKey
          body
          status
          error
          sentAt
        }
      }
      ... on TestSmsSendError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<SmsTestSendMutation, SmsTestSendMutationVariables>;
export const TaskListDocument = new TypedDocumentString(`
    query TaskList($limit: Int, $offset: Int, $filters: TaskFilter, $order: TaskOrder, $scope: CalendarScopeEnum! = MINE, $venueId: ID) {
  task {
    list(
      limit: $limit
      offset: $offset
      filters: $filters
      order: $order
      scope: $scope
      venueId: $venueId
    ) {
      items {
        id
        title
        status
        category
        priority
        startAt
        endAt
        dueAt
        allDay
        assigneeId
        isOverdue
        calendarProvider
        syncStatus
        syncExportable
        pipelineId
        stageId
      }
      totalCount
    }
  }
}
    `) as unknown as TypedDocumentString<TaskListQuery, TaskListQueryVariables>;
export const TaskNodeDocument = new TypedDocumentString(`
    query TaskNode($id: ID!) {
  task {
    node(id: $id) {
      id
      title
      description
      status
      priority
      category
      assigneeId
      creatorId
      startAt
      endAt
      allDay
      dueAt
      locationLabel
      clientId
      propertyId
      dealId
      leadId
      isOverdue
      pipelineId
      stageId
      reminders {
        id
        channel
        remindAt
      }
      calendarProvider
      syncStatus
      syncExportable
      externalCalendarId
      externalEventId
      icalUid
      lastSyncedAt
      syncError
    }
  }
}
    `) as unknown as TypedDocumentString<TaskNodeQuery, TaskNodeQueryVariables>;
export const TaskPipelineDocument = new TypedDocumentString(`
    query TaskPipeline($id: ID) {
  task {
    pipeline(id: $id) {
      ...TaskPipelineFields
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskPipelineQuery, TaskPipelineQueryVariables>;
export const TaskPipelinesDocument = new TypedDocumentString(`
    query TaskPipelines($includeArchived: Boolean! = false, $kind: TaskPipelineKindEnum) {
  task {
    pipelines(includeArchived: $includeArchived, kind: $kind) {
      ...TaskPipelineFields
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskPipelinesQuery, TaskPipelinesQueryVariables>;
export const TaskExternalEventsDocument = new TypedDocumentString(`
    query TaskExternalEvents($start: DateTime, $end: DateTime, $limit: Int! = 200, $userId: ID) {
  task {
    externalEvents(start: $start, end: $end, limit: $limit, userId: $userId) {
      id
      userId
      provider
      externalId
      title
      startAt
      endAt
      allDay
      isBusy
      isPrivate
      originTaskId
    }
  }
}
    `) as unknown as TypedDocumentString<TaskExternalEventsQuery, TaskExternalEventsQueryVariables>;
export const TaskCreateDocument = new TypedDocumentString(`
    mutation TaskCreate($input: CreateTaskInput!) {
  task {
    create(input: $input) {
      __typename
      ... on CreateTaskSuccess {
        message
        task {
          id
          syncStatus
          calendarProvider
          syncExportable
          stageId
          pipelineId
        }
      }
      ... on CreateTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskCreateMutation, TaskCreateMutationVariables>;
export const TaskUpdateDocument = new TypedDocumentString(`
    mutation TaskUpdate($input: UpdateTaskInput!) {
  task {
    update(input: $input) {
      __typename
      ... on UpdateTaskSuccess {
        message
        task {
          id
        }
      }
      ... on UpdateTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskUpdateMutation, TaskUpdateMutationVariables>;
export const TaskCompleteDocument = new TypedDocumentString(`
    mutation TaskComplete($id: ID!) {
  task {
    complete(id: $id) {
      __typename
      ... on CompleteTaskSuccess {
        message
        task {
          id
          status
          stageId
        }
      }
      ... on CompleteTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskCompleteMutation, TaskCompleteMutationVariables>;
export const TaskCancelDocument = new TypedDocumentString(`
    mutation TaskCancel($id: ID!) {
  task {
    cancel(id: $id) {
      __typename
      ... on CancelTaskSuccess {
        message
        task {
          id
          status
          stageId
        }
      }
      ... on CancelTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskCancelMutation, TaskCancelMutationVariables>;
export const TaskChangeStageDocument = new TypedDocumentString(`
    mutation TaskChangeStage($id: ID!, $stageId: ID!) {
  task {
    changeStage(id: $id, stageId: $stageId) {
      __typename
      ... on ChangeTaskStageSuccess {
        message
        task {
          id
          status
          stageId
          pipelineId
        }
      }
      ... on ChangeTaskStageError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskChangeStageMutation, TaskChangeStageMutationVariables>;
export const TaskSetPipelineDocument = new TypedDocumentString(`
    mutation TaskSetPipeline($id: ID!, $pipelineId: ID!) {
  task {
    setPipeline(id: $id, pipelineId: $pipelineId) {
      __typename
      ... on SetTaskPipelineSuccess {
        message
        task {
          id
          pipelineId
          stageId
          status
        }
      }
      ... on SetTaskPipelineError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSetPipelineMutation, TaskSetPipelineMutationVariables>;
export const TaskCreatePipelineDocument = new TypedDocumentString(`
    mutation TaskCreatePipeline($name: String!, $isDefault: Boolean! = false, $withDefaultStages: Boolean! = true, $teamId: ID, $cloneFromId: ID, $kind: TaskPipelineKindEnum! = GENERAL) {
  task {
    createPipeline(
      name: $name
      isDefault: $isDefault
      withDefaultStages: $withDefaultStages
      teamId: $teamId
      cloneFromId: $cloneFromId
      kind: $kind
    ) {
      __typename
      ... on CreateTaskPipelineSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on CreateTaskPipelineError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskCreatePipelineMutation, TaskCreatePipelineMutationVariables>;
export const TaskUpdatePipelineDocument = new TypedDocumentString(`
    mutation TaskUpdatePipeline($id: ID!, $name: String, $isDefault: Boolean, $position: Int, $teamId: ID, $kind: TaskPipelineKindEnum) {
  task {
    updatePipeline(
      id: $id
      name: $name
      isDefault: $isDefault
      position: $position
      teamId: $teamId
      kind: $kind
    ) {
      __typename
      ... on UpdateTaskPipelineSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on UpdateTaskPipelineError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskUpdatePipelineMutation, TaskUpdatePipelineMutationVariables>;
export const TaskArchivePipelineDocument = new TypedDocumentString(`
    mutation TaskArchivePipeline($id: ID!) {
  task {
    archivePipeline(id: $id) {
      __typename
      ... on ArchiveTaskPipelineSuccess {
        message
        pipeline {
          id
          isArchived
        }
      }
      ... on ArchiveTaskPipelineError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskArchivePipelineMutation, TaskArchivePipelineMutationVariables>;
export const TaskDeletePipelineDocument = new TypedDocumentString(`
    mutation TaskDeletePipeline($id: ID!, $targetPipelineId: ID, $mappings: [StageMappingInput!]) {
  task {
    deletePipeline(
      id: $id
      targetPipelineId: $targetPipelineId
      mappings: $mappings
    ) {
      __typename
      ... on DeleteTaskPipelineSuccess {
        message
        success
      }
      ... on DeleteTaskPipelineError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskDeletePipelineMutation, TaskDeletePipelineMutationVariables>;
export const TaskMovePipelineItemsDocument = new TypedDocumentString(`
    mutation TaskMovePipelineItems($fromPipelineId: ID!, $toPipelineId: ID!, $mappings: [StageMappingInput!]!) {
  task {
    movePipelineItems(
      fromPipelineId: $fromPipelineId
      toPipelineId: $toPipelineId
      mappings: $mappings
    ) {
      __typename
      ... on MoveTaskPipelineItemsSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on MoveTaskPipelineItemsError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskMovePipelineItemsMutation, TaskMovePipelineItemsMutationVariables>;
export const TaskAddPipelineStageDocument = new TypedDocumentString(`
    mutation TaskAddPipelineStage($pipelineId: ID!, $name: String!, $color: String, $mapsStatus: TaskStatusEnum! = TODO, $isOpen: Boolean! = true, $isDone: Boolean! = false, $isCancelled: Boolean! = false, $position: Int) {
  task {
    addPipelineStage(
      pipelineId: $pipelineId
      name: $name
      color: $color
      mapsStatus: $mapsStatus
      isOpen: $isOpen
      isDone: $isDone
      isCancelled: $isCancelled
      position: $position
    ) {
      __typename
      ... on AddTaskPipelineStageSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on AddTaskPipelineStageError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskAddPipelineStageMutation, TaskAddPipelineStageMutationVariables>;
export const TaskUpdatePipelineStageDocument = new TypedDocumentString(`
    mutation TaskUpdatePipelineStage($id: ID!, $name: String, $color: String, $mapsStatus: TaskStatusEnum, $isOpen: Boolean, $isDone: Boolean, $isCancelled: Boolean) {
  task {
    updatePipelineStage(
      id: $id
      name: $name
      color: $color
      mapsStatus: $mapsStatus
      isOpen: $isOpen
      isDone: $isDone
      isCancelled: $isCancelled
    ) {
      __typename
      ... on UpdateTaskPipelineStageSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on UpdateTaskPipelineStageError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskUpdatePipelineStageMutation, TaskUpdatePipelineStageMutationVariables>;
export const TaskDeletePipelineStageDocument = new TypedDocumentString(`
    mutation TaskDeletePipelineStage($id: ID!, $moveToStageId: ID) {
  task {
    deletePipelineStage(id: $id, moveToStageId: $moveToStageId) {
      __typename
      ... on DeleteTaskPipelineStageSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on DeleteTaskPipelineStageError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskDeletePipelineStageMutation, TaskDeletePipelineStageMutationVariables>;
export const TaskReorderPipelineStagesDocument = new TypedDocumentString(`
    mutation TaskReorderPipelineStages($pipelineId: ID!, $stageIds: [ID!]!) {
  task {
    reorderPipelineStages(pipelineId: $pipelineId, stageIds: $stageIds) {
      __typename
      ... on ReorderTaskPipelineStagesSuccess {
        message
        pipeline {
          ...TaskPipelineFields
        }
      }
      ... on ReorderTaskPipelineStagesError {
        message
        code
        details
      }
    }
  }
}
    fragment TaskPipelineFields on TaskPipelineType {
  id
  name
  isDefault
  isArchived
  position
  teamId
  kind
  itemCount
  stages {
    id
    name
    color
    position
    mapsStatus
    isOpen
    isDone
    isCancelled
    itemCount
  }
}`) as unknown as TypedDocumentString<TaskReorderPipelineStagesMutation, TaskReorderPipelineStagesMutationVariables>;
export const TaskSetSyncExportableDocument = new TypedDocumentString(`
    mutation TaskSetSyncExportable($id: ID!, $exportable: Boolean!, $removeFromExternal: Boolean! = true) {
  task {
    setSyncExportable(
      id: $id
      exportable: $exportable
      removeFromExternal: $removeFromExternal
    ) {
      __typename
      ... on SetTaskSyncExportableSuccess {
        message
        task {
          id
          syncExportable
          syncStatus
          externalEventId
        }
      }
      ... on SetTaskSyncExportableError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSetSyncExportableMutation, TaskSetSyncExportableMutationVariables>;
export const TaskAddReminderDocument = new TypedDocumentString(`
    mutation TaskAddReminder($input: AddTaskReminderInput!) {
  task {
    addReminder(input: $input) {
      __typename
      ... on AddTaskReminderSuccess {
        message
        task {
          id
          reminders {
            id
            channel
            remindAt
          }
        }
      }
      ... on AddTaskReminderError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskAddReminderMutation, TaskAddReminderMutationVariables>;
export const TaskSyncToCalendarDocument = new TypedDocumentString(`
    mutation TaskSyncToCalendar($input: SyncTaskToCalendarInput!) {
  task {
    syncToCalendar(input: $input) {
      __typename
      ... on SyncTaskToCalendarSuccess {
        message
        task {
          id
          syncStatus
          syncExportable
          externalEventId
          lastSyncedAt
          syncError
        }
      }
      ... on SyncTaskToCalendarError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSyncToCalendarMutation, TaskSyncToCalendarMutationVariables>;
export const TaskSyncRangeToCalendarDocument = new TypedDocumentString(`
    mutation TaskSyncRangeToCalendar($input: SyncTasksToCalendarInput!) {
  task {
    syncRangeToCalendar(input: $input) {
      __typename
      ... on SyncTaskRangeToCalendarSuccess {
        message
        queued
        skipped
        cooldownUntil
        lastManualSyncAt
      }
      ... on SyncTaskRangeToCalendarError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSyncRangeToCalendarMutation, TaskSyncRangeToCalendarMutationVariables>;
export const TaskRemoveFromCalendarDocument = new TypedDocumentString(`
    mutation TaskRemoveFromCalendar($id: ID!) {
  task {
    removeFromCalendar(id: $id) {
      __typename
      ... on RemoveTaskFromCalendarSuccess {
        message
        task {
          id
          syncStatus
          calendarProvider
        }
      }
      ... on RemoveTaskFromCalendarError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskRemoveFromCalendarMutation, TaskRemoveFromCalendarMutationVariables>;
export const TaskDeleteDocument = new TypedDocumentString(`
    mutation TaskDelete($id: ID!) {
  task {
    delete(id: $id) {
      __typename
      ... on DeleteTaskSuccess {
        message
        success
      }
      ... on DeleteTaskError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskDeleteMutation, TaskDeleteMutationVariables>;
export const TaskGenerateViewingProtocolDocument = new TypedDocumentString(`
    mutation TaskGenerateViewingProtocol($input: GenerateViewingProtocolInput!) {
  task {
    generateViewingProtocol(input: $input) {
      __typename
      ... on GenerateViewingProtocolSuccess {
        message
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on GenerateViewingProtocolError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskGenerateViewingProtocolMutation, TaskGenerateViewingProtocolMutationVariables>;
export const TaskSendViewingProtocolForSigningDocument = new TypedDocumentString(`
    mutation TaskSendViewingProtocolForSigning($documentId: ID!, $deliveryMode: ViewingProtocolSigningDeliveryMode!, $signers: [ViewingProtocolSignerInput!]) {
  task {
    sendViewingProtocolForSigning(
      documentId: $documentId
      deliveryMode: $deliveryMode
      signers: $signers
    ) {
      __typename
      ... on SendViewingProtocolForSigningSuccess {
        message
        creditsCharged
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on SendViewingProtocolForSigningError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSendViewingProtocolForSigningMutation, TaskSendViewingProtocolForSigningMutationVariables>;
export const TaskRefreshViewingProtocolSigningDocument = new TypedDocumentString(`
    mutation TaskRefreshViewingProtocolSigning($documentId: ID!) {
  task {
    refreshViewingProtocolSigning(documentId: $documentId) {
      __typename
      ... on RefreshViewingProtocolSigningSuccess {
        message
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on RefreshViewingProtocolSigningError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskRefreshViewingProtocolSigningMutation, TaskRefreshViewingProtocolSigningMutationVariables>;
export const TaskCancelViewingProtocolSigningDocument = new TypedDocumentString(`
    mutation TaskCancelViewingProtocolSigning($documentId: ID!) {
  task {
    cancelViewingProtocolSigning(documentId: $documentId) {
      __typename
      ... on CancelViewingProtocolSigningSuccess {
        message
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on CancelViewingProtocolSigningError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskCancelViewingProtocolSigningMutation, TaskCancelViewingProtocolSigningMutationVariables>;
export const TaskDownloadViewingProtocolAuditTrailDocument = new TypedDocumentString(`
    mutation TaskDownloadViewingProtocolAuditTrail($documentId: ID!) {
  task {
    downloadViewingProtocolAuditTrail(documentId: $documentId) {
      __typename
      ... on DownloadViewingProtocolAuditTrailSuccess {
        message
        document {
          id
          originalName
          downloadUrl
        }
      }
      ... on DownloadViewingProtocolAuditTrailError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskDownloadViewingProtocolAuditTrailMutation, TaskDownloadViewingProtocolAuditTrailMutationVariables>;
export const TaskCompleteViewingProtocolSigningDocument = new TypedDocumentString(`
    mutation TaskCompleteViewingProtocolSigning($documentId: ID!) {
  task {
    completeViewingProtocolSigning(documentId: $documentId) {
      __typename
      ... on CompleteViewingProtocolSigningSuccess {
        message
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on CompleteViewingProtocolSigningError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskCompleteViewingProtocolSigningMutation, TaskCompleteViewingProtocolSigningMutationVariables>;
export const TaskViewingProtocolDocument = new TypedDocumentString(`
    query TaskViewingProtocol($taskId: ID!) {
  task {
    viewingProtocol(taskId: $taskId) {
      id
      originalName
      signingStatus
      signingProvider
      signingDeliveryMode
      signingLinks {
        email
        url
      }
      downloadUrl
      metadata
    }
  }
}
    `) as unknown as TypedDocumentString<TaskViewingProtocolQuery, TaskViewingProtocolQueryVariables>;
export const TaskSigningInboxDocument = new TypedDocumentString(`
    query TaskSigningInbox($status: String, $limit: Int = 50, $offset: Int = 0) {
  task {
    signingInbox(status: $status, limit: $limit, offset: $offset) {
      totalCount
      items {
        id
        originalName
        signingStatus
        signingProvider
        signingDeliveryMode
        signingTaskId
        updatedAt
        downloadUrl
        metadata
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSigningInboxQuery, TaskSigningInboxQueryVariables>;
export const TaskSigningCandidatesDocument = new TypedDocumentString(`
    query TaskSigningCandidates($search: String, $limit: Int = 50, $offset: Int = 0) {
  task {
    signingCandidates(search: $search, limit: $limit, offset: $offset) {
      totalCount
      items {
        id
        originalName
        category
        signingStatus
        updatedAt
        downloadUrl
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSigningCandidatesQuery, TaskSigningCandidatesQueryVariables>;
export const TaskSendDocumentForSigningDocument = new TypedDocumentString(`
    mutation TaskSendDocumentForSigning($documentId: ID!, $deliveryMode: ViewingProtocolSigningDeliveryMode!, $signers: [ViewingProtocolSignerInput!]) {
  task {
    sendDocumentForSigning(
      documentId: $documentId
      deliveryMode: $deliveryMode
      signers: $signers
    ) {
      __typename
      ... on SendDocumentForSigningSuccess {
        message
        creditsCharged
        document {
          id
          originalName
          signingStatus
          signingProvider
          signingDeliveryMode
          signingLinks {
            email
            url
          }
          downloadUrl
          metadata
        }
      }
      ... on SendDocumentForSigningError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<TaskSendDocumentForSigningMutation, TaskSendDocumentForSigningMutationVariables>;
export const EntityPickerTasksDocument = new TypedDocumentString(`
    query EntityPickerTasks($query: String, $limit: Int = 20, $scope: CalendarScopeEnum! = TEAM) {
  task {
    list(
      limit: $limit
      offset: 0
      filters: { title: { icontains: $query } }
      order: { updatedAt: DESC }
      scope: $scope
    ) {
      items {
        id
        title
        status
        category
        dueAt
        assigneeId
      }
    }
  }
}
    `) as unknown as TypedDocumentString<EntityPickerTasksQuery, EntityPickerTasksQueryVariables>;
export const ViewingListForPropertyDocument = new TypedDocumentString(`
    query ViewingListForProperty($propertyId: ID!) {
  viewing {
    listForProperty(propertyId: $propertyId) {
      id
      propertyId
      clientId
      dealId
      agentId
      scheduledAt
      status
      reasonNotPurchased
      reasonNote
      taskId
      feedback
      suppressSms
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingListForPropertyQuery, ViewingListForPropertyQueryVariables>;
export const ViewingListDocument = new TypedDocumentString(`
    query ViewingList($limit: Int = 100, $offset: Int = 0) {
  viewing {
    list(limit: $limit, offset: $offset) {
      id
      propertyId
      clientId
      dealId
      agentId
      scheduledAt
      status
      reasonNotPurchased
      reasonNote
      taskId
      feedback
      suppressSms
      createdAt
      updatedAt
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingListQuery, ViewingListQueryVariables>;
export const ViewingOwnerReportDocument = new TypedDocumentString(`
    query ViewingOwnerReport($propertyId: ID!) {
  viewing {
    ownerReport(propertyId: $propertyId) {
      total
      attended
      notPurchased
      reasons
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingOwnerReportQuery, ViewingOwnerReportQueryVariables>;
export const ViewingCreateDocument = new TypedDocumentString(`
    mutation ViewingCreate($input: CreateViewingInput!) {
  viewing {
    create(input: $input) {
      __typename
      ... on CreateViewingSuccess {
        message
        viewing {
          id
          propertyId
          clientId
          agentId
          scheduledAt
          status
          suppressSms
        }
      }
      ... on CreateViewingError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingCreateMutation, ViewingCreateMutationVariables>;
export const ViewingUpdateDocument = new TypedDocumentString(`
    mutation ViewingUpdate($input: UpdateViewingInput!) {
  viewing {
    update(input: $input) {
      __typename
      ... on UpdateViewingSuccess {
        message
        viewing {
          id
          scheduledAt
          agentId
          feedback
          suppressSms
          reasonNote
        }
      }
      ... on UpdateViewingError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingUpdateMutation, ViewingUpdateMutationVariables>;
export const ViewingTransitionStatusDocument = new TypedDocumentString(`
    mutation ViewingTransitionStatus($input: TransitionViewingStatusInput!) {
  viewing {
    transitionStatus(input: $input) {
      __typename
      ... on TransitionViewingStatusSuccess {
        message
        viewing {
          id
          status
          reasonNotPurchased
          reasonNote
          feedback
        }
      }
      ... on TransitionViewingStatusError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingTransitionStatusMutation, ViewingTransitionStatusMutationVariables>;
export const ViewingDeleteDocument = new TypedDocumentString(`
    mutation ViewingDelete($id: ID!) {
  viewing {
    delete(id: $id) {
      __typename
      ... on DeleteViewingSuccess {
        message
        success
      }
      ... on DeleteViewingError {
        message
        code
        details
      }
    }
  }
}
    `) as unknown as TypedDocumentString<ViewingDeleteMutation, ViewingDeleteMutationVariables>;